window.myinsyteresources = {
    en: {
        translation: {


            "contact_method_mobile": "MOBILE",
            "contact_method_email": "EMAIL",

            "disc_rule_level_base": "BASE PRICE",

            "bu_item_type_opportunity": "Opportunity",
            "bu_item_type_job": "Job",
            "bu_item_type_invoice": "Invoice",

            "file_note_css": "CSS",
            "type_file_note_general": "General",
            "type_file_note_install": "Install",

            "promo_state_pending": "Pending",
            "promo_state_live": "Live",
            "promo_state_expired": "Expired",

            "type_area_sales": "Sales",
            "type_area_install": "Install",

            "sales_disc_rounding_standard": "Nearest",
            "sales_disc_rounding_up": "Up",
            "sales_disc_rounding_down": "Down",

            "line_edit_summary_none": "None",
            "line_edit_summary_split_column": "Split Columns",
            "line_edit_summary_no_split": "No Split",
            "finish_edit_match_price_mode_additional_lines_zero_removed_lines_prorata": "Additional lines zero, removed lines prorata",
            "finish_edit_match_price_mode_additional_lines_prorata_removed_lines_prorata": "Additional lines prorata, removed lines prorata",
            "finish_edit_match_price_mode_keep_line_prices_lock_by_threshold": "Keep line prices, lock by margin threshold",
            "wf_trigger_move_to_supply": "Move to supply",
            "wf_trigger_confirm_quote": "Confirm quote",
            "wf_run_running": "Running",
            "wf_run_waiting": "Waiting",
            "wf_run_completed": "Completed",
            "wf_run_failed": "Failed",
            "wf_run_cancelled": "Cancelled",
            "wf_diag_generic_field": "a required field",
            "wf_diag_generic_node": "workflow node",
            "wf_diag_generic_error_title": "Validation issue",
            "wf_diag_where_label": "Where",
            "wf_diag_technical_details": "Technical details",
            "wf_diag_code_label": "Code",
            "wf_diag_node_id_label": "Node ID",
            "wf_diag_path_label": "Path",
            "wf_diag_raw_message_label": "Raw message",
            "wf_diag_wf_cfg_missing_required_title": "Required field missing",
            "wf_diag_wf_cfg_missing_required_detail": "This {{nodeType}} needs {{field}} before it can run.",
            "wf_diag_wf_cfg_unknown_field_title": "Unknown field in configuration",
            "wf_diag_wf_cfg_unknown_field_detail": "This {{nodeType}} has an unsupported field: {{field}}.",
            "wf_diag_wf_edge_incoming_too_few_title": "Missing connection",
            "wf_diag_wf_edge_incoming_too_few_detail": "This {{nodeType}} needs a connection from another workflow step.",
            "wf_diag_wf_edge_outgoing_too_few_title": "Missing connection",
            "wf_diag_wf_edge_outgoing_too_few_detail": "This {{nodeType}} needs at least one outgoing connection.",
            "wf_diag_wf_final_stage_required_title": "Final Stage required",
            "wf_diag_wf_final_stage_required_detail": "If the workflow contains Stage nodes, add a Final Stage node before publishing.",
            "wf_diag_wf_stage_key_required_title": "Stage key missing",
            "wf_diag_wf_stage_key_required_detail": "Open the stage node and enter a unique stage key.",
            "wf_diag_wf_stage_duplicate_key_title": "Duplicate stage key",
            "wf_diag_wf_stage_duplicate_key_detail": "Two or more stage nodes share the same stage key. Give each stage a unique key.",
            "wf_diag_wf_cfg_action_target_path_required_title": "Target path required",
            "wf_diag_wf_cfg_action_target_path_required_detail": "This {{nodeType}} acts on a different entity than the workflow. Set a path to the target entity, or switch to query resolution.",
            "wf_diag_wf_cfg_action_target_query_required_title": "Target query required",
            "wf_diag_wf_cfg_action_target_query_required_detail": "This {{nodeType}} uses query resolution but has no query.",
            "wf_diag_wf_cfg_waitfor_expression_required_title": "Pass expression required",
            "wf_diag_wf_cfg_waitfor_expression_required_detail": "The Wait For step needs a pass expression to decide when the wait completes.",
            "wf_diag_wf_cfg_waitfor_wakeon_required_title": "Wake-on fields required",
            "wf_diag_wf_cfg_waitfor_wakeon_required_detail": "Select at least one field whose changes should re-evaluate the wait.",
            "wf_diag_wf_cfg_delay_duration_required_title": "Delay duration required",
            "wf_diag_wf_cfg_delay_duration_required_detail": "Enter how long this delay should wait (seconds, hh:mm:ss, or ISO-8601).",
            "wf_user_msg_wf_cfg_missing_required": "A required field is missing.",
            "wf_user_msg_wf_cfg_unknown_field": "This workflow step has an unsupported setting.",
            "wf_user_msg_wf_cfg_notify_recipient_required": "Recipient is required.",
            "wf_user_msg_wf_cfg_notify_recipient_ambiguous": "Select only one recipient method.",
            "wf_user_msg_wf_cfg_notify_sender_required": "Sender is required.",
            "wf_user_msg_wf_cfg_notify_sender_ambiguous": "Select only one sender method.",
            "wf_user_msg_wf_edge_incoming_too_few": "Missing connection.",
            "wf_user_msg_wf_edge_outgoing_too_few": "Missing connection.",
            "wf_user_msg_wf_final_stage_required": "Add a Final Stage before publishing.",
            "wf_user_msg_wf_stage_key_required": "A stage node is missing a stage key.",
            "wf_user_msg_wf_stage_duplicate_key": "Two or more stage nodes share the same stage key.",
            "wf_user_msg_wf_trigger_no_effectful_path": "Connect the trigger to a workflow step that performs an action.",
            "wf_user_msg_wf_durable_wait_requires_stage": "Add a Stage before the first Delay or Wait For step.",

            "wf_validation_outcome_allow": "Allow",
            "wf_validation_outcome_warn": "Warn",
            "wf_validation_outcome_block": "Block",
            "wf_validation_outcome_require_manual": "Require manual action",
            "wf_validation_outcome_retry": "Retry later (computed)",

            "wf_validation_failure_policy_block_selection": "Block selection",
            "wf_validation_failure_policy_block_line_only": "Block line only",
            "wf_validation_failure_policy_block_product": "Block product",

            "wf_notification_recipient_sales_rep": "Sales rep",
            "wf_notification_recipient_po_rep": "PO rep",
            "wf_notification_recipient_account_manager": "Account manager",


            "fin_generic_type_invoice": "Invoice",
            "fin_generic_type_payment": "Payment",
            "fin_generic_type_allocation": "Allocation",

            "fin_state_none": "",
            "fin_state_awaiting_transfer": "Pending Transfer",
            "fin_state_queued_transfer": "Queued for Transfer",
            "fin_state_awaiting_force_transfer": "Pending Forced Transfer",
            "fin_state_transferred": "Transferred",
            "fin_state_ignored": "Not Transferred",
            "fin_state_v1_transfer": "Fiance Version 1.0",
            "fin_state_version_miss_match": "Finance Version Miss Match",
            "fin_state_awaiting_cancellation_transfer": "Pending Cancellation Transfer",
            "fin_state_queued_cancellation_transfer": "Queued for Cancellation Transfer",
            "fin_state_cancel_ignored": "Cancellation Not Transferred",
            "fin_state_cancel_transferred": "Cancellation Transferred",

            "job_install_rule_manual": "Manual",
            "job_install_rule_no_split": "No Split",
            "job_install_rule_system": "System",

            "fin_trans_alloc_version_miss_match": "Finance Integration Version Miss Match",
            "fin_trans_alloc_version_miss_match_tooltip": "The allocation is assigned to a payment and invoice which have been Transferred with different versions of the finance integration. Please adjust to ensure finance integration versions are consistent between payments and invoices.",

            "fin_trans_payment_already_exists": "Unable to Transfer as Payment Already Exists in {{provider}}",
            "fin_trans_payment_receiptno_exceeds_max_length": "Insyte Web Receipt No exceeds the Maximum Length of '{{ReceiptNoFinanceMaxLength}}' characters for {{provider}}. You will need to enter a shorter number for {{provider}}",
            "fin_trans_invoice_already_exists": "Unable to Transfer as Invoice Already Exists in {{provider}}",
            "fin_trans_invoice_invoiceno_exceeds_max_length": "Insyte Web Invoice No exceeds the Maximum Length of '{{InvoiceNoFinanceMaxLength}}' characters for {{provider}}. You will need to enter a shorter number for {{provider}}",

            "fin_trans_cancel_payment_not_created": "Unable to Find Payment to Cancel in {{provider}}",
            "fin_trans_cancel_payment_not_created_tooltip": "Payment may have been Manually Deleted in {{provider}}",
            "fin_trans_alloc_invoice_not_created": "Unable to Find Invoice in {{provider}} to Update Allocation",
            "fin_trans_alloc_invoice_not_created_tooltip": "Invoice may have been Manually Deleted in {{provider}}",
            "fin_trans_cancel_alloc_invoice_not_created": "Unable to Find Invoice in {{provider}} to Cancel Allocation",
            "fin_trans_cancel_alloc_invoice_not_created_tooltip": "Invoice may have been Manually Deleted in {{provider}}",
            "fin_trans_alloc_payment_not_created": "Unable to Find Payment in {{provider}} to Update Allocation",
            "fin_trans_alloc_payment_not_created_tooltip": "Payment may have been Manually Deleted in {{provider}}",
            "fin_trans_cancel_alloc_payment_not_created": "Unable to Find Payment in {{provider}} to Cancel Allocation",
            "fin_trans_cancel_alloc_payment_not_created_tooltip": "Payment may have been Manually Deleted in {{provider}}",
            "fin_trans_cancel_invoice_not_created": "Unable to Find Invoice to Cancel in {{provider}}",
            "fin_trans_cancel_invoice_not_created_tooltip": "Invoice may have been Manually Deleted in {{provider}}",

            "fin_trans_product_refund_not_created": "Refund settings are not configured in finance integration settings",
            "fin_trans_product_refund_not_created_tooltip": "Please ensure the Refund Product and Account are set in the finance integration settings",

            "fin_trans_individual_invoice_product_not_created": "Independent Invoice Product settings are not configured in finance integration settings",
            "fin_trans_individual_invoice_product_not_created_tooltip": "Please ensure the Independent Invoice Taxable Product and/or Independent Invoice Non-Taxable Product are set in the finance integration settings",

            "fin_trans_contact_multiple_records": "Matches multiple existing contacts in {{provider}}",
            "fin_trans_contact_multiple_records_tooltip": "The contact matched multiple {{provider}} contacts. You will need to click 'Match' to select the correct {{provider}} Contact or choose to create a new contact in {{provider}}",
            "fin_trans_contact_already_matched": "Matched to {{provider}} Contact that already has a matching contact",
            "fin_trans_contact_already_matched_tooltip": "The contact matched a {{provider}} contact that is already linked to another Insyte contact",
            "fin_trans_payment_multiple_records": "Matched to Multiple Payments in {{provider}}",
            "fin_trans_payment_no_contactid": "Contact '{{ContactFullName}}' for Payment '{{ReceiptNo}}' has not yet been mapped or transferred to {{provider}}",
            "fin_trans_alloc_invoice_multiple_records": "Matched Allocation to Multiple Invoices in {{provider}}",
            "fin_trans_alloc_payment_multiple_records": "Matched Allocation to Multiple Payments in {{provider}}",
            "fin_trans_invoice_multiple_records": "Matched to Multiple Invoices in {{provider}}",
            "fin_trans_invoice_no_contactid": "Contact '{{ContactFullName}}' for Invoice '{{InvoiceNo}}' has not yet been mapped or transferred to {{provider}}",

            "fin_trans_no_id_invoice": "Cannot Find Invoice in {{provider}} While Cancelling",
            "fin_trans_no_id_invoice_tooltip": "Invoice May Have Been Manually Transferred in {{provider}}",

            "fin_trans_no_id_alloc_invoice": "Cannot Find Invoice for Allocation in {{provider}}",
            "fin_trans_no_id_alloc_invoice_tooltip": "Invoice May Have Been Manually Transferred in {{provider}}",
            "fin_trans_no_id_alloc_payment": "Cannot Find Payment for Allocation in {{provider}}",
            "fin_trans_no_id_alloc_payment_tooltip": "Payment May Have Been Manually Transferred in {{provider}}",

            "fin_trans_no_id_payment": "Cannot Find Payment in {{provider}}, May Have Been Manually Transferred",
            "fin_trans_no_id_payment_tooltip": "Payment May Have Been Manually Transferred in {{provider}}",

            "fin_trans_no_id_alloc_payment_cancel": "Cannot Find Payment in {{provider}} While Cancelling Allocation",
            "fin_trans_no_id_alloc_payment_cancel_tooltip": "Payment May Have Been Manually Transferred in {{provider}}",
            "fin_trans_no_id_alloc_invoice_cancel": "Cannot Find Invoice in {{provider}} While Cancelling Allocation",
            "fin_trans_no_id_alloc_invoice_cancel_tooltip": "Invoice May Have Been Manually Transferred in {{provider}}",

            "fin_trans_payment_voided": "Payment has been Voided in {{provider}}",
            "fin_trans_payment_allocation_voided": "Payment has already been Voided in {{provider}}",
            "fin_trans_invoice_voided": "Invoice has been Voided in {{provider}}",
            "fin_trans_product_not_created": "Unable to Match Products on Invoice in {{provider}}",
            "fin_trans_no_negative_invoices": "{{provider}} Does Not Support Negative Invoices",
            "fin_trans_no_positive_credits": "{{provider}} Does Not Support Positive Credits",
            "fin_trans_no_credit": "{{provider}} Integration Does Not Support Credit Notes",
            "fin_trans_no_credit_tooltip": "As {{provider}} Integration Does Not Support Credit Notes, you will need to manually enter these transactions in {{provider}} and Mark as Ignored",
            "fin_trans_contact_company_taxexempt_missing_reason": "Missing {{provider}} tax exemption id for company",
            "fin_trans_no_refund_allocate": "{{provider}} Integration Does Not Support Refund Allocation",
            "fin_trans_no_refund_allocate_tooltip": "As {{provider}} Integration Does Not Support Allocations for Refunds, you will need to manually check the refund in {{provider}} and Mark as Ignored",

            "measurement_systems_metric": "Metric",
            "measurement_systems_imperial": "Imperial",

            "cust_availability_slot_type_sales": "Sales",
            "cust_availability_slot_type_dispatch": "Dispatch",

            "report_param_title": "TITLE",
            "report_param_tandc": "TERMS AND CONDITIONS",
            "report_param_payment": "PAYMENT TERMS",
            "report_param_options_format": "OPTIONS LAYOUT",
            "report_param_options_format_comma": "Comma List",
            "report_param_options_format_table": "Table",
            "report_param_options_format_hidden": "Hidden",
            "report_param_option_colums": "COLUMNS",
            "report_style_title": "TITLE",
            "report_style_caption": "CAPTIONS",
            "report_style_notes": "NOTES",
            "report_style_options": "OPTIONS",
            "report_style_amount_outstanding_caption": "AMOUNT OUTSTANDING CAPTION",
            "report_style_amount_outstanding_amount": "AMOUNT OUTSTANDING",

            "report_param_product_tax_code_label": "PRODUCT TAX CODE LABEL",
            "report_param_business_number_label": "BUSINESS NUMBER LABEL",
            "report_param_customer_business_number_label": "CUSTOMER BUSINESS NUMBER LABEL",
            "report_param_business_address": "BUSINESS ADDRESS",
            "report_param_business_address_address": "Address",
            "report_param_business_address_billing": "Billing",
            "report_param_business_address_delivery": "Delivery",
            "report_param_show_sizes": "SHOW SIZE",
            "report_param_show_sizes_show": "Show",
            "report_param_show_sizes_hide": "Hide",

            "report_param_show_product_tax_code": "SHOW PRODUCT TAX CODE",
            "report_param_show_product_tax_code_show": "Show",
            "report_param_show_product_tax_code_hide": "Hide",


            "report_param_show_tax_breakup": "SHOW TAX BREAKUP",
            "report_param_show_tax_breakup_none": "None",
            "report_param_show_tax_breakup_line": "For line",
            "report_param_show_tax_breakup_total": "For total",
            "report_param_show_tax_breakup_line_total": "For line and total",



            "report_param_show_install_completion_form": "SHOW FITTER COMPLETION FORM",
            "report_param_show_install_completion_form_show": "Show",
            "report_param_show_install_completion_form_hide": "Hide",


            "report_param_show_email": "SHOW EMAIL",
            "report_param_show_email_hide": "Hide",
            "report_param_show_email_rep": "Representative",
            "report_param_show_email_bu": "Business Unit",



            "report_param_show_signature": "SHOW SIGNATURE",
            "report_param_show_signature_never": "Never",
            "report_param_show_signature_signed": "If signed",
            "report_param_show_signature_always": "Always",

            "report_param_css_sig_flow": "CSS SIGNATURE FLOW",
            "report_param_css_sig_flow_default": "Default (digital)",
            "report_param_css_sig_flow_guidance": "Signature with guidance",
            "report_param_css_sig_flow_no_guidance": "Signature without guidance",


            "report_param_show_price": "SHOW PRICE",
            "report_param_show_price_show": "All",
            "report_param_show_price_hide": "None",
            "report_param_show_price_summary": "Summary",
            "report_param_options_format_table_columns": "COLUMNS",
            "report_param_options_format_table_columns_1": "1",
            "report_param_options_format_table_columns_2": "2",
            "report_param_options_format_table_columns_3": "3",
            "report_param_options_format_table_columns_4": "4",
            "report_param_options_format_table_columns_5": "5",
            "report_param_show_customer_notes": "SHOW CUSTOMER NOTES",
            "report_param_show_customer_notes_show": "Show",
            "report_param_show_customer_notes_hide": "Hide",
            "report_param_show_manufacturing_notes": "SHOW SUPPLY MANUFACTURING NOTES",
            "report_param_show_manufacturing_notes_show": "Show",
            "report_param_show_manufacturing_notes_hide": "Hide",
            "report_param_show_install_notes": "SHOW INSTALLATION NOTES",
            "report_param_show_install_notes_show": "Show",
            "report_param_show_install_notes_hide": "Hide",
            "report_param_show_line_number": "SHOW LINE NUMBER",
            "report_param_show_line_number_show": "Show",
            "report_param_show_line_number_hide": "Hide",
            "report_param_show_location": "SHOW LOCATION",
            "report_param_show_location_show": "Show",
            "report_param_show_location_hide": "Hide",
            "report_param_show_promotions": "SHOW PROMOTIONS",
            "report_param_show_promotions_show": "Show",
            "report_param_show_promotions_hide": "Hide",
            "report_param_group_supp_charges": "GROUP SUPPLEMENTARY CHARGES",
            "report_param_group_supp_charges_show": "Show",
            "report_param_group_supp_charges_hide": "Hide",

            "acc_type_retail": "Retail",
            "acc_type_wholesale": "Wholesale",
            "acc_type_commercial": "Commercial",

            "disp_type_delivery": "Delivery",
            "disp_type_install": "Install",
            "disp_type_pickup": "Pickup",


            "prc_type_retail": "Retail",
            "prc_type_wholesale": "Wholesale",
            "prc_type_Cost": "Cost",

            "stm_type_activity": "Activity",
            "stm_type_outstanding": "Outstanding",


            "doc_temp_type_quote": "Quote",
            "doc_temp_type_oc": "Order Confirmation",
            "doc_temp_type_inv": "Invoice",
            "doc_temp_type_stmt": "Statement",
            "doc_temp_type_install": "Install Job Sheet Report",
            "doc_temp_type_js": "Job Summary",
            "doc_temp_type_jr": "Job Review",

            "charge_to_na": "N/A",
            "charge_to_office": "Office",
            "charge_to_installer": "Installer",
            "charge_to_sales_rep": "Sales Rep",
            "charge_to_supplier": "Supplier",
            "charge_to_mf_department": "MF Department",

            "tax_lookup_type_sales": "Sales Tax",
            "tax_lookup_type_purchasing": "Purchasing Tax",

            "job_edit_conflict_order": "Job",
            "job_edit_conflict_order_suggestion": "May want to send order confirmation to customer",
            "job_edit_conflict_address": "Address Changed",
            "job_edit_conflict_address_suggestion": "May want to update appointments with new address",
            "job_edit_conflict_invoice": "Invoice",
            "job_edit_conflict_invoice_suggestion": "May want to cancel and resend invoice",
            "job_edit_conflict_invoice_removal": "Remove from Invoice",
            "job_edit_conflict_invoice_removal_suggestion": "One or more lines will be removed from this invoice.",
            "job_edit_conflict_supply_job": "Supply Job",
            "job_edit_conflict_supply_job_suggestion": "May need to cancel and resend Supply job.",
            "job_edit_conflict_supply_job_removal": "Remove from Supply Job",
            "job_edit_conflict_supply_job_removal_removal_suggestion": "One or more lines will be removed from this supply job.",
            "job_edit_conflict_appointments": "Appointment",
            "job_edit_conflict_appointments_suggestion": "May want to check that appointment is still valid",
            "job_edit_conflict_appointment_line_removal": "Remove From Appointment",
            "job_edit_conflict_appointment_line_removal_suggestion": "One or more lines will be removed from this appointment.",
            "job_edit_conflict_validation": "Validation Error",
            "job_edit_conflict_validation_suggestion": "Fix errors before continuing",

            "PurchaseOrder": "Supply Job",
            "status_invoice_overdue": "Overdue",
            "status_invoice_awaiting_payment": "Awaiting Payment",

            "quote_expired": "EXPIRED",
            "job_closed": "CLOSED",
            "job_cancelled": "CANCELLED",
            "activity_cancelled": "CANCELLED",
            "activity_status_open": "Open",
            "activity_status_closed": "Closed",
            "activity_status_cancelled": "Cancelled",
            "job_lost": "LOST",
            "job_order": "ORDER",

            "type_job_sales": "Sales",
            "type_job_service": "Service",

            "stage_job_quote": "Quote",
            "stage_job_order": "Order",
            "stage_job_order_edit": "EDIT",
            "stage_job_lost": "Lost",
            "status_job_open": "Open",
            "status_job_closed": "Closed",
            "status_job_sent": "Sent",
            "status_job_supply": "Supply",
            "status_job_cancelled": "Cancelled",
            "status_job_on_hold": "OnHold",
            "status_job_lost": "Lost",

            "priority_job_standard": "Standard",
            "priority_job_high": "High",

            "supply_delivery_address_rule_business_unit_delivery_address": "Business Unit Delivery Address",
            "supply_delivery_address_rule_site_address": "Site Address",

            "supplier_interfacetype_none": "None",
            "supplier_interfacetype_ubl": "UBL",
            "supplier_interfacetype_ascx12": "ASCX12",
            "supplier_transporttype_email": "Email",
            "supplier_transporttype_sftp": "SFTP",
            "edi_file_processingstatus_pending": "Pending",
            "edi_file_processingstatus_processing": "Processing",
            "edi_file_processingstatus_complete": "Complete",
            "edi_file_result_sent": "Sent",
            "edi_file_result_processed": "Processed",
            "edi_file_result_failed": "Failed",
            "edi_file_result_not_processed_duplicate": "Not Processed - Duplicate",
            "edi_file_result_not_processed_out_of_sequence": "Not Processed - Out of Sequence",
            "edi_outboundfile_result_sent": "Sent",
            "edi_outboundfile_result_failed": "Failed",
            "edi_outboundfile_result_partially_sent": "Partially Sent",
            "edi_outboundfiletransport_result_sent": "Sent",
            "edi_outboundfiletransport_result_failed": "Failed",
            "ctrl_x12_env": "Envelope",
            "ctrl_x12_grp": "Group",
            "ctrl_x12_trn": "Transaction",
            "supplier_myproductsettings_supplyjobfile": "Supply Job File",
            "supplier_myproductsettings_transports": "Transports",
            "supplier_transporttype_label": "Transport Type",
            "supplier_transport_send_supply_job_file": "Send Supply Job File",
            "supplier_transport_send_attachments": "Send Attachments",
            "supplier_transport_send_worksheets": "Send Worksheets",
            "supplier_transport_send_order_notification": "Send Order Notification",
            "supplier_transport_send_copy_to_me": "Send Copy to Me",
            "supplier_transport_add": "Add Transport",
            "supplier_transport_edit": "Edit Transport",
            "supplier_transport_move_up": "Move Up",
            "supplier_transport_move_down": "Move Down",
            "supplier_transport_duplicate_type": "Only one transport row is currently allowed for each transport type.",
            "supplier_transport_no_settings": "No settings available.",
            "supplier_transport_settings": "Settings",
            "supplier_transport_default_email_message": "Email Transport will be used for all unless you specify specific Transports.",
            "supplier_transport_supply_job_required": "At least one transport must be marked Send Supply Job File when an interface is selected.",

            "dispatch_job_line_install_not_booked": "Install Not Booked",
            "dispatch_job_line_install_booked": "Install Booked",
            "dispatch_job_line_delivery_not_booked": "Delivery Not Booked",
            "dispatch_job_line_delivery_booked": "Delivery Booked",
            "dispatch_job_line_pickup_not_booked": "Pickup Not Booked",
            "dispatch_job_line_pickup_booked": "Pickup Booked",
            "dispatch_job_line_installed": "Installed",
            "dispatch_job_line_picked_up": "Collected",
            "dispatch_job_line_delivered": "Delivered",
            "dispatch_job_line_pending_service": "Service Pending",

            "stage_job_line_unconfirmed_sent": "Unconfirmed Sent",
            "stage_job_line_unconfirmed": "Unconfirmed",
            "stage_job_line_unconfirmed_cm": "CM Unconfirmed",
            "stage_job_line_cm_not_booked": "CM Not Booked",
            "stage_job_line_cm_booked": "CM Booked",
            "stage_job_line_cm_inprogress": "CM In Progress",
            "stage_job_line_cm_completed": "CM Completed",
            "stage_job_line_cm_completed_unconfirmed": "CM Completed (Unconfirmed)",
            "stage_job_line_cm_completed_confirmed": "CM Completed (Confirmed)",
            "stage_job_line_cm_completed_reschedule": "CM Completed Reschedule",
            "stage_job_line_cm_completed_confirmed_reschedule": "CM Completed Reschedule (Confirmed)",
            "stage_job_line_confirmed": "Confirmed",
            "stage_job_line_confirmed_cm": "CM Confirmed",
            "stage_job_line_supply": "Supply",
            "stage_job_line_supply_pending": "Supply Pending",
            "stage_job_line_supply_failed": "Supply Failed",
            "stage_job_line_dispatch": "Dispatch",
            "stage_job_line_invoicing": "Invoicing",
            "stage_job_line_restocked": "Restocked",
            "stage_job_line_restocked_consumed": "Stock Consumed",
            "stage_job_line_restocked_discarded": "Stock Discarded",

            "status_job_line_open": "Open",
            "status_job_line_closed": "Closed",
            "status_job_line_cancelled": "Cancelled",
            "status_job_line_edit": "Edit",
            "status_job_line_on_hold": "On Hold",
            "type_job_line_new": "New",
            "type_job_line_remake": "Remake",
            "type_job_line_alter": "Alteration",
            "type_job_line_service": "Service",

            "status_po_released": "Released",
            "status_po_open": "Open",
            "status_po_sent": "Sent",
            "status_po_partial_delivered": "Partial Delivered",
            "status_po_delivered": "Delivered",
            "status_po_closed": "Closed",
            "status_po_priced": "Priced",
            "status_po_received": "Received",
            "status_po_manufacturing": "Manufacturing",
            "status_po_dispatch": "Dispatch",
            "status_po_invoiced": "Invoiced",
            "status_po_cancelled": "Cancelled",

            "status_po_line_released": "Released",
            "status_po_line_open": "Open",
            "status_po_line_sent": "Sent",
            "status_po_line_partial_delivered": "Partial Delivered",
            "status_po_line_delivered": "Delivered",
            "status_po_line_closed": "Closed",
            "status_po_line_priced": "Priced",
            "status_po_line_received": "Received",
            "status_po_line_manufacturing": "Manufacturing",
            "status_po_line_dispatch": "Dispatch",
            "status_po_line_invoiced": "Invoiced",
            "status_po_line_cancelled": "Cancelled",
            "status_po_line_inprogress": "In-Progress",
            "status_po_line_completed": "Completed",

            "po_delivery_method_email": "Email",
            "po_delivery_method_marketplace": "Marketplace",
            "po_delivery_method_internal_manufacturing": "Internal MF",


            "status_invoice_open": "Open",
            "status_invoice_closed": "Closed",
            "status_invoice_sent": "Sent",
            "status_invoice_cancelled": "Cancelled",

            "status_invoice_line_open": "Open",
            "status_invoice_line_closed": "Closed",
            "status_invoice_line_sent": "Sent",
            "status_invoice_line_cancelled": "Cancelled",


            "type_payment_payment": "Payment",
            "type_payment_refund": "Refund",
            "type_payment_credit": "Credit",
            "type_payment_transfer": "Transfer",

            "status_payment_draft": "Draft",
            "status_payment_confirmed": "Confirmed",
            "status_payment_cancelled": "Cancelled",
            "status_payment_finalised": "Finalised",


            "status_lead_open": "Open",
            "status_lead_abandoned": "Abandoned",
            "status_lead_lost": "Lost",
            "status_lead_won": "Won",

            "stage_lead_lead": "Lead",
            "stage_lead_negotiation": "Negotiation",
            "stage_lead_quotation": "Quotation",
            "stage_lead_contract": "Contract",

            "pt_job_pod": "Payment On Delivery",
            "pt_job_ppd": "Payment Prior Delivery",
            "pt_job_invoice_terms": "Invoice Terms",
            "pt_job_account_customer": "Account Customer",

            "pd_no_of_days": "In Given No Of Days",
            "pd_eom": "Day of the Month",
            "pd_days_after_eom": "Days after EOM",
            "pd_day_of_month_after_eom": "Day of the Month after EOM",


            "sales_rep": "Sales Rep",
            "current_user": "Current User",
            "business_unit_area": "Business Unit Area",

            "comm_type_email": "EMAIL",
            "comm_type_sms": "SMS",
            "comm_type_sms_reply": "SMS REPLY",
            "comm_type_whatsapp": "WHATSAPP",
            "comm_type_whatsapp_reply": "WHATSAPP REPLY",

            "comm_outcome_pending": "Pending",
            "comm_outcome_succeeded": "Succeeded",
            "comm_outcome_failed": "Failed",

            "rep_view_data_all": "All",
            "rep_view_data_teams": "Teams",
            "rep_view_data_own": "Own",


            "rep_manage_roster_all": "All",
            "rep_manage_roster_teams": "Teams",
            "rep_manage_roster_own": "Own",
            "rep_manage_roster_none": "None",

            "retail_job_signature_rule_no_warning": "No Warning",
            "retail_job_signature_rule_warning": "Warning",
            "retail_job_signature_rule_required": "Required",


            "priority_activity_high": "High",
            "priority_activity_medium": "Medium",
            "priority_activity_low": "Low",

            "comm_summary_type_val": "Value",
            "comm_summary_type_sum": "Sum",
            "comm_summary_type_count": "Count",
            "comm_summary_type_avg": "Average",
            "comm_summary_type_max": "Max",
            "comm_summary_type_min": "Min",
            "comm_summary_type_count_dist": "Count Distinct",

            "status_draft": "Draft",
            "status_paid": "Paid",
            "type_standard": "Standard",
            "type_amendment": "Amendment",
            "type_manual": "Manual",

            "product_version_active": "Active",
            "product_version_superseded": "Superseded",


            "pricelist_version_active": "Active",
            "pricelist_version_superseded": "Superseded",

            "cust_doc_superseded": "Superseded",
            "cust_doc_draft": "Draft",
            "cust_doc_published": "Published",

            "commission_run_error_run_not_found": "Commission run could not found",
            "commission_run_error_run_contains_paid": "Attempting to rerun a PAID commission run",
            "commission_run_error_no_data": "No Job data for commissions found",
            "commission_run_error_no_rules": "No commission rules configured",
            "commission_run_error_no_user_rules": "No users allocated to commission rules",
            "commission_run_msg_saving": "Saving results",
            "commission_run_msg_done": "Finished",
            "commission_run_msg_email_done": "Emails Sent Successfully",
            "commission_run_msg_email_error": "Error sending email to 1 or more users. Please see notifications.",

            "application_strings": {
                "notifications": {
                    "jobInstallerPlannerPrint": {
                        "InProgress": {
                            "subject": "Print Installer Planner",
                            "message": "Printing installer planner please wait"
                        },
                        "Done": {
                            "subject": "Print Installer Planner",
                            "message": "Download for printing"
                        }
                    },
                    "marketplaceErrors": {
                        "noEndpointFound": "(MP001) No endpoint on incoming order",
                        "jobExists": "(MP002) Job already exists, cannot download order for existing active job",
                        "clientPublickKeyNotFound": "(MP003) No matching public key for incoming order",
                        "companyAccountManagerNotFound": "(MP004) Company account manager not found. Please verify account manager assignment",
                        "companyContactNotFound": "(MP005) Company contact information not found. Please update contact details",
                        "productNotSpecified": "(MP006) Product not specified in the order. Please select a valid product",
                        "productNotFound": "(MP007) Product specified in the order was not found. Please verify product selection",
                        "errorImportingWidth": "(MP008) Error importing width specifications. Please check width values and format",
                        "errorImportingHeight": "(MP009) Error importing height specifications. Please check height values and format",
                        "errorProcessingOption": "(MP010) Error processing product option. Please verify option configuration",
                        "errorProcessingOptions": "(MP011) Error processing multiple product options. Please review option selections",
                        "errorProcessingOptionAdditionalValues": "(MP012) Error processing additional values for product option. Please check option parameters",
                        "errorProcessingOptionsAdditionalValues": "(MP013) Error processing additional values for multiple product options. Please review all option parameters",
                        "errorProcessingExtra": "(MP014) Error processing extra product feature. Please verify extra feature configuration",
                        "errorProcessingExtras": "(MP015) Error processing multiple extra product features. Please review all extra features",
                        "errorProcessingOptionOverride": "(MP016) Error processing option override. Please check override configuration",
                        "errorProcessingOptionsOverride": "(MP017) Error processing multiple option overrides. Please review all override configurations",
                        "errorProcessingOptionLinedToSet": "(MP018) Error processing option linked to set. Please verify option-to-set linkage",
                        "errorProcessingOptionLinedToSets": "(MP019) Error processing options linked to multiple sets. Please review all option-to-set linkages"
                    },
                    "jobInstallerPlannerEmail": {
                        "InProgress": {
                            "subject": "Email Installer Planner",
                            "message": "Emailing installer planner please wait"
                        },
                        "Done": {
                            "subject": "Email Installer Planner",
                            "message": "Emails sent"
                        },
                        "Failed": {
                            "subject": "Email Installer Planner Failed",
                            "message": "Emailing failed please try again"
                        }
                    },
                    "areasExport": {
                        "InProgress": {
                            "subject": "Export Areas",
                            "message": "Exporting areas please wait"
                        },
                        "Done": {
                            "subject": "Export Areas",
                            "message": "Export ready"
                        }
                    },
                    "productSpecification": {
                        "InProgress": {
                            "subject": "Export Product Specification",
                            "message": "Exporting please wait"
                        },
                        "Done": {
                            "subject": "Export Product Specification",
                            "message": "{{ProductName}} Export ready"
                        },
                        "Failed": {
                            "subject": "Failed to generate specification",
                            "message": "Export failed please try again {{Error}}"
                        }
                    },
                    "productSpecificationImport": {
                        "InProgress": {
                            "subject": "Import Specification",
                            "message": "Importing {{FileName}} specification please wait"
                        },
                        "Done": {
                            "subject": "Import Specification",
                            "message": "Import {{FileName}} Result"
                        },
                        "Failed": {
                            "subject": "Import Specification Failed",
                            "message": "Click here to download file with errors."
                        }
                    },
					"rosterExport": {
						"InProgress": {
							"subject": "Export Roster(s)",
							"message": "Exporting roster(s) please wait"
						},
						"Done": {
							"subject": "Export Roster(s)",
							"message": "Export ready"
						}
					},
					"areasImport": {
						"InProgress": {
							"subject": "Import Areas",
							"message": "Importing areas please wait"
						},
						"Done": {
							"subject": "Import Areas",
							"message": "Import Result"
						},
						"Failed": {
							"subject": "Import Areas Failed",
							"message": "Import failed please try again"
						}
					},
					"fabricsImport": {
						"InProgress": {
							"subject": "Import Fabrics",
							"message": "Importing fabrics please wait"
						},
						"Done": {
							"subject": "Import Fabrics",
							"message": "Import Result"
						},
						"Failed": {
							"subject": "Import Fabrics Failed",
							"message": "Click here to download file with errors."
						}
					},
					"partsImport": {
						"InProgress": {
							"subject": "Import Parts",
							"message": "Importing parts please wait"
						},
						"Done": {
							"subject": "Import Parts",
							"message": "Import Result"
						},
						"Failed": {
							"subject": "Import Parts Failed",
							"message": "Click here to download file with errors."
						}
					},
					"companyContactImport": {
						"InProgress": {
							"subject": "Import Companies/Contacts",
							"message": "Importing companies/contacts please wait"
						},
						"Done": {
							"subject": "Import Companies/Contacts",
							"message": "Import Result"
						},
						"Failed": {
							"subject": "Import Companies/Contacts Failed",
							"message": "Click here to download file with errors."
						}
					},
					"jobImport": {
						"InProgress": {
							"subject": "Import Jobs",
							"message": "Importing jobs please wait"
						},
						"Done": {
							"subject": "Import Jobs",
							"message": "Import Result"
						},
						"Failed": {
							"subject": "Import Jobs Failed",
							"message": "Click here to download file with errors."
						}
					},
					"fileNoteImport": {
						"InProgress": {
							"subject": "Import File Notes",
							"message": "Importing file notes please wait"
						},
						"Done": {
							"subject": "Import File Notes",
							"message": "Import Result"
						},
						"Failed": {
							"subject": "Import File Notes Failed",
							"message": "Click here to download file with errors."
						}
					},
					"paymentImport": {
						"InProgress": {
							"subject": "Import Payments",
							"message": "Importing payments please wait"
						},
						"Done": {
							"subject": "Import Payments",
							"message": "Import Result"
						},
						"Failed": {
							"subject": "Import Payments Failed",
							"message": "Click here to download file with errors."
						}
					},
                    "representativeImport": {
                        "InProgress": {
                            "subject": "Import Users",
                            "message": "Importing users please wait"
                        },
                        "Done": {
                            "subject": "Import Users",
                            "message": "Import Result"
                        },
                        "Failed": {
                            "subject": "Import Users Failed",
                            "message": "Click here to download file with errors."
                        }
                    },
					"activityImport": {
						"InProgress": {
							"subject": "Import Activities",
							"message": "Importing activities please wait"
						},
						"Done": {
							"subject": "Import Activities",
							"message": "Import Result"
						},
						"Failed": {
							"subject": "Import Activities Failed",
							"message": "Click here to download file with errors."
						}
					},
                    "fabricsExport": {
                        "InProgress": {
                            "subject": "Export Fabrics",
                            "message": "Exporting fabrics please wait"
                        },
                        "Done": {
                            "subject": "Export Fabrics",
                            "message": "Export Ready"
                        }
                    },
                    "partsExport": {
                        "InProgress": {
                            "subject": "Export Parts",
                            "message": "Exporting parts please wait"
                        },
                        "Done": {
                            "subject": "Export Parts",
                            "message": "Export Ready"
                        }
                    },
                    "jobDetailExport": {
                        "InProgress": {
                            "subject": "Export Job Detail Grid",
                            "message": "Exporting jobs please wait"
                        },
                        "Done": {
                            "subject": "Export Job Detail Grid",
                            "message": "Export Result"
                        },
                        "Failed": {
                            "subject": "Export Job Detail Grid Failed",
                            "message": "Export failed please try again"
                        }
                    },
                    "aiDataExport": {
                        "InProgress": {
                            "subject": "Data Export {{Label}}",
                            "message": "Generating data export please wait"
                        },
                        "Done": {
                            "subject": "Data Export {{Label}}",
                            "message": "Export Ready"
                        },
                        "Failed": {
                            "subject": "Data Export Failed {{Label}}",
                            "message": "Export failed please try again"
                        }
                    },
                    "customizationGridExport": {
                        "InProgress": {
                            "subject": "Grid Export {{Label}}",
                            "message": "Generating grid export please wait"
                        },
                        "Done": {
                            "subject": "Grid Export {{Label}}",
                            "message": "Export Ready"
                        },
                        "Failed": {
                            "subject": "Grid Export Failed {{Label}}",
                            "message": "Export failed please try again"
                        }
                    },
                    "areasUpdateAddresses": {
                        "InProgress": {
                            "subject": "Update Address Areas",
                            "message": "Updating addresses please wait"
                        },
                        "Done": {
                            "subject": "Update Address Areas",
                            "message": "Update addresses done"
                        },
                        "Failed": {
                            "subject": "Update Address Areas Failed",
                            "message": "Update addresses failed please try again"
                        }
                    },
                    "pricingExport": {
                        "InProgress": {
                            "subject": "Export Pricing ({{PriceListCode}} v{{PriceListVersion}})",
                            "message": "Exporting. please wait"
                        },
                        "Done": {
                            "subject": "Export Pricing ({{PriceListCode}} v{{PriceListVersion}})",
                            "message": "Export Result - {{Urls.length}} File(s)"
                        },
                        "Failed": {
                            "subject": "Export Pricing ({{PriceListCode}} v{{PriceListVersion}})",
                            "message": "Export Failed. {{Error}}"
                        }
                    },
                    "pricingImport": {
                        "InProgress": {
                            "subject": "Import Pricing ({{PriceListCode}})",
                            "message": "Importing from {{DocumentCount}} File(s). please wait"
                        },
                        "Done": {
                            "subject": "Import Pricing ({{PriceListCode}})",
                            "message": "Import complete for {{DocumentCount}} File(s)."
                        },
                        "Failed": {
                            "subject": "Import Pricing ({{PriceListCode}})",
                            "message": "Import Failed."
                        }
                    }
                },
                "toasts": {
                    "activityMissingSkill": "Activity {{Subject}} booked for {{Representative}} may be missing a skill",
                    "invoiceCreated": "Invoice for {{Prompt}} processed",
                    "invoiceCreateFailed": "Invoice Failed {{Prompt}}",
                    "supplyJobCreated": "Supply jobs for {{Prompt}} processed",
                    "supplyJobCreateFailed": "Supply jobs for {{Prompt}} has errors",
                    "confirmJobValidationInvalidStage": "Unable to validate job {{Prompt}}, job is currently being edited",
                    "confirmJobValidationErrors": "Job {{Prompt}} has some errors",

                },
                "operators": {
                    "eq": "Equals",
                    "ne": "Does not equal",
                    "ge": "Is greater than or equal to",
                    "le": "Is less than or equal to",
                    "gt": "Is greater than",
                    "lt": "Is less than",
                    "startswith": "Begins with",
                    "endswith": "Ends with",
                    "isempty": "Is empty",
                    "isnotempty": "Is not empty",
                    "in": "Is one of",
                    "notin": "Is not one of",
                    "within": "Is with in days",
                    "relative": "Relative",
                    "anygt": "Any after",
                    "anyge": "Any at or after",
                    "anylt": "Any before",
                    "anyle": "Any at or before",
                    "allin": "All are one of",
                    "allgt": "All after",
                    "allge": "All at or after",
                    "alllt": "All before",
                    "allle": "All at or before",
                    "nonein": "None are one of",
                    "exactlyin": "Exactly these stages"
                },
                "months": {
                    "1": "Jan",
                    "2": "Feb",
                    "3": "Mar",
                    "4": "Apr",
                    "5": "May",
                    "6": "Jun",
                    "7": "Jul",
                    "8": "Aug",
                    "9": "Sep",
                    "10": "Oct",
                    "11": "Nov",
                    "12": "Dec",
                },
                "application": {
                    "errors": {
                        "error_ai_limit_reached": "Your AI limits have been reached for the month.",
			"error_company_code_must_be_unique": "Company code {{Code}} is already used by {{ExistingCompanyName}}",
                        "error_message_max_size_exceeded": "The maximum message size has been exceeded. Please review the size of attachments for this order.",
                        "error_payment_unconfirm_finance_transferred": "This payment has already been transferred to your finance system and cannot be unconfirmed.",
                        "error_payment_unconfirm_css_payment": "Customer Self Service payments cannot be unconfirmed.",
                        "error_payment_unconfirm_external_payment": "Merchant Payments cannot be unconfirmed.",
                        "error_invoice_contact_changed_finance_transferred": "This invoice has already been transferred to your finance system so the contact cannot be changed. You may need to cancel the invoice.",
                        "error_invoice_date_changed_finance_transferred": "This invoice has already been transferred to your finance system so the invoice date cannot be changed. You may need to cancel the invoice.",
                        "error_invoice_date_prior_finance_lock_date": "Invoice date must be after the finance lock date",
                        "error_payment_date_prior_finance_lock_date": "Payment date must be after the finance lock date",
                        "error_payment_receiptno_finance_maxlength_exceeded": "Receipt No '{{ReceiptNo}}' exceeds Max Length of '{{ReceiptNoFinanceMaxLength}}' characters supported by Finance Provider. Please update the Receipt No so it does not exceed '{{ReceiptNoFinanceMaxLength}}' characters",
                        "error_payment_receiptno_duplicate": "Another Payment with the same Receipt Number '{{ReceiptNo}}' already exists",
                        "error_css_dispatch_link_without_activity": "This template can only be sent from a dispatch activity",
                        "error_close_unexpected_disptach_activity": "Cannot process this activity there is another open activity {{StartDate, dateTime}} - {{Subject}}",
                        "error_overlapping_customer_availability": "The start and end time overlaps with another",
                        "error_cannot_open_non_quote": "This job is already confirmed to an order and is no longer a quote.",
                        "workflow": {
                            "NotSupportedJobLineWorkflowState_AccessRequirdToApproveCM": "Approval access required to complete this action.",
                            "NotSupportedJobLineWorkflowState_HasCheckMeasureAppointment": "Check measure appointment already exists.",
                            "NotSupportedJobLineWorkflowState_HasCheckMeasure": "Check measure already in place.",
                            "NotSupportedJobLineWorkflowState_HasCheckMeasureInprogress": "Check measure already in progress please complete check measure first.",
                            "NotSupportedJobLineWorkflowState_MustStartOrByPassCM": "Must start or bypass the check measure.",
                            "NotSupportedJobLineWorkflowState_JobIsAlreadyConfirmed": "This job is already confirmed.",
                            "NotSupportedJobLineWorkflowState_SupplyLineShouldNotExist": "Supply line should not exist.",
                            "NotSupportedJobLineWorkflowState_CannotReceiptLineWithActiveCM": "Cannot receipt line with an active check measure.",
                            "NotSupportedJobLineWorkflowState_CannotDispatchLineWithActiveCM": "Cannot dispatch line with an active check measure.",
                            "NotSupportedJobLineWorkflowState_CannotMoveLineToSupplyWithActiveCM": "Cannot move line to supply with an active check measure.",
                            "NotSupportedJobLineWorkflowState_CannotConfirmLineWithActiveCM": "Cannot confirm line with an active check measure.",
                            "NotSupportedJobLineWorkflowState_CannotSendToSupplyWithActiveCM": "Cannot send to supply with an active check measure.",
                            "NotSupportedJobLineWorkflowState_CannotDeleteCMWithActiveCM": "Cannot delete while a check measure is active.",
                            "NotSupportedJobLineWorkflowState_LineIsAlreadyConfirmed": "This line is already confirmed.",
                            "NotSupportedJobLineWorkflowState_LineIsAlreadyUnConfirmed": "This line is already unconfirmed.",
                            "NotSupportedJobLineWorkflowState_LineIsNotInCMStage": "This line is not in the check measure stage.",
                            "NotSupportedJobLineWorkflowState_LineRequiresCM": "This line requires a check measure.",
                            "NotSupportedJobLineWorkflowState_LineIsInCMNotBookedStage": "Line is in check measure stage but not booked.",
                            "NotSupportedJobLineWorkflowState_LineIsNotInSupplyPendingStage": "Line is not in supply pending stage.",
                            "NotSupportedJobLineWorkflowState_LineDoesNotRequireCM": "This line does not require a check measure.",
                            "NotSupportedJobLineWorkflowState_LineIsNotInSupplyStage": "Line is not in supply stage.",
                            "NotSupportedJobLineWorkflowState_LineIsInCMBookedStage": "Line is in check measure booked stage.",
                            "NotSupportedJobLineWorkflowState_LineIsAlreadyDispatch": "Line is already in dispatch.",
                            "NotSupportedJobLineWorkflowState_LineIsAlreadyInvoicing": "Line is already in invoicing process.",
                            "NotSupportedJobLineWorkflowState_LineIsAlreadySupply": "Line is already in supply.",
                            "NotSupportedJobLineWorkflowState_LineIsAlreadySupplyPending": "Line is already in supply pending status.",
                            "NotSupportedJobLineWorkflowState_LineIsNotConfirmed": "Line is not confirmed.",
                            "NotSupportedJobLineWorkflowState_LineAlreadySupplied": "Line has already been supplied.",
                            "NotSupportedJobLineWorkflowState_LineOrJobStatusInvalidForSending": "Line or job status is invalid for sending.",
                            "NotSupportedJobLineWorkflowState_LineIsUnconfirmedCM": "Line is unconfirmed in check measure.",
                            "NotSupportedJobLineWorkflowState_JobIsNotInCM": "Job is not in check measure stage.",
                            "NotSupportedJobLineWorkflowState_LineIsInRestocked": "Line is in restocked stage.",
                            "NotSupportedJobLineWorkflowState_LineNotReceived": "Line has not been received.",
                            "NotSupportedJobLineWorkflowState_LineNotRestocked": "Line has not been restocked.",
                            "NotSupportedJobLineWorkflowState_LineHasInvoice": "Line has an associated invoice.",
                            "NotSupportedJobLineWorkflowState_JobMaybeInCMOrLineHasInvoice": "Job may be in check measure or line has an invoice.",
                            "NotSupportedJobLineWorkflowState_CannotRestockServiceLine": "Cannot restock service line.",
                            "NotSupportedJobLineWorkflowState_LineIsInRestockedConsumed": "This action cannot be performed on a line that has already been consumed.",
                            "NotSupportedJobLineWorkflowState_LineIsInRestockedDiscarded": "This action cannot be performed on a line that has already been discarded.",
                            "NotSupportedJobLineWorkflowState_NeedToCancelSupplyJob": "Need to cancel the supply job.",
                            "NotSupportedJobLineWorkflowState_DispatchNotProcessed": "Dispatch has not been processed.",
                            "NotSupportedJobLineWorkflowState_LineIsOnHold": "Line is on hold."
                        }
                    },
                    "title": "Insyte Web",
                    "companyOnHold": {
                        "badge": "On Hold",
                        "place": "Place On Hold",
                        "release": "Release On Hold"
                    },
                    "sms": {
                        "to": "Mobile Number",
                        "send": "Send"
                    },
                    "whatsapp": {
                        "to": "WhatsApp Number",
                        "send": "Send"
                    },
                    "menu": {
                        "showHideContext": "Show/Hide Context",
                        "login": "Log in",
                        "logoff": "Log Off",
                        "changePassword": "Change Password",
                        "changeProfile": "Edit Profile",
                        "dashboard": "Dashboard",
                        "calendar": "Calendar",
                        "activities": "Activities",
                        "myKey": "My Key",
                        "sales": "Sales",
                        "leads": "Leads",
                        "settings": "Settings",
                        "management": "Management",
                        "customizations": "Customizations",
                        "productManagement": "Products",
                        "reports": "Reports",
                        "training": "Connect to Training",
                        "production": "Connect to Live",
                        "help": "Help",
                        "new": " New ",
                        "lead": " Lead",
                        "job": " Job",
                        "supply": " Supply",
                        "home": "Home",
                        "company": "Company",
                        "tracking": " Tracking",
                        "supplyJobs": " Supply",
                        "payment": " Payment",
                        "refund": " Refund",
                        "finance": " Finance",
                        "commissions": " Commissions",
                        "marketing": " Marketing",
                        "activity": " Activity",
                        "invoice": " Invoice",
                        "wholesaleOrder": " Wholesale Order",
                        "creditNote": " Credit Note",
                        "serviceJob": " Service Job",
                        "inbox": " Inbox",
                        "workflowInbox": " Workflow",
                        "savedGrids": "Grids",
                        "savedReports": "Reports",
                        "whatsNewTooltip": "Whats New",
                        "supportTooltip": "Help and Support"
                    },
                    "buttons": {
                        "apply": "Apply",
                        "configure": "Configure",
                        "fees": "Fees",
                        "hold": "Hold",
                        "release": "Release",
                        "restock": "Restock",
                        "unrestock": "Undo Restock",
                        "insert": "Insert",
                        "assign": "Assign",
                        "priceHistory": "Price History",
                        "runComparisonReport": "Run Comparison Report",
                        "downloadComparisonReport": "Download Comparison Report",
                        "productSpecification": "Specification",
                        "productSpecificationDownload": "Export Specification",
                        "productSpecificationUpload": "Import Specification",
						"publish": "Publish",
						"printSettings": "Print Settings",
                        "create": "Create",
                        "upgradeProducts": "Upgrade Products",
                        "collectPayment": "Collect Payment",
                        "test": "Test",
                        "update": "Update",
                        "upload": "Upload",
                        "taxRateLookups": "Tax Rate Lookups",
                        "moveToSupply": "Send",
                        "invoice": "Invoice",
                        "detach": "Detach",
                        "promotions": "Promotions",
                        "applyPromotions": "Apply Promotions",
                        "downloadModels": "Download Models",
                        "newVersion": "New Version",
                        "generateLink": "Generate Link",
                        "bookService": "Book Service Call in Calendar",
                        "bookServiceMaps": "Book Service Call with Maps",
                        "migrate": "Migrate",
                        "pay": "Pay",
                        "run": "Run",
                        "continueWithoutSignature": "Continue without signature",
                        "completeInstall": "Complete Appt.",
                        "previewStatement": "Preview Statements",
                        "emailStatement": "Email Statements",
                        "markAsPaid": "Mark As Paid",
                        "exportSummary": "Summary Export",
                        "createNextRun": "Create Next Run",
                        "showDiscounts": "Show Discounts",
                        "clearDiscounts": "Clear All Discounts",
                        "approveDiscount": "Approve Discount",
                        "viewSmsQueue": "View SMS Queue",
                        "setAlterProduct": "Set Alter Product",
                        "setTaxCode": "Set Tax Code",
                        "setFinanceItemCode": "Set Finance Provider Product Code",
                        "setFinancePayMethod": "Set Finance Provider Payment Method",
                        "setCategory": "Set Category",
                        "auditLog": "Audit History",
                        "recordInfo": "Record Info",
                        "clearAlterProduct": "Clear Alter Product",
                        "docs": "Documentation",
                        "skipCM": "Skip Check Measure",
                        "startCM": "Start Check Measure",
                        "viewOtherCM": "View Other Check Measure",
                        "approveCM": "Approve Check Measure",
                        "completeCM": "Complete Check Measure",
                        "completeActivity": "Complete Activity",
                        "enableSupport": "Click to Enable Support Access",
                        "disableSupport": "Click to Disable Support Access",
                        "disable2Factor": "Click to Disable 2 Factor Auth",
                        "manage2Factor": "Click to Manage 2 Factor Auth",
                        "enable2Factor": "Click to Enable 2 Factor Auth",
                        "sendTestEmail": "Send Test Email",
                        "sendTestSms": "Send Test SMS",
                        "marketplace": "Marketplace",
                        "sendTestWhatsApp": "Send Test WhatsApp Message",
                        "bold": "Bold",
                        "italic": "Italic",
                        "discard": "Discard",
                        "setAsDraft": "Override Draft",
                        "editDraft": "Edit Draft",
                        "add": "Add",
                        "reset": "Reset",
                        "editJob": "Edit Job",
                        "finishEditJob": "Finish Edit",
                        "fabricOptimisation": "Optimise Fabrics",
                        "showMeHow": "Show me how",
                        "dismiss": "Dismiss",
                        "snooze": "Snooze",
                        "attach": " Attach",
                        "document": " Document",
                        "file": " File",
                        "sketch": " Sketch",
                        "allocate": " Allocate",
                        "unAllocate": " Un-Allocate",
                        "newCustomMadeProduct": "New Custom Made Product",
                        "parts": "Parts",
                        "fabrics": "Fabrics",
                        "newMultiProduct": "New Multi Product",
                        "new": " New",
                        "edit": " Edit",
                        "delete": " Delete",
                        "view": " View",
                        "changeBusinessUnit": "Change Business Unit",
                        "unconfirm": " Unconfirm",
                        "editProduct": " Edit Product",
                        "editPricing": " Edit Pricing",
                        "editReportSettings": "Edit Reports",
                        "insertField": " Insert Field",
                        "email": " Email",
                        "sendQuote": " Send Quote",
                        "closeOrReciept": "Close/Receipt",
                        "undo": " Undo",
                        "close": " Close",
                        "back": " Go Back",
                        "open": " Open",
                        "ok": "OK",
                        "openParent": "Go to Parent",
                        "search": "Search",
                        "previous": "Previous",
                        "yes": "Yes",
                        "no": "No",
                        "previewSupplySheets": "Preview Supply Sheets",
                        "installTimes": "Est. Install Time",
                        "sortLines": "Sort Lines",
                        "download": " Download",
                        "remove": "Remove",
                        "cancel": " Cancel",
                        "clearAll": " Clear All",
                        "completeAppointment": " Mark as Completed",
                        "reOpenAppointment": " Re-Open",
                        "uncancelAppointment": " Uncancel Appointment",
                        "cancelAppointment": " Cancel Appointment",
                        "finish": " Finish",
                        "next": " Next",
                        "save": " Save",
                        "copy": " Copy",
                        "closeJobsWidthWarnings": "Close Jobs (Including warnings)",
                        "closeJobsWithoutWarning": "Close Jobs",
                        "duplicate": " Duplicate",
                        "removeConfig": "Remove Configuration",
                        "select": " Select",
                        "selectItem": " Select {{item}}",
                        "selectItems": " Select ({{count}})",
                        "toggleDetails": " Details",
                        "actions": "Actions",
                        "review": " Review",
                        "refresh": " Refresh",
                        "recapture": " Recapture",
                        "priceJob": " Price Job",
                        "priceDetails": "Price Details",
                        "costSummary": "Job Costing Summary",
                        "priceSupplyJob": " Price",
                        "adjustSupplyCosts": " Adjust Costs",
                        "confirmQuote": " Confirm Quote",
                        "confirmRemainder": "Confirm Lines",
                        "discounts": " Discounts",
                        "abandoned": " Abandoned",
                        "print": " Print",
                        "schedule": " Schedule",
                        "newShowroomQuote": "New Showroom Quote",
                        "scheduleInCalendar": " Schedule in Calendar",
                        "scheduleWidthMaps": " Schedule with Maps",
                        "scheduleCheckMeasureWithCalendar": " Check Measure in Calendar",
                        "scheduleCheckMeasureWithMaps": " Check Measure with Maps",
                        "bookCheckMeasureWithCalendar": " Book CM in Calendar",
                        "bookCheckMeasureWithMaps": " Book CM with Maps",
                        "bookInstallWithCalendar": " Book Intall in Calendar",
                        "bookInstallWithMaps": " Book Intall with Maps",
                        "scheduleInstallWithCalendar": " Install in Calendar",
                        "scheduleInstallWithMaps": " Install with Maps",
                        "send": " Send",
                        "sendRegistrationEmail": " Send Registration Email",
                        "syncCalendar": " Update Phone Calendar",
                        "reopenJob": " Re-Open Job",
                        "reopenSupplyJob": " Re-Open",
                        "orderAgain": " Order Again",
                        "reopenQuote": " Re-Open",
                        "reOpenWithRePrice": "Re-Open and Refresh Price",
                        "reOpenNoRePrice": "Re-Open and Match Price",
                        "reQuote": " Re-Quote",
                        "reOpenJob": " Re-Open Order",
                        "holdJob": " On Hold",
                        "unHoldJob": " Off Hold",
                        "quoteLost": " Opportunity Lost",
                        "copyAddress": " Copy Address",
                        "newQuote": " New Quote",
                        "newServiceJob": " New Service Job",
                        "openServiceJob": " Open Service",
                        "openOriginalJob": "Open Job",
                        "discardChanges": "Discard Changes",
                        "editChanges": "Edit Changes",
                        "saveChanges": "Save Changes",
                        "getSendFile": "Download Send File",
                        "newCustomer": " New Customer",
                        "undoCancel": " Undo Cancel",
                        "login": " Submit",
                        "submit": " Submit",
                        "sendCode": " Send Code",
                        "bulkChange": " Bulk Change",
                        "preview": " Preview",
                        "viewNotify": " View Notifications",
                        "notNow": " Not Now",
                        "export": "Export",
                        "import": " Import",
                        "useDefaultTemplate": "Replace with Default Template",
                        "useDefaultTemplateKeepOptions": "Replace with Default Template (Keep Product Options)",
                        "downloadDefaultTemplate": "Download Default Template",
                        "uploadTemplate": "Upload a Template",
                        "override": "Override",
                        "showHidden": "Show Hidden",
                        "fulfillment": "Move to Supply",
                        "resendToSupply": "Resend to Supply",
                        "emailInvoice": "Email Invoice",
                        "closeJob": "Close the Job",
                        "saveAndClose": "Save and Close",
                        "viewInCalendar": "View in Calendar",
                        "createNew": "Create New",
                        "viewJobList": "View Job List",
                        "details": "Details",
                        "confirmPayment": "Confirm Payment",
                        "unconfirmPayment": "Unconfirm Payment",
                        "processPayment": "Process Payment",
                        "forceFinanceTransfer": "FORCE ON TO TRANSFER QUEUE",
                        "resetFinanceTransferState": "RESET TRANSFER STATE",
                        "financeItemsOpenIn": "Open in {{provider}}",
                        "financeItemsRemap": "Remap Insyte Contact To Another Customer in {{provider}}",
                        "selectAll": " Select All",
                        "selectNone": " Deselect All",
                        "linkAccount": "Link Account",
                        "status": "Status",
                        "cancelPayment": "Cancel Payment",
                        "confirm": "Confirm",
                        "confirmAndSign": "Sign and Confirm"
                    },
                    "controls": {
                        "accentLicensePackageSummary": {
                            "labelTotalQty": "Total Qty",
                            "labelRemainingQty": "Remaining Qty",
                            "updatePackage": "Update Package",
                            "updatePackageTooltip": "Please Log Off and In for package changes to become visible."
                        },
                        "productParams": {
                            "reorderDisabledTooltip": "Remove sort and filter to enable reordering"
                        },
                        "configFilter": {
                            all: "ALL",
                            all_tooltip: "Displays all product options",
                            quote: "QUOTE",
                            quote_tooltip: "Displays product options required for quoting",
                            order: "ORDER",
                            order_tooltip: "Displays product options required for ordering",
                            invalid: "INVALID",
                            invalid_tooltip: "Displays product options that are invalid",
                            userSet: "USER",
                            userSet_tooltip: "not used",
                            calculations: "CALC",
                            calculations_tooltip: "Displays all calculations",
                            changed: "CHANGED",
                            changed_tooltip: "Displays product options that have changed since last save"
                        }
                    },
                    "dialogs": {
                        "activityCancelDlg": {
                            "title": "Cancel Activity",
                            "indexOfTotal": "{{index}} of {{total}}",
                            "skipActivityButton": "Skip",
                            "keepActivityButton": "Back",
                            "reasonLabel": "Reason *",

                            "notesLabel": "Notes (optional)",
                            "opportunityLostPrompt": "Is the Opportunity Lost?",
                            "outcomeReasonLabel": "Outcome Reason *",
                            "confirmButton": "Cancel Activity",
                            "nextButton": "Next",
                            "cancelledReasonLabel": "Reason",
                            "cancelledByLabel": "Cancelled By",
                            "cancelledNotesLabel": "Notes",
                            "cancelledNoDetails": "This activity has been cancelled."
                        },
                        "warnFinanceAnomaliesProcess": {
                            "title": "WARNING",
                            "msg": "This action will prevent this record from being transferred automatically."
                        },
                        "warnContactMatchReconfigure": {
                            "title": "WARNING",
                            "msg": "There is already a {{provider}} contact matched to this Insyte contact. Remapping will only affect future transfers; existing transferred items will not be remapped.",
                            "msgQuickBooks": "To affect previously transferred items, you will need to \"Merge contacts\" in QuickBooks."
                        },
                        "warnMultiLineDelete": {
                            "title": "WARNING",
                            "msg": "The following {{count}} lines will be deleted. {{lines}}"
                        },
                        "warnMultiLineUnconfirm": {
                            "title": "WARNING",
                            "msg": "The following {{count}} lines will be unconfirmed. {{lines}}"
                        },
                        "completeCMDlg": {
                            "title": "Completed Items"
                        },
                        "jobOnHoldDlg": {
                            "title": "On Hold Lines",
                            "noLines": "No lines available",
                        },
                        "upgradeProducts": {
                            "title": "Upgrade Products",
                            "allProducts": "All",
                            "item": "Item",
                            "qty": "Qty",
                            "location": "Location",
                            "option": "Option",
                            "selectedQty": "Selected Qty"
                        },
                        "productFabricsImport": {
                            "title": "Product Fabrics Import",
                            "fabricCategories": "Fabric Categories",
                            "fabrics": "Fabrics",
                            "groupCodeHandling": "Group Code Handling",
                            "groupCodeDefault": "Default when not set",
                            "groupCodeReplace": "Override to",
                            "groupCode": "Group Code",
                            "groupCodes": "Group Codes",
                            "summary": "Summary"
                        },
                        "productExtrasImport": {
                            "title": "Import Extras",
                        },
                        
                        "jobOnHoldErrorDlg": {
                            "title": "Cannot place job on hold",
                            "hasCMBooked": "A check measure exists and will need to be deleted first.",
                            "hasCMInprogress": "A check measure is currently in progress and will need to be completed first.",
                            "hasDispatch": "A dispatch appointment exists and will need to be deleted first.",
                            "hasStockConsumed": "One or more lines has Stock Consumed and will need to be excluded.",
                            "hasStockDiscarded": "One or more lines has Discarded Stock and will need to be excluded.",
                            "hasEdit": "Job has line in edit, please finish edit first",
                        },
                        "unconfirmWarning": {
                            "title": "Related Records",
                            "invoice": "Line has invoice",
                            "supply": "Line has supply job",
                            "activites": "Line has one or more activities",
                            "removeActivities": "Line is last line linked to {{count}} activities. These activities will be removed",
                            "removeActivity": "Line is last line linked to {{count}} activity. This activity will be removed",
                            "msg": "Click unconfirm to REMOVE the line from these items and continue",
                        },
                        "restockLine": {
                            "title": "Retock Job Line",
                            "locationsLabel": "Stock Location"
                        },
                        "jobInstallNotesDlg": {
                            "title": "Job Install Notes"
                        },
                        "reassignAppointments": {
                            "title": "Reassign Appointments"
                        },
                        "bulkAssignLeads": {
                            "title": "Bulk Assign Leads"
                        },
                        "installPlannerDlg": {
                            "title": "Installer Planner"
                        },
                        "snoozeNotificationDlg": {
                            "title": "Snooze Notification"
                        },
                        "displayUrlDlg": {
                            "title": "Viewer"
                        },
                        "sketch": {
                            "title": "Sketch",
                            "sketchName": "Description"

                        },
                        "cssStringDlg": {
                            "code": "String Key",
                            "language": "Language",
                            "value": "Value"
                        },
                        "setProductTaxCode": {
                            "title": "Set Product Tax Code",
                        },
                        "setProductCategory": {
                            "title": "Set Product Category",
                        },
                        "setProductFinanceItem": {
                            "title": "Set Finance Provider Product Code"
                        },
                        "setFinanceProviderPaymentMethod": {
                            "title": "Set Finance Provider Payment Method"
                        },
                        "finishEditJob": {
                            "title": "Review Edit Changes",
                            "selectPriceInfo": "The sales price of the job has changed. Please select the appropriate price action to take. Note variances are based on the before edit values.",
                            "changesInfo": "Please review changes",
                            "affectsInfo": "The following items may be affected by this change.",
                            "salePriceInc": "Sale Price Inc",
                            "salePriceIncChange": "Variance",
                            "margin": "Margin",
                            "marginChange": "Variance",
                            "matchOriginalQuotePrice": "Match Quote price",
                            "matchCurrentQuotePrice": "Match Quoted price (excluding unconfirmed lines)",
                            "matchPriceBeforeEdit": "Match Before Edit price",
                            "matchCurrentPriceBeforeEdit": "Match Before Edit price (excluding unconfirmed lines)",
                            "useNewPrice": "Keep new price",
                            "updatingPrice": "Updating price please wait.",
                            "pricingTitle": "Confirm Pricing",
                            "reviewTitle": "Review Changed",
                            "affectsTitle": "Warnings",
                            "keepPriceDecisionInfo": "The margin on the following lines has changed by more than the allowed threshold. Please choose for each line whether to keep the before edit price or use the new price.",
                            "keepPriceAllKeptInfo": "All {{count}} lines will keep their before edit price. Margin change is within the allowed threshold.",
                            "keepPriceNoLinesInfo": "There are no priced lines to review.",
                            "keepPriceColLine": "Line",
                            "keepPriceColProduct": "Product",
                            "keepPriceColBeforePrice": "Before Edit Price",
                            "keepPriceColBeforeMargin": "Before Edit Margin",
                            "keepPriceColKeptMargin": "Margin If Kept",
                            "keepPriceColNewPrice": "New Price",
                            "keepPriceColNewMargin": "New Margin",
                            "keepPriceColPriceDiff": "Change",
                            "keepPriceColDecision": "Decision",
                            "keepPriceKeep": "Keep price",
                            "keepPriceUseNew": "Use new price",
                            "keepPriceNewLine": "New line",
                            "keepPriceRemovedLine": "Removed",
                            "keepPriceKeepAll": "Keep all",
                            "keepPriceUseNewAll": "Use new all",
                            "keepPriceShowAutoKept": "{{count}} line(s) kept automatically (within threshold) - show",
                            "keepPriceHideAutoKept": "{{count}} line(s) kept automatically (within threshold) - hide",
                            "keepPriceShowMargins": "Show margins",
                            "keepPriceHideMargins": "Hide margins",
                            "keepPriceResultingTotal": "Resulting Total",
                            "keepPriceResultingMargin": "Resulting Margin",
                            "keepPriceUseJobActions": "Match a whole job price instead (quote / before edit)",
                            "keepPriceUseLineDecisions": "Back to line by line decisions",
                        },
                        "selectSketch": {
                            "title": "Select Sketch",
                        },
                        "moveToSupply": {
                            "title": "Generate and Send to Supply",
                            "selectedQty": "Selected Qty",
                            "canMove": "Ready for supply",
                            "inEdit": "Is being edited",
                            "validationErrors": "Has validation errors",
                            "requireCM": "Check measure pending",
                            "inSupply": "Already in supply",
                            "dispatched": "Has already been dispatched",
                            "dispatch": "Is in dispatch stage",
                            "restock": "Has been restocked",
                            "onHold": "Is on hold",
                            "companyOnHoldWarn": "Company is on hold (override allowed)",
                            "companyOnHoldBlocked": "Company is on hold",
                            "hasSupplyNotesWarning": "Job or line(s) have supply notes",
                            "hasError": "1 or more lines not ready",
                            "ready": "All ready for supply",
                            "noAccess": "You do not have permission. Please see you administrator."
                        },
                        "moveToSupplyCreditLimitExceeded": {
                            "title": "Credit Limit Exceeded",
                            "msgShort": "Company Credit Limit Reached/Exceeded",
                            "msg": "The outstanding total of {{outstandingTotal}} exceeds this company's credit limit of {{creditLimit}}. You do not have permission to exceed the credit limit.",
                            "msgCanProceed": "The outstanding total of {{outstandingTotal}} exceeds this company's credit limit of {{creditLimit}}.",
                            "creditLimitOverrideFileNote": "Credit Limit Check Overridden by {{user}}"
                        },
                        "companyOnHold": {
                            "confirmBlockedTitle": "Company On Hold",
                            "confirmBlockedMsg": "This company is on hold and you do not have permission to confirm this job.",
                            "confirmWarnTitle": "Company On Hold",
                            "confirmWarnMsg": "This company is on hold. Do you want to override and confirm this job?",
                            "confirmBlocked": "Company is on hold. You do not have permission to confirm this job.",
                            "supplyBlocked": "Company is on hold. You do not have permission to send this job to supply.",
                            "placeTitle": "Place Company On Hold",
                            "releaseTitle": "Release Company From Hold",
                            "reasonLabel": "Reason",
                            "reasonPlaceholder": "Select a reason...",
                            "notesLabel": "Notes",
                            "notesPlaceholder": "Enter notes...",
                            "reasonRequired": "A reason is required.",
                            "notesRequired": "Notes are required."
                        },
                        "selectLinesToInvoice": {
                            "title": "Select For Invoicing",
                            "selectedQty": "Selected Qty",
                            "noLines": "There are no remaining lines to invoice"
                        },
                        "signature": {
                            "title": "Capture Signature"
                        },
                        "detachMultiProductDlg": {
                            "title": "Detach line from group",
                            "msg": "This action will detach this line from the group. This action cannot be undone."
                        },
                        "onExcludeExistingMultiLineDlg": {
                            "title": "Exclude Existing Job Line",
                            "msg": "Existing confirmed job lines cannot be excluded here. Please separate the line and unconfirm it from the job screen"
                        },
                        "restoreCustomDocumentVersionTitle": "Restore version to draft",
                        "restoreCustomDocumentVersionConfirmMsg": "Warning: Current draft changes will be lost",
                        "failedToImportCustomDocumentDraftTitle": "Import Failed",
                        "failedToImportCustomDocumentDraftMsg": "Import failed please check the file format.",
                        "toolbarSaveErrorTitle": "Error saving",
                        "defaultChanged": "Default Business Changed",
                        "failedToImportLookupTableTitle": "Import Failed",
                        "failedToImportLookupTableMsg": "Please check the file format, text is not too long and products/representatives exist.",
                        "lookupTableExportNoDataTitle": "Export Failed",
                        "lookupTableExportNoDataMsg": "No entries to export.",
                        "failedToImportCommissionValuesTitle": "Import Failed",
                        "failedToImportCommissionValuesMsg": "Import failed please check the file format.",
                        "requireMarginApprovalTitle": "Discount Approval",
                        "requireMarginApprovalMsg": "Discount requires approval before continuing.",
                        "requireServiceJobFeatureTitle": "Permissions",
                        "requireServiceJobFeatureMsg": "You do not have permission to create service jobs, please contact your administrator to enable feature.",
                        "checkDiscountsTitle": "Confirm Discounts Required",
                        "checkDiscountsMsg": "Job discounts may have changed, click 'Show Discounts' to view and confirm discounts.",
                        "noDiscountPermission": "Discounting Permissions Required",
                        "noDiscountPermissionMsg": "Access to the Discounting feature is required to perform this action.",
                        "noOriginalLine": "No Original Line",
                        "noOriginalLineMsg": "There is no associated original line with this line",
                        "completeCMInprogressTitle": "Check Measure In-Progress",
                        "completeCMInprogressMsg": "This check measure is already in progress and was not completed. Check measures must be completed from the job page.",
                        "closeItemsSkippkedTitle": "Some Activites Skipped",
                        "completeCMsInprogressMsg": "Not all check measures were closed due to being in-progress.",
                        "installHasCMPendingTitle": "Pending Checkmeasures",
                        "installHasCMPendingMultiMsg": "Not all dispatch appointments were closed due to pending check measures.",
                        "installHasCMPendingMsg": "This dispatch appointment cannot be closed due to pending check measures.",
                        "warnSignatureTitle": "No Signature Captured",
                        "warnSignatureMsg": "Warning if you continue a signature will not be captured. Click cancel to go back.",
                        "confirmWithPromotionsTitle": "Partial Confirm",
                        "confirmWithPromotionsMsg": "This job has promotions and cannot be patrially confirmed.",
                        "activityAddProductsSucessTitle": "Update Activity",
                        "activityAddProductsSucessMsg": "{{AddedCount}} lines(s) added",
                        "activityAddProductsFailTitle": "Update Activity",
                        "activityAddProductsFailMsg": "Failed to add products",
                        "confirmCreateNewSupplySheetTitle": "Create New Supply Sheet",
                        "confirmCreateNewSupplySheetMsg": "This product does not have a supply sheet. Do you want to create a new supply sheet?",
                        "productSelectionTitle": "Select a Product",
                        "confirmCompleteFinishEditTitle": "Validation Errors",
                        "confirmCompleteFinishEditMsg": "The job has some validation errors. Do you want to continue?",
                        "selectRepTitle": "Select Representative",
                        "selectRepMsg": "Please select a representative and try again",
                        "reopenQuoteTitle": "Re-Open Expired\\Lost Quote",
                        "reopenQuoteMsg": "This action will re-open the quote.",
                        "jobRequireOppTitle": "Opportunity Link Required",
                        "jobRequireOppMsg": "Opportunity link is required for jobs that are not linked to wholesale companies.",
                        "payRollNoDataTitle": "No Commission Data",
                        "payRollNoDataMsg": "No commission data to export.",
                        "confirmPayCommissionsTitle": "Mark Run as Paid",
                        "confirmPayCommissionsMsg": "WARNING: This action cannot be undone. Click Pay to mark commission run as paid",
                        "commissionErrorTitle": "Commission Error",
                        "estimatedCommissionsTitle": "Estimated Commissions",
                        "noCommissionsTitle": "No Commission",
                        "noCommissionsMsg": "This job has been marked as no sales commission.",
                        "matchCompanyPaymentTermsTitle": "Update Payment Terms",
                        "matchCompanyPaymentTermsMsg": "Company has changed, do you want to use the payment terms from {{ Company }}?",
                        "matchSiteContactAddressTitle": "Update Site Address from Site Contact",
                        "matchSiteContactAddressMsg": "Site Contact has changed, do you want to update the job site address from contact?",
                        "matchContactAddressTitle": "Update Address from Contact",
                        "matchContactAddressMsg": "Contact has changed, do you want to update the address from the contact?",
                        "quickAuthTitle": "Authorize",
                        "quickAuthPassword": "Password",
                        "quickAuthPasswordInvalid": "The password you have entered is invalid",
                        "teamInUseTitle": "Team in use",
                        "priceDetailsTitle": "Price Details",
                        "costSummaryTitle": "Job Costing Summary",
                        "teamInUseMsg": "This team is currently assigned to one or more users. Please ensure the team is not assigned to any users before deactivating the team. This can be done from the Manage Teams view",
                        "roleInUseTitle": "Role in use",
                        "roleInUseMsg": "This role is currently assigned to one or more users or used by workflow rules. Please remove assignments/usages before deactivating the role.",
                        "activityRepRequiredTitle": "Representative Required",
                        "activityRepRequiredMsg": "Please assign the activity to a Representative before trying again",
                        "missingDataTitle": "Required Fields",
                        "missingDataMsg": "Please complete all required fields",
                        "locationServicesOffTitle": "Location services is Disabled",
                        "locationServicesOffMsg": "Please turn on location services.",
                        "firstFinanceTransferTitle": "First Finance Transfer",
                        "firstFinanceTransferMsg": "This is your first finance transfer. On the first transfer no journals will be sent to your finance system, any finance movements from this point on will be journaled to your finance system.",
                        "existingShowroomQuoteTitle": "Existing Showroom Quote",
                        "existingShowroomQuoteMsg": "A job already exists. Do you want to create a new Quote?",
                        "existingSalesApptTitle": "Existing Sales Appointment",
                        "existingSalesApptMsg": "An open sales appointment already exists. Do you want to view it in the calendar or schedule a new appointment?",
                        "changeAPIKeyTitle": "Generate new API Key",
                        "changeAPIKeyMsg": "Generating a new API Key will in-activate you existing one. Do you want to continue?",
                        "notLicensedForFinanceIntegrationTitle": "No License",
                        "notLicensedForFinanceIntegrationMsg": "Your current license package does not allow for Finance Integration",
                        "jobInvoicedSupplyWarningTitle": "Job Invoiced/Supply",
                        "jobInvoicedSupplyWarningMsg": "Warning: This job has Invoices or Supply Jobs",
                        "getETATitle": "Update ETA",
                        "getAlterTagsTitle": "Alter Tags",
                        "confirmCloseJob": "Close Job",
                        "confirmCloseJobMsg1": "The following Job(s) are not in Invoicing Stage and will be closed.",
                        "confirmCloseJobMsg2": "Note: Closing jobs will close related Check Measures and Dispatch Appointment.",
                        "confirmCloseJobMsg3": "Are you sure you want to continue?",
                        "unsavedchangesTitle": "Unsaved Changes",
                        "unsavedchanges": "You have unsaved changes.",
                        "missingRequireFields": "You are missing some required fields.",
                        "newVersionTitle": "New Version",
                        "newVersionMsg": "A new version has been detected. Click OK to reload.",
                        "requireBUTitle": "Require Additional License",
                        "requireBUMsg": "Please upgrade your license package to include our Business Unit module.",
                        "whatsThis": "Whats this?",
                        "sendSupplyJob": "Send Supply Job",
                        "sendSupplyJobMsg": "You are about to automatically send the Supply Job. Click Send to continue.",
                        "sendSupplyJobSucessfullMsg": "Supply Job Sent",
                        "sendSupplyJobFailedMsg": "Supply failed to send. Please try again later or contact your administrator. ",
                        "confirmQuoteFailedTitle": "Confirm Quote",
                        "sendUserRegEmailSuccessTitle": "Send Registration Email",
                        "sendOrderFailed": "Could not email order at this time.",
                        "deleteActivityTitle": "Delete Activity",
                        "deleteActivityMsg": "Are you sure you want to delete this activity?",
                        "deletePriceMarkupTitle": "Delete Markup",
                        "deletePriceMarkupSelectMsg": "Please select a markup to delete first.",
                        "deletePriceMarkupConfirmMsg": "You are about to delete markup {{product}}. Do you want to continue?",
                        "deleteAutomationTitle": "Delete Automation",
                        "deleteAutomationSelectMsg": "Please select an Automation to delete first.",
                        "deleteAutomationConfirmMsg": "You are about to delete Automation {{ name }}. Do you want to continue?",
                        "deleteOrderLineTitle": "Delete Line",
                        "deleteOrderLineSelectMsg": "Please select a line to delete first.",
                        "deleteOrderLineConfirmMsg": "You are about to delete line {{line}}. Do you want to continue?",
                        "deleteJobLineTitle": "Delete Line",
                        "deleteJobLineConfirmMsg": "You are about to delete line {{line}}. Do you want to continue?",
                        "unconfirmJobLineTitle": "Unconfirm Line",
                        "unconfirmJobLineConfirmMsg": "You are about to unconfirm line {{line}}. Do you want to continue?",
                        "deleteTemplateTitle": "Delete Template",
                        "deleteTemplateResponseTitle": "Delete Template Response",
                        "deleteTemplateSelectMsg": "Please select a Template to delete first.",
                        "deleteTemplateResponseSelectMsg": "Please select a Template Response to delete first.",
                        "deleteTemplateConfirmMsg": "You are about to delete template {{desc}}. Do you want to continue?",
                        "deleteTemplateResponseConfirmMsg": "You are about to delete template response {{desc}}. Do you want to continue?",
                        "deleteLookupTitle": "Delete Lookup entry",
                        "deleteLookupSelectMsg": "Please select an entry to delete first.",
                        "deleteLookupConfirmMsg": "You are about to delete the selected lookup entry. Do you want to continue?",
                        "deleteCustomDocumentTitle": "Delete Custom Document",
                        "deleteCustomDocumentSelectMsg": "Please select a Custom Document to delete first.",
                        "deleteCustomDocumentConfirmMsg": "You are about to delete Custom Document {{name}}. Do you want to continue?",
                        "copyOrderLineTitle": "Validation",
                        "copyOrderLineMsg": "Cannot duplicate line as one or more fields are required. Please complete the required fields before trying again.",
                        "copyJobLineTitle": "Validation",
                        "copyJobLineMsg": "Cannot duplicate line as one or more fields are required. Please complete the required fields before trying again.",
                        "amendmentNotAllowedTitle": "Paid Run",
                        "amendmentNotAllowedMsg": "Amendments cannot be created againts paid runs. Please create amendment in an unpaid run.",
                        "amendmentNoRunTitle": "Run not found",
                        "amendmentNoRunMsg": "No active commission run could be. Please create a new run for the amendment.",
                        "promotionsRemovedTitle": "Promotions Removed",
                        "promotionsRemovedMsg": "One or more promotions have been removed due to product changes. Please review promotions before continuing.",
                        "jobLineValidForCopyTitle": "Linked Service Line",
                        "jobLineValidForCopyMsg": "This service line is linked to another job line and cannot be copied",
                        "viewValidationTitle": "Validation",
                        "viewValidationMsg": "One or more fields are required.",
                        "startOfWeekRefreshTitle": "Refresh Required",
                        "startOfWeekRefreshMsg": "For start of week change to take affect a refresh will be required. Click refresh to refresh now",
                        "licensingTitle": "Licensing",
                        "licQuoteCalendar": "Your current licensing does not allow for quoting from the calendar.",
                        "licExportCalendar": "Your current licensing does not allow for exporting the calendar.",
                        "loading": "Loading",
                        "errorSavingFileNote": "Error in saving file note.",
                        "errorSavingWizardData": "Error in saving wizard data.",
                        "addNew": "Add new {{type}}",
                        "updatingPhoneCalendar": " Updating Phone Calendar",
                        "calendarSyncTitle": "Update Phone Calendar",
                        "calendarSyncComplete": " Phone calendar update complete. Please note it may take a few minutes for your phone to update.",
                        "requireFeatureAllowSyncCalendar": "Please enable the 'Allow Sync Calendar' feature for this user.",
                        "completeActivityTitle": "Mark Appointment as Completed",
                        "completeActivityMsg": "Clicking on 'Complete' will mark the appointment as done.",
                        "existingCMInprogressTitle": "Another Check Measure In-Progress",
                        "existingCMInprogressMsg": "Another check measure has already been started for this job. Please complete the other check measure before starting a new one.",
                        "existingEditInprogressTitle": "Edit In-Progress",
                        "existingEditInprogressMsg": "You cannot start this check measure because the Job is already being edited. Please contact the office.",
                        "reOpenActivityTitle": "Mark Appointment as Open",
                        "reOpenActivityMsg": "Clicking on 'Open' will mark the appointment as open.",
                        "uncancelActivityTitle": "Uncancel Appointment",
                        "uncancelActivityMsg": "Clicking on 'Open' will uncancel the appointment and restore it to an open state.",
                        "pleaseWait": "Please wait.",
                        "overrideTemplateTitle": "Override Existing Template",
                        "overrideTemplateConfirmMsg": "Uploading a new template will override your existing one. Click Overide if you want to continue.",
                        "linesInErrorTitle": "Product Lines",
                        "linesInErrorEmailQuoteMsg": "Some products have errors. All errors need to be addressed before emailing the quote to the customer",
                        "activityInvalidProductsTitle": "Invalid Products",
                        "activityInvalidProductsMsg": "One or more selected products is not valid. Please fix the products before trying again.",
                        "emailSent": "Email Sent",
                        "sendTestWhatsAppMessageTitle": "Send Test WhatsApp Message",
                        "sendMethodDlg": {
                            "sendQuote": "Send Quote",
                            "description": "Choose how you would like to send this quote to your customer.",
                            "emailTitle": "Email",
                            "emailDescription": "Send via email with PDF attachment and custom message",
                            "whatsAppTitle": "WhatsApp",
                            "whatsAppDescription": "Send via WhatsApp Template with document link"
                        }
                    },
                    "general": {
                        "notificationsSnooze": "Snooze Notification",
                        "trialBanner": "You have {{days}} day(s) remaining on your free demo.",
                        "trialBannerExpired": "Your free demo has EXPIRED.",
                        "trialBannerSignupLink": "Click here to sign-up now and get 30 Days Free.",
                        "addressLocatorTitle": "Locate Address on Map",
                        "requestFeatureTitle": "Make a suggestion or request feature or ask a question",
                        "pleaseWait": "Please wait.",
                        "mapCoordinateIndication": "A tick indicates if the address has map coordinates.",
                        "invalidPhoneFormat": "Not a recognized phone format",
                        "invalidEmailFormat": "Not a recognized email format",
                        "userDoesNothavePermissionDlgTitle": "Permission Error",
                        "userDoesNothavePermissionDlg": "Oops! You do not have permission to access this resource. Click OK to continue.",
                        "searchForAddress": "Search for address",
                        "addressLinesPlaceHolder": "street and number...",
                        "addressCityPlaceHolder": "",
                        "addressStateSubArea1PlaceHolder": "",
                        "addressStatePlaceHolder": "",
                        "addressPostcodePlaceHolder": "",
                        "addressCountryPlaceHolder": "",
                        "fileNotes": "File Notes",
                        "fileNotesPlaceHolder": "Enter new file note",
                        "emailAttachments": "Attachments",
                        "emailTo": "To",
                        "smsTo": "To",
                        "smsTemplate": "Template",
                        "smsLimits": "Long SMS messages will consume additional SMS credits. Messages up to 160 characters will cost 1 credit, after that every 153 characters will cost an addition credit.\ni.e.\n1 - 160 = 1 SMS Credit\n161 - 306 = 2 SMS Credits\n307 - 459 = 3 SMS Credits\netc.",
                        "smsNotConfigured": "You cannot send an SMS as you have not configured an SMS gateway",
                        "emailFrom": "From",
                        "emailSubject": "Subject",
                        "emailBody": "Body",
                        "emailCopyMe": "Copy me ({{email}})",
                        "emailQuote": "Email Quote",
                        "whatsAppQuote": "Send Quote via WhatsApp",
                        "emailOrderConfirmation": "Email Order",
                        "emailInvoice": "Email Invoice",
                        "emailOrder": "Send Order",
                        "emailReplyTo": "Reply To",
                        "emailTemplate": "Email Template",
                        "smsTemplate": "SMS Template",
                        "whatsAppTemplate": "WhatsApp Template",
                        "documentTemplate": "Document Template",
                        "emailMissing": "EMAIL MISSING!!!",
                        "notifications": "Notifications",
                        "notificationsEmptyMessage": "You currently have no notifications",
                        "progressUpload": "Uploading...",
                        "progressConfirmQuote": "Confirming quote...",
                        "progressSendEmail": "Sending email...",
                        "progressCancelOrder": "Cancelling order...",
                        "progressUndoCancelOrder": "Undo cancel order...",
                        "progressCopyLines": "Duplicating line...",
                        "progressCreateQuote": "Creating Quote...",
                        "progressSendOrders": "Sending Order(s)...",
                        "progressSavingQuote": "Saving Quote...",
                        "progressSaving": "Saving...",
                        "progressSavingSettings": "Saving Settings...",
                        "progressUpdatePrice": "Updating price...",
                        "progressReopenOrder": "Opening Order...",
                        "progressReQuote": "Re-Quoting...",
                        "progressPleaseWait": "Please Wait...",
                        "pricingJobPleaseWait": "Pricing job, please Wait...",
                        "fileTooLarge": "File {{file}} too large!!!",
                        "emptyFile": "File {{file}} is empty!!!",
                        "fileNameTooLong": "File name {{file}} too long. Max Length is {{maxLength}}",
                        "fileTypeNotAllowed": "File type {{type}} is not allowed",
                        "rateView1Title": "{{name}} Page Feedback",
                        "rateView1Message": "Click thumbs down to indicate the {{viewName}} page needs improvement or click on cancel to close the rating dialog.",
                    },
                    "message": {
                        "retry": "Resend selected messages",
                        "delete": "Delete selected messages",
                        "prev": "Previous",
                        "next": "Next",
                        "start": "Start",
                        "end": "End",
                        "query": "Search",
                        "noMessagesSelectTitle": "No selected messages",
                        "noMessagesSelectMsg": "Please select one or more messages",
                        "noAuthMethodSelectTitle": "No authentication method selected",
                        "noAuthMethodSelecttMsg": "Please select one or authentication methods",
                    },
                    "status": {
                        "Failed": "Failed",
                        "Sent": "Sent",
                        "Pending": "Pending",
                    },
                },
                "wizards": {
                    "changeBusinessUnit": {
                        "title": "Change Business Unit",
                        "opportunities": "Opportunities",
                        "jobs": "Jobs",
                        "invoices": "Invoices",
                        "description": "The following item(s) will be updated",
                        "selectNewBusinessUnit": "New Business Unit",
                        "updateAddress": "Update Job Delivery Addressed"
                    },
                    "setReceivedQty": {
                        "title": "Received Quantity",
                        "receiveAll": "Receive All",
                        "unreceiveAll": "Unreceive All",
                        "noLines": "There are no valid lines to receive on this job"
                    },
                    "setInstallTimes": {
                        "title": "Estimated Installation Times"
                    },
                    "columnChooser": {
                        "title": "Select Columns"
                    },
                    "moveToDispatched": {
                        "page01Title": "Mark as having been dispatched",
                        "ready": "Will be marked as Dispatached",
                        "requireCMs": "Require Check Measures to be completed",
                        "requireInstall": "Require Dispatch appointments to be scheduled",
                        "installs": "Has uncompleted dispatch appointments (WARNING: dispatch appointments will be closed)",
                        "requireSupply": "Goods have not been received",
                        "restocked": "Has been restocked. Cannot be dispatched",
                        "dispatched": "Already been dispatched (will be skipped)",
                        "reference": "Reference",
                        "product": "Product",
                        "force": "Force Anyway",
                        "qty": "Qty",
                        "selectedQty": "Selected Qty",
                        "jobInEdit": "Job is in edit mode and cannot be selected",
                        "noAccess": "You do not have permission. Please see you administrator."
                    },
                    "scheduleActivity": {
                        "page01Title": "Please confirm products to schedule",
                        "validation": {
                            "productHasErrors": "Product has warnings...",
                            "notRequired": "Is not required for {{ActivityType}}",
                            "hasPendingService": "Has a pending service and cannot be selected",
                            "hasExisting": "Has existing {{ActivityType}} activity",
                            "hasExistingInst": "Has existing {{ActivityType}} or has already been dispatched",
                            "isInSupply": "Line already in supply",
                            "hasBeenReceipted": "Is ready for dispatch or has already been dispatched",
                            "selectedQty": "Selected Qty",
                            "hasCMUnconfirmed": "Has been unconfirmed in an existing Check Measure",
                            "isRestockItem": "Item has been restocked and cannot be dispatched",
                            "hasExistingOpenActivities": "Has existing open activities. [{{list}}]"
                        }
                    },
                    "jobLineSort": {
                        "lines": {
                            "title": "Set Line Order"
                        },
                        "products": {
                            "title": "Set Product Order"
                        }
                    },
                    "closeJobWizard": {
                        "page01Title": "Close Jobs",
                        "blockerMessage": "One or more job(s) cannot be closed due to open related records. Please close or cancel related records before trying again. For unconfirmed payments you can either confirm or unallocate the payment",
                        "warningInvoiceMessage": "Warning,  one or more job/lines has not been invoiced. You will not be able to invoice a closed job. Click on Close Jobs (Including warnings) to close these job(s) anyway.",
                        "warningServiceJobsMessage": "Warning,  one or more jobs has related service jobs. Click on Close Jobs (Including warnings) to close these job(s) anyway.",
                        "warningOnHoldMessage": "Warning,  one or more job lines are on hold. Closing these job(s) will also close the on hold lines. Click on Close Jobs (Including warnings) to close these job(s) anyway.",
                        "okMessage": "The following job(s) will be closed.",
                    },
                    "bulkUpdateWiz": {
                        "title": "BULK CHANGE",
                        "page1Title": "PRODUCT",
                        "page2Title": "CHANGES",
                        "page3Title": "REVIEW",
                        "page4Title": "UPDATING",
                        "next": "Next",
                        "info_1": "Select lines to bulk change. Note only one product can be changed at a time",
                        "info_2": "Only select values that you want change.",
                        "info_3": "Please wait, your quote is being updated.",
                        "errorLineRequired": "Please select at least one line to update",
                        "errorInComplete": "Please wait for all lines to complete or you may loose your changes.",
                        "inProgress": "Updating...",
                        "done": "Done",
                        "noProducts": "This job does not have any products that can be bulk updated",
                        "supplementaryChargesTitle": "Supplementary Charges"
                    },
                    "productPrintSettings": {
                        "title": "{{product}} Report Settings",
                        "showSelected": "Show Visible",
                        "selectAll": "Select All",
                        "clearAll": "Clear All",
                        "option": "Product Option",
                        "show": "Show",
                        "select": "Select {{group}}",
                        "settings": "Settings",
                        "showFabricWidth": "Show Fabric Width",
                        "showPatternRepeat": "Show Pattern Repeat"
                    },
                    "sendEmail": {
                        "email": {
                            "title": "Email Preview",
                            "titleMobile": "Email",
                        },
                        "preview": {
                            "title": "Document Preview",
                            "titleMobile": "Document",
                        }
                    },
                    "sendSms": {
                        "sms": {
                            "title": "Send SMS"
                        }
                    },
                    "sendWhatsApp": {
                        "whatsApp": {
                            "title": "WhatsApp Preview",
                            "titleMobile": "WhatsApp"
                        },
                        "preview": {
                            "title": "Document Preview",
                            "titleMobile": "Document",
                        }
                    },
                    "completeDispatch": {
                        "title": "Complete Dispatch",
                        "noAction": "None",
                        "faultAction": "Please create service job",
                        "hasServiceJobLink": "Linked to Service Job"
                    },
                    "newLead": {
                        "title": "New Lead Wizard",
                        "customerSearch": {
                            "title": "1. Customer Search",
                            "newCustomer": "New Customer",
                            "existingCustomer": "New Lead for {{CustomerName}} {{CompanyName}}",
                            "selectedCustomer": "Selected Customer"
                        },
                        "customerDetails": {
                            "title": "2. Billing Details",
                            "contactTitle": "Billing Contact for {{Company}}"
                        },
                        "siteContact": {
                            "title": "3. Site Contact",
                            "selectBillingContact": "Billing Contact ({{FullName}})",
                            "selectContact": "{{FullName}}",
                            "selectOther": "Other",
                            "selectExisting": "Select",
                            "linkToCompany": "Link to Company ({{Name}})",
                            "matchTitle": "Possible Existing Matches",
                            "clearMatch": "Clear Selected Match ({{FullName}})",
                        },
                        "siteAddress": {
                            "title": "4. Site Address",
                            "selectBillingContact": "Billing Contact ({{FullName}})",
                            "selectContact": "{{FullName}}",
                            "selectOther": "Other",
                            "siteAddress": "Site Address"
                        }
                    },
                    "editJob": {
                        "page01Title": "Edit Job",
                        "page01Message": "The Job {{reference}} for customer {{contactName}} has supply jobs. Changes to the job may affect supply jobs with the following Supplier(s).",
                        "confirmSuppliersContacted": "Warning changes made to the job may affect existing supply jobs. Continue anyway."
                    },
                    "cancelActions": {
                        "page01Title": "Cancellation Wizard",
                        "page01Message": "The $t({{Type}}) ({{Description}}) could not be cancelled as it has related items. Complete this wizard to finalize the cancellation.",
                        "page02Title": "Cancellation Wizard",
                        "page02Message": "WARNING you are about to perform the following actions. Which may not be reversible.",
                        "page01Blocked_1": "STOP: Job {{Description}} has active service jobs and cannot be cancelled. Please cancel related jobs first.",
                        "types": {
                            "payment": "Payment",
                            "refund": "Refund",
                            "payments": "Payments",
                            "paymentBalanceDraft": "Draft Payment Balance",
                            "paymentBalanceConfirmed": "Confirmed Payment Balance",
                            "job": "Job",
                            "invoice": "Invoice",
                            "invoices": "Invoices",
                            "creditNote": "Credit Note",
                            "supplyJobs": "Supply Jobs",
                            "supplyJob": "Supply Job"
                        },
                        "reminders": {
                            "supplyJob": "Remind me to notify the supplier",
                        },
                        "descriptions": {
                            "cancelPayment": "The following payments will be cancelled",
                            "cancelJob": "Cancel the job.",
                            "cancelInvoice": "Cancel the invoice.",
                            "cancelSupplyJob": "Cancel the supply job. (Warning your suppliers will need to be manually notified by you as they will not be sent any automatic notifications. They may also have begun manufacturing and you may still incur a cost.)",
                            "refundPayment": "Refund payment to customer (will generate a refund)",
                            "refundPaymentBalance": "Refund balance to customer (will generate a refund)",
                            "refundCreditNote": "Refund credit note to customer (will generate a refund)",
                            "cancelCreditNote": "Cancel the credit note",
                            "cancelPartialCreditNote": "Cancel the credit note. (Warning this will affect other invoices too)",
                            "clearCreditNote": "Clear credit note allocations (will leave the credit against the customer and remove allocations to any jobs or invoices)",
                            "clearAllocations": "Clear allocations (will un-allocate the payment from the job or invoice and leave it as a payment against the customer)",
                            "clearPaymentBalanceAllocations": "This will leave the balance as Credit against the customer",
                            "clearPaymentBalanceAllocationsInvoice": "This will leave the balance allocated to the Job or as Credit against the customer"
                        }
                    },
                    "setupWizard": {
                        "page01Title": "Setup myinsyte...",
                        "page01Message": "Please take a minute to configure your new system",
                        "page02Title": "Setup - General",
                        "page02Message": "Configure your default settings...",
                        "logo": "Logo",
                        "businessPH": "Business Ph",
                        "timeZone": "Time Zone",
                        "page03Title": "Setup - Sales",
                        "page03Message": "Configure your default sales information...",
                        "defaultPriceMarkup": "Default Price Markup",
                        "taxCodeMgs": "Every sales item requires a tax rate. A tax rate with 0% tax has automatically been configured for you. Enter below your default sales tax.",
                        "taxCodeEg": "e.g.GST and 10 for a tax code called GST with a rate of 10%",
                        "taxCode": "Tax Code",
                        "taxRate": "Tax Rate %",
                        "page04Title": "Setup - Complete",
                        "page04Message": "Click on finish to save your settings",
                    },
                    "lostOpportunityWizard": {
                        "quoteOutcomReason": "Outcome Reason",
                        "outcomeNotes": "Outcome Notes",
                        "outcomeNotesPlaceHolder": "Enter any outcome notes...",
                        "page01Title": "Lost Reason",
                        "page01Message": "Select the reason the opportunity was lost",
                        "page01MessageNotAllowed": "This opportunity cannot be marked as lost because the following Job need to be cancelled first",
                        "page01MessageHasQuotes": "The following quotes will All be closed off and marked as lost",
                        "cancelOpenActivities": "Cancel open activities",
                        "activityCancelReason": "Activity Cancel Reason",
                        "openActivitySummary": "Open activities: {{summary}}"
                    },
                    "newContactWizard": {
                        "firstName": "First Name",
                        "lastName": "Last Name",
                        "workPhone": "Work Phone",
                        "homePhone": "Home Phone",
                        "mobile": "Mobile",
                        "email": "Email",
                        "company": "Company",
                        "companyName": "Name",
                        "companyEmail": "Email",
                        "companyPhone": "Phone",
                        "companyAccountType": "Account Type",
                        "companyBusinessNumber": "Business Number",
                        "companyMobile": "Mobile",
                        "companyWWW": "WWW",
                        "contactHeader": "Contact:",
                        "contactSiteAddressHeader": "Contact Address:",
                        "companyHeader": "Company:",
                        "companyAddressHeader": "Address:",
                        "page01Title": "New Contact",
                        "page01Message": "Please fill in the contact information",
                    },
                    "invoiceWizard": {
                        "page01Title": "New Invoice",
                        "page01Message": "Create a new BLANK invoice linked to...",
                        "page01JobMessage": "Current job {{Reference}}",
                        "page01ContactMessage": "Contact {{FullName}}",
                        "page01OtherMessage": "Other"
                    },
                    "paymentWizard": {
                        "page01Title": "New Payment",
                        "page01Message": "Create a new payment for...",
                        "page01JobMessage": "Current job {{Reference}}",
                        "page01ContactMessage": "Contact {{FullName}}",
                        "page01OtherMessage": "Other"
                    },
                    "newServiceJob": {
                        "page01Title": "New Service Job",
                        "page01Message": "Create a new service job for...",
                        "page01JobMessage": "Current job {{Reference}}",
                        "page01ContactMessage": "For contact {{Contact}}",
                        "page01OtherMessage": "Other"
                    },
                    "newServiceLine": {
                        "page01Title": "New Service Line",
                        "page01Message": "Please select the line type",
                        "page01Service": "Service",
                        "page01Remake": "Remake",
                        "page01Warranty": "Warranty",
                        "page01Alter": "Alteration",
                        "page01LinkExisting": "Link Existing Line",
                        "selectLine": "Select Existing Line",
                        "page01ExistingService": "WARNING: The selected line has a later service line on service job {{Reference}}",
                    },
                    "refundWizard": {
                        "page01Title": "New Refund",
                        "page01Message": "Create a new refund for...",
                        "page01JobMessage": "Current job {{Reference}}",
                        "page01ContactMessage": "Contact {{FullName}}",
                        "page01OtherMessage": "Other"
                    },
                    "creditNoteWizard": {
                        "page01Title": "New Credit Note",
                        "page01Message": "Create a new credit note for...",
                        "page01JobMessage": "Current job {{Reference}}",
                        "page01ContactMessage": "Contact {{FullName}}",
                        "page01OtherMessage": "Other",
                        "customerNamePlaceHolder": "Search Customer",
                        "page02Title": "New Credit Note",
                        "page02Message": "Enter the credit note details",
                        "description": "Description",
                        "amount": "Amount",
                        "taxRate": "Tax Rate",
                        "page03Title": "New Credit Note",
                        "page03Message": "Choose the action to be performed with the credit note",
                        "page03Transfer": "Apply to an existing invoice",
                        "page03Refund": "Refund to customer",
                        "page03None": "None (Not sure if this should even be an option)"
                    },
                    "linkOpportunityWizard": {
                        "page01Title": "Link Lead Details",
                        "page01SelectExistingMsg": "Select an existing Lead or create new",
                        "page01NewLine": "Create New - selecting this row will create a new lead",
                        "nextCreate": "Next",
                        "nextExisting": "Finish",
                        "page02Title": "Link Lead Details",
                        "page02LeadDetailsMsg": "Enter lead details",
                        "leadSourceLable": "Select a lead source",
                        "page02POIMsg": "Enter product of interest",
                        "visitedShowroomLable": "Visited Showroom"
                    },
                    "linkJobWizard": {
                        "page01Title": "Link Job Details",
                        "page01SelectExistingMsg": "Select a Job by clicking on the left hand side. Or select product by selecting on the right hand side.",
                        "select": "Select Job",
                        "reference": "Reference",
                        "job": "Job",
                        "salesRep": "Sales Rep",
                        "contact": "Contact",
                        "city": "City",
                        "type": "Type",
                        "stage": "Stage",
                        "product": "Product",
                        "orderDate": "Order Date",
                        "eta": "ETA",
                        "cmBy": "CM By",
                        "cmDate": "CM Date",
                        "instBy": "Dispatch By",
                        "instDate": "Dispatch Date"
                    },
                    "sendInvoiceWizard": {
                        "page01Title": "Send Invoices",
                        "page01Message": "Select the email and invoice templates to use.",
                        "email": "Send as Email",
                        "pdf": "Send in person or snail mail (pdf documents will be emailed to {{email}})",
                        "skip": "Skip (do not send at this time)",
                        "withEmail": "{{count}} job(s) have an email address",
                        "noEmail": "{{count}} job(s) do NOT have an email address",
                        "noJobs": "There were no jobs selected that could be invoiced",
                        "noAmount": "INFO: {{count}} job(s) do NOT have a sales amount",
                        "taxInclusive": "Show Tax Inclusive",
                        "sortLines": "Use job line sort"
                    },
                    "sendStatementWizard": {
                        "page01Title": "Email Statements",
                        "page01Message": "Select the email templates to use.",
                        "email": "Send as Email",
                        "pdf": "Send in person or snail mail (pdf documents will be emailed to {{email}})",
                        "skip": "Skip (do not send at this time)",
                        "withEmail": "{{count}} statements have an email address",
                        "noEmail": "{{count}} statements do NOT have an email address",
                        "noStatements": "There were no statements selected to be sent",
                        "statementTemplate": "Statement Template"
                    }

                },
                "views": {
                    "item": {
                        "title": "Item {{Name}}",
                        "outOfStockNotesPlaceHolder": "enter notes regarding out of stock"
                    },
                    "supplierItem": {
                        "title": "Supplier Item {{Name}}",
                        "outOfStockNotesPlaceHolder": "enter notes regarding out of stock"
                    },
                    "parts": {
                        "title": "Parts",
                        "import": {
                            "title": "Import Parts",
                            "info": "Import or update parts and supplier parts from spreadsheet"
                        }
                    },
                    "fabrics": {
                        "title": "Fabrics",
                        "import": {
                            "title": "Import Fabrics",
                            "info": "Import or update fabrics from spreadsheet"
                        }
                    },
                    "contacts": {
                        "import": {
                            "title": "Import Companies/Contacts",
                            "info": "Upload an Excel file containing a Company sheet and a Contact sheet. The import validates the entire workbook first; if there are errors, the returned file will include per-row errors in 'Import Result' and 'Import Errors' columns."
                        }
                    },
                    "fabric": {
                        "title": "Fabric - {{Name}}"
                    },
                    "productConfig": {
                        "Product": {
                            "ID": "ID",
                            "Active": "Active",
                            "AllowBrokenPacks": "Allow Broken Packs",
                            "AllowCustomPrice": "Allow Custom Price",
                            "AllowManufacturing": "Allow Manufacturing",
                            "AllowSupplier": "Allow Supplier",
                            "AppendPackCode": "Append Pack Code",
                            "AvailableForReselling": "Available For Reselling",
                            "Type": "Type",
                            "Barcode": "Barcode",
                            "BrokenPackSC": "Broken Pack SC",
                            "BrokenPackSCPercentage": "Broken Pack SC Percentage",
                            "BrokenPackUnits": "Broken Pack Units",
                            "BrokenPackWaivedOnPickup": "Broken Pack Waived On Pickup",
                            "BaseUnit": "Base Unit",
                            "AreaUnit": "Area Unit",
                            "VolumeUnit": "VolumeU nit",
                            "LinealUnit": "Linear Unit",
                            "BaseUnitFormat": "Base Unit Format",
                            "ProductPrecision": "Product Precision",
                            "FabricPrecision": "Fabric Precision",
                            "CanSell": "Can Sell",
                            "DiscontinuedDate": "Discontinued Date",
                            "ExtPictureLink": "External Picture Link",
                            "InnerQuantity": "Inner Quantity",
                            "InnerUnitID": "Inner Unit",
                            "InStockETA": "In Stock ETA",
                            "InventoryItemRequired": "Inventory Item Required",
                            "InventoryLotRequired": "Inventory Lot Required",
                            "InventoryRequired": "Inventory Required",
                            "MaxOrderLineQty": "Max Order Line Quantity",
                            "OutOfStock": "Out Of Stock",
                            "OutOfStockNotes": "Out Of Stock Notes",
                            "PricingOption1UseGroupCode": "Pricing Option 1 Use Group Code",
                            "PricingOption2UseGroupCode": "Pricing Option 2 Use Group Code",
                            "ProductCode": "Product Code",
                            "ProductName": "Product Name",
                            "ProductNotes": "Product Notes",
                            "Version": "Version",
                            "PricingGroupID": "Pricing Group",
                            "PricingOption1ID": "Pricing Option 1",
                            "PricingOption2ID": "Pricing Option 2",
                            "Groups": "Groups",
                            "DisplayOption1ID": "Display Option 1",
                            "DisplayOption2ID": "Display Option 2",
                            "DisplayOption3ID": "Display Option 3",
                            "DisplayOption4ID": "Display Option 4",
                            "DisplayOption5ID": "Display Option 5",
                            "DisplayOption6ID": "Display Option 6",
                            "DisplayOption7ID": "Display Option 7",
                            "DisplayOption8ID": "Display Option 8",
                            "DisplayOption9ID": "Display Option 9",
                            "DisplayOption10ID": "Display Option 10",
                            "OptimisationScript": "Optimisation Script",
                            "ProductSourceScript": "Product Source Script",
                            "ValidationScript": "Validation Script",
                            "SplitForInstallation": "Split For Installation",
                            "MaxRequiredInstallers": "Max Required Installers",
                            "RequiredInstallers": "Required Installers",
                            "InstallTime": "Installation Time (mins)",
                            "MaxInstallTime": "Max Installation Time (mins)",
                            "CheckMeasureTime": "Check Measure Time (mins)",
                            "MaxCheckMeasureTime": "Max Check Measure Time (mins)",
							"ProductSize": {
								"AllowedHeightList": "Allowed Height List",
								"AllowedWidthList": "Allowed Width List",
								"HeightMeasurementPricingType": "Height Measurement Pricing Type",
								"HeightMeasurementType": "Height Measurement Type",
								"MaxHeight": "Maximum Height",
								"Maxm2": "Maximum Area",
								"MaxWidth": "Maximum Width",
								"MinHeight": "Minimum Height",
								"Minm2": "Minimum Area",
								"MinWidth": "Minimum Width",
								"SizeRestriction": "Size Restriction",
								"SizeRestrictionOption": "Size Restriction Option",
								"WidthMeasurementPricingType": "Width Measurement Pricing Type",
								"WidthMeasurementType": "Width Measurement Type",
								"ProductID": "Product ID"
							}

                        },
                        "ProductOptionGroup": {
                            "Code": "Code",
                            "Description": "Description",
                            "Active": "Active",
                            "Notes": "Notes"
                        },
                        "ProductOption": {
                            "Code": "Code",
                            "Description": "Description",
                            "Active": "Active",
                            "LinkedProductID": "Linked Item",
                            "MandatoryQuoting": "Required for Quoting",
                            "Mandatory": "Required for Supply",
                            "DoNotCopy": "Don't copy when duplicating line",
                            "DisplayType": "Display Type",
                            "NotForWholesaleOrdering": "Don’t send to Marketplace",
                            "MyOption": "My Option",
                            "DefaultValue": "Default Value",
                            "DefaultSingleValue": "Default Single Value",
                            "AdditionalMFTime": "Additional MF Time",
                            "AdditionalMFLeadTime": "Additional MF Lead Time",
                            "AdditionalSupplyLeadTime": "Additional Supply Lead Time (Days)",
                            "DefaultOptionValueID": "Default Option Value",
                            "LinkValueCode": "Link Value Code",
                            "Calculated": "Calculation Only",
                            "DefaultIntegrationValueID": "Default Integration Value",
                            "DefaultOptionValueScript": "Default Value Script",
                            "CustomOptionScript": "Display Type Settings",
                            "MandatoryScript": "Required Script",
                            "ValidationScript": "Validation Script",
                            "CalculatedScript": "Calculation Only Script",
                            "Notes": "Notes",
                            "LengthSettings": "Length Settings",
                            "AreaSettings": "Area Settings",
                            "VolumeSettings": "Volume Settings",
                            "RequiredInstallers": "Required Installers",
                            "InstallTime": "Installation Time (mins)",
                            "CheckMeasureTime": "Check Measure Time (mins)",
                            "MinValue": "Minimum Value",
                            "MaxValue": "Maximum Value"
                        },
                        "ProductOptionValue": {
                            "Code": "Code",
                            "Description": "Description",
                            "Active": "Active",
                            "LinkedProductID": "Linked Item",
                            "GroupCode": "GroupCode",
                            "CustomValue": "CustomValue",
                            "IsEmptyValue": "Is Empty Value",
                            "NotForWholesaleOrdering": "Don’t send to Marketplace",
                            "AdditionalMFTime": "Additional MF Time (Mins)",
                            "AdditionalMFLeadTime": "Additional MF Lead Time (Days)",
                            "AdditionalSupplyLeadTime": "Additional Supply Lead Time (Days)",
                            "OutOfStock": "OutOfStock",
                            "InStockETA": "InStockETA",
                            "OutOfStockNotes": "OutOfStockNotes",
                            "DiscontinuedDate": "Discontinued Date",
                            "MinWidthDisplayException": "Minimum Width",
                            "MinHeightDisplayException": "Minimum Height",
                            "Minm2DisplayException": "Minimum Area",
                            "MaxWidthDisplayException": "Maximum Width",
                            "MaxHeightDisplayException": "Maximum Height",
                            "Maxm2DisplayException": "Maximum Area",
                            "DisplayExceptions": "Don't display values unless the size is within range",
                            "NotValidForOrdering": "Not Valid For Ordering",
                            "RequiredInstallers": "Required Installers",
                            "InstallTime": "Installation Time (mins)",
                            "CheckMeasureTime": "Check Measure Time (mins)",
							"Notes": "Notes"
						},
						"ProductParam": {
							"Code": "Code",
							"Description": "Description",
							"ParamType": "Type",
							"Notes": "Notes",
							"ScriptInterface": "Script Type"
						},
						"ProductParamValue": {
							"Cost": "Cost",
							"Description": "Description",
							"Width1": "Width 1",
							"Width2": "Width 2",
							"Height1": "Height 1",
							"Height2": "Height 2",
							"Sqm1": "Area 1",
							"Sqm2": "Area 2",
							"AnyOption": "Any Option",
							"LookupRangeID": "Lookup",
							"SupplierID": "Supplier",
							"LookupRangeInput": "Lookup Input",
							"LookupRangeInputCustomOptionID": "Custom Option Input",
							"ProductOptionID": "Option",
							"ProductOptionValueID": "Option Value",
							"ScriptData": "Script",
							"WidthOptionID": "Width Option",
							"HeightOptionID": "Height Option"
						},
						"ProductMember": {
							"Caption": "Caption",
							"ProductVersionID": "Product Version",
							"Required": "Required",
                            "CanBeSeparated": "Can Be Separated",
                            "InstallSequence": "Install Sequence",
                            "SizeLinked": "Size Linked"
                        }

                    },
                    "productManagement": {
                        "title": "Product Management"
                    },
                    "mobileCalendar": {
                        "warningUnconfirmed": "Appointment may not be confirmed with customer"
                    },
                    "marketplace": {
                        "title": "Marketplace",
                    },
                    "marketplaceSupplierClient": {
                        "title": "Marketplace Supplier Client {{MPKey}}",
                    },
                    "financeTransferAnomalies": {
                        "title": "Finance Transfer Issues"
                    },
                    "supplyChat": {
                        "title": "Supply Chats"
                    },
                    "skills": {
                        "title": "Skill",
                        "management": {
                            "title": "Skills",
                            "updateSalesSkills": "Bulk Update Sales Skills",
                            "updateFitterSkills": "Bulk		Update Fitter Skills",
                            "newSalesSkill": "Bulk Update Sales Skill",
                            "newFitterSkill": "Bulk Update Fitter Skill",
                            "exportSalesSkills": "Export Sales Skills",
                            "importSalesSkills": "Import Sales Skills",
                            "exportFitterSkills": "Export Fitter Skills",
                            "importFitterSkills": "Import Fitter Skills",
                            "salesSkills": "Sales Skills",
                            "fitterSkills": "Fitter Skills",
                            "skillsNotEnabled": "Skills are not enabled. Go to Settings (User Menu > Settings) and enable the Skills option, then refresh the browser. Note: it may take up to 30 seconds for the change to apply."
                        },
                        "representative": "Representative",
                        "product": "Product",
                        "byRepresentative": "By Representative",
                        "byProduct": "By Product"

                    },
                    "area": {
                        "title": "Area {{SalesArea}} - {{InstallArea}}",
                        "management": {
                            "title": "Areas",
                            "new": "New Area",
                            "export": "Export Areas",
                            "import": "Import Areas",
                            "updateAddresses": "Update Addresses",
                            "updateAddressesTooltip": "Will update existing addresses that does not have an associated area",
                            "updateAddressesConfirmTitle": "Update Addresses",
                            "updateAddressesConfirmMsg": "Click on Update to update all existing addresses that are not currently associated with an area",
                            "activeAreas": "Active Areas",
                            "inactiveAreas": "Inactive Areas",
                        },
                        "duplicateDlg": {
                            "title": "Duplicate",
                            "msg": "Duplicate Sales Area or Install Area. Another active area already exists with either this Sales Area or Install Area",
                            "ok": "OK"
                        },
                        "import": {
                            "title": "Import/Update Areas",
                            "info": "Importing may add new areas and or update existing areas. No Areas will be removed or inactivated"
                        },
                        "postcodeAreas": {
                            "title": "Postcode Areas"
                        }
                    },
                    "postcodeArea": {
                        "title": "Postcode Area",
                    },
                    "customerSelfServiceInstanceList": {
                        "title": "Configure Customer Self Service Integration",
                        "headerSection": "Customer Self Service Websites"
                    },
                    "customerSelfServiceSettings": {
                        "title": "Configure Customer Self Service Settings",
                        "companyName": "Company Name",
                        "companyEmail": "Company Email",
                        "companyWWW": "Company WWW",
                        "contactUsUrl": "Contact Us URL",
                        "provisionBtn": "Provision Customer Self Service Site",
                        "provisionSubdomain": "Enter a value that is meaningful to your company. It will form part of the URL for customer self service",
                        "download": "Download",
                        "currency": "Currency",
                        "provision": {
                            "resultTitle": "Setup Result",
                            "noLicense": "Your package does not include the customer self service module",
                            "urlMissing": "Please provide a valid url subdomain",
                            "notLiveRTL": "You require an active Insyte Web site",
                            "urlInUse": "This url is taken. Please choose another.",
                            "liveCSS": "You aleady have a site with this url. Click close to configure it or choose another url for a new site.",
                            "createdSchemaCSS": "Site is ready. Please complete the settings and assign the business unit(s) to activate it.",
                            "errorCreatingSchemaCSS": "An error occured while setting up your site. Please contact support.",
                            "undefined": "An error occured while setting up your site. Please contact support."
                        },
                        "emailSettings": {
                            "providerType": "Provider",
                            "server": "Server",
                            "enableSSL1": "SSL (STARTTLS)",
                            "enableSSL2": "HTTPS (TLS)",
                            "username": "Username",
                            "password": "Password",
                            "sender": "Sender",
                            "senderName": "Sender Name",
                            "resourcePrefix": "Email Logo URL"
                        },
                        "smsSettings": {
                            "providerType": "Provider",
                            "username": "Username",
                            "password": "Password",
                            "sender": "Sender",
                            "defaultCountry": "Default Country"
                        },
                        "securitySettings": {
                            "customer2FAPreferredMethod": "Customer 2FA Preferred Method",
                            "finalPaymentLinkExpiry": "Final Payment Link Expiry",
                            "merchantPaymentLinkExpiry": "Merchant Payment Link Expiry"
                        },
                        "payments": {
                            "add": "Add Payment Provider",
                            "reorder": "Edit Sort Order",
                            "edit": "Edit Values",
                            "defaultPaymentMethod": "Default Payment Method"
                        },
                        "documents": {
                            "unsignMinutes": "Window in minutes to allow customer to undo the signing",
                            "showCancelledDocuments": "Show Cancelled Signed Documents",
                            "notifySignedDocumentCancelled": "Notify Customer when a Signed Document is Cancelled",
                            "notifyPayableItemCancelled": "Notify Customer when a Quote/Order is Cancelled"
                        },
                        "maintenance": {
                            "reset": "Clicking RESET resent Customer Self Service Data. Data will be lost",
                            "resetBtn": "RESET",
                            "resetTitle": "Reset and Delete Data",
                            "resetMsg": "Click Reset to reset and delete customer serlf service data",
                            "resetDoneTitle": "Reset and Delete Data",
                            "resetDoneMsg": "It's done...well not yet as not implemented yet"
                        },
                        "file": {
                            "toLargeTitle": "Large File",
                            "toLargeMsg": "Max file size is 1MB please select a smaller file."
                        }
                    },
                    "companyPricelistMapping": {
                        "title": "Company Pricelist",
                        "product": "Product",
                        "pricelist": "Pricelist",
                        "existing": {
                            "title": "Error selection exists",
                            "message": "Selected product and pricelist already exists for this company"
                        }
                    },
                    "customerReportEdit":{
                        "title": "Custom Document Editor"
                    },
                    "userApiKey": {
                        "title": "User Api Key",
                    },
                    "signOut": {
                        "title": "Sign Out",
                    },
                    "supplySheetTemplate": {
                        "title": "Supply Sheet - {{Description}}"
                    },
                    "apiIntegration": {
                        "title": "Api Integration",
                        "header": "Api Keys",
                        "help": "Click here to view the Api Documentation",
                        "url": "API Endpoint - {{url}}",
                        "liveDiaryApi": {
                            "header": "Live Dirary API"
                        }
                    },
                    "documentView": {
                        "title": "Document ({{Description}})",
                    },
                    "documentTemplate": {
                        "title": "Document Template ({{Name}})",
                    },
                    "printSetting": {
                        "title": "Print Setting ({{Name}})",
                    },
                    "printSettings": {
                        "title": "Print Settings",
                    },
                    "automation": {
                        "title": "Automation {{Name}}",
                        "SmsDeliveryReceipt": "Require SMS Delivery Receipt",
                        "ScheduleTimeOfDay": "Time of day",
                        "deliveryReceiptWarning": "This may attract an additional charge per SMS"
                    },
                    "jobLine": {
                        "title": "Job Line {{JobLineNo}}",
                    },
                    "leadIntegrationSettings": {
                        "title": "Lead Integration",
                    },
                    "financeIntegrationSettings": {
                        "title": "Finance Settings",
                    },
                    "emailIntegrationSettings": {
                        "title": "Email Settings",
                        "businessUnitSettings": {
                            "title": "Business Unit Settings",
                            "businessUnit": "Business Unit"
                        }
                    },
                    "smsIntegrationSettings": {
                        "title": "Sms Settings",
                        "headerSection": "Sms Integration",
                        "businessUnitSettings": {
                            "title": "Business Unit Settings",
                            "businessUnit": "Business Unit"
                        }
                    },
                    "whatsappIntegrationSettings": {
                        "title": "Configure WhatsApp Integration",
                        "headerSectionAccounts": "WhatsApp Integration Accounts",
                        "headerSectionSettings": "WhatsApp Integration Business Unit Settings",
                        "templates": {
                            "title": "WhatsApp Template"
                        },
                        "buttons": {
                            "syncTemplates": "Sync WhatsApp Templates",
                            "syncTemplate": "Sync WhatsApp Template",
                            "setParameterValues": "Set WhatsApp Parameter Values"
                        },
                        "toggle": {
                            "sectionTitle": "WhatsApp Integration",
                            "activeTitle": "WhatsApp Integration is Active",
                            "inactiveTitle": "WhatsApp Integration is Inactive",
                            "activeDescription": "Your business can send and receive WhatsApp messages",
                            "inactiveDescription": "Enable to start using WhatsApp Business messaging",
                            "enabledBanner": "WhatsApp messaging is enabled for your organisation",
                            "enabledNoTemplatesWarning": "WhatsApp messaging is enabled, but no templates are configured. We recommend creating templates to send marketing messages and notifications to customers.",
                            "disabledBanner": "WhatsApp messaging is currently disabled",
                            "disabledTooltip": "To enable WhatsApp, you must first connect at least one WhatsApp account and configure at least one phone number.",
                            "disableWarningTitle": "Disable WhatsApp Integration?",
                            "disableWarningMessage": "Disabling WhatsApp integration will have the following effects: (1) You will no longer be able to send messages via WhatsApp, (2) You will no longer be able to receive messages via WhatsApp, and (3) All existing WhatsApp chats will become read-only. Are you sure you want to continue?",
                            "disableConfirmButton": "Disable Integration",
                            "saveFailedTitle": "Failed to Update",
                            "saveFailedMessage": "An error occurred while updating the WhatsApp integration status.",
                            "noTemplatesDialog": {
                                "title": "No WhatsApp Templates Found",
                                "message": "We strongly recommend creating at least one WhatsApp template before enabling the integration. Would you like to continue anyway?",
                                "continue": "Continue Anyway"
                            }
                        },
                        "phoneNumber": {
                            "dialogTitle": "Configure Phone Number",
                            "saveFailedMessage": "An error occurred while saving the configuration.",
                            "tabs": {
                                "general": "General",
                                "businessUnits": "Business Units",
                                "visitBusinessUnitsStart": "ℹ️ Please visit the",
                                "visitBusinessUnitsEnd": "tab to complete the configuration."
                            },
                            "fields": {
                                "account": "WhatsApp Account *",
                                "phoneNumber": "Phone Number *",
                                "pin": "Create PIN (6 digits) *",
                                "confirmPin": "Confirm PIN *",
                                "displayName": "Display Name *",
                                "defaultTeam": "Default Team",
                                "defaultRep": "Default Representative"
                            },
                            "placeholders": {
                                "selectAccount": "Select account...",
                                "selectPhone": "Select phone number...",
                                "selectTeam": "Select team...",
                                "selectRep": "Select representative...",
                                "displayName": "e.g., Sales Line"
                            },
                            "loading": {
                                "accountDetails": "Loading account details..."
                            },
                            "routing": {
                                "title": "Message Routing (Optional)",
                                "description": "Assign new incoming messages to a team or representative. If neither is selected, messages will go to Unassigned.",
                                "or": "— OR —",
                                "hint": "💡 Only one can be selected. Representative takes priority."
                            },
                            "pin": {
                                "bannerTitle": "Create a PIN for this phone number",
                                "create": "Create a 6-digit PIN to register this phone number with WhatsApp.",
                                "notStored": "This PIN will NOT be stored in our system.",
                                "saveSecure": "You may need it for future administrative actions in WhatsApp Manager, so please save it somewhere secure.",
                                "confirmMismatch": "PINs do not match",
                                "confirmMismatchDescription": "⚠️ PINs do not match. Please ensure both fields contain the same PIN and are numbers only.",
                                "important": "Important: ",
                                "writePin": "Write down this PIN and store it securely. We will not save it, and you may need it to manage this phone number in Meta Business Manager. If you lose it, you'll need to reset it through WhatsApp Manager.",
                                "alreadyRegistered": "ℹ️ This phone number is already registered. No PIN is required for updates.",
                            },
                            "fallback": {
                                "toggle": "Use as global fallback configuration",
                                "description": "The fallback configuration is used for automations when no Business Unit-specific configuration exists.",
                                "isFallbackDescription": "✓ This is the global fallback configuration",
                                "notRequired": "Business Unit assignment is not required for a fallback configuration."
                            },
                            "businessUnits": {
                                "description": "Select which Business Units should use this phone number for automated WhatsApp messages. Each Business Unit can only be assigned to one phone configuration.",
                                "error": "⚠️ Please select at least one Business Unit, or enable the fallback option above."
                            },
                            "conflicts": {
                                "phoneInUse": "This phone number is already configured as \"{{name}}\". Each phone number can only be configured once. Please select a different phone number or edit the existing configuration.",
                                "fallbackExists": "A fallback configuration already exists: \"{{name}}\". Only one fallback configuration is allowed. Please edit the existing fallback configuration or disable fallback mode to assign Business Units."
                            },
                            "cta": {
                                "configure": "Configure Phone Number"
                            }
                        },
                        "accounts": {
                            "title": "WhatsApp Account",
                            "dialogTitle": "Edit WhatsApp Account",
                            "sectionTitle": "WhatsApp Accounts",
                            "connectedHeader": "Connected Accounts",
                            "help": "Get started by connecting your WhatsApp Business Account",
                            "cannotChangeHint": "This cannot be changed after connection.",
                            "tokenManagement": "This token is managed automatically and cannot be viewed for security reasons.",
                            "deleteConfirmTitle": "Disconnect WhatsApp Account?",
                            "deleteConfirmMsg": "Are you sure you want to disconnect \"{{name}}\"? This action will: (1) Unsubscribe Insyte from webhook notifications, (2) Remove this account from your Insyte configuration, (3) Stop all message routing through this account, and (4) Delete all associated Phone Number Configurations. Furthermore, if this is your only connected account, this will also DISABLE the WhatsApp Integration. NOTE: This does NOT delete your WhatsApp Business Account or revoke access tokens on Meta's platform. To fully disconnect, you should also remove Insyte's app access in your Meta Business Manager.",
                            "deleteFailed": "Delete Failed",
                            "saveFailed": "Save Failed",
                            "saveFailedMessage": "An error occurred while saving the account.",
                            "deleteFailedMessage": "An error occurred while deleting the account.",
                            "labels": {
                                "displayName": "Display Name",
                                "wabaId": "WABA ID",
                                "connected": "Connected"
                            },
                            "deleteTooltip": "Delete Account"
                        },
                        "configList": {
                            "sectionTitle": "Phone Number Configurations",
                            "description": "Configure which phone numbers handle messages for your business units and set up default routing",
                            "emptyHelp": "💡 Connect a WhatsApp Business Account first to configure phone numbers",
                            "details": {
                                "businessUnits": "Business Units",
                                "defaultTeam": "Default Team",
                                "defaultRep": "Default Representative",
                                "fallbackBadge": "Fallback"
                            },
                            "deleteTooltip": "Delete configuration",
                            "deleteConfirmTitle": "Delete Phone Number Configuration?",
                            "deleteConfirmMsg": "Are you sure you want to delete the configuration for \"{{name}}\"? This action will: (1) Deregister this phone number with Meta/WhatsApp, (2) Remove all routing rules for this number, (3) Stop incoming messages to this number, and (4) Make all linked existing chats read-only. Furthermore, if this is your only Phone Number Configuration, this will also DISABLE the WhatsApp Integration. IMPORTANT: You will need your 2-step verification PIN to re-register this number in the future.",
                            "deleteFailedMessage": "An error occurred while deleting the configuration."
                        },
                        "status": {
                            "saving": "Saving...",
                            "deletingAccount": "Deleting account...",
                            "deletingConfig": "Deleting configuration..."
                        }
                    },
                    "chat": {
                        "banner": {
                            "channelNotConfigured": "Channel Not Configured",
                            "channelNotConfiguredMessage": "{{channelName}} messaging has not been configured. Please configure {{channelName}} in the integration settings to use {{channelName}} in chats."
                        },
                        "paging": {
                            "range": "1 – {{shown}} of {{total}}",
                            "zero": "0 of 0",
                            "loadMore": "Load more."
                        },
                        "actions": {
                            "newChat": "New chat",
                            "markRead": "Mark as Read",
                            "markUnread": "Mark as Unread",
                            "pin": "Pin",
                            "unpin": "Unpin",
                            "mute": "Mute",
                            "unmute": "Unmute",
                            "linkJobs": "Link Job(s)",
                            "newContact": "New Contact",
                            "newLead": "New Lead",
                            "archive": "Archive",
                            "unarchive": "Unarchive"
                        },
                        "uniqueness": {
                            "title": "Another chat is already open",
                            "body": "You already have an open chat for this Contact Point. Close it first before setting this one to Open, Pending, or On Hold."
                        },
                        "channelTitle": "Chat with {{contactPoint}}",
                        "a11y": {
                            "dragToResize": "Drag to resize"
                        },
                        "toolbar": {
                            "refPlaceholder": "No.",
                            "searchPlaceholder": "Search...",
                            "filters": {
                                "channel": "Channel",
                                "status": "Status"
                            },
                            "toggles": {
                                "mine": "Mine",
                                "unread": "Unread",
                                "unreadTooltip": "Show chats with unread for me",
                                "archived": "Archived",
                                "archivedTooltip": "Show archived chats"
                            }
                        },
                        "row": {
                            "pinned": "Pinned",
                            "muted": "Muted",
                            "openContact": "Open Contact",
                            "archivedAt": "Archived at",
                            "by": "by",
                            "lastActivityAt": "Last activity at"
                        },
                        "rightPane": {
                            "unsupportedChannel": "Unsupported Channel",
                            "selectChat": "Select a chat to view messages.",
                            "chat": {
                                "nav": {
                                    "backAria": "Go back",
                                    "backToList": "Back to Chat list"
                                },
                                "subject": {
                                    "placeholder": "Add a subject…",
                                    "save": "Save",
                                    "cancel": "Cancel",
                                    "editBtn": "Edit",
                                    "editTitle": "Edit subject",
                                    "none": "No subject",
                                    "titlePrefix": "#{{referenceNo}}: "
                                },
                                "detailsToggle": {
                                    "show": "Show details",
                                    "hide": "Hide details",
                                    "showShort": "Show",
                                    "hideShort": "Hide"
                                },
                                "contactLine": {
                                    "callTitle": "Call this number",
                                    "callAria": "Call",
                                    "openContactTitle": "Open Contact",
                                    "fallbackContact": "Contact",
                                    "unlinked": "Unlinked contact",
                                    "via": "via {{fromDisplayName}}"
                                },
                                "jobs": {
                                    "linkedLabel": "Linked job{{plural}}:",
                                    "openJobTitle": "Open Job {{jobRef}}",
                                    "jobNumber": "Job #{{jobId}}",
                                    "linkBtn": "Link to Job(s)",
                                    "linkBtnTitle": "Link to a Job",
                                    "newLeadBtn": "New Lead",
                                    "newLeadBtnTitle": "Create a new Lead"
                                },
                                "meta": {
                                    "openedAt": "Opened at {{date}}",
                                    "closedAt": "Closed at {{date}}",
                                    "archivedAtBy": "Archived at {{date}} by {{name}}"
                                },
                                "suggestions": {
                                    "foundTitle": "We found possible contact matches for this contact point",
                                    "possiblePrefix": "Possible Contact{{plural}}:",
                                    "link": "Link",
                                    "dismiss": "Dismiss",
                                    "create": "Create New Contact",
                                    "noneFound": "No existing contact found for {{contactPoint}}"
                                },
                                "list": {
                                    "loadingInitial": "Loading messages...",
                                    "loadOlder": "Load Older Messages",
                                    "loadingOlder": "Loading...",
                                    "unreadDivider": "New Messages Below"
                                },
                                "compose": {
                                    "internal": "Internal",
                                    "external": "External",
                                    "internalHint": "This will not send to the customer",
                                    "externalHint": "This will send to the customer",
                                    "disabledTooltip": "You can send custom messages only when a Customer Service Window is opened by a customer responding, or if the chat is not archived",
                                    "placeholderMobile": "Type a message...",
                                    "placeholderDesktop": "Type a message... (Shift+Enter for new line)",
                                    "insertTemplate": "Insert Template",
                                    "lockTitle": "Lock (send as template)",
                                    "unlockTitle": "Unlock to edit (send as custom message)",
                                    "attachFileTitle": "Attach file",
                                    "replyingTo": "Replying to {{name}}",
                                    "cancelReplyAria": "Cancel reply",
                                    "clearTemplateAria": "Clear template",
                                    "sendAria": "Send"
                                },
                                "attachments": {
                                    "clear": "Clear",
                                    "tooLarge": "File is too large (over {{limitMB}}MB)!: {{fileList}}"
                                },
                                "errors": {
                                    "cannotSendOutsideWindow": "You can only send a custom message when the service window is open.",
                                    "updateSubjectFailed": "Could not update subject. Please try again.",
                                    "linkContactFailed": "Could not link contact. Please try again."
                                },
                                "mentions": {
                                    "popupAria": "Mention list"
                                },
                                "uniqueness": {
                                    "title": "Another chat is already open",
                                    "message": "You already have an open chat for this number. Close it first before setting this one to Open, Pending, or On Hold.",
                                    "ok": "OK"
                                },
                                "message": {
                                    "status": {
                                        "queued": "queued",
                                        "sent": "sent",
                                        "delivered": "delivered",
                                        "read": "read",
                                        "failed": "failed",
                                        "resentAlternate": "resent via alternate channel"
                                    },
                                    "actions": {
                                        "reply": "Reply",
                                        "jumpToReply": "Jump to replied message",
                                        "replyOriginalMissing": "Original message is in a previous conversation",
                                        "previousAttempt": "Previous attempt",
                                        "nextAttempt": "Next attempt"
                                    },
                                    "replyContext": {
                                        "previousConversationSender": "Previous conversation",
                                        "previousConversationText": "Reply to previous conversation",
                                        "thumbAlt": "thumb"
                                    },
                                    "media": {
                                        "imageAlt": "Chat content",
                                        "imageSending": "Image (sending…)",
                                        "videoSending": "Video (sending…)",
                                        "audioSending": "Audio (sending…)",
                                        "documentLabelFallback": "Download"
                                    },
                                    "previewTokens": {
                                        "image": "📷 Image",
                                        "video": "🎬 Video",
                                        "audio": "🎵 Audio",
                                        "attachment": "📎 {{fileName}}",
                                        "attachmentNoName": "📎 Document"
                                    },
                                    "footer": {
                                        "openContactTitle": "Open Contact",
                                        "contactFallback": "Contact",
                                        "internalBadge": "Internal",
                                        "internalBadgeTitle": "Team-only — not sent to customer",
                                        "timeSeparator": " - "
                                    },
                                    "errors": {
                                        "failedToSend": "Message failed to send"
                                    }
                                }
                            }
                        },
                        "assigneeBadge": {
                            "assigned": "Assignee: {{label}}{{kind}}",
                            "unassigned": "Assignee: Unassigned"
                        },
                        "assigneePicker": {
                            "header": "Assign to…",
                            "loading": "Loading…",
                            "loadFailed": "Failed to load teams",
                            "empty": "No teams found.",
                            "untitledTeam": "Untitled Team",
                            "buttons": {
                                "close": "Close",
                                "assignToMe": "Assign to me",
                                "select": "Select",
                                "saving": "Saving…"
                            },
                            "errors": {
                                "setAssigneeFailed": "Could not set assignee. Please try again.",
                                "assignToMeFailed": "Could not assign to you. Please try again."
                            }
                        },
                        "jobSelector": {
                            "suggested": "Suggested",
                            "suggestedTitle": "Pick a contact to see suggestions",
                            "searchAll": "Search all"
                        },
                        "serviceWindowBanner": {
                            "timeRemaining": "Closes at {{date}}",
                            "timeRemainingFallback": "Time remaining in service window",
                            "closed": "Customer Service Window closed - only templates can be sent",
                            "open": "Customer Service Window: {{time}} remaining"
                        }
                    },
                    "supplier": {
                        "title": "Supplier ({{Name}})"
                    },
                    "team": {
                        "title": "Team ({{Name}})"
                    },
                    "accessRole": {
                        "title": "Access Role ({{Name}})",
                        "manageRoles": "Manage Roles"
                    },
                    "salesDiscountRule": {
                        "title": "Disc Rule ({{MinimumMargin}})"
                    },
                    "salesDiscountLimits": {
                        "title": "Disc Lmit ({{MinimumMargin}})"
                    },
                    "lookupTable": {
                        "title": "Lookup Table ({{Name}})"
                    },
                    "lookupTableItem": {
                        "title": "Lookup Item ({{From}} - {{To}})"
                    },
                    "picklist": {
                        "title": "Picklist ({{Description}})",
                        "opportunityStage": "Opportunity Stage",
                    },
                    "taxRate": {
                        "title": "Tax Rate ({{Description}})"
                    },
                    "commissions": {
                        "title": "Commissions",
                        "valuesHeader": "Values to be used in Rules",
                        "rulesHeader": "Commission Rules",
                        "plansHeader": "Commission Plans",
                        "description": "Description",
                        "add": "New",
                        "sort": "Sort Values",
                        "optionLookup": "Lookup Product Option",
                        "name": "Value Name",
                        "ruleName": "Rule Name",
                        "commissionDate": "Commission Date",
                        "byJob": "By Job",
                        "filter": "Filter",
                        "expression": "Value Expression",
                        "ruleExpression": "Rule Expression",
                        "textValues": "Text Values",
                        "summaryType": "Summary Type",
                        "summaryBy": "Distinct By",
                        "groupType": "Group By",
                        "showOnStatement": "Show On Statement",
                        "isText": "Is Text",
                        "JobLine": "Line",
                        "Job": "Job",
                        "importValuesTitle": "Import Values",
                        "importValuesWarning": "WARNING: Importing will clear all existing commision values",
                        "export": "Export",
                        "import": "Import",
                        "testRule": "Rule Results",
                        "toggleMatchCols": "Toggle Expression Columns",
                        "usersForRule": "Users for Rule - {{Name}}",
                        "rulesForPlan": "Rules for Plan - {{Description}}",
                        "commissionDateRules": "Commission Date Rules",
                        "commissionDate1": "Commission Date 1",
                        "commissionDate1Short": "Date 1",
                        "commissionDate2": "Commission Date 2",
                        "commissionDate2Short": "Date 2",
                        "commissionDate3": "Commission Date 3",
                        "commissionDate3Short": "Date 3",
                        "commissionDate4": "Commission Date 4",
                        "commissionDate4Short": "Date 4",
                        "commissionDate5": "Commission Date 5",
                        "commissionDate5Short": "Date 5",
                        "validation": {
                            "required": "Required, must start with a alphabetical character and only contain alphnumeric characters or underscore character. Underscore will be displayed as a space character in reports",
                            "duplicate": "Name is already in use."
                        }
                    },
                    "support": {
                        "selectDlg": {
                            "title": "Support access expiry date",
                        }
                    },
                    "mfa": {
                        "selectDlg": {
                            "title": "Multi-Factor Authentication Type",
                            "none": "None",
                            "sms": "SMS",
                            "email": "Email",
                            "totp": "TOTP",
                            "manageDevices": "Manage the registered authenticator devices below",
                            "noDevices": "You will be asked to register your authenticator next time you log in."
                        }
                    },
                    "commissionRun": {
                        "title": "Commission Run ({{Description}})",
                        "amendmentSection": "Unresolved Amendments",
                        "runDlg": {
                            "title": "SELECT USERS TO RUN COMMISSIONS FOR",
                            "startRun": "Start Run",
                            "continue": "Continue"
                        },
                        "emailDlg": {
                            "title": "SELECT USERS TO EMAIL",
                            "sendEmails": "Send Emails",
                        },
                        "previewDlg": {
                            "title": "SELECT USERS TO PREVIEW",
                            "previewPdf": "Generate Pdf",
                            "previewExcel": "Generate Excel",
                        },
                        "amendmentDlg": {
                            "title": "Amendment",
                            "createAmendment": "Save",
                            "notesPlaceHolder": "Enter any notes here..."
                        }
                    },
                    "lookupTableListView": {
                        "lookupTables": "Lookup Tables",
                        "add": "Add"
                    },
                    "lookups": {
                        "title": "Lookup Tables",
                        "importValuesWarning": "WARNING: Importing will clear existing lookup values for this table",
                    },
                    "officeAddinSettings": {
                        "title": "Office Excel Addin",
                    },
                    "documentTemplateListView": {
                        "title": "Document Template",
                        "add": "New Document Template",
                        "addSettings": "New Print Settings",
                        "quotes": "Quotes",
                        "orderConfirmations": "Order Confirmations",
                        "invoices": "Invoices",
                        "statements": "Statements",
                        "installers": "Install Job Sheet Report",
                        "jobReview": "Job Review",
                        "jobSummaries": "Job Summary",
                        "copyAsType": "Copy as type",


                    },
                    "printSettingsListView": {
                        "title": "Print Settings",
                        "add": "New",
                        "printSettings": "Print Settings",

                    },
                    "businessUnit": {
                        "title": "Business Unit ({{Name}})",
                        "title2": "Business Unit",
                        "sectionExclusions": "Product Exclusions",
                        "add": "Add",
                        "missing": "<MISSING>",
                        "sectionAddress": "Address",
                        "address": "Address",
                        "billingAddress": "Billing Address",
                        "deliveryAddress": "Delivery Address"
                    },
                    "activity": {
                        "title": "Activity",
                        "notes": "Activity Notes",
                        "installNotes": "Installation Notes",
                    },
                    "scanMFJob": {
                        "title": "Scan Job",
                        "done": "Done",
                        "allCompleted": "All lines have been completed or Link has expired.",
                    },
                    "installCompletionForm": {
                        "title": "Installation {{Job.Reference}}",
                        "hasService": "WARNING: Some of these lines already have a service. Changing the outcome of a line may result in service lines being removed or regenerated and possible loss of details on the existing service lines",
                        "errors": {
                            "document_failed_to_upload": "An error occured during upload, please try again.",
                            "invalid_document": "Uploaded document is not appear to be the correct document",
                            "table_not_found": "The results table could not be found in the uploaded document",
                            "table_lines_not_found": "No job line rows found in the uploaded document",
                            "no_line_numbers_found": "No line numbers found in the uploaded document, make sure the file is an image or pdf file of the installation completion form"
                        },
                        "lineErrors": {
                            "line_number_not_determined": "The quality of the uploaded document prevented the determination of the job line number on Row {{RowIndex}} Column {{ColumnIndex}}",
                        }
                    },
                    "mfScheduling": {
                        "setCommitReason": "Set Commit Reason",
                        "setDepartment": "Set Department",
                        "setMFDate": "Set MF Date",
                        "setETADate": "Set ETA Date",
                        "release": "Release (Download)",
                        "preview": "Preview (Download)",
                        "updateStatus": "Set Status to Released",
                        "downloadSupplyWorksheets": "Download Worksheets (Excel/CSV)",
                        "dowloadSupplyJobFile": "Download Supply Job Interface File (UBL/ASCX12)",
                        "complete": "Complete",
                        "supplyJobsToComplete": "Click OK to mark {{count}} selected item(s) as completed"
                    },
                    "mapRunPlanner": {
                        "title": "Run Planner",
                    },
                    "mapScheduler": {
                        "title": "Map Scheduler",
                        "calendar": "Calendar",
                        "map": "Map",
                        "details": "Details",
                        "activityDate": "Activity Date",
                        "activityRep": "Activity Rep",
                        "jobDetails": {
                            "estInstallTime": "Est. Install Time",
                            "estCheckMeasureTime": "Est Check Measure Time",
                            "reference": "Reference",
                            "company": "Company",
                            "contact": "Contact",
                            "siteContact": "Site Contact",
                            "eta": "ETA",
                            "handoverDate": "Handover Date",
                            "previousRep": "Previous Rep",
                            "products": "Products",
                            "salePriceInc": "Sale Price Inc",
                            "balance": "Balance",
                        },
                        "oppDetails": {
                            "description": "Description",
                            "company": "Company",
                            "contact": "Contact",
                            "siteContact": "Site Contact",
                            "notes": "Notes",
                        },
                        "activityDetails": {
                            "activityType": "Activity Type",
                            "opportunity": "Opportunity",
                            "products": "Products",
                            "category": "Category",
                            "subject": "Subject",
                            "job": "Job",
                            "notes": "Notes"
                        }
                    },
                    "splitLine": {
                        "title": "Split Line",
                        "originalLine": "Original Line",
                        "newLine": "New Line ({{num}})",
                        "noOfLines": "Number of lines"
                    },
                    "multiLineJobEdit": {
                        "title": "Job Multi - {{Reference}}",
                    },
                    "multiLineSupplyEdit": {
                        "title": "Supply Multi - {{OrderNumber}}"
                    },
                    "multiLineEdit": {
                        "title": "Multi Line",
                        "lineNo": "#",
                        "lineType": "Type",
                        "location": "Location",
                        "qty": "Qty",
                        "width": "Width",
                        "drop": "Height",
                        "addProduct": "ADD PRODUCT",
                        "lineDetails": "DETAILS",
                        "unitPrice": "Unit Price",
                        "price": "Price (Inc Tax)",
                        "addLine": "ADD {{ProductName}} LINE",
                        "refreshPrice": "Refresh Price",
                        "howManyCopies": "How many copies?",
                        "noOfCopies": "Select Number Of Copies",
                        "showAll": "Show All Lines",
                        "showInvalid": "Show Invalid Lines",
                        "total": "Total",
                        "detailsDialog": {
                            "requiredTitle": "Required Fields",
                            "requiredMsg": "Please ensure product and location fields are populated",
                        }
                    },
                    "queryPage": {
                        "title": "Query - $t({{name}})",
                        "Search_Job": "Search Jobs",
                        "Search_SupplyJob": "Search Supply Jobs",
                        "Search_Invoice": "Search Invoices",
                        "Search_Contact": "Search Contacts",
                        "Search_Company": "Search Companies",
                        "PO_Open": "Open Supply Jobs",
                        "PO_Sent": "Sent Supply Jobs",
                        "PO_Priced": "Priced Supply Jobs",
                        "PO_Received": "Received Supply Jobs",
                        "PO_Manufacturing": "Supply Jobs in Manufacturing",
                        "PO_Dispatch": "Supply Jobs in Dispatch",
                        "PO_Invoiced": "Invoiced Supply Jobs",
                        "PO_Closed": "Closed Supply Jobs",
                        "PO_Canceled": "Canceled Supply Jobs",
                        "Invoice_Open": "Open Invoices",
                        "Invoice_AwaitingPayment": "Invoices Awaiting Payment",
                        "Invoice_Overdue": "Overdue Invoices",
                        "Dashboard_SalesPerformanceByMonth_Won": "Sales By Month (Won)",
                        "Dashboard_SalesPerformanceByMonth_Lost": "Sales By Month (Lost)",
                        "Dashboard_SalesPerformanceByRep_Lead": "Sales By Rep (Lead)",
                        "Dashboard_SalesPerformanceByRep_Quotation": "Sales By Rep (Quotation)",
                        "Dashboard_SalesPerformanceByRep_Negotiation": "Sales By Rep (Negotiation)",
                        "Dashboard_SalesPerformanceByRep_Won": "Sales By Rep (Won)",
                        "Dashboard_SalesPerformanceByRep_Lost": "Sales By Rep (Lost)",
                        "Dashboard_SalesEfficiencyByRep_Quotation": "Sales Efficiency By Rep (Quotation)",
                        "Dashboard_SalesEfficiencyByRep_Negotiation": "Sales Efficiency By Rep (Negotiation)",
                        "Dashboard_SalesEfficiencyByRep_Won": "Sales Efficiency By Rep (Won)",
                        "Dashboard_SalesEfficiencyByRep_Lost": "Sales Efficiency By Rep (Lost)",
                        "Dashboard_SalesEfficiencyByRep_Total": "Sales Efficiency By Rep (Total)",
                        "Dashboard_FinanceProjectedRevenue_Sales": "Sales Projected Revenue",
                        "Dashboard_FinanceProjectedRevenue_Services": "Services Projected Revenue",
                        "Dashboard_FinanceProjectedRevenue_Total": "Projected Revenue",
                        "Dashboard_SalesByRep": "Sales By Rep For Month"
                    },
                    "addjustSupplyCost": {
                        "title": "Adjust Supply Costs",
                        "lineNo": "Line No",
                        "location": "Location",
                        "product": "Product",
                        "unitPrice": "Unit Cost",
                        "qty": "Qty",
                        "price": "Cost",
                        "tax": "Tax",
                        "total": "Cost Inc"
                    },
                    "AutoLines": {
                        "Lines": "Lines",
                        "lineItemID": "Line Item ID",
                        "lineOption": "Line Option",
                        "Job": "Job",
                        "Company": "Company",
                        "SiteAddress": "Site Address",
                        "DeliveryAddress": "Delivery Address",
                        "BusinessUnit": "Business Unit",
                        "product": "Product",
                        "productName": "Product Name",
                        "supplier": "Supplier",
                        "qty": "Qty",
                        "status": "Status",
                        "stage": "Stage",
                        "type": "Type",
                        "requireInstall": "Require Install",
                        "requireDelivery": "Require Delivery",
                        "requirePickup": "Require Pickup",
                        "width": "Width",
                        "drop": "Drop",
                        "estimatedInstallTime": "Est Install Time",
                        "estCheckmeasureTime": "Est Checkmeasure Time",
                        "numberOfInstaller": "No. of Installers",
                        "name": "Name",
                        "accountType": "Account Type",
                        "organisationType": "Organisation Type",
                        "suburb": "Suburb",
                        "state": "State",
                        "postCode": "Postcode",
                        "businessUnit": "Business Unit",
                        "Item": "Item",
                        "kind": "Kind"
                    },
                    "filterView": {
                        "title": "Grid Filter",
                        "owner": "Owner",
                        "filterName": "Name",
                        "users": "Select Users",
                        "teams": "Select Teams",
                        "selectFilter": "Select Filter",
                        "saveFilter": "Save",
                        "editFilter": "Edit",
                        "newFilter": "Save As",
                        "importFilter": "Import",
                        "exportFilter": "Export",
                        "exportFilterTitle": "Select Filter(s) to Export",
                        "importFilterTitle": "Select File to Import",
                        "selectFiltersImportFile": "Select File (.json)",
                        "and": "AND",
                        "or": "OR",
                        "notand": "NOT AND",
                        "notor": "NOT OR",
                        "addPredicate": "+",
                        "addGroup": "[...]",
                    "excludeServices": "Exclude services",
                    "excludeCharges": "Exclude charges",
                        "schemas": {
                            "ActivityAlert": "Activity Alert",
                            "JobAlert": "Job Alert",
                            "OpportunityAlert": "Lead Alert",
                            "LJ__ActivityAlertActive": "Activity Alert Is Active",
                            "LJ__ActivityAlertMessage": "Activity Alert Message",
                            "LJ__ActivityAlertType": "Activity Alert Type",
                            "LJ__JobAlertActive": "Job Alert Is Active",
                            "LJ__JobAlertMessage": "Job Alert Message",
                            "LJ__JobAlertType": "Job Alert Type",
                            "LJ__OpportunityAlertActive": "Lead Alert Is Active",
                            "LJ__OpportunityAlertMessage": "Lead Alert Message",
                            "LJ__OpportunityAlertType": "Lead Alert Type",
                            "select_field": "Select a field",
                            "Contact": "Contact",
                            "SiteContact": "Site Contact",
                            "Company": "Company",
                            "Job": "Job",
                            "JobLine": "Job Line",
                            "Opportunity": "Lead",
                            "OrderLine": "Supply Job Line",
                            "PurchaseOrder": "Supply Job",
                            "Activity": "Activity",
                            "Invoice": "Invoice",
                            "ID": "Record ID",
                            "QuoteDate": "Quote date",
                            "CloseDate": "Close date",
                            "HandoverDate": "Handover date",
                            "LJ__OrderDate": "Order date",
                            "LJ__JobLineStageDate": "Stage date",
                            "LJ__CommissionDate1": "Commission Date 1",
                            "LJ__CommissionDate2": "Commission Date 2",
                            "LJ__CommissionDate3": "Commission Date 3",
                            "LJ__CommissionDate4": "Commission Date 4",
                            "LJ__CommissionDate5": "Commission Date 5",
                            "LJ__ETADate": "Eta date",
                            "LJ__Amount": "Amount inc tax",
                            "LJ__Paid": "Amount paid",
                            "LJ__HasPayment": "Has a payment",
                            "Stage": "Stage",
                            "LJ__JobLineStatus": "Status",
                            "LJ__JobLineType": "Line Type",
                            "LJ__JobLineStage": "Stage",
                            "LJ__JobLineDispatchStage": "Dispatch Stage",
                            "SalesRepID": "Sales rep",
                            "BusinessUnitID": "Business Unit",
                            "LJ__Balance": "Job Balance",
                            "LJ__PercentagePaid": "Paid %",
                            "LJ__JobLineProductID": "Product",
                            "LJ__JobLineSupplierID": "Supplier",
                            "LJ__CompanyName": "Name",
                            "LJ__OrganisationType": "Type",
                            "LJ__AccountType": "Account Type",
                            "LJ__ContactFirstName": "First name",
                            "LJ__ContactLastName": "Last name",
                            "LJ__ContactHasCredit": "Has credit",
                            "LJ__SiteContactFirstName": "First name",
                            "LJ__SiteContactLastName": "Last name",
                            "LJ__ActivityType": "Type",
                            "LJ__ActivityCategory": "Category",
                            "LJ__ActivityStart": "Start date",
                            "LJ__ActivityRepresentative": "Representative",
                            "LJ__ActivityClosed": "Is closed",
                            "LJ__ActivityConfirmed": "Is confirmed",
                            "LJ__ActivityCancelled": "Is cancelled",
                            "LJ__ActivityPercentagePaid": "Paid %",
                            "LJ__ActivityAmount": "Amount",
                            "LJ__ActivityPaid": "Paid",
                            "LJ__ReferredByID": "Referred by",
                            "LJ__LeadGenerator": "Lead Generator",
                            "LJ__OpportunityConfidenceLevel": "Confidence level",
                            "LJ__OpportunityStatus": "Status",
                            "LJ__OpportunityOutcomeReason": "Outcome reason",
                            "LJ__OpportunityInstallArea": "Area (Install)",
                            "LJ__OpportunitySalesArea": "Area (Sales)",
                            "LJ__OpportunityForecast": "Forecast",
                            "LJ__LeadSource": "Lead source",
                            "LJ__VisitedShowroom": "Visited showroom",
                            "LJ__OpportunityRepresentative": "Representative",
                            "LJ__CMRequired": "Require check measure",
                            "LJ__InstallRequired": "Require install",
                            "LJ__PickupRequired": "Require pickup",
                            "LJ__DeliveryRequired": "Require delivery",
                            "LJ__Tags": "Tags",
                            "QuoteExpiryDate": "Quote expiry date",
                            "LJ__PercentageInvoiced": "Invoiced %",
                            "LJ__CompanyAccountType": "Account Type",
                            "LJ__JobID": "Record ID",
                            "LJ__JobIsSigned": "Is Signed",
                            "LJ__JobSalesRep": "Sales rep",
                            "LJ__JobStage": "Stage",
                            "LJ__JobTags": "Tags",
                            "LJ__QuoteDate": "Quote date",
                            "LJ__QuoteExpiryDate": "Quote expiry date",
                            "LJ__QuoteLastSentDate": "Quote last sent date",
                            "LJ__JobLineCMRequired": "Require check measure",
                            "LJ__JobLineInstallRequired": "Require install",
                            "LJ__JobLinePickupRequired": "Require pickup",
                            "LJ__JobLineDeliveryRequired": "Require delivery",
                            "LJ__JobLineETADate": "Eta date",
                            "LJ__CommitmentReason": "Commit reason",
                            "LJ__HandoverDate": "Handover date",
                            "LJ__SalesRepID": "Sales rep",
                            "LJ__DispatchBy": "Dispatch by",
                            "LJ__DispatchDate": "Dispatch date",
                            "LJ__SupplyLineDepartment": "Department",
                            "LJ__SupplyLineMFDate": "MF Date",
                            "LJ__SupplyLineProductID": "Product",
                            "LJ__SupplyLineStatus": "Status",
                            "LJ__Internal": "Internal",
                            "LJ__AtFaultSupplierID": "Service At Fault Supplier",
                            "LJ__AtFaultUserID": "Service At Fault User",
                            "LJ__FaultReasonID": "Service Fault Reason",
                            "LJ__JobSalesArea": "Area (Sales)",
                            "LJ__JobInstallArea": "Area (Install)",
                            "LJ__JobLinePromotionID": "Promotions",
                            "CustomerReference": "Cust. Ref",
                            "OrderNumber": "Order Number",
                            "SupplierID": "Supplier",
                            "ETADate": "Eta date",
                            "PL_QuoteOutcomeReasonID": "Outcome reason",
                            "Description": "Description",
                            "LJ__JobCompanyName": "Name",
                            "LJ__JobOrganisationType": "Type",
                            "LJ__JobCompanyAccountType": "Account type",
                            "LJ__JobContactFirstName": "First name",
                            "LJ__JobContactLastName": "Last name",
                            "Forecast": "Forecasted",
                            "LeadGeneratorID": "Lead generator",
                            "PlannedInstallerID": "Planned Installer",
                            "PlannedInstallerSetDate": "Planned Installer Set Date",
                            "PL_LeadSourceID": "Lead source",
                            "PL_OppConfidenceLevelID": "Confidence level",
                            "PL_CommitmentReasonID": "Commit reason",
                            "ReferedByID": "Referred by",
                            "RepresentativeID": "Representative",
                            "Status": "Status",
                            "VisitedShowroom": "Visited showroom",
                            "MarginApprovalRequired": "Sales Discount Approval Required",
                            "JobType": "Job Type",


                        }
                    },
                    "userProfileSettings": {
                        "title": "Profile Settings",
                        "quickAuthInfo": "Please enter you password to access your profile.",
                        "resetPassword": "Click here to change your log in password",
                        "sectionPasswords": "Passwords",
                        "loginPassword": "Log in Password",
                        "defaultBusinessChanged": "Your default business has been changed. Please log in again to access."
                    },
                    "discountLevel": {
                        "title": "Discount Level ({{Description}})",
                        "searchCompanies": "Search for Companies",
                        "sectionDiscountItems": "Discounts"
                    },
                    "discountItem": {
                        "title": "Discount Item ({{Percentage}} - {{Product}})",
                    },
                    "projectTracking": {
                        "projectTemplate": "Template",
                        "newTemplate": "+",
                        "templateDetails": "...",
                        "deleteTemplate": "Delete",
                        "editTemplate": "Edit Template",
                        "newStage": "Add Stage",
                        "description": "Description",
                        "selectTemplateDlgTitle": "Missing Template",
                        "selectTemplateDlgMsg": "Please select a project template first before trying again",
                        "duplicateFilter": "Each row must have a unique combination of Activity Type and Activity Category"
                    },
                    "activitiesView": {
                        "title": "Activities",
                        "closeActivityTitle": "Close Activities",
                        "closeActivities": "Close Activities",
                        "cancelActivity": "Cancel",
                        "cancelActivitySummaryTitle": "Cancel Activities - Summary",
                        "cancelActivityConfirm": "Cancel Selected Activities",
                        "cancelSummaryOpportunityLost": "Opportunity",
                        "cancelSummaryReason": "Reason",
                        "cancelSummaryNotes": "Notes",
                        "cancelSummaryYes": "Lost",
                        "cancelSummaryMoveToLead": "Move to Lead",
                        "noActivitiesToCancelTitle": "No Activities to Cancel",
                        "noActivitiesToCancelMsg": "The selected activities cannot be cancelled (already cancelled or closed).",
                        "reassignActivityTitle": "Reassign Activities",
                        "reassignActivities": "Reassign",
                        "noActivitiesSelectTitle": "No Selected Activites",
                        "noActivitiesSelectMsg": "Please select one or more activities",
                        "assignTo": "Reassign to:",
                        "filterDlgTitle": "Activity Filters",
                        "filters": {
                            "myActivities": "Mine",
                            "futureActivities": "Future",
                            "any": "Any",
                            "low": "Low",
                            "medium": "Medium",
                            "high": "High",
                            "what": "What",
                            "priority": "Priority",
                            "teams": "Teams",
                            "users": "Users",
                            "showDetails": "Show Details",
                            "hideDetails": "Hide Details",
                            "status": "Status",
                            "open": "Open",
                            "all": "All",
                            "show": "Show",
                            "hide": "Hide",
                            "detailsLabel": "Details"
                        }
                    },
                    "manageTeamsView": {
                        "title": "Manage Teams",
                        "searchPlaceholder": "Filter User by Name",
                        "invalidUser": {
                            "title": "Missing team",
                            "message": "The following users require a team"
                        }
                    },
                    "manageRolesView": {
                        "title": "Manage Roles",
                        "searchPlaceholder": "Filter User by Name"
                    },
                    "managePackageView": {
                        "title": "Manage Package",
                        "searchPlaceholder": "Filter User by Name",
                        "overallocatedTitle": "Over Allocated",
                        "overallocatedMsg": "One or more licenses has been overallocated",
                        "upgradePackage": "Upgrade Package"
                    },
                    "contactInfo": {
                        "title": "Contact Details",
                        "name": "Name",
                        "jobTitle": "Job Title",
                        "jobCategory": "Job Category",
                        "email": "Email",
                        "mobile": "Mobile",
                        "workPhone": "Work Ph",
                        "homePhone": "Home Ph",
                        "address": "Address",
                        "businessUnit": "Business Unit",
                        "team": "Team"
                    },
                    "snoozeDialog": {
                        "title": "Snooze Lead",
                    },
                    "jobHealthCheck": {
                        "title": "Job Health Check",
                        "noData": "No data available  for this job",
                        "depost": "Deposit",
                        "payment_terms": "Payment Terms",
                        "not_booked": "Not Booked",
                        "not_required": "Not Required",
                        "check_measures": "Check Measures",
                        "installs": "Dispatch Appointments",
                        "supply_jobs": "Supply Jobs",
                        "invoices": "Invoices",
                        "booked": "Booked",
                        "confirmed_partial": "Partial ({{x}} / {{n}})",
                        "confirmed_all": "All ({{n}})",
                        "confirmed": "Confirmed",
                        "not_created": "Not Created",
                        "not_sent": "Not Sent",
                        "sent": "Sent",
                        "released": "Released",
                        "overdue": "Overdue",
                        "paid": "Paid",
                        "required": "Required",
                        "received": "Received",
                        "completed": "Completed",
                        "collected_warning": "Collected*",
                        "collected": "Collected",
                        "tooltips": {
                            "job_ignore_deposit_limit": "The deposit limit has been overridden on the job",
                            "no_min_dep_configured": "There is no mimimum deposit amount configured for your system",
                            "min_dep_collected": "The minimum deposit requirement has been met.",
                            "min_dep_not_collected": "The minimum deposit requirement has NOT been met",
                            "confirmed_all": "All {{n}} line(s) from the quote have been confirmed",
                            "confirmed_partial": "{{x}} out of {{n}} line(s) from the quote have been confirmed",
                            "cm_not_required": "Check Measure was not required.",
                            "cm_booked": "A Check Measure appointment has been book but is not yet confirmed",
                            "cm_not_booked": "A Check Measure Appointment is required and has not yet been scheduled",
                            "cm_confirmed": "The Check Measure Appointment has been confirmed with the customer",
                            "cm_completed": "The Check Measure has been completed",

                            "inst_completed": "The Dispatch Appointment has been completed",
                            "inst_confirmed": "The Dispatch Appointment has been confirmed with the customer",
                            "inst_not_required": "A Dispatch Appointment is not required for this item",
                            "inst_booked": "The Dispatch Appointment has been booked but not yet confirmed with the customer",
                            "inst_not_booked": "A Dispatch appointment is required for this item but has not yet been scheduled",
                            "inst_not_booked_in_supply": "The item is in supply and a Dispatch Appointment has not yet been scheduled",
                            "inst_not_booked_in_goods_receipted": "The stock has arrived and the Dispatch Appointment has not yet been scheduled",
                            "inst_booked_in_goods_receipted": "The stock has arrived and the Dispatch Appointment has not been confirmed with the customer",
                            "inst_overdue": "The Dispatch Appointment is overdue",
                            "inst_warning_days": "The install has not yet been confirmed OR The install is comming up and the stock has not arrived",
                            "inst_booked_but_not_required": "A Dispatch Appointment has been scheduled for this item but was not required (as indicated on the job).",
                            "inst_on_or_before_eta": "Stock will not arrive on time, based on supply ETA.",

                            "supply_not_created_service": "Service products do not require supply jobs",
                            "supply_not_created": "Supply jobs have not yet been created. Check Measures are still outstanding",
                            "supply_not_created_warning": "Supply jobs have not yet been created.",
                            "supply_not_sent": "Supply jobs have been NOT yet been Sent to the supplier.",
                            "supply_sent": "Supply jobs have been sent to the supplier",
                            "supply_released": "Supply jobs have been released to manufacturing",
                            "supply_overdue": "Stock has not arrived and the ETA date has passed",
                            "supply_received": "Stock has been received",
                            "supply_received_partial": "Some of the stock has been received",
                            "supply_stock_due": "The ETA Date is comming up and the stock has not yet arrived",
                            "supply_waiting_cm": "Check Measure must be completed first",


                            "invoice_not_created": "An Invoice for this item has not yet been created. Note stock is still outstanding",
                            "invoice_not_created_warning": "An Invoice for this item has not yet been created and all stock has arrived",
                            "invoice_not_sent": "An invoice has been created and has not yet been sent to the customer",
                            "invoice_overdue": "The payments for the invoice are overdue",
                            "invoice_sent": "Invoice has been sent to the customer",
                            "invoice_paid": "Invoice has been paid.",
                        }
                    },
                    "jobDiff": {
                        "BasePrice": "Base Price",
                        "DeliveryPrice": "Delivery Price",
                        "InstallPrice": "Install Price",
                        "OptionsPrice": "Options Price",
                        "OriginalCostPrice": "Original Cost Price",
                        "OriginalCostPriceIncTax": "Original Cost Price Inc Tax",
                        "OriginalCostPriceTax": "Original Cost Price Tax",
                        "Price": "Price",
                        "PriceIncTax": "Price (Inc Tax)",
                        "PriceTax": "Price Tax",
                        "AdjustmentCost": "Adjustment Cost",
                        "BaseCost": "Base Cost",
                        "DeliveryCost": "Delivery Cost",
                        "Drop": "Drop",
                        "InstallCost": "Install Cost",
                        "OptionsCost": "Options Cost",
                        "Width": "Width",
                        "MaterialType": "Material Type",
                        "Material Type": "Material Type",
                        "title": "Edit Changes",
                        "noChanges": "There are no changes to view.",
                        "originalValue": "Before Edit",
                        "quoted": "Quoted",
                        "newValue": "After Edit",
                        "change": "Variance",
                        "CostPrice": "Cost Price",
                        "CostPriceIncTax": "Cost Price (Inc Tax)",
                        "CostPriceTax": "Cost Price Tax",
                        "salePriceInc": "Sale Price (Inc Tax)",
                        "SalePriceIncTax": "Sale Price (Inc Tax)",
                        "SalePrice": "Sale Price",
                        "SalePriceTax": "Sale Price Tax",
                        "margin": "Margin",
                        "newLine": "New Line",
                        "jobDetails": "Job Details",
                        "lineDetails": "Item Details",
                        "lineNo": "Line",
                        "location": "Location",
                        "supplier": "Supplier",
                        "product": "Product",
                        "details": "Details",
                        "originalSalePrice": "Original Sale Price",
                        "newSalePrice": "New Sale Price",
                        "property": "Property",
                        "BaseCostAdjustment": "Base Cost Adjustment",
                        "BaseCostDiscount": "Base Cost Discount",
                        "BasePriceAdjustment": "Base Price Adjustment",
                        "BasePriceDiscount": "Base Price Discount",
                        "DeliveryCostAdjustment": "Delivery Cost Adjustment",
                        "DeliveryCostDiscount": "Delivery Cost Discount",
                        "DeliveryPriceDiscount": "Delivery Price Discount",
                        "DeliveryPriceAdjustment": "Delivery Price Adjustment",
                        "InstallCostAdjustment": "Install Cost Adjustment",
                        "InstallCostDiscount": "Install Cost Discount",
                        "InstallPriceDiscount": "Install Price Discount",
                        "InstallPriceAdjustment": "Install Price Adjustment"
                    },
                    "productTester": {
                        "title": "Product Tester",
                        "addLine": "Add Test Line",
                        "testLineDlgTitle": "Test Line",
                        "generateOutput": "Generate Artifacts",
                        "copy": "Copy",
                        "edit": "Edit",
                        "quoteDocumentTemplate": "Quote Template",
                        "invoiceDocumentTemplate": "Invoice Template",
                        "lockWarning": "WARNING: This feature WILL affect other users. Only user this when no other user are using the system.",
                        "businessUnit": "Business Unit",
                        "taxRate": "Tax Rate",
                        "priceList": "Price List",
                    },
                    "productPricingTester": {
                        "title": "Product Pricing Tester"
                    },
                    "accentTutorials": {
                        "title": "Tutorials",
                        "salesReps": "Sales Representatives",
                        "wholesaleOrders": "Wholesale Orders (Supply Jobs)"
                    },
                    "paymentReconciliation": {
                        "title": "Payment Reconciliation"
                    },
                    "statements": {
                        "title": "Statements",
                        "statementType": "Statement Type",
                        "asAtDate": "Raised on or before",
                        "activityDateRange": "Activity Range",
                        "generatingStatements": "Generate {{count}} statement(s)",
                        "generateStatementsTitle": "Generating Statements",
                        "noSelection": "No companies were selected"
                    },
                    "transferReport": {
                        title: "Transfer Report"
                    },
                    "invoices": {
                        "title": "Finance",
                        "expectedIncome": "Incoming Money",
                        "sectionInvoices": "Invoices",
                        "summaryBox": {
                            "open": "Open",
                            "openTooltip": "Invoices in open status, not sent to customer",
                            "awaitingPayment": "Awaiting Payment",
                            "awaitingPaymentTooltip": "Invoices sent to customer and awaiting payment",
                            "overdue": "Overdue",
                            "overdueTooltip": "Invoices awaiting payment that are past the due date",
                            "statements": "Statements",
                            "statementsTooltip": "View and Generate Statements",
                            "transferReport": "Transfer Report",
                            "transferReportTooltip": "Report of transferred data"
                        },
                        "sectionPayments": "Payments",
                        "paymentSummaryBox": {
                            "unreconciled": "Unreconciled",
                            "unreconciledTooltip": "Payments that have not yet been marked as reconciled with your back account",
                            "reconciled": "Reconciled",
                            "reconciledTooltip": "Payments that have been marked as reconciled with your back account"
                        }
                    },
                    "tracking": {
                        "title": "Tracking",
                        "titleWithType": "Tracking - {{viewType}}",
                        "existingAppointment": "There are existing open activities for this job",
                        "existingAppointmentOpenSelect": "Open Selected",
                        "existingAppointmentCreateNew": "Create New",
                        "selectAppointment": "Select Appointment",
                        "selectViewLabel": "Tracking View",
                        "selectViewPlaceholder": "Select View",
                        "searchPlaceholder": "Search...",
                        "newNotePlaceholder": "Enter file note text and press <enter>",
                        "noResults": "No Result Found",
                        "total": "TOTAL",
                        "showDetails": "Show Details",
                        "hideDetails": "Hide Details",
                        "quoting": "Quoting",
                        "jobs": "Jobs",
                        "opportunities": "Opportunities",
                        "projects": "Projects",
                        "followUp": "Follow Up",
                        "snooze1Day": "1 Day",
                        "snooze2Day": "2 Days",
                        "snooze3Day": "3 Days",
                        "snooze1Week": "1 Week",
                        "snooze2Week": "2 Weeks",
                        "snooze3Week": "3 Weeks",
                        "snooze1Month": "1 Month",
                        "recordChanged": "This job has changed. Click the refresh icon to refresh the data",
                        "quoting_active": "Active Quotes",
                        "quoting_active_desc": "$t(application_strings.views.tracking.quoting_active) - All active jobs in the quoting stage",
                        "quoting_open": "Open Quotes",
                        "quoting_open_desc": "$t(application_strings.views.tracking.quoting_open) - Jobs in the quoting stage that have an open status",
                        "quoting_sent": "Sent Quotes",
                        "quoting_sent_desc": "$t(application_strings.views.tracking.quoting_sent) - Jobs in the quoting stage that have had the quote document sent to the customer",
                        "quoting_expired": "Expired Quotes",
                        "quoting_expired_desc": "$t(application_strings.views.tracking.quoting_expired) - Jobs in the quoting stage that expired before the customer accepted the quote document",
                        "quoting_lost": "Lost Quotes",
                        "quoting_lost_desc": "$t(application_strings.views.tracking.quoting_lost) - Jobs where the customer did not progress and have been marked as lost",
                        "jobs_active": "Active Orders",
                        "jobs_active_desc": "$t(application_strings.views.tracking.jobs_active) - All active jobs in the order stage",
                        "jobs_all_orders": "All Orders",
                        "jobs_all_orders_desc": "$t(application_strings.views.tracking.jobs_all_orders) - All active and closed jobs in the order stage.",
                        "jobs_book_appt": "Book Appointments",
                        "jobs_book_appt_desc": "$t(application_strings.views.tracking.jobs_book_appt) - All active jobs that require appointments to be booked",
                        "projects_all": "Project Management View",
                        "projects_all_desc": "$t(application_strings.views.tracking.projects_all) - Project Management view of active jobs",
                        "opps_lead": "Leads",
                        "opps_lead_desc": "$t(application_strings.views.tracking.opps_lead) - Leads that are not profiled and/or have not been scheduled an appointment",
                        "opps_quotation": "Quotation",
                        "opps_quotation_desc": "$t(application_strings.views.tracking.opps_quotation) - Lead becomes an Opportunity as a quote has been created and has been sent to the customer",
                        "opps_negotiation": "Negotiation",
                        "opps_negotiation_desc": "$t(application_strings.views.tracking.opps_negotiation) - Leads profiled and/or have not been scheduled an appointment",
                        "opps_won": "Won",
                        "opps_won_desc": "$t(application_strings.views.tracking.opps_won) - Opportunity won.  Customer has confirmed to proceed with a quote",
                        "opps_lost": "Lost",
                        "opps_lost_desc": "$t(application_strings.views.tracking.opps_lost) - Opportunity Lost.  Customer is not proceeding with any quotes given",
                        "dispatch": "Dispatch",
                        "dispatch_scheduler": "Dispatch Scheduling",
                        "dispatch_scheduler_desc": "$t(application_strings.views.tracking.dispatch_scheduler) - Schedule and manage dispatch appointments",
                        "dispatch_job_planning": "Dispatch Job Planning",
                        "dispatch_job_planning_desc": "$t(application_strings.views.tracking.dispatch_job_planning) - Plan and group jobs for dispatch scheduling",
                        "service_pending_approval": "Pending Approval",
                        "service_pending_approval_desc": "$t(application_strings.views.tracking.service_pending_approval) - All active service jobs in the quoting stage",
                        "service_sent": "Sent",
                        "service_sent_desc": "$t(application_strings.views.tracking.service_sent) - Service jobs in the quoting stage that have had the quote document sent to the customer",
                        "service_approved": "Approved",
                        "service_approved_desc": "$t(application_strings.views.tracking.service_approved) - Active service jobs that have been confirmed",
                        "service_expired": "Expired Service Jobs",
                        "service_expired_desc": "$t(application_strings.views.tracking.service_expired) - Service jobs in the quoting stage that expired before the being approved",
                        "restock_restock": "Restocked Lines",
                        "restock_restock_desc": "$t(application_strings.views.tracking.restock_restock) - All Unconsumed restocked items",
                        "restock_all": "Restocked/Consumed/Discarded",
                        "restock_all_desc": "$t(application_strings.views.tracking.restock_all) - All restocked items",
                        "expired": "Expired",
                        "service": "Service",
                        "restock": "Restock",
                        "workflow": "Workflow",
                        "workflow_inbox": "Workflow Inbox",
                        "workflow_inbox_desc": "$t(application_strings.views.tracking.workflow_inbox) - Workflow tasks that require manual stage action",
                        "mf": "Manufacturing",
                        "mf_scheduler": "MF Scheduling",
                        "mf_scheduler_desc": "$t(application_strings.views.tracking.mf_scheduler) - All supply jobs ready for or in Manufacturing",
                        "updateCommitReasonTitle": "Bulk Update Commitment Reason",
                        "updateCommitReasonLabel": "Select Commitment Reason",
                        "updateCommissionDateTitle": "Bulk Update Commission Date",
                        "updateCommissionDateLabel": "Select Commission Date",
                        "updateCommissionDateNoPermission": "You do not have permission to change commission dates",
                        "alerts": {
                            "requireCM": "The job was confirmed {{days}} day(s) ago with no check measure booked",
                            "stockDue": "Stock has not been receipted and is due in {{days}} day(s)",
                            "jobEdit": "Job has been in edit mode for {{days}} day(s)",
                            "supplyPending": "This job failed to successfully send to your supplier. Please investigate or try resending it to the supplier.",
                            "stockNotArrived": "Dispatch Appt. is due in {{days}} day(s) and stock has not been receipted",
                            "quoteToExpire": "The quote will expire in {{days}} day(s)",
                            "validationErrors": "Validation Errors",
                            "requireDep": "A minimum deposit of {{amount}} is required",
                            "cmNotConfirmed": "Check Measure Appointment was booked {{days}} day(s) ago and has not been confirmed.",
                            "instNotConfirmed": "Dispatch Appointment was booked {{days}} day(s) ago and has not been confirmed.",
                            "instNotCompleted": "Dispatch Appointment was {{days}} day(s) ago and has not been completed.",
                            "availableCredit": "{{name}} has {{amount}} of credit"
                        },
                        "actions": {
                            "bookService": "Book Service in Calendar",
                            "bookServiceMaps": "Book Service with Maps",
                            "bookCM": "Book Check Measure in Calendar",
                            "bookCMMaps": "Book Check Measure with Maps",
                            "bookInst": "Book Dispatch in Calendar",
                            "bookInstMaps": "Book Dispatch with Maps",
                            "planInstaller": "Installer Planner",
                            "moveToSupply": "Move to Supply",
                            "alterTags": "Alter Tags",
                            "updateCommitReason": "Set Commit Reason",
                            "updateCommissionDate": "Set Commission Date",
                            "resendToSupply": "Resend to Supply",
                            "updateETA": "Update ETA",
                            "goodsReceived": "Receipt Goods",
                            "closeJob": "Close Job",
                            "cancelJob": "Cancel Job",
                            "invoiceJobGenerate": "Generate Invoice Only",
                            "invoiceJob": "Generate and Send Invoice",
                            "editJob": "Edit Job",
                            "finishEditJob": "Finish Edit",
                            "newPayment": "New Payment",
                            "sendOrderConfirmation": "Email Order Confirmation",
                            "printOrderConfirmation": "Print - Order Confirmation",
                            "printInstallJobSheet": "Print - Install Job Sheet",
                            "processInstall": "Process Install",
                            "markAsDispatched": "Mark as Dispatched"
                        },
                        "filters": {
                            "alertHasAlert": "Show Alert",
                            "all": "Show All",
                            "dayToday": "Today",
                            "dayTomorrow": "Tomorrow",
                            "day_1": "Monday",
                            "day_2": "Tuesday",
                            "day_3": "Wednesday",
                            "day_4": "Thursday",
                            "day_5": "Friday",
                            "day_6": "Saturday",
                            "day_0": "Sunday"
                        },
                        "quotingGrid": {
                            "reference": "Reference",
                            "salesRep": "Sales Rep",
                            "company": "Company",
                            "quoteDate": "Quote Date",
                            "daysSinceSent": "Days since Sent",
                            "contact": "Contact",
                            "stage": "Stage",
                            "alert": "Alert",
                            "city": "City",
                            "productSummary": "Products",
                            "daysToExpiry": "Days to Expiry",
                            "amountPaid": "Paid",
                            "salePriceInc": "Sale Price Inc",
                            "validation": "Validation",
                            "followUp": "Follow Up",
                            "expired": "EXPIRED",
                            "today": "TODAY"
                        },
                        "orderingGrid": {
                            "check": "Select",
                            "alert": "Alerts",
                            "reference": "Reference",
                            "orderDate": "Order Date",
                            "salesRep": "Sales Rep",
                            "company": "Company",
                            "contact": "Contact",
                            "siteContact": "Site Contact",
                            "city": "City",
                            "status": "Status",
                            "amountPaid": "Paid",
                            "products": "Product",
                            "eta": "ETA",
                            "jobType": "Type",
                            "supplier": "Supplier",
                            "priority": "Priority",
                            "cmBy": "CM By",
                            "installedBy": "Dispatch By",
                            "installDate": "Dispatch Date",
                            "salesInc": "Sales Inc",
                            "actions": "Actions"
                        },
                        "bookApptGrid": {
                            "reference": "Reference",
                            "contact": "Name",
                            "city": "City",
                            "contactInfo": "Contact",
                            "paidPerc": "Paid %",
                            "product": "Product",
                            "daysSinceConfirmed": "Days Since Ordered",
                            "checkMeasuresRequired": "CM Required",
                            "installsRequired": "Installs Required",
                            "eta": "ETA",
                            "validation": "Validation",
                            "followUp": "Follow Up",
                            "today": "TODAY"
                        }

                    },
                    "scheduler": {
                        "title": "Scheduler",
                        "user": "Representative",
                        "missingMapCoordinates": "One or more items to be scheduled are missing map coordinates",
                        "noData": "No items to schedule.",
                        "missingAddressExistingApt": "<p>The location of this address in not known. Please drag this appointment to the correct location on the map.</p><p>{{address}}</p>"
                    },
                    "newVersionDialog": {
                        "title": "Insyte Web Updated",
                        "message": "Insyte Web has been updated. Please see your notifications for important changes."
                    },
                    "login": {
                        "title": " Insyte Web",
                        "username": "Email",
                        "password": "Password",
                        "passwordVerify": "Confirm Password",
                        "rememberMe": "Remember Me",
                        "submit": "Log in",
                        "forgotPassword": "Forgot your password?",
                        "loginFailedMsg": "The email or password entered was in correct. If you are having trouble logging in you may want to try the Forgot your password feature below",
                        "passwordMissmatch": "Passwords do not match",
                        "passwordRequired": "Password is required",
                        "account": "Select Business",
                        "accountMsg": "You email is associated with multiple businesses. Please select the business you want to login to.",
                        "passwordRquirementTitle": "Password Strength",
                        "passwordRquirementMin": "Minimum length 6",
                        "passwordRquirementDigit": "At least 1 digit",
                        "passwordRquirementLower": "At least 1 lowercase letter",
                        "passwordRquirementUpper": "At least 1 uppercase letter",
                        "passwordRquirementMatch": "Confirm password matches",
                    },
                    "resetPassword2FA": {
                        "title": " Reset Password",
                        "username": "Email",
                        "code": "Enter Code",
                        "invalidCode": "Invalid Code",
                        "passwordMissmatch": "Passwords do not match",
                        "passwordRequired": "Password is required",
                        "password": "Password",
                        "passwordVerify": "Confirm Password",
                    },
                    "dashboard": {
                        "title": "Dashboard",
                        "noOfMonthsLabel": {
                            "label0": "# of Months (current month)",
                            "label1": "# of Months (from previous month)",
                            "labelX": "# of Months (from {{months}} months ago)"
                        },
                        "etaDaysLabel": {
                            "label0": "Same ETA",
                            "label1": "From {{days}} day before and upto {{days}} day after ETA",
                            "labelX": "From {{days}} days before and upto {{days}} days after ETA"
                        },
                        "distanceLabel": "Within {{distance}}km",
                        "installTimeLabel": "Estimated install time per line {{installTime}} mins",
                        "businessUnit": "Business Units",
                        "jobLineStage": "Job Line Stages",
                        "widgets": {
                            "oppPipeLine": {
                                "leads": "Leads",
                                "leads_desc": "Leads that are not profiled and/or have not been scheduled an appointment",
                                "quotations": "Quotations",
                                "quotations_desc": "Leads profiled and have been scheduled an appointment, but no quote has been sent to the customer",
                                "negotiations": "Negotiations",
                                "negotiations_desc": "Lead becomes an Opportunity as a quote has been created and has been sent to the customer",
                                "won": "Won",
                                "won_desc": "Opportunity won.  Customer has confirmed to proceed with a quote",
                                "lost": "Lost",
                                "lost_desc": "Opportunity Lost.  Customer is not proceeding with any quotes given"
                            },
                            "salesConversion": {
                                "rep": "Rep",
                                "rep_desc": "KS to provide",
                                "rep": "Rep",
                                "rep_desc": "KS to provide",
                            },
                            "salesPerformanceByMonth": {
                                "month": "Month",
                                "wonCount": "Won (Count)",
                                "wonCountDesc": "Opportunities with a status of Won that was closed in the Month",
                                "lostCount": "Lost (Count)",
                                "lostCountDesc": "Opportunities in the pipline stage negotiation or contract with a status of Lost that was closed in the Month",
                                "conversionCount": "Conversion %",
                                "conversionCountDesc": " Win(Count)  /( (Win_count) + (Lost Count))",
                                "wonAmount": "Won {{accentCurrencySymbol}}",
                                "wonAmountDesc": "sum(confirmed orderines inc GST) linked to Opportunities with a status of Won that was closed in the Month",
                                "lostAmount": "Lost {{accentCurrencySymbol}}",
                                "lostAmountDesc": "sum(Quotes inc GST forecasted) linked Opportunities in the pipline stage of negotiation with a status of Lost that was closed in the Month",
                                "conversionAmount": "Conv {{accentCurrencySymbol}}",
                                "conversionAmountDesc": "Win {{accentCurrencySymbol}}   / ( (Win {{accentCurrencySymbol}}) + (Lost {{accentCurrencySymbol}}))",
                            },
                            "salesPerformanceByRep": {
                                "month": "Month",
                                "leadCount": "Leads (Count)",
                                "leadCountDesc": "All leads in the lead stage that are assigned to the rep.",
                                "quotationCount": "Quotation (Count)",
                                "quotationCountDesc": "All leads in the Quotation pipeline stage that are assigned to the rep.",
                                "negotiationCount": "Negotiation (Count)",
                                "negotiationCountDesc": "Opportunities in Negotiation Stage.",
                                "wonCount": "Won (Count)",
                                "wonCountDesc": "Opportunities with a status of Won that was closed in the time frame",
                                "lostCount": "Lost (Count)",
                                "lostCountDesc": "ALl opportunities with a status changed to Lost in the time frame",
                                "conversionCount": "Conversion %",
                                "conversionCountDesc": " Win(Count)  /( (Win_count) + (Lost Count))",
                                "negotiationAmount": "Negotiation {{accentCurrencySymbol}}",
                                "negotiationAmountDesc": "Sum of quotes link to opportunities in negotiation stage ( quote is forecasted)",
                                "wonAmount": "Won {{accentCurrencySymbol}}",
                                "wonAmountDesc": "All opportunites Won - when the opportunity status changed to won, in the time frame",
                                "lostAmount": "Lost {{accentCurrencySymbol}}",
                                "lostAmountDesc": "All opportunties Lost - when the opporutnity status is changed to lost in the time frame",
                                "conversionAmount": "Conv {{accentCurrencySymbol}}",
                                "conversionAmountDesc": "Win {{accentCurrencySymbol}}   / ( (Win {{accentCurrencySymbol}}) + (Lost {{accentCurrencySymbol}}))",
                            },
                            "salesAmountByRepByMonth": {
                                "total": "TOTAL"
                            },
                            "financeProjectedRevenue": {
                                "businessUnit": "Business Unit",
                                "businessUnitDesc": "Un-invoiced amounts excluding tax for the business unit",
                                "sales": "Sales",
                                "salesDesc": "Un-invoiced amounts excluding tax for sales jobs",
                                "services": "Services",
                                "servicesDesc": "Un-invoiced amounts excluding tax for service jobs",
                                "total": "Total",
                                "totalDesc": "Total un-invoiced amounts excluding tax for the sales and service jobs"
                            }

                        }
                    },
                    "picklists": {
                        "title": "Picklists"
                    },
                    "calendar": {
                        "title": "Calendar",
                        "notes": "Notes",
                        "notesPlaceHolder": "enter notes",
                        "appointment": "Appointment",
                        "owner": "Owner",
                        "ownerTeam": "Owner/Team",
                        "newAppointment": "New",
                        "newEvent": "New Recurring Event",
                        "editEvent": "Edit Event",
                        "editRecurringEvent": "Edit recurring event",
                        "editSeriesOrOccurrence": "Do you want to change the series or just this occurrence?",
                        "editSeries": "Edit series",
                        "editInstance": "Edit instance",
                        "editOccurrence": "Edit this occurrence",
                        "eventTitleWithSubject": "Event — {{subject}}",
                        "eventUntitledSubject": "(no subject)",
                        "eventSwitchToEdit": "Edit",
                        "eventSwitchToView": "View",
                        "viewSeriesTab": "Series",
                        "viewInstanceTab": "Instance",
                        "eventViewTitle": "Event",
                        "eventDetails": "Event Details",
                        "scheduleDetails": "Schedule Details",
                        "useDialogTitle": "Select Calendars",
                        "settingsDialogTitle": "Calendar Settings",
                        "generateRunDialogTitle": "Generate Run",
                        "generateRunDialogSplitByRep": "Split by representative",
                        "generateRunDialogEmailRep": "Email representative",
                        "setupTitle": "Setting up your calendar",
                        "setupMessage": "Make sure you have selected to include either Sales or Installation users. If you still can't see any users make sure the 'Show in calendar' and either quoting or installation features are enabled in settings for your users",
                        "setupLink": "",
                        "deleteCMWithCompletedTitle": "Deleting Check Measure Appointment",
                        "deleteCMWithCompletedTitleMsg": "You are deleting this check measure appointment. There is a previously completed check measure. Do you want to update the job as having been check measured",
                        "deleteInstallWithCompletedTitle": "Deleting Dispatch Appointment",
                        "deleteInstallWithCompletedTitleMsg": "You are deleting this dispatch appointment. There is a previously completed appointment. Do you want to update the job as having been dispatched",
                        "deleteClosedActivityTitle": "Cannot Delete Activity",
                        "deleteClosedActivityMsg": "Closed and cancelled activities cannot be deleted",
                        "deleteActivityFeatureDisabledTitle": "Delete Appointment not permitted",
                        "deleteActivityFeatureDisabledMsg": "You are not permitted to perform this action",
                        "byPassCMTitle": "Skip Check Measure",
                        "byPassCMMsg": "STOP: If you continue one or more jobs that require a Check Measure will be marked as Check Measure Completed.",
                        "byPassCMNoPermissionMsg": "One or more jobs that require a Check Measure will be marked as Check Measure Completed. You don't have permission to continue",
                        "byPassCMButton": "Complete Check Measures",
                        "deleteInProgressCMTitle": "Check Measure In-Progress",
                        "deleteInProgressCMMsg": "This check measure is in-progress and cannot be deleted. Please complete the check measure first.",
                        "runSheet": "Generate Run Sheet",
                        "jobSheet": "Generate Job Sheet",
                        "combined": "Both",
                        "noReps": "No representatives are selected.",
                        "invalidDates": "Invalid date range selected.",
                        "noTemplate": "No document template selected.",
                        "oneRepForPreview": "Preview is only available when selecting a single representative.",
                        "repeatEvery": "Repeat every",
                        "repeatEveryNumber": "Number",
                        "repeatEveryUnit": "Unit",
                        "repeatUnit_day": "Day",
                        "repeatUnit_week": "Week",
                        "repeatUnit_month": "Month",
                        "repeatUnit_year": "Year",
                        "repeatUnit_day_plural": "Days",
                        "repeatUnit_week_plural": "Weeks",
                        "repeatUnit_month_plural": "Months",
                        "repeatUnit_year_plural": "Years",
                        "eventOccurs_daily": "Occurs every day",
                        "eventOccurs_every": "Occurs every",
                        "eventOccurs_onDays": " on {{days}}",
                        "eventOccurs_noPattern": "No recurrence pattern",
                        "eventOccurs_untilDate": "Until {{date}}",
                        "eventOccurs_afterOccurrences": "Stops after {{n}} {{unit}}",
                        "eventOccurs_lastSeriesDate": "Last series date: {{date}}",
                        "day_SU": "Sun",
                        "day_MO": "Mon",
                        "day_TU": "Tue",
                        "day_WE": "Wed",
                        "day_TH": "Thu",
                        "day_FR": "Fri",
                        "day_SA": "Sat",
                        "recurrenceEnd_never": "Never ends",
                        "recurrenceEnd_endsOn": "Ends on",
                        "recurrenceEnd_endsAfter": "Ends after",
                        "recurrenceUntil": "End date",
                        "recurrenceCount": "Occurrences",
                        "recurrenceMonthlyPattern": "Repeat on",
                        "recurrenceByWeekday": "On weekday (e.g. 2nd Thursday)",
                        "recurrenceByDayOfMonth": "On day of month (e.g. 12th)",
                        "recurrenceOnDay_month": "On Day {{day}}",
                        "recurrenceOnDay_year": "On {{month}} {{day}}",
                        "recurrenceOnWeekday_month": "On {{ordinal}} {{weekday}}",
                        "recurrenceOnWeekday_year": "On the {{ordinal}} {{weekday}} of {{month}}",
                        "ordinal_1": "1st",
                        "ordinal_2": "2nd",
                        "ordinal_3": "3rd",
                        "ordinal_4": "4th",
                        "ordinal_5": "5th",
                        "occurrence": "occurrence",
                        "occurrences": "occurrences",
                        "instance": "instance",
                        "instances": "instances",
                        "busyStatus": "Show as",
                        "busy": "Busy",
                        "free": "Free",
                        "activityColor": "Activity Color",
                        "summary": {
                            "rep": ""
                        }
                    },
                    "company": {
                        "title": "Company",
                        "sectionDetails": "Details",
                        "sectionAddress": "Address/Notes",
                        "sectionCustomPricing": "Custom Pricing",
                        "sectionJobs": "Jobs",
                        "sectionPayments": "Payments",
                        "sectionActivities": "Activities",
                        "sectionContacts": "Contacts",
                        "sectionFinancialDetails": "Financial Details",
                        "duplicatePricing": {
                            "title": "Duplicate Products",
                            "msg": "Duplicate Product found. Please ensure each product is only specified once"
                        }
                    },
                    "contact": {
                        "title": "Contact - {{LastName}}",
                        "sectionDetails": "Details",
                        "sectionAddress": "Billing Address/Notes",
                        "sectionJobs": "Jobs",
                        "sectionPayments": "Payments",
                        "sectionActivities": "Activities",
                        "sectionCommunications": "Communication Log",
                    },
                    "job": {
                        "title": "Job - {{Reference}}",
                        "all": "Select All",
                        "unconfirmed": "Unconfirmed Only",
                        "confirmed": "Confirmed Only",
                        "clear": "Clear",
                        "serviceJobs": "Service Jobs",
                        "invoices": "Invoices",
                        "servicesEmpty": "No Service Jobs",
                        "invoicesEmpty": "No invoices",
                        "supplyJobs": "Supply Jobs",
                        "supplyJobsEmpty": "No supply jobs",
                        "sectionDetailsJob": "Job - $t({{Stage}}) Stage ",
                        "sectionDetailsServiceJob": "Service Job - $t({{Stage}}) Stage ",
                        "sectionAddress": "Address",
                        "sectionJobCommissions": "Commissions",
                        "sectionCommunications": "Communication Log",
                        "sectionNotes": "Notes",
                        "sectionJobDetails": "Job Details",
                        "siteAddress": "Site / Delivery Address",
                        "deliveryAddress": "Default Supply Job Delivery Address",
                        "useCompanyAddress": "Copy Company Address",
                        "useContactAddress": "Copy Contact Address",
                        "useSiteContactAddress": "Copy Site Contact Address",
                        "sectionPayments": "Payments",
                        "sectionActivities": "Activities",
                        "customerNotes": "Customer Notes",
                        "customerNotesPlaceHolder": "Enter customer notes here...",
                        "customerNamePlaceHolder": "name of your customer...",
                        "siteContactNamePlaceHolder": "name of the site contact...",
                        "fileNotesDisabled": "Please save job before adding file notes",
                        "installNotes": "Installation Notes",
                        "installNotesDisabled": "Please save job before adding install notes",
                        "supplyNotes": "Supply/Manufacturing Notes",
                        "supplyNotesPlaceHolder": "Enter notes concerning the supplier here...",
                        "installNotesPlaceHolder": "Enter notes concerning the installation here...",
                        "internalNotesPlaceHolder": "Enter internal notes here...",
                        "scheduleServiceMessage": "Create a new Appointment to schedule a service appointment for '{{order}}'",
                        "scheduleCheckMeasureMessage": "Create a new Appointment to schedule a check measure appointment for '{{order}}'",
                        "scheduleInstallMessage": "Create a new Appointment to schedule a dispatch appointment for '{{order}}'",
                        "scheduleAppointmentSubject": "{{type}} - {{order}} - {{name}} - {{city}}",
                        "reprice": "Reprice Now",
                        "hideLineDetails": "Hide Details",
                        "showLineDetails": "Show Details",
                        "reviewJobTitle": "Preview",
                        "printJobTitle": "Print",
                        "mobileJobReviewTitle": "Review Details",
                        "mobileJobReviewCommon": "COMMON",
                        "reQuoteInfo": "When re-quoting you can change from one product to another if you choose to.",
                        "excludeProduct": "EXCLUDE PRODUCT",
                        "percentage": "%",
                        "dollar": "{{accentCurrencySymbol}}",
                        "incTax": "Inc. Tax",
                        "exTax": "Ex. Tax",
                        "lines": {
                            "lineNo": "Line No",
                            "productName": "Product",
                            "qty": "Qty",
                            "width": "Width",
                            "drop": "Drop",
                            "location": "Location/Desc",
                            "stage": "Stage",
                            "status": "Status",
                            "dispatchStage": "Dispatch Stage",
                            "cost": "Cost Ex",
                            "salePrice": "Sale Price",
                            "salePriceTax": "Tax",
                            "salePriceInc": "Sale Price Inc",
                            "lessCredit": "Less Credit ({{Credit}})",
                            "lessCCFee": "Less CC Fee ({{Fee}})",
                            "paid": "Paid",
                            "paidIncludesProcessedDraft": "Includes a draft merchant payment that needs to be processed or cancelled",
                            "balance": "Balance",
                            "lines": "Lines",
                            "confirmedLines": "Confirmed Lines",
                            "unconfirmedLines": "Unconfirmed Lines",
                            "supplementaryCharges": "Supplementary Charges",
                            "total": "Total",
                            "lineType": "Type"
                        },
                        "openDispatchAppointment": "Unresolved Dispatch Appointment",
                        "closeDispatchAppointments": "The following appoint must be closed before continuing.",
                        "viewEstimatedCommissions": "Est. Commissions",
                        "viewEstimatedCommissionsMobile": "Est.",
                        "viewComissionDates": "Commission Dates",
                        "viewComissionDatesMobile": "Dates",
                        "viewOrderDates": "Order Dates",
                        "viewOrderDatesMobile": "Dates",
                        "viewActualCommissions": "Statement",
                        "etaDatesDlg": {
                            "title": "ETA Dates",
                            "warning": ""
                        },
                        "commissionDatesDlg": {
                            "title": "Commission Dates",
                            "warning": "WARNING: Changing the date may result in commissions being paid more than once. The automatic commission date rule only applies to jobs with no commission date set."
                        },
                        "orderDatesDlg": {
                            "title": "Order Dates",
                            "warning": "",
                            "validation": {
                                "invalidPayload": "Invalid request.",
                                "jobDateRequired": "Job date is required.",
                                "jobNotFound": "Job not found.",
                                "notAllowedForQuote": "Order dates can only be updated for confirmed orders.",
                                "jobNotInEditMode": "Job must be in edit mode or closed to update order dates.",
                                "invalidLine": "Invalid job line.",
                                "requireAllDates": "All confirmed lines must have an Order Date.",
                                "lineBeforeJobDate": "Line Order Date cannot be before Job Date."
                            }
                        },
                        "css": {
                            "documentLastSentDate": "Document Last Sent",
                            "lastViewDate": "Last Viewed",
                            "viewCount": "View Count",
                            "jobAmount": "Amount",
                            "jobPaid": "Paid",
                            "jobRemainingAmount": "Remaining Amount"
                        }
                    },
                    "reportAccess": {
                        "title": "Report Access",
                    },
                    "report": {
                        "title": "Reports",
                        "prompt": "Please select a report to view.",
                        "noAccess": "You have not been given access to any reports. Please see your administrator or assign access under reports in Management.",
                        "toggleDesignFrom": {
                            "true": "View",
                            "false": "Design"
                        }
                    },
                    "customReportEdit": {
                        "title": "Custom Report Editor",
                        "readonlyMode": "This document is in readonly mode and cannot be saved"
                    },
                    "customDocument": {
                        "title": "Custom Document ({{Name}})",
                        "unpublishedChanges": "This document has unpublished changes",
                        "importDraftTitle": "Import Draft (.rep)"
                    },
                    "jobDiscount": {
                        "title": "Discounts",
                        "cost": "COST",
                        "sales": "SALES",
                        "profit": "PROFIT",
                        "show": "Show",
                        "discountType": "Discount",
                        "dollar": "{{accentCurrencySymbol}}",
                        "percentage": "%",
                        "amountType": "Amounts",
                        "incTax": "Inc. Tax",
                        "exTax": "Ex. Tax",
                        "showTax": "Tax",
                        "amount": "Amount",
                        "install": "Install",
                        "lineGroup": "Show Lines By",
                        "groupProduct": "Product",
                        "groupLine": "Job",
                        "margin": "Margin",
                        "markup": "Markup",
                        "marginBtn": "MARGIN",
                        "markupBtn": "MARKUP",
                        "delivery": "Delivery",
                        "showAmount": "Show Amounts",
                        "taxWarning": "*Tax will be calculated by line and so may change",
                        "approvalRequired": "Approval Required",
                        "minJobPrice": "Min approved price {{amount}}",
                        "salesPromotionWarning": "Sales promotion rules are applied to the sales price. These rules cannot be overridden.",
                        "toolTips": {
                            "BaseCostAmount": "Cost amount excluding install and delivery before any discounts",
                            "BaseCostInstall": "Cost amount for installation before any discounts",
                            "BaseCostDelivery": "Cost amount for delivery before any discounts",
                            "BaseCostTotal": "Total cost amount including base cost, installation cost and delivery cost before any discounts",
                            "DiscCostAmount": "The amount of discount to be applied to the cost excluding installation and delivery",
                            "DiscCostInstall": "The amount of discount to be applied to the installation portion of the cost",
                            "DiscCostDelivery": "The amount of discount to be applied to the delivery portion of the cost",
                            "DiscCostTotal": "The amount of discount to be applied to the total cost including installation and delivery",
                            "FinalCostAmount": "Total cost amount excluding installation and delivery costs after the discount is applied",
                            "FinalCostInstall": "Total installation cost amount after the installation discount is applied",
                            "FinalCostDelivery": "Total delivery cost amount after the delivery discount is applied",
                            "FinalCostTotal": "Total cost amount including installation and delivery after the discounts are applied",

                            "BaseRetailAmount": "Sales list price excluding install and delivery before any discounts",
                            "BaseRetailInstall": "Installation sales list price before any discounts",
                            "BaseRetailDelivery": "Delivery sales list price before any discounts",
                            "BaseRetailTotal": "Total sales list price including base price, installation price and delivery price before any discounts",
                            "DiscRetailAmount": "The amount of discount to be applied to the sales list price excluding installation and delivery",
                            "DiscRetailInstall": "The amount of discount to be applied to the installation portion of the sales list price",
                            "DiscRetailDelivery": "The amount of discount to be applied to the delivery portion of the sales list price",
                            "DiscRetailTotal": "The amount of discount to be applied to the total sales list price including installation and delivery",
                            "FinalRetailAmount": "Total sales price excluding installation and delivery after the discount is applied",
                            "FinalRetailInstall": "Total installation sales price after the installation discount is applied",
                            "FinalRetailDelivery": "Total delivery sales price after the delivery discount is applied",
                            "FinalRetailTotal": "Total sales price including installation and delivery after the discounts are applied",
                        },
                        "warnings": {
                            "productsHidden": "Select show lines by product to display hidden product level discounts",
                            "amountHidden": "Select 'Amount' to display hidden discounts on the amount columns",
                            "installHidden": "Select 'Install' to display hidden discounts on the install columns",
                            "deliveryHidden": "Select 'Delivery' to display hidden discounts on the delivery columns",
                            "salesHidden": "Select 'SALES' to display hidden discounts on sale price columns",
                            "costHidden": "Select 'COST' to display hidden discounts on cost price columns",
                        }
                    },
                    "opportunity": {
                        "title": "Opportunity {{Description}}",
                        "sectionContactDetails": "Contact / Status",
                        "sectionAddress": "Address / Notes",
                        "sectionLeadDetails": "Lead Details",
                        "useCompanyAddress": "Copy Company Address",
                        "useContactAddress": "Copy Contact Address",
                        "useSiteContactAddress": "Copy Site Contact Address",
                        "useCompanyAddressSmall": "Company",
                        "useContactAddressSmall": "Contact",
                        "useSiteContactAddressSmall": "Site Contact",
                        "siteAddress": "Site Address",
                        "deliveryAddress": "Delivery Address",
                        "fullHouse": "Full",
                        "notes": "Notes",
                        "notesPlaceHolder": "enter notes here...",
                        "customerNamePlaceHolder": "name of your customer...",
                        "siteContactNamePlaceHolder": "name of site contact",
                        "scheduleOpportunityMessage": "Create a new Appointment to schedule '{{opportunity}}' opportunity",
                        "sectionProductOfInterest": "Lead Source / Products of Interest",
                        "poi": "Products of Interest",
                        "sectionJobs": "Jobs"
                    },
                    "leads": {
                        "title": "Leads",
                        "sectionLeads": "Leads",
                        "hideDetails": "Hide Details",
                        "showDetails": "Show Details",
                        "summaryBox": {
                            "webLeads": "Web Leads",
                            "webLeadsTooltip": "Unprocessed leads imported from other websites",
                            "leads": "Leads",
                            "leadsTooltip": "Unqualified leads, no appointment and no quote",
                            "quotationLeads": "Quotation",
                            "quotationLeadsTooltip": "Leads profiled and have been scheduled an appointment, but no quote has been sent to the customer",
                            "negotiationLeads": "Negotiation",
                            "negotiationLeadsTooltip": "Lead becomes an Opportunity as a quote has been created and has been sent to the customer",
                            "lostLeads": "Lost",
                            "lostLeadsTooltip": "Leads lost in the last 12 months"
                        },
                        "leadGrid": {
                            "actions": "Actions",
                            "matches": "Possible Matching Contacts:",
                            "noMatches": "No matches found.",
                            "createNew": "New Contact",
                            "snooze": "Snooze Lead",
                            "wake": "Wake Lead",
                            "createExising": "Existing",
                            "discard": "Discard Lead",
                            "leadDetails": "Lead Details",
                            "productsOfInterest": "Products Of Interest",
                            "customProperties": "Custom Properties",
                            "fileNotes": "File Notes",
                            "date": "Date",
                            "snoozeDate": "Select Snooze Date",
                            "selectSnoozeDateTitle": "Snooze lead until...",
                            "leadSource": "Lead Source",
                            "firstName": "First Name",
                            "lastName": "Last Name",
                            "email": "Email",
                            "mobile": "Mobile",
                            "workPh": "Work Ph",
                            "homePh": "Home Ph",
                            "phone": "Phone",
                            "snoozed": "Snoozed",
                            "discardDlgTitle": "Discard Lead",
                            "discardReasonLabel": "Discard Reason",
                            "discardNotesLabel": "Discard Notes",
                        }
                    },
                    "newLead": {
                        "title": "New Lead",
                        "searchLabel": "Search",
                        "description": "Existing Customer Results",
                        "useExisting": "Use Existing",
                        "searchPlaceholder": "Search to see if customer exists",
                        "instruction1": "1. First check for existing customer by searching on either name, company, phone numbers, suburb, postcode or address",
                        "instruction2": "2. Select Use Existing if the customer already exists OR select New Customer if the customer cannot be found."
                    },
                    "payment": {
                        "title": "Payment",
                        "notesPlaceHolder": "Enter payment notes",
                        "type": "Customer $t({{Type}})",
                        "required": "Required",
                        "requiredPositive": "Value must be positive",
                        "overAllocated": "This payment has been over allocated. Please un-allocate some monies",
                        "maxRefund": "The maximum amount that can be refunded is {{maxRefund}}",
                        "processAlert1": "This draft payment was processed as a merchant payment but processing was declined or not completed.",
                        "processAlert2": "You may want to cancel it to avoid it appearing in balances or try processing it again.",
                        "processAlertClearTooltip": "Permanently remove this warning",
                        "cancelDraft": {
                            "title": "Canceling Payments",
                            "msg": "You are about to cancel this payment. This cannot be undone. Click \"Cancel Payment\" to continue or click \"Back\" to go back",
                        },
                        "noAllocations": {
                            "title": "Warning: No Allocations",
                            "msg": "Payment/Refund has unallocated monies. Are you sure you want to continue?",
                            "continue": "Continue",
                            "goBack": "Go Back"
                        },
                        "overAllocation": {
                            "title": "Warning: Payment Over-allocated",
                            "msg": "Total of payment/refund allocations exceeds the payment amount. This must be corrected before saving."
                        },
                        "invalidJobRefund": {
                            "title": "Warning: Invalid Refund From Job",
                            "msg": "{{jobNo}} has {{paid}} paid but {{invoiced}} is allocated to an invoice. Reduce the job only allocation to {{max}} and allocate the rest to an invoice."
                        },
                        "allocations": {
                            "job": "Job",
                            "invoice": "Invoice",
                            "amount": "Amount",
                            "minDeposit": "Min Deposit",
                            "paid": "Paid",
                            "outstanding": "Outstanding",
                            "allocated": "Allocated",
                            "allocatedFee": "Fee Applied",
                            "refund": "Refund",
                            "payment": "Payment",
                            "allocations": "Allocations",
                            "unallocated": "Unallocated",
                            "total": "Total"
                        },
                        "processPayment": {
                            "validation": {
                                "title": "Processing Payments",
                                "msg": "Payment Method '{{method}}' must be selected and Amount entered to be able to process a payment."
                            }
                        }
                    },
                    "quoteDiscount": {
                        "title": "Discounts",
                        "line": "Line",
                        "product": "Product Name",
                        "price": "Price",
                        "tax": "Tax",
                        "total": "Total",
                        "discount": "Discount",
                        "discount_abbrev": "Disc.",
                        "final": "Final",
                    },
                    "management": {
                        "title": "Management"
                    },
                    "invoice": {
                        "title": "Invoice {{InvoiceNo}}",
                        "sectionDetails": "Invoice - $t({{Status}}) ",
                        "sectionAddress": "Details / Billing Address",
                        "sectionLines": "Invoice Lines",
                        "billingAddress": "Customer Billing Address",
                        "useCompanyAddress": "Copy Company Address",
                        "useContactAddress": "Copy Contact Address",
                        "sectionCommunications": "Communication Log",
                        "invoiceType": "Customer Invoice",
                        "creditNoteType": "Customer Credit Note",
                        "reOpen": "Re-Open",
                        "email": "Email",
                        "emailSend": "Email (Mark as Sent)",
                        "print": "Print to PDF",
                        "printSend": "Print to PDF (Mark as Sent)",
                        "reviewInvoiceMsg": "Please select the invoice template to use",
                        "reviewInvoiceTitle": "Review Invoice",
                        "lines": {
                            "line": "Line",
                            "description": "Description",
                            "unitPrice": "Unit Price",
                            "qty": "Qty",
                            "price": "Price",
                            "tax": "Tax",
                            "total": "Total",
                            "paid": "Paid",
                            "balance": "Balance",
                            "allocated": "Allocated",
                            "remainingCredit": "Remaining Credit",
                            "lessCredit": "Less Credit ({{Credit}})",
                            "lessCCFee": "Less CC Fee ({{Fee}})",
                            "taxRecalculationWarning": "Tax rates may be out of date.",
                            "taxRecalculationWarningButton": "Refresh Taxes"
                        }
                    },
                    "supplyJob": {
                        "title": "Supply Job {{OrderNumber}}",
                        "relatedOrders": "Related",
                        "relatedOrdersEmpty": "No related items",
                        "sectionDetails": "Supply Job - $t({{Status}}) ",
                        "sectionAddress": "Address",
                        "sectionCommunications": "Communication Log",
                        "sectionNotes": "Notes",
                        "sectionOrderDetails": "Details",
                        "billingAddress": "Billing Address",
                        "deliveryAddress": "Delivery Address",
                        "useCompanyAddress": "Copy Company Address",
                        "useContactAddress": "Copy Contact Address",
                        "supplyNotes": "Supply/Manufacturing Notes",
                        "supplyNotesPlaceHolder": "Enter notes concerning the supplier here...",
                        "internalNotes": "System Notes",
                        "internalNotesPlaceHolder": "System generated note...",
                        "scheduleCheckMeasureMessage": "Create a new Appointment to schedule a check measure appointment for '{{order}}'",
                        "scheduleInstallMessage": "Create a new Appointment to schedule a dispatch appointment for '{{order}}'"
                    },
                    "orderLine": {
                        "title": "Product Line",
                        "sectionDetails": "Details",
                        "sectionConfiguration": "Configuration",
                        "sectionService": "Service",
                        "sectionStock": "Stock",
                        "required": "Required",
                        "requiredOrdering": "Ordering",
                        "requiredQuoting": "Quoting",
                        "all": "All",
                        "sectionNotes": "Notes\\Line Details",
                        "sizeLabel": "Size",
                        "width": "Width",
                        "drop": "Drop",
                        "product": "Product",
                        "customerNotes": "Customer Notes",
                        "customerNotesPlaceHolder": "Enter customer notes here...",
                        "installNotes": "Installation Notes",
                        "installNotesDisabled": "Please save line before adding install notes",
                        "installNotesPlaceHolder": "Enter install notes here...",
                        "supplyNotes": "Supply/Manufacturing Notes",
                        "supplyNotesPlaceHolder": "Enter notes concerning the supplier here...",
                        "reasonNotesPlaceHolder": "Enter notes concerning the fault here...",
                        "pricingInProgress": "Pricing in progress. If this message persists click the reprice button.",
                        "dispatchType": "Dispatch Type",
                        "install": "Install",
                        "pickup": "Pickup",
                        "delivery": "Delivery",
                        "dispatchStage": "Dispatch Stage",
                        "changeServiceLine": "Change Original Line"
                    },
                    "priceMarkup": {
                        "title": "Price Markup",
                    },
                    "quote": {
                        "title": "Quote",
                        "sectionDetails": "Quote",
                        "sectionAddress": "Site Address/Notes",
                        "sectionQuoteDetails": "Quote Details",
                        "siteAddress": "Site Address",
                        "useCompanyAddress": "Copy Company Address",
                        "useContactAddress": "Copy Contact Address",
                        "useSiteContactAddress": "Copy Site Contact Address",
                        "customerNotes": "Customer Notes",
                        "customerNotesPlaceHolder": "Enter customer notes here...",
                        "customerNamePlaceHolder": "name of your customer...",
                    },
                    "quoteReportSettings": {
                        "title": "Quote Report Settings",
                        "termsAndConditions": "Terms and Conditions",
                        "paymentDetails": "Payment Details",
                        "notes": "Notes",
                        "options": "Options",
                        "optionsAsList": "Comma list",
                        "optionsAsTable": "Table",
                        "optionsAsListLabel": "Format As"
                    },
                    "representative": {
                        "title": "User ({{FullName}})",
                        "mobile": "Mobile",
                        "workPhone": "Work Phone",
                        "jobTitle": "Job Title",
                        "emailSignature": "Email Signature",
                        "sectionGeneral": "General",
                        "sectionFeatures": "Features",
                        "manageTeams": "Manage Teams",
                        "manageLicense": "Manage License",
                        "manageSalesDiscountLimits": "Sales Discount Limits",
                        "manageAvailabililty": "Availability",
                        "changeEmail": "Change Email",
                        "changeEmailMsg": "Enter the new email",
                        "changeEmailDone": "Change Email Processed",
                        "canViewCalendarLabel": "Feature Can View Calendars / Activities",
                        "retailJobSignatureRuleLabel": "Validation/Warning Rule for Retail Job Signature Capture",
                        "commisionRules": "Commission Rules",
                        "calendarSync": {
                            "confirmNewLinkTitle": "Generate New Calandar Link",
                            "confirmNewLinkMsg": "The user will need to update their phone calendar with the new link to continue receiving calendar updates",
                            "header": "Calandar Sync Settings",
                            "url": "Link",
                            "generateNew": "Generate New Link",
                            "emailUser": "Email Link to User",
                            "smsUser": "SMS Link to User",
                            "loading": "...",

                            "emailNoLinkTitle": "Link Required",
                            "emailNoLinkMsg": "Please generate a new link before trying again",
                            "emailNoConfigTitle": "Email Configuration Required",
                            "emailNoConfigMsg": "Please check your Email settings",
                            "emailNoCredTitle": "Email Credentials Required",
                            "emailNoCredMsg": "Please check the users email credentials",
                            "emailErrorTitle": "Error Sending Email",
                            "emailErrorMsg": "The following error was returned {{err}}",

                            "smsNoLinkTitle": "Link Required",
                            "smsNoLinkMsg": "Please generate a new link before trying again",
                            "smsNoMobileTitle": "Mobile Number Required",
                            "smsNoMobileMsg": "Please provide a mobile number of the user",
                            "smsNoConfigTitle": "SMS Configuration Required",
                            "smsNoConfigMsg": "Please check your SMS settings",
                            "smsNoCredTitle": "SMS Configuration Required",
                            "smsNoCredMsg": "Please check your SMS settings",
                            "smsErrorTitle": "Error Sending SMS",
                            "smsErrorMsg": "The following error was returned {{err}}",
                            "linkSentTitle": "Link Sent",
                            "linkSentMsg": "The link has been sent.",

                        },
                        "changeEmailDlg": {
                            "emailInUse": {
                                "title": "EMAIL IN USE",
                                "msg": "This email is already in use by another account. Click \"Link Account\" to sent a link request to {{email}}. Once the request is approved by {{email}} the accounts will be linked."
                            },
                            "requestAccountLinkSent": {
                                "title": "LINK REQUEST SENT",
                                "msg": "A link request has been sent to {{email}}"
                            },
                            "emailChanged": {
                                "title": "EMAIL CHANGED",
                                "msg": "Email has been changed"
                            },
                            "unknownError": {
                                "title": "UNKNOWN ERROR",
                                "msg": "An unknown error has occured. Please try again and if the problem persists please contact your administrator"
                            }
                        },
                        "deactivateConfirm": {
                            "title": "Deactivate User",
                            "msg": "Do you also want to remove all licenses from this user and revoke support access?"
                        },
                        "registration": {
                            "emailInUse": {
                                "title": "EMAIL IN USE",
                                "msg": "This email is already in use by another account. Click \"Link Account\" to sent a link request to {{email}}. Once the request is approved by {{email}} the accounts will be linked."
                            },
                            "requestAccountLinkSent": {
                                "title": "LINK REQUEST SENT",
                                "msg": "A link request has been sent to {{email}}"
                            },
                            "createAccountFailed": {
                                "title": "ERROR CREATING ACCOUNT",
                                "msg": "Failed to send the email. There was an error creating the account. Please contact your administrator if the problem persists.",
                            },
                            "sendFailed": {
                                "title": "ERROR SENDING EMAIL",
                                "msg": "Failed to send the email. There was an error sending the email. Please contact your administrator if the problem persists.",
                            },
                            "sentNoLic": {
                                "title": "REGISTRATION EMAIL",
                                "msg": "Registration email has been sent. WARNING, this user has no license allocated, please allocate a license to the user.",
                            },
                            "sent": {
                                "title": "REGISTRATION EMAIL",
                                "msg": "Registration email has been sent."
                            },
                            "localEmailInUse": {
                                "title": "Email In Use",
                                "msg": "The email is already assigned to another representative"
                            }
                        },
                        "featuresHeaders": {
                            "administration": "Administration",
                            "calendar": "Calendar",
                            "finance": "Finance",
                            "commissions": "Commissions",
                            "purchasing": "Purchasing",
                            "sales": "Sales",
                            "projects": "Projects",
                            "installation": "Installation",
                            "dashboards": "Dashboards",
                            "customerChat": "Customer Chat"
                        }
                    },
                    "search": {
                        "title": "Search",
                    },
                    "quotes": {
                        "title": "Quotes",
                        "searchPlaceholder": "Search sales data",
                        "sectionQuotesTitle": "Quotes",
                        "outstandingQuotesTitle": "Outstanding Quotes",
                        "largestQuotesTitle": "Largest Quotes",
                        "daysToExpire": {
                            "title": "Quote Expiry (Count)",
                            "cat1": "30 days above",
                            "cat2": "20 days to 29 days",
                            "cat3": "10 days to 19 days",
                            "cat4": "5 days to 9 days",
                            "cat5": "1 day to 4 days",
                        },
                        "jobFunnel": {
                            "title": "Job Funnel",
                            "cat1": "Leads",
                            "cat2": "Quote Stage (Not Sent)",
                            "cat3": "Quote Stage (Sent)",
                            "cat4": "Order Stage"
                        },
                        "summaryBox": {
                            "open": "Open",
                            "active": "Active",
                            "sent": "Sent",
                            "received": "Received",
                            "expired": "Expired",
                            "won": "Won",
                            "lost": "Lost",
                            "manufacturing": "Manufacturing",
                            "dispatch": "Dispatch",
                            "invoiced": "Invoiced",
                        },
                    },
                    "orders": {
                        "title": "Supply",
                        "searchPlaceholder": "Search sales data",
                        "sectionOrdersTitle": "Supply Jobs",
                        "ordersTitle": "Supply Jobs",
                        "ordersDueTitle": "Supply Jobs Due",
                        "summaryBox": {
                            "open": "Open",
                            "openTooltip": "Supply that can be modified",
                            "priced": "Priced",
                            "pricedTooltip": "Supply jobs that have been priced, validated and are ready to be sent to the supplier",
                            "sent": "Sent",
                            "sentTooltip": "Supply jobs that have been sent to the supplier but not yet received",
                            "received": "Received",
                            "receivedTooltip": "Supply jobs that have been sent and successfully received by the supplier",
                            "expired": "Expired",
                            "won": "Won",
                            "lost": "Lost",
                            "manufacturing": "Manufacturing",
                            "manufacturingTooltip": "Supply jobs that are being manufactured",
                            "dispatch": "Dispatch",
                            "dispatchTooltip": "Supply jobs that have been manufactured and are being dispatched",
                            "invoiced": "Invoiced",
                            "invoicedTooltip": "Supply jobs for which invoices have been raised by the supplier",
                            "closed": "Closed",
                            "closedTooltip": "Supply jobs closed in the last 12 months",
                            "canceled": "Canceled",
                            "canceledTooltip": "Supply jobs canceled in the last 12 months",
                        },
                    },
                    "sendOrderDialog": {
                        "title": "Send Order(s)",
                        "titleResult": "Send Order(s) Result",
                        "order": "Order",
                        "result": "Result",
                        "error": "Error",
                        "email": "Email",
                        "summary": "Summary",
                        "status": "Status",
                    },
                    "sendSmsDialog": {
                        "title": "Send SMS",
                        "sendSuccess": "SMS Sent.",
                        "sendSmsSuccess": "SMS Sent.",
                        "titleResult": "Send SMS Result",
                        "configSaved": "SMS Config Saved",
                        "emailConfigSaved": "Email Config Saved"
                    },
                    "sendWhatsAppDialog": {
                        "title": "Send WhatsApp Message",
                        "sendSuccess": "WhatsApp Message Sent.",
                        "sendWhatsAppSuccess": "WhatsApp Message Sent.",
                        "titleResult": "Send WhatsApp Message Result"
                    },
                    "sendEmailDialog": {
                        "selectPrintSettings": "Please select print settings for the attached invoice",
                        "selectInvoiceTemplate": "Please select a template for the attached invoice",
                        "selectQuoteTemplate": "Please select template and print settings for the attached quote",
                        "sending": "Sending Email...",
                        "sendEmailSuccess": "Email Sent.",
                        "title": "Send Email",
                        "titleResult": "Send Email Result",
                        "result": "Result",
                        "error": "Error",
                        "email": "Email",
                        "attachments": "Attachments",
                        "document": "Document",
                        "attach": "Attach",
                        "emailAccountDetails": "Email Account Details",
                        "username": "Username",
                        "password": "Password",
                        "requireAccountDetails": "Email not sent, require valid account details",
                        "configurationRequired": "Email Integration Settings are not configured correctly"
                    },
                    "settings": {
                        "title": "Settings",
                        "download": "Download selected",
                        "close": "Close",
                        "financeNewTransfers": "New or Not Download Transfers",
                        "financeHistory": "Previous Transfers",
                        "financeAnomalies": "Transfer Issues ({{Count}})",
                        "financeGenericPost": "POST",
                        "financeGenericRepost": "REPOST",
                        "sectionBusinessDetails": "Business Details",
                        "sectionDefaults": "Defaults & Picklists",
                        "sectionSettings": "General Settings",
                        "sectionUsers": "Users",
                        "sectionPriceMarkups": "Price Markups",
                        "sectionProductsAndPricing": "Products (Marketplace)",
                        "sectionMyProductsAndPricing": "Products (My Products)",
                        "sectionTaxRates": "Tax Rates",
                        "sectionReports": "Reports",
                        "noModuleAccess": "This feature is not available in you current Package.",
                        "sectionIntegration": "Integration",
                        "sectionEdiIntegration": "EDI Integration",
                        "messageQueue": "Message Queue",
                        "managePicklists": "Click here to manage Picklists",
                        "manageLookups": "Click here to manage Lookup Tables",
                        "sectionLicensing": "Package",
                        "manageLicenses": "Manage Licenses",
                        "cssManagement": "Customer Self Service",
                        "smsIntegration": {
                            "SettingsTitle": "SMS Integration Settings",
                            "trialMsg": "During a trial, no SMS messages will be sent"
                        },
                        "whatsAppIntegration": {
                            "SettingsTitle": "WhatsApp Integration Settings",
                            "trialMsg": "During a trial, no WhatsApp messages will be sent",
                            "configSaved": "WhatsApp Config Saved",
                            "meta": {
                                "displayName": "Display Name",
                                "wabaID": "WhatsApp Business App (WABA) ID",
                                "senderNumberID": "Sender Number ID",
                                "accessTokenMessagingOnly": "Bearer/Access Token (Send Only)",
                                "accessTokenAll": "Bearer/Access Token (Full Access)"
                            }
                        },
                        "sms": {
                            "sendSms": ""
                        },
                        "emailIntegration": {
                            "SettingsTitle": "Email Server Settings",
                            "ActiveDomainSettingsTitle": "Verified Email Domains",
                            "PendingDomainSettingsTitle": "Pending Email Domains",
                            "domain": {
                                "title": "Email Domain",
                                "provider": "Provider",
                                "domainName": "Domain Name",
                                "key1Host": "Domain Key 1",
                                "key1": "Domain Key 1 Key",
                                "key1Status": "Domain Key 1 Status",
                                "key2Host": "Domain Key 2",
                                "key2": "Domain Key 2 Key",
                                "key2Status": "Domain Key 2 Status",
                                "activeKey": "Active Key",
                                "domainHost": "Domain Host",
                                "domain": "Domain",
                                "domainStatus": "Domain Host Status",
                                "branding1Host": "Branding 1 Host",
                                "branding1": "Branding 1",
                                "branding1Status": "Branding 1 Status",
                                "branding2Host": "Branding 2 Host",
                                "branding2": "Branding 2",
                                "branding2Status": "Branding 2 Status",
                                "spfValue": "SPF",
                                "spfStatus": "SPF Status",
                                "dmarcValue": "DMARC",
                                "dmarcStatus": "DMARC Status",
                                "insyteWebEmailDNSSendCustomMessage": "To verify ownership and allow Insyte Web to securely send email using your domain \"{{DomainName}}\" as the sender, DNS configuration is required for your domain. Step #1: Configure the SPF Record for the Insyte Web Email Server: {{SPF_DNSValue}}. Step #2: Configure Domain Ownership, Domain Keys (DKIM) and DMARC by clicking on the \"View DNS Records & Instructions\" button below",
                                "buttons": {
                                    "regenKey1": "Regenerate Key 1",
                                    "regenKey2": "Regenerate Key 2",
                                    "toggleActiveKey": "Toggle Active Key",
                                    "verify": "Verify",
                                    "emailDnsEntries": "Email DNS Entries",
                                    "send": "Send",
                                    "sendTo": "Send to",
                                    "copyDnsEntries": "Copy DNS Entries",
                                    "copyDnsEntriesInfo": "Enter a Domain Name, and click Save. Then click the Copy or Email button to provide details to your network administration team to add to DNS. Once the DNS Entries have been completed, come back and click on 'Verify' to activate the Email Domain",
                                },
                                documentationUrl: "https://accentsoftware.atlassian.net/wiki/x/CIAfrw",
                            },
                            "insyteWebEmail": "Insyte Web Email",
                            "smtpEmail": "SMTP Email Account",
                            "trialMsg": "During a trial, email messages will only be sent to the trial email address",
                            "providerInfo_undefined": "Please select an email provider",
                            "providerInfo_1": "This option uses the built in Email Account for Insyte Web and requires not additional configuration, some email tracking will be available with this option.",
                            "providerInfo_2": "This option allows you to configure your own SMTP account so emails will be sent via your company email server. Email tracking will not be available with this option.",
                            "smtp": {
                                "server": "Mail Server",
                                "authentication": "Use Authentication",
                                "secureConnection": "User Secure Connection",
                                "userName": "Username",
                                "password": "Password",
                                "portNumber": "Port Number",
                                "singleAccount": "Single Account",
                                "individualAccounts": "Individual Accounts",
                                "accountInfo_Single": "All emails will be sent via this account. Reply To will be set to the representative.",
                                "accountInfo_1": "All emails will be sent via this account. Reply To will be set to the representative.",
                                "accountInfo_2": "Emails will be sent via the individual users email account. By selecting this account type users will be forced to enter their own username and password the first time they send an email.",
                                "enterAccountPasswordInfo": "Enter the username and password for email account.",
                                "useGeneralFromEmail": "Use a general email as the sender (FROM) and the user's email as the REPLY TO",
                                "useUserFromEmail": "Use the user's email as the sender (FROM)",
                                "generalFromEmail": "General FROM email",
                                "email": "Email"
                            }
                        },
                        "financeIntegration": {
                            "SettingsTitle": "Finance Integration",
                            "xero": "Xero",
                            "myob": "MYOB",
                            "generic": "Generic (JSON File)",
                            "providerInfo_1": "Integrate with Xero.",
                            "providerInfo_2": "Integrate with MYOB",
                            "pleaseConnect_Xero": "Please connect to Xero to configure integration",
                            "pleaseConnect_MYOB": "Please connect to MYOB to configure integration",
                            "pleaseConnect_Generic": "JSON Files will be downloaded",
                            "disconnectTitle": "Disconnect First",
                            "disconnectMsg": "Please disconnect the current finance provider before changing to another.",
                            "myobCompany": "Business",
                            "username": "Username",
                            "password": "Password"
                        },
                        "financeItems": {
                            "quickbooks": "QuickBooks",
                            "generic": "Generic",
                            "disconnectText": "Disconnect from {{org}}",
                            "pleaseConnectSettings": "Please connect to {{org}} to configure integration.",
                            "financeTransfer": "Transfer to {{provider}}"
                        },
                        "contact": {
                            "emailContact": "Email Contact"
                        },
                        "representative": {
                            "emailRepresentative": "Email Representative",
                            "emailLead": "Email Lead"
                        },
                        "leadsIntegration": {
                            "newApiKey": "Generate New API Key",
                            "apiInfoTitle": "API Details",
                            "apiMethod": "Method: post",
                            "apiContent": "Content-Type: application/json",
                            "apiEndPoint": "End Point: ",
                            "testAPIDescription": "Below is the test data that will be posted to the API. Click on TEST API to test the API. !!WARNING!! Clicking on TEST API will create a real lead in your system.",
                            "testAPI": "TEST API (will create a new lead)",
                            "contactHeader": "Contact Details",
                            "contactDescription": "Enter test details for contact information",
                            "SettingsTitle": "Lead Integration",
                            "FirstName": "First Name",
                            "FirstNameLabel": "Enter first name",
                            "LastName": "Last Name",
                            "LastNameLabel": "Enter last name",
                            "Email": "Email",
                            "EmailLabel": "Enter email",
                            "Mobile": "Mobile",
                            "MobileLabel": "Enter mobile number",
                            "WorkPh": "Work Ph",
                            "WorkPhLabel": "Enter work phone number",
                            "HomePh": "Home Ph",
                            "HomePhLabel": "Enter home phone number",
                            "LeadSource": "Lead Source",
                            "LeadSourceLabel": "Select a lead source",
                            "leadSourceMap": "{{desc}}: {{value}}",
                            "LeadSourceValues": "Post Values:",
                            "POILabel": "Enter qty for {{poi}}",
                            "poiHeader": "Products of Interest",
                            "poiDescription": "Enter test details for Products of Interest",
                            "POIValue": "Value to post is: {{value}}",
                            "emailDocumentation": "Email Integration Documentation",
                            "notLicensed": "Your current license does not allow access to Web Leads.",
                            "enableTest": "Show lead integration tester"
                        },
                        "tracking": {
                            "emailAddress": "BCCs the specified email address in all emails that are sent:\n(empty field does not bcc)",
                            "emailAddress_Label": "Tracking - Email Address",
                            "quoteExpiryDays": "Shows an Alert on the Tracking screen for every Job in the Quote stage that  is going to Expire in the specified number of days:\n(empty field does not show any alerts)",
                            "quoteExpiryDays_Label": "Tracking -  Quote Expiry Days",
                            "cmNotBookedDays": "Shows an Alert on the Tracking screen for every Job that can have a Check Measure booked, but nothing has happened for the specified number of days:\n(empty field does not show any alerts)",
                            "cmNotBookedDays_Label": "Tracking - CM Not Booked Days",
                            "cmNotConfirmedDays": "Shows an Alert on the Tracking screen for every Job that has a Check Measure booked, but the Check Measure Appointment has not been confirmed in the specified number of days since it was created:\n(empty field does not show any alerts)",
                            "cmNotConfirmedDays_Label": "Tracking - CM Not Confirmed Days",
                            "stockDueDays": "Shows an Alert on the Tracking screen for every Job that has Stock that has not arrived, and it is the specified number of days away from the ETA date:\n(empty field does not show any alerts)",
                            "stockDueDays_Label": "Tracking - Stock Due Days",
                            "stockNotArrivedDays": "Shows an Alert on the Tracking screen for every Job that has Stock that has not arrived within the specified number of days from the Dispatch Appointment date:\n(empty field does not show any alerts)",
                            "stockNotArrivedDays_Label": "Tracking - Stock Not Arrived Days",
                            "installNotConfirmedDays": "Shows an Alert on the Tracking screen for every Job that has a Dispatch Appointment, but it has not been confirmed within the specified number of days since it was created:\n(empty field does not show any alerts)",
                            "installNotConfirmedDays_Label": "Tracking - Dispatch Appt. Not Confirmed Days",
                            "installNotCompletedDays": "Shows an Alert on the Tracking screen for every Job that has a Dispatch Appointment that has not been closed off after the specified number of days has passed since the Dispatch Appointment date:\n(empty field does not show any alerts)",
                            "installNotCompletedDays_Label": "Tracking - Dispatch Appt. Not Completed Days",
                        },
                        "xeroConnected": "Status: Connected to {{org}}",
                        "xeroDisconnected": "Status: Disconnected",
                        "match": "Match",
                        "new": "New",
                        "skip": "Skip",
                        "manualMatchRequired": "The following contacts could not be matched automatically. Please review the list of Insyte contacts and select the appropriate action for each.",
                        "selectNewMatch": "Select a new finance contact to link this Insyte contact to.",
                        "insyteContacts": "Insyte Contacts",
                        "financeContacts": "Finance Contacts",
                        "apply": "Apply",
                        "xeroSettingsTitle": "Configure Xero",
                        "xeroTaxRatesHeader": "Map Tax Rates",
                        "xeroAccountsHeader": "Map Accounts",
                        "depositAccount": "Deposit Holding Account",
                        "bankAccount": "Bank / Check Account",
                        "receivablesAccount": "Accounts Receivable",
                        "salesAccount": "Sales Revenue Account",
                        "xeroAccountsDescription": "Insyte Web will export journals for Deposits, Sales and Allocations into {{providerName}}. These items need to be mapped to {{providerName}} accounts. Note we cannot journal directly to the {{providerName}}'s Accounts Receivable account so please select an alternative or click create button to create a specific account for Insyte Web.",
                        "xeroContactsHeader": "Contacts",
                        "xeroTaxRatesDescription": "Please map tax rates for Insyte Web to {{providerName}}",
                        "xeroContactsDescription": "Instyle Web will include contact details in transaction exported into {{providerName}}. These contacts need to be transferred to {{providerName}}",
                        "transferContacts": "Transfer to {{providerName}}",
                        "transferContactsError": "Failed to transfer contacts due to the following reason. {{error}}.",
                        "transferContactsErrorTitle": "Transfer Contacts",
                        "createAccounts": "Create in {{providerName}}",
                        "createAccountsErrorTitle": "Create Account",
                        "createAccountsError": "Failed to create the account due to the following reason. {{error}}.",
                        "transferNow": "Transfer Now",
                        "financeTransfer": "Transfer Journals to {{provider}}",
                        "transferNowError": "Failed to complete transfer due to the following reason. {{error}}.",
                        "transferNowErrorTitle": "Transfer Error",
                        "transferItemsNowError": "{{error}}. Failed to complete transfer.",
                        "transferItemsNowErrorTitle": "{{provider}} Transfer Error",
                        "transferNowCompleteTitle": "Transfer Complete",
                        "transferNowComplete": "The transfer has successfully completed",
                        "transferItemsNowCompleteTitle": "{{provider}} Transfer Complete",
                        "transferItemsNowComplete": "The transfer has successfully completed. {{count}} anomalies have been identified.",                        
                        "transferNowCompleteNoDataTitle": "Transfer Complete",
                        "transferNowCompleteNoData": "The transfer has successfully completed, no items available to transfer",
                        "transferNowCompleteDowloadTitle": "Download File",
                        "transferNowCompleteDowloadMsg": "Click here to download file",
                        "resetCompleteTitle": "Reset Complete",
                        "resetComplete": "The reset has successfully completed",
                        "resetFinance": "Reset Insyte Web Journals for {{provider}}",
                        "resetFinanceMsg": "WARNING: You are about to reset {{provider}} journals in Insyte Web. Any finance movements since your last transfer will be lost. You may need to manually correct {{provider}}. To continue type 'reset' in the box below.",
                        "typeReset": "Type Reset",
                        "resetCompare": "reset",
                        "resetDataTitle": "DELETE ALL TRANSACTIONAL DATA",
                        "resetDataCompare": "Delete all my data",
                        "resetDataMsg": "WARNING: If you proceed you will DELETE all you transactional data. This process may be irreversible. Some of your data may be recoverable at a minimum cost of $5,000. To proceed type \"$t(application_strings.views.settings.resetDataCompare)\" in the input box below.",
                        "typeResetData": "Type \"$t(application_strings.views.settings.resetDataCompare)\"",
                        "resetDataRecordTypes": "Record Types to Delete",
                        "discountLimits": "Discount Limits",
                        "editDiscountLimits": "Edit Sales Discount Limits",
                        "salesDiscountLimits": {
                            "title": "Sales Discount Limits"
                        }

                    },
                    "template": {
                        "title": "Template {{Description}}",
                        "missingTemplateMsg": "You are missing a template document. Please select to use the default or upload your own. Hint you can select default then download it to change it for your needs.",
                        "downloadTemplate": "Download Template",
                        "uploadDocumentTemplateDlgTitle": "Upload Document Template",
                        "uploadDocumentTemplateInstructions": "Select a template document to upload.",
                        "uploadSuccess": "Upload Complete",
                        "previewItem": "Select Item to Preview",
                        "keepOptions": {
                            "msg": "Select were to copy the product option settings from. Note this does not affect the layout only which product options are printed",
                            "current": "Keep previously configured product option settings ",
                            "defaultTemplate": "Use product options settings from the default template",
                            "copyFrom": "Copy from {{from}} template"
                        },
                        "insertMsg": "Right-Click to insert merge fields into your template"
                    },
                    "templateResponse": {
                        "title": "Template Response {{ID}}",
                    },
                    "productSupplier": {
                        "title": "Supplier Product",
                    },
                    "product": {
                        "title": "My Product - {{ProductName}}",
                        "notesTemplatePlaceHolder": "Will default on to order line customer notes.",
                        "notesTemplate": "Notes Template",
                        "draft": "Draft - Unpublished changes",
                        "serviceProductMsg": "Service Products do not generate supply jobs and will not be sent to the supplier. They are good for service calls, additional installation charges etc",
                        "alterProductMsg": "Alter Products will be automatically selected when performing an alteration for the product",
                        "configuration": {
                            "editProductDlg": {
                                "title": "Configure {{ProductName}}"
                            },
                            "productTreeCtrl": {
                                "setDependencies": "Set Dependencies",
                                "name": "Name",
                                "code": "Code",
                                "active": "Active",
                                "actions": "Actions",
                                "hasDependencies": "Dependencies"
                            },
                            "productScriptCtrl": {
                                "type": "Script Type",

                            }
                        }
                    },
                    "priceList": {
                        "title": "Price List - {{Code}}",
                        "hasUnpublishedDraftNotification": "Draft - Unpublished changes",
                        "configuration": {
                            "editPriceListDlg": {
                                "title": "Configure {{Code}}"
                            },
                        },
                        "duplicate": {
                            "dialogTitle": "Copy Price List",
                            "draftButton": "Copy Draft",
                            "draftButtonTooltip": "Copy the unpublished draft to a new pricelist.",
                            "confirmDuplicateVersion": "This will create a new price list with the same configuration as Version {{VersionNumber}} of {{PriceListCode}}",
                            "confirmDuplicateDraft": "This will create a new price list with the same configuration as the current draft of {{PriceListCode}}"
                        },
                        "importPricing": {
                            "button": "Import Pricing",
                        },
                        "exportPricing": {
                            "button": "Export Pricing",
                        },
                        "testProductPricing": {
                            "button": "Test",
                            "tooltip": "Test Product Pricing for the current (unpublished) draft of the pricelist"
                        }
                    },
                    "versionInfo": {
                        "title": "Version",
                    },
                    "versionCreditInfo": {
                        "title": "Credits",
                        "description": "Insyte Web software is developed by Accent Software. Portions of this product include software licensed under other licenses as listed below",
                    },
                    "initialsetupwizard": {
                        "title": "Initial Setup",
                    },
                    "cssMerchantTerminalDialog": {
                        "title": "Merchant Payment Terminal",
                        "alreadyPaid": {
                            "title": "",
                            "msg": "The payment was found to have been processed already."
                        },
                        "instanceError": {
                            "title": "",
                            "none": "Please allocate the payment to a job for a business unit that uses customer self service",
                            "multiple": "Please allocate the payment only to jobs for the same business unit or group of business units"
                        }
                    }
                },
                "validation": {
                    "emailIsRequired": "Email is required",
                    "passwordIsRequired": "Password is required"
                },
                "dashboards": {
                    "recentPurchases": {
                        "title": "Purchases",
                        "titleSub": "(6 months)",
                    },
                    "dashboardRequired": "Please set your default dashboard using the drop down above.",
                    "permissionRequired": "You do not have permission to view this dashboard",
                    "licenseRequired": "You require an upgrade to your license to view this dashboard",
                    "edit": "Edit",
                    "noWidgetAccess": "You require a license to view {{title}} widget",
                    "save": "Save",
                    "empty": "Empty",
                    "sales": "Sales",
                    "purchasing": "Purchasing",
                    "widget": "Widget",
                    "size": "Size",
                    "small": "Small",
                    "normal": "Normal",
                    "options": "Options",
                    "splitH": "split H",
                    "splitV": "split V",
                    "remove": "Remove",
                    "reset": "Default Dashboard Layouts",
                    "resetTitle": "Reset Dashboard",
                    "resetMsg": "Resting the dashboard will loose your current settings. Do you want to continue?",
                    "widgets": {
                        "serviceJobSummaryWidget": {
                            "pendingApproval": "Pending Approval",
                            "pendingApproval_desc": "All active service jobs in the Quote stage",
                            "sent": "Sent",
                            "sent_desc": "Active service jobs in the quoting stage that have had the quote document sent to the customer",
                            "approved": "Approved",
                            "approved_desc": "All active confirmed service jobs",
                            "expired": "Expired",
                            "expired_desc": "Service jobs in the quote stage that have expired",
                        }
                    }
                },
                "grids": {
                    "companyPricelistMapping": {
                        "title": "Custom Pricing"
                    },
                    "customDocuments": {
                        "title": "Custom Documents"
                    },
                    "customDocumentVersions": {
                        "title": "Document Versions",
                        "setAsDraft": "Set as Draft"
                    },
                    "SmsIntegration": {
                        "title": "Sms Integration"
                    },
                    "templateresponse": {
                        "title": "Response Actions",
                        "tagAction": "Tag Action"
                    },
                    "templateparam": {
                        "title": "Params",
                        "tagAction": "Tag Action"
                    },
                    "commissionAccountTransactions": {
                        "title": "Transactions"
                    },
                    "commissionRuns": {
                        "title": "Commission Runs",
                    },
                    "financeTrasferAnomalies": {
                        "title": "Finance Transfer Issues",
                        "markAsProcessed": "MARK AS PROCESSED",
                        "confirmProcessed": "CONFIRM PROCESSED",
                        "matchContact": "MATCH CONTACT",
                        "editReceiptNumber": "EDIT RECEIPT NO",
                        "editInvoiceNumber": "EDIT INVOICE NO",
                        "ignore": "MARK AS IGNORED",
                        "confirmIgnore": "CONFIRM IGNORED"
                    },
                    "salesDiscountLimitsBUs": {
                        "title": "Business Units Limits"
                    },
                    "salesDiscountLimitsUsers": {
                        "title": "Users Limits"
                    },
                    "automations": {
                        "title": "Automations",
                    },
                    "businessUnits": {
                        "title": "Business Units",
                    },
                    "lookuptableitem": {
                        "title": "Entries"
                    },
                    "productSupplier": {
                        "title": "Suppliers"
                    },
                    "productLinks": {
                        "title": "Linked Products"
                    },
                    "picklists": {
                        "PL_ActivityCategory": "Activity Categories",
                        "PL_ActivityCancelReason": "Activity Cancel Reasons",
                        "PL_ActivityRescheduleReason": "Activity Reschedule Reasons",
                        "PL_ActivityColor": "Activity Colours",
                        "PL_CommissionAmendmentCategory": "Commission Amendment Categories",
                        "PL_AccountOnHoldReason": "Account On Hold Reasons",
                        "PL_ContactJobCategory": "Contact Job Categories",
                        "PL_CommitmentReason": "Commitment Reasons",
                        "PL_JobCustomStatus": "Job Custom Status",
                        "PL_MFDepartment": "Manufacturing Departments",
                        "PL_OrderLineLocation": "Job Line Location",
                        "PL_OrganisationType": "Organisation Type",
                        "PL_QuoteOutcomeReason": "Outcome Reason",
                        "PL_LeadSource": "Lead Source",
                        "PL_ProductCategory": "Product Category",
                        "PL_ProductOfInterest": "Products Of Interest",
                        "PL_DispatchSnoozeCategory": "Dispatch Snooze Category",
                        "PL_OppConfidenceLevel": "Confidence Level",
                        "PL_PaymentMethod": "Payment Method",
                        "PL_Tag": "Tags",
                        "PL_FaultReason": "Fault Reasons",
                        "PL_LeadDiscardReason": "Lead Discard Reason",
                        "PL_StockLocation": "Stock Location",
                        "PL_ProductTaxCode": "Product Tax Code",
                        "PL_TaxExemptionReason": "Tax Exemption Reasons",
                        "PL_CreditCard": "Credit Cards",
                        "PL_CustomerAvailability": "Customer Availability",
                        "PL_UnitType": "Unit Types",
                        "PL_FabricCategory": "Fabric Categories",
                        "PL_ResponsibleDepartment": "Responsible Departments",
                        "PL_PromotionPrecedenceGroup": "Promotion Precedence Groups"
                    },
                    "customerDiscountLevel": {
                        "title": "Customer Discounts",
                    },
                    "supplierDiscountLevel": {
                        "title": "Supplier Discounts",
                    },
                    "discountItems": {
                        "title": "Discounts",
                        "showAll": "Show All",
                        "showCurrentOnly": "Show Current Only"
                    },
                    "communications": {
                        "title": "Communication Log",
                    },
                    "teams": {
                        "title": "Teams",
                        "manage": "Manage"
                    },
                    "accessRoles": {
                        "title": "Access Roles",
                        "manage": "Manage"
                    },
                    "activityCategories": {
                        "title": "Activity Categories",
                    },
                    "suppliers": {
                        "title": "Suppliers",
                    },
                    "companies": {
                        "title": "Companies",
                    },
                    "contacts": {
                        "title": "Contacts",
                    },
                    "documents": {
                        "title": "Documents",
                        "attachDlgTitle": "Attach Documents",
                        "sendToCustomer": "Send to Customer",
                        "sketchName": "Description",
                        "sendToSupplier": "Send to Supplier",
                        "uploadSuccess": "Attachments Completed",
                        "jobLine": "JobLine",
                        "supplyJobLine": "Supply Job Line",
                        "supplier": "Supplier",
                        "signed": "Signed",
                        "deleteDocument": "Delete Document"
                    },
                    "supplySheetTemplates": {
                        "title": "Supply Sheet Templates",
                        "attachDlgTitle": "Create New Supply Sheet Teamplate",
                        "supplier": "Supplier",
                        "description": "Description"
                    },
                    "leadSources": {
                        "title": "Lead Sources",
                    },
                    "jobCustomStatus": {
                        "title": "Job Custom Status",
                    },
                    "marketplaceSupplierClients": {
                        "title": "Marketplace Clients",
                    },
                    "marketplaceSupplierProducts": {
                        "title": "Marketplace Products",
                    },
                    "payments": {
                        "title": "Payments",
                    },
                    "paymentMethods": {
                        "title": "Payment Methods",
                    },
                    "purchaseOrders": {
                        "title": "Purchase Orders",
                        "showClosed": "Show Closed",
                        "hideClosed": "Hide Closed",
                    },
                    "jobs": {
                        "title": "Jobs",
                        "showClosed": "Show Closed",
                        "hideClosed": "Hide Closed",
                    },
                    "invoices": {
                        "title": "Invoices",
                        "showClosed": "Show Closed",
                        "hideClosed": "Hide Closed"
                    },
                    "activities": {
                        "title": "Activities",
                        "showClosed": "Show Closed",
                        "hideClosed": "Hide Closed",
                    },
                    "opportunities": {
                        "title": "Leads/Opportunities",
                        "showClosed": "Show Closed",
                        "hideClosed": "Hide Closed",
                    },
                    "orderLines": {
                        "title": "Product Lines",
                    },
                    "jobLines": {
                        "title": "Lines",
                    },
                    "orderLineLocations": {
                        "title": "Product Line Locations",
                    },
                    "organisationTypes": {
                        "title": "Organisation Types",
                    },
                    "oppConfidenceLevel": {
                        "title": "Opportunity Confidence Level",
                    },
                    "priceMarkups": {
                        "title": "Price Markups",
                    },
                    "productOfInterests": {
                        "title": "Products of Interest",
                    },
                    "quotes": {
                        "title": "Quotes",
                        "showClosed": "Show Closed",
                        "hideClosed": "Hide Closed",
                    },
                    "quoteOutcomeReasons": {
                        "title": "Outcome Reasons",
                    },
                    "taxRates": {
                        "title": "Tax Rates",
                    },
                    "products": {
                        "title": "Products (My Products)",
                        "testProducts": "Test Products"
                    },
                    "priceLists": {
                        "title": "Price Lists (My Products)",
                        "sort": {
                            "button": "Reorder",
                            "tooltip": "Opens a dialog where the Price Lists' can be rearranged to generate new Search Orders",
                            "dialogTitle": "Price List Reorder"
                        },
                    },
                    "priceListVersions": {
                        "title": "Versions",
                        "setAsDraft": {
                            "confirm": "Set as Draft",
                            "button": "Restore",
                            "tooltip": "Override the current draft configuration with the pricing configuration from version {{VersionNumber}}"
                        },
                        "testPricing": {
                            "button": "Test",
                            "tooltip": "Test product pricing for version {{VersionNumber}} of the price list"
                        },
                        "duplicate": {
                            "button": "Copy",
                            "tooltip": "Create a new price list as a copy of version {{VersionNumber}}",
                        },
                    },
                    "priceListProducts": {
                        "title": "Products",
                        "warnUnpublishedDraft": "The unpublished draft may contain changes that won't be reflected here until publishing.",
                        "testPricing": {
                            "button": "Test",
                            "tooltip": "Test product pricing for {{ProductName}} with the active version of the price list"
                        }
                    },
                    "priceListParts": {
                        "title": "Parts",
                        "warnUnpublishedDraft": "The unpublished draft may contain changes that won't be reflected here until publishing.",
                    },
                    "priceListFabrics": {
                        "title": "Fabrics",
                        "warnUnpublishedDraft": "The unpublished draft may contain changes that won't be reflected here until publishing.",
                    },
                    "productPriceLists": {
                        "title": "Price Lists",
                        "testPricing": {
                            "button": "Test",
                            "tooltip": "Test pricing for {{PriceListName}} with the current draft of the product"
                        }
                    },
                    "productVersions": {
                        "title": "Versions",
                        "setAsDraft": "Set as Draft",
                        "compare": "Compare Versions"
                    },
                    "productChangeReviews": {
                        "title": "Change Reviews"
                    },
                    "supplierItems": {
                        "title": "Supplier Items",
                    },
                    "templates": {
                        "title": "Templates",
                        "newQuoteEmailTemplate": "Email Template -> Quote",
                        "newInvoiceEmailTemplate": "Email Template -> Invoice",
                        "newOrderConfirmationEmailTemplate": "Email Template -> Order Confirmation",
                        "newJobEmailTemplate": "Email Template -> Job",
                        "newSupplyEmailTemplate": "Email Template -> Supply",
                        "newWebLeadEmailTemplate": "Email Template -> Web Lead",
                        "newStatementEmailTemplate": "Email Template -> Statement",
                        "newAutomatedEmailTemplate": "Email Template -> Activity",
                        "newQuoteDocumentTemplate": "Document Template -> Quote",
                        "newInvoiceDocumentTemplate": "Document Template -> Invoice",
                        "newOrderConfirmationDocumentTemplate": "Document Template -> Order Confirmation",
                        "newAutomatedSMSTemplate": "SMS Template -> Activity",
                        "newQuoteSMSTemplate": "SMS Template -> Quote",
                        "newOrderConfirmationSMSTemplate": "SMS Template -> Order Confirmation",
                        "newInvoiceSMSTemplate": "SMS Template -> Invoice",
                        "newJobSMSTemplate": "SMS Template -> Job",
                        "newWebLeadSMSTemplate": "SMS Template -> Web Lead",
                        "newCSSDispatchEmailTemplate": "Email Template -> CSS Dispatch",
                        "newCSSDispatchSMSTemplate": "SMS Template -> CSS Dispatch",
                        "newAutomatedWhatsAppTemplate": "WhatsApp Template -> Activity",
                        "newQuoteWhatsAppTemplate": "WhatsApp Template -> Quote",
                        "newOrderConfirmationWhatsAppTemplate": "WhatsApp Template -> Order Confirmation",
                        "newInvoiceWhatsAppTemplate": "WhatsApp Template -> Invoice",
                        "newJobWhatsAppTemplate": "WhatsApp Template -> Job",
                        "newWebLeadWhatsAppTemplate": "WhatsApp Template -> Web Lead",
                    },
                    "users": {
                        "title": "Users",
                        "salesDiscountLimits": "Sales Discount Limits",
                        "salesDiscountLimitsSmall": "Sales Disc Limts",
                        "commissions": "Commissions",
                        "commissionsSmall": "Comm."
                    },
                },
                "workflows": {
                    "confirmedOrderProcessing": {
                        "open": "Open",
                        "openTooltip": "Quote is open",
                        "priced": "Priced",
                        "pricedTooltip": "Quote has been priced",
                        "sent": "Sent",
                        "sentTooltip": "Quote has been sent to customer",
                        "won": "Won",
                        "wonTooltip": "Quote has been won",
                        "lost": "Lost",
                        "lostTooltip": "Quote has been lost",
                        "tooltip": "Represents any number of paths that could have been taken",
                    },
                    "quoteProcessing": {
                        "open": "Open",
                        "openTooltip": "Order is open",
                        "priced": "Priced",
                        "pricedTooltip": "Order has been priced",
                        "sent": "Sent",
                        "sentTooltip": "Order has been sent to supplier",
                        "manufacturing": "Manufacturing",
                        "manufacturingTooltip": "Order is in manufacturing",
                        "dispatched": "Dispatched",
                        "dispatchedTooltip": "Order has been dispatched",
                        "invoiced": "Invoiced",
                        "invoicedTooltip": "Order has been invoiced",
                        "tooltip": "Represents any number of paths that could have been taken",
                    },
                },
            }, // application strings
        }
    },
    xx: {
    }
};


window.myinsyteresources.en.translation.application_strings.entities = {
    "Event": {
        "title": "Event"
    },
    "workflowRunsGrid": {
        "entityTitle": "Workflow Runs",
        "WorkflowName": "Workflow",
        "WorkflowEntityPrompt": "Entity",
        "WorkflowEntityId": "Entity ID",
        "EntityType": "Entity Type",
        "Status": "Status",
        "StartedDate": "Started",
        "CompletedDate": "Completed",
        "NeedsAttention": "Attention",
        "LastError": "Last Error",
    },
    "AutoLineRuleSet": {
        "Name": "Description",
        "Active": "Active",
        "SupplierID": "Supplier",
        "RunSupplierRuleSetOnJob": "Also Run On Customer Jobs",
        "AllowUserChangeAutoProduct": "Allow User To Edit The Auto Line",
        "AllowUserRemoveAutoProduct": "Allow User To Delete The Auto Line",
        "DontAutoReevalForConfirmedJob": "Don't Re-evaluate This Rule For Confirmed Jobs",
        "DontAutoRemoveForConfirmedJob": "Don't Auto-remove Existing Auto Lines For Confirmed Jobs"
    },
    "CustomValidationRule": {
        "Description": "Description",
        "Active": "Active",
        "BeforeStageKey": "Before Stage",
        "SortOrder": "Sort Order",
        "ValidationMessage": "Validation Message",
        "Query": "Query",
        "ValidationExpression": "Validation Expression",
        "Notes": "Notes"
    },
    "Representative": {
        "FeatureAllowCreditLimitToBeExceeded": "Feature Allow Credit Limit To Be Exceeded"
    },
    "area": {
        "Name": "Name",
        "SalesArea": "Sales Area",
        "InstallArea": "Install Area",
        "BusinessUnit": "Business Unit",
        "BusinessUnitID": "Business Unit",
        "Active": "Active"
    },
    "promotion": {
        "Name": "Name",
        "Description": "Description",
        "Status": "Status",
        "StartDate": "Start Date",
        "EndDate": "End Date",
        "Code": "Code",
        "Colour": "Colour",
        "ApplyToQuoteDate": "Apply To Quote Date",
        "ApplyToLeadDate": "Apply To Lead Date",
        "ApplyToCurrentDate": "Apply To Current Date",
        "AccountType_Retail": "Retail Account",
        "AccountType_Wholesale": "Wholesale Account",
        "AccountType_Commercial": "Commercial Account",
        "AllProductsWithException": "All Products With Exception",
        "AllProductOptionsWithException": "All Product Options With Exception",
        "PrintOnQuote": "Print On Quote",
        "DeductFromCommission": "Deduct From Commission",
        "Message": "Message",
        "PrecedenceGroup": "Precedence Group",
        "PL_PrecedenceGroupID": "Precedence Group",
        "Notes": "Notes"
    },
    "customDocument": {
        "Name": "Name",
        "LastPublishedBy": "Last Published By",
        "LastPublishedDate": "Last Published Date"
    },
    "CustomDocument": {
        "Name": "Name",
        "LastPublishedBy": "Last Published By",
        "LastPublishedDate": "Last Published Date"
    },
    "CustomDocumentVersion": {
        "Status": "Status",
        "CreatedBy": "Created By",
        "CreatedDate": "Created Date",
        "UpdatedBy": "Updated By",
        "UpdatedDate": "Updated Date"
    },
    "promotionsGrid": {
        "Name": "Name",
        "Description": "Description",
        "Active": "Active",
        "StartDate": "Start Date",
        "EndDate": "End Date",
        "Code": "Code",
        "Status": "Status"
    },
    "jobPromotion": {
        "AgreedDeposit": "Agreed Deposit",
        "DiscountAmount": "Discount Amount",
        "DiscountBaseAmount": "Discount Base Amount"
    },
    "promotionCombination": {
        "PromotionLinkID": "Linked Promotion"
    },
    "promotionDiscountDeposit": {
        "Amount": "Amount",
        "Percentage": "Percentage",
        "ApplyToBase": "Apply To Base",
        "ApplyToOptions": "Apply To Options",
        "ApplyToDelivery": "Apply To Delivery",
        "ApplyToInstallation": "Apply To Installation",
        "ApplyToOptionValues": "Apply To Option Values",
        "MinPercent": "Min Percent",
        "MaxPercent": "Max Percent",
        "MinAmount": "Min Amount",
        "MaxAmount": "Max Amount"
    },
    "promotionDiscountDirect": {
        "Amount": "Amount",
        "Percentage": "Percentage",
        "ApplyToBase": "Apply To Base",
        "ApplyToOptions": "Apply To Options",
        "ApplyToDelivery": "Apply To Delivery",
        "ApplyToInstallation": "Apply To Installation",
        "ApplyToOptionValues": "Apply To Option Values"
    },
    "promotionDiscountMultiItem": {
        "Amount": "Amount",
        "Percentage": "Percentage",
        "ApplyToBase": "Apply To Base",
        "ApplyToOptions": "Apply To Options",
        "ApplyToDelivery": "Apply To Delivery",
        "ApplyToInstallation": "Apply To Installation",
        "PurchaseThreshold": "Purchase Threshold",
        "DiscountQty": "Discount Qty",
        "SortBy": "Sort By",
        "MaxDiscounted": "Max Discounted",
        "MaxDiscountedEnabled": "Max Discounted Enabled",
        "DiscountFilter": "Discount Filter",
        "Algorithm": "Algorithm",
        "GroupingRule": "Grouping Rule"
    },
    "promotionDiscountProductOption": {
    },
    "promotionDiscountSaleValue": {
        "Amount": "Amount",
        "Percentage": "Percentage",
        "ApplyToBase": "Apply To Base",
        "ApplyToOptions": "Apply To Options",
        "ApplyToDelivery": "Apply To Delivery",
        "ApplyToInstallation": "Apply To Installation",
        "ApplyToOptionValues": "Apply To Option Values",
        "MinAmount": "Min Amount",
        "MaxAmount": "Max Amount",
        "DiscountMethod": "Discount Method",
        "GroupingRule": "Grouping Rule",
        "PL_ProductCategoryID": "Product Category"
    },
    "promotionQualificationState": {
        "State": "State"
    },
    "promotionQualificationBusinessUnit": {
        "BusinessUnitID": "Business Unit"
    },
    "promotionQualificationProduct": {
    },
    "promotionQualificationProductOption": {
    },
    "pL_PromotionPrecedenceGroup": {
        "Name": "Name",
        "Description": "Description",
        "Active": "Active",
        "Precedence": "Precedence"
    },
    "postcodeArea": {
        "ID": "ID",
        "City": "Suburb/Town/City",
        "State": "State/County",
        "Postcode": "Postcode/Zip Code",
        "AreaID": "Area",
        "Area": "Area",
        "BusinessUnit": "Business Unit",
        "SalesArea": "Sales Area",
        "InstallArea": "Install Area"

    },
    "UserApiKey": {
        "Description": "Description",
        "Scope": "Scope",
        "Key": "Key",
        "RepID": "Rep"
    },
    "externalLeadGrid": {
        "Date": "Date",
        "LeadSource": "Lead Source",
        "ContactFirstName": "First Name",
        "ContactLastName": "Last Name",
        "ContactMobile": "Mobile",
        "ContactWorkPh": "Work Ph",
        "ContactHomePh": "Home Ph",
        "ContactEmail": "Email",
        "SnoozeDate": "Snoozed"
    },
    "activities": {
        "entityTitle": "Activities",
        "Subject": "Subject",
        "Start": "Start",
        "End": "End",
        "AllDay": "All Day",
        "Closed": "Closed",
        "Notes": "Notes",
        "ProcessDetails": "Process Details",
        "ActivityType_abbrev": "Type",
        "ActivityType": "Activity Type",
        "Confirmed": "Confirmed",
        "IsInstall": "Is Install",
        "IsPickup": "Is Pickup",
        "IsDelivery": "Is Delivery",
        "IsService": "Is Service",
        "Category": "Activity Category",
        "PL_ActivityCategoryID_abbrev": "Category",
        "PL_ActivityCategoryID": "Activity Category",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Team": "Team",
        "TeamID": "Team",
        "Address": "Address",
        "AddressID": "Address",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Company": "Company",
        "CompanyID": "Company",
        "Job": "Job",
        "JobID": "Job",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "CreatedBy": "Representative",
        "CreatedByID": "Representative",
        "CreatedOn": "Created On",
        "Priority": "Priority",
        "Attendees": "Attendees",
        "JobLines": "Job Lines",
        "TagData": "Tag Data",
        "ActivityID": "Activity ID",
    },
    "activitiesForCompany": {
        "entityTitle": "Activities For Company",
        "ID": "ID",
        "Subject": "Subject",
        "Start": "Start",
        "AllDay": "All Day",
        "Closed": "Closed",
        "Notes": "Notes",
        "ActivityType_abbrev": "Type",
        "ActivityType": "Activity Type",
        "ActivityCategory_abbrev": "Category",
        "ActivityCategory": "Activity Category",
        "Confirmed": "Confirmed",
        "Representative": "Representative",
        "Priority": "Priority",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity ID",
        "IsInstall": "Is Install",
        "IsPickup": "Is Pickup",
        "IsDelivery": "Is Delivery",
        "IsService": "Is Service",
    },
    "activitiesForContact": {
        "entityTitle": "Activities For Contact",
        "ID": "ID",
        "Subject": "Subject",
        "Start": "Start",
        "AllDay": "All Day",
        "Closed": "Closed",
        "Notes": "Notes",
        "ActivityType_abbrev": "Type",
        "ActivityType": "Activity Type",
        "ActivityCategory_abbrev": "Category",
        "ActivityCategory": "Activity Category",
        "Confirmed": "Confirmed",
        "Representative": "Representative",
        "Priority": "Priority",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity ID",
        "IsInstall": "Is Install",
        "IsPickup": "Is Pickup",
        "IsDelivery": "Is Delivery",
        "IsService": "Is Service",
    },
    "activitiesForOpportunity": {
        "entityTitle": "Activities For Opportunity",
        "ID": "ID",
        "Subject": "Subject",
        "Start": "Start",
        "AllDay": "All Day",
        "Closed": "Closed",
        "Notes": "Notes",
        "ActivityType_abbrev": "Type",
        "ActivityType": "Activity Type",
        "ActivityCategory_abbrev": "Category",
        "ActivityCategory": "Activity Category",
        "Confirmed": "Confirmed",
        "Representative": "Representative",
        "Priority": "Priority",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity ID",
        "IsInstall": "Is Install",
        "IsPickup": "Is Pickup",
        "IsDelivery": "Is Delivery",
        "IsService": "Is Service",
    },
    "activitiesForUser": {
        "entityTitle": "Activities For User",
        "ID": "ID",
        "Subject": "Subject",
        "Start": "Start",
        "AllDay": "All Day",
        "Closed": "Closed",
        "Cancelled": "Cancelled",
        "CancelledReason": "Cancel Reason",
        "CancelledNotes": "Cancel Notes",
        "Status": "Status",
        "Notes": "Notes",
        "ActivityType_abbrev": "Type",
        "ActivityType": "Activity Type",
        "ActivityCategory_abbrev": "Category",
        "ActivityCategory": "Activity Category",
        "Confirmed": "Confirmed",
        "Representative": "Representative",
        "Priority": "Priority",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity ID",
        "IsInstall": "Is Install",
        "IsPickup": "Is Pickup",
        "IsDelivery": "Is Delivery",
        "IsService": "Is Service",
    },
    "activityJobLines": {
        "entityTitle": "Activity Job Lines",
        "Job": "Job",
        "JobID": "Job",
        "JobLine": "Job Line",
        "JobLineID": "Job Line",
        "Activity": "Activity",
        "ActivityID": "Activity",
    },
    "genericFinanceItemExport": {
        "entityTitle": "Finance Generic Export",
        "FileName": "File Name",
        "Type": "Type",
        "Downloaded": "Downloaded",
        "Posted": "Posted",
        "ExportedBy": "Exported By",
    },
    "addresses": {
        "entityTitle": "Addresses",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "Country": "Country",
        "Location": "Location",
        "PosLong": "Pos Long",
        "PosLat": "Pos Lat",
        "AddressID": "Address ID",
        "Formatted": "Formatted",
    },
    "addressForCompanyID": {
        "entityTitle": "Address For Company ID",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "Country": "Country",
        "Location": "Location",
        "PosLong": "Pos Long",
        "PosLat": "Pos Lat",
        "AddressID": "Address ID",
        "Formatted": "Formatted",
    },
    "addressForContactID": {
        "entityTitle": "Address For Contact ID",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "Country": "Country",
        "Location": "Location",
        "PosLong": "Pos Long",
        "PosLat": "Pos Lat",
        "AddressID": "Address ID",
        "Formatted": "Formatted",
    },
    "addressForJobID": {
        "entityTitle": "Address For Job ID",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "Country": "Country",
        "Location": "Location",
        "PosLong": "Pos Long",
        "PosLat": "Pos Lat",
        "AddressID": "Address ID",
        "Formatted": "Formatted",
    },
    "advancedFilter_Job": {
        "entityTitle": "Advanced Filter _ Job",
        "ID": "ID",
        "QuoteDate": "Quote Date",
        "QuoteExpiryDate": "Quote Expiry Date",
        "HandoverDate": "Handover Date",
        "LJ__CommissionDate1": "LJ __ Commission Date 1",
        "LJ__CommissionDate2": "LJ __ Commission Date 2",
        "LJ__CommissionDate3": "LJ __ Commission Date 3",
        "LJ__CommissionDate4": "LJ __ Commission Date 4",
        "LJ__CommissionDate5": "LJ __ Commission Date 5",
        "LJ__OrderDate": "LJ __ Order Date",
        "LJ__JobLineStageDate": "LJ __ Stage Date",
        "LJ__ETADate": "LJ __ ETA Date",
        "LJ__Amount": "LJ __ Amount",
        "LJ__Paid": "LJ __ Paid",
        "LJ__HasPayment": "LJ __ Has Payment",
        "Stage": "Stage",
        "Status": "Status",
        "JobType": "Job Type",
        "MarginApprovalRequired": "Margin Approval Required",
        "LJ__JobLineStatus": "LJ __ Job Line Status",
        "LJ__JobLineStage": "LJ __ Job Line Stage",
        "LJ__JobLineType": "LJ __ Job Line Type",
        "LJ__FaultReasonID": "LJ __ Fault Reason ID",
        "LJ__AtFaultUserID": "LJ __ At Fault User ID",
        "LJ__AtFaultSupplierID": "LJ __ At Fault Supplier ID",
        "LJ__JobLineDispatchStage": "LJ __ Job Line Dispatch Stage",
        "SalesRepID": "Sales Rep ID",
        "BusinessUnitID": "Business Unit ID",
        "PL_CommitmentReasonID": "PL _ Commitment Reason ID",
        "LJ__Balance": "LJ __ Balance",
        "LJ__PercentagePaid": "LJ __ Percentage Paid",
        "LJ__JobLineProductID": "LJ __ Job Line Product ID",
        "LJ__JobLineSupplierID": "LJ __ Job Line Supplier ID",
        "LJ__CompanyName": "LJ __ Company Name",
        "LJ__OrganisationType": "LJ __ Organisation Type",
        "LJ__AccountType": "LJ __ Account Type",
        "LJ__ContactFirstName": "LJ __ Contact First Name",
        "LJ__ContactLastName": "LJ __ Contact Last Name",
        "LJ__ContactHasCredit": "LJ __ Contact Has Credit",
        "LJ__SiteContactFirstName": "LJ __ Site Contact First Name",
        "LJ__SiteContactLastName": "LJ __ Site Contact Last Name",
        "LJ__ActivityType": "LJ __ Activity Type",
        "LJ__ActivityCategory": "LJ __ Activity Category",
        "LJ__ActivityStart": "LJ __ Activity Start",
        "LJ__ActivityRepresentative": "LJ __ Activity Representative",
        "LJ__Tags": "LJ __ Tags",
        "LJ__ActivityClosed": "LJ __ Activity Closed",
        "LJ__ActivityConfirmed": "LJ __ Activity Confirmed",
        "LJ__ActivityCancelled": "LJ __ Activity Cancelled",
        "LJ__ReferredByID": "LJ __ Referred By ID",
        "LJ__LeadGenerator": "LJ __ Lead Generator",
        "LJ__OpportunityConfidenceLevel": "LJ __ Opportunity Confidence Level",
        "LJ__OpportunityStatus": "LJ __ Opportunity Status",
        "LJ__OpportunityOutcomeReason": "LJ __ Opportunity Outcome Reason",
        "LJ__OpportunityForecast": "LJ __ Opportunity Forecast",
        "LJ__LeadSource": "LJ __ Lead Source",
        "LJ__VisitedShowroom": "LJ __ Visited Showroom",
        "LJ__OpportunityRepresentative": "LJ __ Opportunity Representative",
        "LJ__CMRequired": "LJ __ CM Required",
        "LJ__InstallRequired": "LJ __ Install Required",
        "LJ__PickupRequired": "LJ __ Pickup Required",
        "LJ__DeliveryRequired": "LJ __ Delivery Required",
        "LJ__PercentageInvoiced": "LJ __ Percentage Invoiced",
    },
    "advancedFilter_Opportunity": {
        "entityTitle": "Advanced Filter _ Opportunity",
        "ID": "ID",
        "Description": "Description",
        "ExpectedCloseDate": "Expected Close Date",
        "Status": "Status",
        "RepresentativeID": "Representative ID",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Forecast": "Forecast",
        "LeadGeneratorID": "Lead Generator ID",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "BusinessUnitID": "Business Unit ID",
        "PL_QuoteOutcomeReasonID": "PL _ Outcome Reason ID",
        "ReferedByID": "Refered By ID",
        "VisitedShowroom": "Visited Showroom",
        "LJ__Tags": "LJ __ Tags",
        "LJ__ActivityType": "LJ __ Activity Type",
        "LJ__ActivityCategory": "LJ __ Activity Category",
        "LJ__ActivityStart": "LJ __ Activity Start",
        "LJ__ActivityRepresentative": "LJ __ Activity Representative",
        "LJ__ActivityClosed": "LJ __ Activity Closed",
        "LJ__ActivityConfirmed": "LJ __ Activity Confirmed",
        "LJ__ActivityCancelled": "LJ __ Activity Cancelled",
        "LJ__CompanyName": "LJ __ Company Name",
        "LJ__OrganisationType": "LJ __ Organisation Type",
        "LJ__CompanyAccountType": "LJ __ Company Account Type",
        "LJ__ContactFirstName": "LJ __ Contact First Name",
        "LJ__ContactLastName": "LJ __ Contact Last Name",
        "LJ__Amount": "LJ __ Amount",
        "LJ__QuoteLastSentDate": "LJ __ Quote Last Sent Date",
        "LJ__QuoteDate": "LJ __ Quote Date",
        "LJ__QuoteExpiryDate": "LJ __ Quote Expiry Date",
        "LJ__JobID": "LJ __ Job ID",
        "LJ__JobSalesRep": "LJ __ Job Sales Rep",
        "LJ__JobStage": "LJ __ Job Stage",
        "LJ__JobLineStageDate": "LJ __ Stage Date",
        "LJ__JobTags": "LJ __ Job Tags",
        "LJ__JobCompanyName": "LJ __ Job Company Name",
        "LJ__JobOrganisationType": "LJ __ Job Organisation Type",
        "LJ__JobCompanyAccountType": "LJ __ Job Company Account Type",
        "LJ__JobContactFirstName": "LJ __ Job Contact First Name",
        "LJ__JobContactLastName": "LJ __ Job Contact Last Name",
        "LJ__JobLineETADate": "LJ __ Job Line ETA Date",
        "LJ__JobLineProductID": "LJ __ Job Line Product ID",
        "LJ__JobLineSupplierID": "LJ __ Job Line Supplier ID",
        "LJ__JobLineCMRequired": "LJ __ Job Line CM Required",
        "LJ__JobLineInstallRequired": "LJ __ Job Line Install Required",
        "LJ__JobLinePickupRequired": "LJ __ Job Line Pickup Required",
        "LJ__JobLineDeliveryRequired": "LJ __ Job Line Delivery Required",
        "LJ__JobLineStatus": "LJ __ Job Line Status",
        "LJ__JobLineStage": "LJ __ Job Line Stage",
    },
    "advancedFilter_SupplyJob": {
        "entityTitle": "Advanced Filter _ Supply Job",
        "ID": "ID",
        "PurchaseOrderID": "Purchase Order ID",
        "RepresentativeID": "Representative ID",
        "OrderNumber": "Order Number",
        "CustomerReference": "Customer Reference",
        "Status": "Status",
        "SupplierID": "Supplier ID",
        "ETADate": "ETA Date",
        "LJ__Internal": "LJ __ Internal",
        "LJ__SupplyLineProductID": "LJ __ Supply Line Product ID",
        "LJ__SupplyLineStatus": "LJ __ Supply Line Status",
        "LJ__SupplyLineMFDate": "LJ __ Supply Line MF Date",
        "LJ__SupplyLineDepartment": "LJ __ Supply Line Department",
        "LJ__CommitmentReason": "LJ __ Commitment Reason",
        "LJ__HandoverDate": "LJ __ Handover Date",
        "LJ__SalesRepID": "LJ __ Sales Rep ID",
        "LJ__DispatchDate": "LJ __ Dispatch Date",
        "LJ__DispatchBy": "LJ __ Dispatch By",
        "LJ__CompanyName": "LJ __ Company Name",
        "LJ__OrganisationType": "LJ __ Organisation Type",
        "LJ__AccountType": "LJ __ Account Type",
        "LJ__Tags": "LJ __ Tags",
        "LJ__InstallRequired": "LJ __ Install Required",
        "LJ__PickupRequired": "LJ __ Pickup Required",
        "LJ__DeliveryRequired": "LJ __ Delivery Required",
    },
    "attachDocumentSuppliersForJob": {
        "entityTitle": "Attach Document Suppliers For Job",
        "Name": "Name",
        "Phone": "Phone",
        "Fax": "Fax",
        "Mobile": "Mobile",
        "Email": "Email",
        "WWW": "WWW",
        "SupplierID": "Supplier ID",
        "TaxRate": "Tax Rate",
        "Internal": "Internal",
        "SplitByProduct": "Split By Product",
        "IsMarketplaceLicensed": "Is Marketplace Licensed",
        "MarketplaceID": "Marketplace ID",
        "AccountID": "Account ID",
        "FabricTemplate": "Binary Data Field",
        "FabricTemplateID": "Binary Data Field",
        "ComponentTemplate": "Binary Data Field",
        "ComponentTemplateID": "Binary Data Field",
        "TemplatePrintType": "Template Print Type",
    },
    "attendees": {
        "entityTitle": "Attendees",
        "Activity": "Activity",
        "ActivityID": "Activity",
        "Rep": "Representative",
        "RepID": "Representative",
    },
    "authTokens": {
        "entityTitle": "Auth Tokens",
        "Token": "Token",
        "Type": "Type",
        "Application": "Application",
        "Date": "Date",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
    },
    "automations": {
        "entityTitle": "Automations",
        "AutomationID": "Automation ID",
        "Name": "Name",
        "Notes": "Notes",
        "Type": "Type",
        "SMSTemplate": "Template",
        "SMSTemplateID": "Template",
        "EmailTemplate": "Template",
        "EmailTemplateID": "Template",
        "SendTo": "Send To",
        "ScheduleTimeframe": "Schedule Timeframe",
        "ScheduleAmount": "Schedule Amount",
        "ScheduleTimeOfDay": "Schedule Time Of Day",
        "Confirmed": "Confirmed",
        "BalanceOutstanding": "Balance Outstanding",
        "AppointmentType": "Appointment Type",
        "DispatchType": "Dispatch Type",
        "JobType": "Job Type",
        "Enabled": "Enabled",
        "SmsDeliveryReceipt": "Sms Delivery Receipt",
    },
    "binaryDataFields": {
        "entityTitle": "Binary Data Fields",
        "Data": "Data",
    },
    "blobItems": {
        "entityTitle": "Blob Items",
        "Data": "Data",
        "BlobItemID": "Blob Item ID",
    },
    "businessUnit_Default": {
        "entityTitle": "Business Unit _ Default",
        "BusinessUnitID": "Business Unit ID",
        "Name": "Name",
        "Logo": "Logo",
        "BusinessNumber": "Business Number",
        "Phone": "Phone",
        "Mobile": "Mobile",
        "Email": "Email",
        "WWW": "WWW",
        "Locale": "Locale",
        "TimeZone": "Time Zone",
        "Address": "Address",
        "AddressID": "Address",
        "DeliveryAddress": "Address",
        "DeliveryAddressID": "Address",
        "BillingAddress": "Address",
        "BillingAddressID": "Address",
        "ProductExclusions": "Product Exclusions",
    },
    "businessUnitProductExclusions": {
        "entityTitle": "Business Unit Product Exclusions",
        "BusinessUnit": "Business Unit",
        "BusinessUnitID": "Business Unit",
        "ProductID": "Product ID",
    },
    "businessUnits": {
        "entityTitle": "Business Units",
        "BusinessUnitID": "Business Unit ID",
        "Name": "Name",
        "Logo": "Logo",
        "BusinessNumber": "Business Number",
        "Phone": "Phone",
        "Mobile": "Mobile",
        "Email": "Email",
        "WWW": "WWW",
        "Locale": "Locale",
        "TimeZone": "Time Zone",
        "Address": "Address",
        "AddressID": "Address",
        "DeliveryAddress": "Address",
        "DeliveryAddressID": "Address",
        "BillingAddress": "Address",
        "BillingAddressID": "Address",
        "ProductExclusions": "Product Exclusions",
    },
    "commandActions": {
        "entityTitle": "Command Actions",
        "Type": "Type",
        "Date": "Date",
        "CommandData": "Command Data",
        "CommandActionKey": "Command Action Key",
    },
    "commissionAccountTransactionDetails": {
        "entityTitle": "Commission Account Transaction Details",
        "Transaction": "Commission Account Tx",
        "TransactionID": "Commission Account Tx",
        "Job": "Job",
        "JobID": "Job",
        "Values": "Values",
    },
    "commissionAccountTransactionGridForJob": {
        "entityTitle": "Commission Account Transaction Grid For Job",
        "ID": "ID",
        "Date": "Date",
        "User": "User",
        "UserID": "User ID",
        "RunID": "Run ID",
        "Run": "Run",
        "Plan": "Plan",
        "Type": "Type",
        "Description": "Description",
        "Status": "Status",
        "Amount": "Amount",
        "Notes": "Notes",
        "IDs": "I Ds",
    },
    "commissionAccountTransactionGridForRun": {
        "entityTitle": "Commission Account Transaction Grid For Run",
        "ID": "ID",
        "Date": "Date",
        "User": "User",
        "UserID": "User ID",
        "RunID": "Run ID",
        "Run": "Run",
        "Plan": "Plan",
        "Type": "Type",
        "Description": "Description",
        "Status": "Status",
        "Amount": "Amount",
        "Notes": "Notes",
        "IDs": "I Ds",
    },
    "commissionAccountTransactions": {
        "entityTitle": "Commission Account Transactions",
        "Date": "Date",
        "User": "Representative",
        "UserID": "Representative",
        "Run": "Commission Run",
        "RunID": "Commission Run",
        "Type": "Type",
        "Description": "Description",
        "Status": "Status",
        "Amount": "Amount",
        "Notes": "Notes",
        "Details": "Details",
    },
    "commissionPlanRules": {
        "entityTitle": "Commission Plan Rules",
        "CommissionPlan": "Commission Plan",
        "CommissionPlanID": "Commission Plan",
        "CommissionRule": "Commission Rule",
        "CommissionRuleID": "Commission Rule",
    },
    "commissionPlans": {
        "entityTitle": "Commission Plans",
        "Description": "Description",
        "Rules": "Rules",
    },
    "commissionRules": {
        "entityTitle": "Commission Rules",
        "Name": "Name",
        "Expression": "Expression",
        "TextValues": "Text Values",
        "ByJob": "By Job",
        "Users": "Users",
    },
    "commissionRuns": {
        "entityTitle": "Commission Runs",
        "Description": "Description",
        "StartDate": "Start Date",
        "EndDate": "End Date",
        "Plan": "Commission Plan",
        "PlanID": "Commission Plan",
        "LastRunBy": "Representative",
        "LastRunByID": "Representative",
        "PaidBy": "Representative",
        "PaidByID": "Representative",
        "Paid": "Representative",
        "InProgress": "In Progress",
    },
    "commissionRunsGrid": {
        "entityTitle": "Commission Runs Grid",
        "ID": "ID",
        "Plan": "Plan",
        "Description": "Description",
        "StartDate": "Start Date",
        "EndDate": "End Date",
        "LastRunBy": "Last Run By",
        "PaidBy": "Paid By",
    },
    "commissionsDataView": {
        "entityTitle": "Commissions Data View",
        "Line_ID": "Line _ ID",
        "Line_OrderDate": "Line _ Order Date",
        "Line_ETA": "Line _ ETA",
        "Line_Width": "Line _ Width",
        "Line_Drop": "Line _ Drop",
        "Line_Qty": "Line _ Qty",
        "Line_Price": "Line _ Price",
        "Line_PriceTax": "Line _ Price Tax",
        "Line_PriceIncTax": "Line _ Price Inc Tax",
        "Line_SalePrice": "Line _ Sale Price",
        "Line_SalePriceTax": "Line _ Sale Price Tax",
        "Line_SalePriceIncTax": "Line _ Sale Price Inc Tax",
        "Line_PaidAllocation": "Line _ Paid Allocation",
        "Line_ManualDiscountIncTax": "Line _ Manual Discount Inc Tax",
        "Line_PromotionDiscountIncTax": "Line _ Promotion Discount Inc Tax",
        "Line_DeductFromCommissionDiscount": "Line _ Deduct From Commission Discount",
        "Line_DeductFromCommissionDiscountIncTax": "Line _ Deduct From Commission Discount Inc Tax",
        "Line_CostPrice": "Line _ Cost Price",
        "Line_CostPriceTax": "Line _ Cost Price Tax",
        "Line_CostPriceIncTax": "Line _ Cost Price Inc Tax",
        "Line_RequireCheckMeasure": "Line _ Require Check Measure",
        "Line_CM_Approved": "Line _ CM _ Approved",
        "Line_RequireInstall": "Line _ Require Install",
        "Line_Inst_Completed": "Line _ Inst _ Completed",
        "Line_ProductID": "Line _ Product ID",
        "Line_ProductName": "Line _ Product Name",
        "Line_Options": "Line _ Options",
        "Line_SupplierID": "Line _ Supplier ID",
        "Line_Status": "Line _ Status",
        "Line_Stage": "Line _ Stage",
        "Line_LineType": "Line _ Line Type",
        "Line_BasePrice": "Line _ Base Price",
        "Line_BaseCost": "Line _ Base Cost",
        "Line_InstallPrice": "Line _ Install Price",
        "Line_InstallCost": "Line _ Install Cost",
        "Line_OptionsPrice": "Line _ Options Price",
        "Line_OptionsCost": "Line _ Options Cost",
        "Line_DeliveryPrice": "Line _ Delivery Price",
        "Line_DeliveryCost": "Line _ Delivery Cost",
        "Line_AdjustmentPrice": "Line _ Adjustment Price",
        "Line_AdjustmentCost": "Line _ Adjustment Cost",
        "Line_Invoiced": "Line _ Invoiced",
        "Line_DisplayOption1": "Line _ Display Option 1",
        "Line_DisplayOption2": "Line _ Display Option 2",
        "Line_DisplayOption3": "Line _ Display Option 3",
        "Line_DisplayOption4": "Line _ Display Option 4",
        "Line_DisplayOption5": "Line _ Display Option 5",
        "Line_DisplayOption6": "Line _ Display Option 6",
        "Line_DisplayOption7": "Line _ Display Option 7",
        "Line_DisplayOption8": "Line _ Display Option 8",
        "Line_DisplayOption9": "Line _ Display Option 9",
        "Line_DisplayOption10": "Line _ Display Option 10",
        "Line_IsService": "Line _ Is Service",
        "Line_RequireDelivery": "Line _ Require Delivery",
        "Line_RequirePickup": "Line _ Require Pickup",
        "Line_DispatchStage": "Line _ Dispatch Stage",
        "Line_StandardCostPrice": "Line _ Standard Cost Price",
        "Line_StandardCostPriceTax": "Line _ Standard Cost Price Tax",
        "Line_StandardCostPriceIncTax": "Line _ Standard Cost Price Inc Tax",
        "ServiceLine_ID": "Service Line _ ID",
        "ServiceLine_OrderDate": "Service Line _ Order Date",
        "ServiceLine_ETA": "Service Line _ ETA",
        "ServiceLine_Width": "Service Line _ Width",
        "ServiceLine_Drop": "Service Line _ Drop",
        "ServiceLine_Qty": "Service Line _ Qty",
        "ServiceLine_Price": "Service Line _ Price",
        "ServiceLine_PriceTax": "Service Line _ Price Tax",
        "ServiceLine_PriceIncTax": "Service Line _ Price Inc Tax",
        "ServiceLine_SalePrice": "Service Line _ Sale Price",
        "ServiceLine_SalePriceTax": "Service Line _ Sale Price Tax",
        "ServiceLine_SalePriceIncTax": "Service Line _ Sale Price Inc Tax",
        "ServiceLine_ManualDiscountIncTax": "Service Line _ Manual Discount Inc Tax",
        "ServiceLine_PromotionDiscountIncTax": "Service Line _ Promotion Discount Inc Tax",
        "ServiceLine_CostPrice": "Service Line _ Cost Price",
        "ServiceLine_CostPriceTax": "Service Line _ Cost Price Tax",
        "ServiceLine_CostPriceIncTax": "Service Line _ Cost Price Inc Tax",
        "ServiceLine_RequireCheckMeasure": "Service Line _ Require Check Measure",
        "ServiceLine_CM_Approved": "Service Line _ CM _ Approved",
        "ServiceLine_RequireInstall": "Service Line _ Require Install",
        "ServiceLine_Inst_Completed": "Service Line _ Inst _ Completed",
        "ServiceLine_ProductID": "Service Line _ Product ID",
        "ServiceLine_ProductName": "Service Line _ Product Name",
        "ServiceLine_Options": "Service Line _ Options",
        "ServiceLine_SupplierID": "Service Line _ Supplier ID",
        "ServiceLine_Status": "Service Line _ Status",
        "ServiceLine_Stage": "Service Line _ Stage",
        "ServiceLine_LineType": "Service Line _ Line Type",
        "ServiceLine_BasePrice": "Service Line _ Base Price",
        "ServiceLine_BaseCost": "Service Line _ Base Cost",
        "ServiceLine_InstallPrice": "Service Line _ Install Price",
        "ServiceLine_InstallCost": "Service Line _ Install Cost",
        "ServiceLine_OptionsPrice": "Service Line _ Options Price",
        "ServiceLine_OptionsCost": "Service Line _ Options Cost",
        "ServiceLine_DeliveryPrice": "Service Line _ Delivery Price",
        "ServiceLine_DeliveryCost": "Service Line _ Delivery Cost",
        "ServiceLine_AdjustmentPrice": "Service Line _ Adjustment Price",
        "ServiceLine_AdjustmentCost": "Service Line _ Adjustment Cost",
        "ServiceLine_Invoiced": "Service Line _ Invoiced",
        "ServiceLine_DisplayOption1": "Service Line _ Display Option 1",
        "ServiceLine_DisplayOption2": "Service Line _ Display Option 2",
        "ServiceLine_DisplayOption3": "Service Line _ Display Option 3",
        "ServiceLine_DisplayOption4": "Service Line _ Display Option 4",
        "ServiceLine_DisplayOption5": "Service Line _ Display Option 5",
        "ServiceLine_DisplayOption6": "Service Line _ Display Option 6",
        "ServiceLine_DisplayOption7": "Service Line _ Display Option 7",
        "ServiceLine_DisplayOption8": "Service Line _ Display Option 8",
        "ServiceLine_DisplayOption9": "Service Line _ Display Option 9",
        "ServiceLine_DisplayOption10": "Service Line _ Display Option 10",
        "ServiceLine_IsService": "Service Line _ Is Service",
        "ServiceLine_RequireDelivery": "Service Line _ Require Delivery",
        "ServiceLine_RequirePickup": "Service Line _ Require Pickup",
        "ServiceLine_DispatchStage": "Service Line _ Dispatch Stage",
        "ServiceLine_StandardCostPrice": "Service Line _ Standard Cost Price",
        "ServiceLine_StandardCostPriceTax": "Service Line _ Standard Cost Price Tax",
        "ServiceLine_StandardCostPriceIncTax": "Service Line _ Standard Cost Price Inc Tax",
        "Job_ID": "Job _ ID",
        "Job_QuoteSentDate": "Job _ Quote Sent Date",
        "Job_SalesRep": "Job _ Sales Rep",
        "Job_Reference": "Job _ Reference",
        "Job_Number": "Job _ Number",
        "Job_Forecasted": "Job _ Forecasted",
        "Job_IsClosed": "Job _ Is Closed",
        "Job_JobDate": "Job _ Job Date",
        "Job_CloseDate": "Job _ Close Date",
        "Job_Stage": "Job _ Stage",
        "Job_JobType": "Job _ Job Type",
        "Job_Priority": "Job _ Priority",
        "Job_ShowroomQuote": "Job _ Showroom Quote",
        "Job_SalesRepID": "Job _ Sales Rep ID",
        "Job_CompanyID": "Job _ Company ID",
        "Job_PL_CustomStatusID": "Job _ PL _ Custom Status ID",
        "Job_HandoverDate": "Job _ Handover Date",
        "CommissionDate1": "Commission Date 1",
        "CommissionDate2": "Commission Date 2",
        "CommissionDate3": "Commission Date 3",
        "CommissionDate4": "Commission Date 4",
        "CommissionDate5": "Commission Date 5",
        "Job_Status": "Job _ Status",
        "Job_MarginApproved": "Job _ Margin Approved",
        "Job_DeductFromCommissionDiscount": "Job _ Deduct From Commission Discount",
        "Job_DeductFromCommissionDiscountIncTax": "Job _ Deduct From Commission Discount Inc Tax",
        "ServiceJob_ID": "Service Job _ ID",
        "ServiceJob_QuoteSentDate": "Service Job _ Quote Sent Date",
        "ServiceJob_Forecasted": "Service Job _ Forecasted",
        "ServiceJob_IsClosed": "Service Job _ Is Closed",
        "ServiceJob_JobDate": "Service Job _ Job Date",
        "ServiceJob_CloseDate": "Service Job _ Close Date",
        "ServiceJob_Stage": "Service Job _ Stage",
        "ServiceJob_JobType": "Service Job _ Job Type",
        "ServiceJob_Priority": "Service Job _ Priority",
        "ServiceJob_ShowroomQuote": "Service Job _ Showroom Quote",
        "ServiceJob_SalesRepID": "Service Job _ Sales Rep ID",
        "ServiceJob_CompanyID": "Service Job _ Company ID",
        "ServiceJob_PL_CustomStatusID": "Service Job _ PL _ Custom Status ID",
        "ServiceJob_HandoverDate": "Service Job _ Handover Date",
        "ServiceJob_Status": "Service Job _ Status",
        "ServiceJob_MarginApproved": "Service Job _ Margin Approved",
        "Line_UserAtFaultID": "Line _ User At Fault ID",
        "Line_PL_FaultReasonID": "Line _ PL _ Fault Reason ID",
        "Payment_Date": "Payment _ Date",
        "Payment_Type": "Payment _ Type",
        "Payment_Status": "Payment _ Status",
        "Payment_Amount": "Payment _ Amount",
        "Payment_IsDeposit": "Payment _ Is Deposit",
        "Payment_ID": "Payment _ ID",
        "Company_AccountType": "Company _ Account Type",
        "Opportunity_LeadSourceID": "Opportunity _ Lead Source ID",
        "Opportunity_LeadGeneratorID": "Opportunity _ LeadGenerator ID",
    },
    "commissionValues": {
        "entityTitle": "Commission Values",
        "Name": "Name",
        "SummaryType": "Summary Type",
        "Filter": "Filter",
        "Expression": "Expression",
        "GroupBy": "Group By",
        "SummaryBy": "Summary By",
        "ShowOnStatement": "Show On Statement",
        "IsText": "Is Text",
        "SortOrder": "Sort Order",
    },
    "marketplaceSupplier": {
        "entityTitle": "Marketplace Supplier",
        "Description": "Description",
        "EmailUBL": "Email Me UBL File",
        "ErrorUser": "User to receive marketplace error notifications",
        "ErrorUserID": "User to receive marketplace error notifications",
        "SendNewOrderNotificationEmail": "Email Me New Order Notification",
        "MPKey": "Marketplace Private Key",
    },
    "marketplaceSupplierClient": {
        "entityTitle": "Marketplace Supplier Client",
        "MarketplaceSupplierID": "Marketplace Supplier",
        "MPKey": "Marketplace Public Key",
        "Notes": "Notes",
        "Company": "Company",
        "CompanyID": "Company",
        "SendToSupplierWithTransforms": "Do Not Reverse Tansforms (when sending jobs to me)",
        "SendNewOrderNotificationEmail": "Send New Order Notification To Client",
    },
    "marketplaceSupplierProduct": {
        "entityTitle": "Marketplace Supplier Product",
        "MarketplaceSupplierID": "Marketplace Supplier",
        "ID": "ID",
        "Product": "Product",
        "ProductID": "Product",
        "LastSentDate": "Last Sent Date",
        "LastVersionNumber": "Last Version Number",
    },
    "communicationLog": {
        "entityTitle": "Communication Log",
        "Date": "Date",
        "Type": "Type",
        "Category": "Category",
        "Description": "Description",
        "Outcome": "Outcome",
        "OutcomeDate": "Outcome Date",
        "ContactPoint": "Contact Point",
        "Tag": "Tag",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Company": "Company",
        "CompanyID": "Company",
        "Job": "Job",
        "JobID": "Job",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "Supplier": "Supplier",
        "SupplierID": "Supplier",
        "SupplyJob": "Purchase Order",
        "SupplyJobID": "Purchase Order",
        "CommunicationID": "Communication ID",
        "activity": "activity",
        "ActivityID": "Activity",
        "TemplateID": "Template ID",
    },
    "companies": {
        "entityTitle": "Companies",
        "Name": "Name",
        "Phone": "Phone",
        "Fax": "Fax",
        "Mobile": "Mobile",
        "Email": "Email",
        "WWW": "WWW",
        "DefaultPaymentTerms": "Default Payment Terms",
        "DefaultPaymentDue": "Default Payment Due",
        "InvoiceDueDays": "Invoice Due Days",
        "Notes": "Notes",
        "OrganisationType": "Organisation Type",
        "PL_OrganisationTypeID": "Organisation Type",
        "Address": "Address",
        "AddressID": "Address",
        "PriceListID": "Price List ID",
        "BillingContact": "Contact",
        "BillingContactID": "Contact",
        "FileNotes": "File Notes",
        "PriceMappings": "Price Mappings",
        "AccountType": "Account Type",
        "CompanyID": "Company ID",
        "ReceiveAutomatedEmail": "Receive Operational Email",
        "ReceiveAutomatedSMS": "Receive Operational SMS",
    },
    "companyDiscounts": {
        "entityTitle": "Company Discounts",
        "DiscountLevel": "Discount Level",
        "DiscountLevelID": "Discount Level",
        "Company": "Company",
        "CompanyID": "Company",
    },
    "companyPriceMappings": {
        "entityTitle": "Company Price Mappings",
        "Company": "Company",
        "CompanyID": "Company",
        "PriceListID": "Price List ID",
        "ProductID": "Product ID",
    },
    "contacts": {
        "entityTitle": "Contacts",
        "FirstName": "First Name",
        "LastName": "Last Name",
        "FullName": "Full Name",
        "JobTitle": "Job Title",
        "JobCategory": "Contact Job Category",
        "PL_ContactJobCategoryID_abbrev": "Job Category",
        "PL_ContactJobCategoryID": "Contact Job Category",
        "WorkPhone": "Work Phone",
        "HomePhone": "Home Phone",
        "Mobile": "Mobile",
        "Email": "Email",
        "Notes": "Notes",
        "Address": "Address",
        "AddressID": "Address",
        "Company": "Company",
        "CompanyID": "Company",
        "FileNotes": "File Notes",
        "ContactID": "Contact ID",
        "FinanceIntegrationID": "Finance Integration ID",
        "ReceiveAutomatedEmail": "Receive Operational Email",
        "ReceiveAutomatedSMS": "Receive Operational SMS",
    },
    "contactsForCompany": {
        "entityTitle": "Contacts For Company",
        "ID": "ID",
        "FirstName": "First Name",
        "LastName": "Last Name",
        "WorkPhone": "Work Phone",
        "HomePhone": "Home Phone",
        "Mobile": "Mobile",
        "Email": "Email",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "InternalNotes": "Internal Notes",
        "Company": "Company",
        "CompanyID": "Company ID",
        "JobCategory": "Job Category",
        "JobTitle": "Job Title",
    },
    "currentActivities": {
        "entityTitle": "Current Activities",
        "ActivityID": "Activity ID",
        "JobID": "Job ID",
        "JobLineID": "Job Line ID",
        "ActiveTypeID": "Active Type ID",
        "ActiveCategoryID": "Active Category ID",
        "ActivityType": "Activity Type",
        "Representative": "Representative",
        "RepresentativeID": "Representative ID",
        "Team": "Team",
        "TeamID": "Team ID",
        "Subject": "Subject",
        "Priority": "Priority",
        "Confirmed": "Confirmed",
        "Closed": "Closed",
        "ContactID": "Contact ID",
        "PL_ActivityCategoryID": "PL _ Activity Category ID",
        "Start": "Start",
        "CreatedOn": "Created On",
    },
    "defaultSettings": {
        "entityTitle": "Default Settings",
        "DefaultMarkupPercentage": "Default Markup Percentage",
        "QuoteExpireDays": "Quote Expire Days",
        "InvoiceDueDays": "Invoice Due Days",
        "DefaultCommitmentReason": "Commitment Reason",
        "DefaultCommitmentReasonID": "Commitment Reason",
        "PrimaryBusinessUnit": "Business Unit",
        "PrimaryBusinessUnitID": "Business Unit",
        "DefaultPaymentTerms": "Default Payment Terms",
        "DefaultPaymentDue": "Default Payment Due",
        "MinDeposit": "Min Deposit",
        "FinancialYearStartDate": "Financial Year Start Date",
        "FinanceLockDate": "Finance Lock Date",
        "CommissionDate1Rule": "Commission Date 1 Rule",
        "CommissionDate1RuleByLine": "Commission Date 1 Rule By Line",
        "DefaultSupplierEmailTemplate": "Template",
        "DefaultSupplierEmailTemplateID": "Template",
        "DefaultBusinessUnitRule": "Default Business Unit Rule",
        "OrderCustomerRefRequired": "Order Customer Ref Required",
        "DefaultSettingID": "Default Setting ID",
        "SetupWizardCompleted": "Setup Wizard Completed",
        "DocumentStore": "Document Store",
        "TrackingEmailAddress": "Tracking Email Address",
        "ManufacturingETABuffer": "Manufacturing ETA Buffer",
        "Tracking_QuoteExpiryDays": "Tracking _ Quote Expiry Days",
        "Tracking_CMNotBookedDays": "Tracking _ CM Not Booked Days",
        "Tracking_CMNotConfirmedDays": "Tracking _ CM Not Confirmed Days",
        "Tracking_StockDuedDays": "Tracking _ Stock Dued Days",
        "Tracking_StockNotArrivedDays": "Tracking _ Stock Not Arrived Days",
        "Tracking_InstNotConfirmedDays": "Tracking _ Inst Not Confirmed Days",
        "Tracking_InstallerNotCompleteDays": "Tracking _ Installer Not Complete Days",
        "AutomationEnabled": "Automation Enabled",
        "AutoCreateFinalPriceDiscountRules": "Auto Create Final Price Discount Rules to Lock Sale Prices",
    },
    "discountItemGrid": {
        "entityTitle": "Discount Item Grid",
        "ID": "ID",
        "Active": "Active",
        "Start": "Start",
        "Finish": "Finish",
        "Base": "Base",
        "Options": "Options",
        "Delivery": "Delivery",
        "Install": "Install",
        "Percentage": "Percentage",
        "Supplier": "Supplier",
        "Product": "Product",
        "Option1": "Option 1",
        "Option2": "Option 2",
        "Option1Value": "Option 1 Value",
        "Option2Value": "Option 2 Value",
        "Option1GroupCode": "Option 1 Group Code",
        "Option2GroupCode": "Option 2 Group Code",
    },
    "discountItems": {
        "entityTitle": "Discount Items",
        "Active": "Active",
        "Start": "Start",
        "Finish": "Finish",
        "ApplyToBase": "Apply To Base",
        "ApplyToOptions": "Apply To Options",
        "ApplyToDelivery": "Apply To Delivery",
        "ApplyToInstallation": "Apply To Installation",
        "Percentage": "Percentage",
        "Amount": "Amount",
        "DiscountLevel": "Discount Level",
        "DiscountLevelID": "Discount Level",
        "ProductID": "Product ID",
        "Supplier": "Supplier",
        "Product": "Product",
        "Option1": "Option 1",
        "Option1ID": "Option 1 ID",
        "Option2ID": "Option 2 ID",
        "Option2": "Option 2",
        "Option1ValueID": "Option 1 Value ID",
        "Option1Value": "Option 1 Value",
        "Option2ValueID": "Option 2 Value ID",
        "Option2Value": "Option 2 Value",
        "Option1GroupCode": "Option 1 Group Code",
        "Option2GroupCode": "Option 2 Group Code",
        "DiscountItemID": "Discount Item ID",
    },
    "discountLevel_CompaniesGrid": {
        "entityTitle": "Discount Level _ Companies Grid",
        "ID": "ID",
        "Name": "Name",
        "Type": "Type",
        "Phone": "Phone",
        "Fax": "Fax",
        "Mobile": "Mobile",
        "Email": "Email",
        "WWW": "WWW",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "InternalNotes": "Internal Notes",
    },
    "discountLevels": {
        "entityTitle": "Discount Levels",
        "Description": "Description",
        "Code": "Code",
        "Type": "Type",
        "Active": "Active",
        "DiscountLevelID": "Discount Level ID",
        "DicountItems": "Dicount Items",
        "CompanyDiscounts": "Company Discounts",
    },
    "documents": {
        "entityTitle": "Documents",
        "Job": "Job",
        "JobID": "Job",
        "SendToCustomer": "Send To Customer",
        "SendToSupplier": "Send To Supplier",
        "SendToSuppierID": "Send To Suppier ID",
        "Signed": "Signed",
    },
    "eDIOutboundFile": {
        "entityTitle": "EDI Outbound File",
        "SenderID": "Sender ID",
        "ReceiverID": "Receiver ID",
        "SupplierID": "Supplier",
        "PurchaseOrderID": "Supply Job",
        "Mode": "Mode",
        "DocumentStandard": "Document Standard",
        "VersionNumber": "Version Number",
        "FileName": "File Name",
        "DateCreated": "Created",
        "DateSent": "Sent",
        "ProcessingStatus": "Processing Status",
        "Result": "Result",
        "FailureMessage": "Failure Message",
        "FailureDetails": "Failure Details",
        "ControlNumberType": "Type",
        "ControlNumber": "Control Number"
    },
    "eDIInboundFile": {
        "entityTitle": "EDI Inbound File",
        "SenderID": "Sender ID",
        "ReceiverID": "Receiver ID",
        "SupplierID": "Supplier",
        "PurchaseOrderID": "Supply Job",
        "Mode": "Mode",
        "DocumentStandard": "Document Standard",
        "VersionNumber": "Version Number",
        "FileName": "File Name",
        "Source": "Source",
        "FileHash": "File Hash",
        "DateReceived": "Received",
        "ProcessingStatus": "Processing Status",
        "Result": "Result",
        "Message": "Message",
        "Details": "Details",
        "ControlNumberType": "Type",
        "ControlNumber": "Control Number"
    },
    "eDIOutboundFileTransport": {
        "entityTitle": "EDI Outbound File Transport",
        "AttemptNo": "Attempt",
        "TransportType": "Transport Type",
        "TransportKey": "Transport Key",
        "Destination": "Destination",
        "ProviderReference": "Provider Reference",
        "SessionID": "Session",
        "DateAttempted": "Attempted",
        "DateSent": "Sent",
        "ProcessingStatus": "Processing Status",
        "Result": "Result",
        "Message": "Message",
        "Details": "Details"
    },
    "documentsForIDWithOrder": {
        "entityTitle": "Documents For ID With Order",
        "Job": "Job",
        "JobID": "Job",
        "SendToCustomer": "Send To Customer",
        "SendToSupplier": "Send To Supplier",
        "SendToSuppierID": "Send To Suppier ID",
    },
    "documentsForJob": {
        "entityTitle": "Documents For Job",
        "ID": "ID",
        "Description": "Description",
        "Job": "Job",
        "JobID": "Job ID",
        "Type": "Type",
        "Date": "Date",
        "Version": "Version",
        "SendToCustomer": "Send To Customer",
        "SendToSupplier": "Send To Supplier",
        "Signed": "Signed",
    },
    "documentTemplates": {
        "entityTitle": "Document Templates",
        "Name": "Name",
        "Type": "Type",
        "TemplateID": "Template ID",
        "TemplateParams": "Template Params",
    },
    "export_JobDetails": {
        "entityTitle": "Export _ Job Details",
        "JobID": "Job ID",
        "Reference": "Reference",
        "Stage": "Stage",
        "JobType": "Job Type",
        "SalesRep": "Sales Rep",
        "CustomStatus": "Custom Status",
        "CommitReason": "Commit Reason",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "Contact": "Contact",
        "SiteContact": "Site Contact",
        "City": "City",
        "CMBy": "CM By",
        "InstallBy": "Install By",
        "LineNo": "Line No",
        "OrderDate": "Order Date",
        "ETA": "ETA",
        "Qty": "Qty",
        "SalePrice": "Sale Price",
        "SalePriceTax": "Sale Price Tax",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "Product": "Product",
        "Supplier": "Supplier",
        "LineStage": "Line Stage",
        "OrderLineOptionsData": "Order Line Options Data",
        "CMDate": "CM Date",
        "InstallDate": "Install Date",
        "Paid": "Paid",
        "Tags": "Tags",
    },
    "externalLeads": {
        "entityTitle": "External Leads",
        "Date": "Date",
        "Processed": "Processed",
        "SnoozeDate": "Snooze Date",
        "ContactFirstName": "Contact First Name",
        "ContactLastName": "Contact Last Name",
        "ContactEmail": "Contact Email",
        "ContactMobile": "Contact Mobile",
        "ContactWorkPh": "Contact Work Ph",
        "ContactHomePh": "Contact Home Ph",
        "LeadData": "Lead Data",
        "LeadSource": "Lead Source",
        "PL_LeadSourceID_abbrev": "Lead Source",
        "PL_LeadSourceID": "Lead Source",
        "DiscardNotes": "Discard Notes",
        "PL_LeadDiscardReason": "Lead Discard Reason",
        "PL_LeadDiscardReasonID": "Lead Discard Reason",
    },
    "fileNotes": {
        "entityTitle": "File Notes",
        "Date": "Date",
        "Notes": "Notes",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Company": "Company",
        "CompanyID": "Company",
        "Job": "Job",
        "JobID": "Job",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "ExternalLead": "External Lead",
        "ExternalLeadID": "External Lead",
        "FileNoteID": "File Note ID",
    },
    "financeIntegrationSettingsRecord": {
        "entityTitle": "Finance Integration Settings Record",
        "Settings": "Settings",
    },
    "financeJournals": {
        "entityTitle": "Finance Journals",
        "EntryDate": "Entry Date",
        "TransferDate": "Transfer Date",
        "Amount": "Amount",
        "Tax": "Tax Rate",
        "Type": "Type",
        "Notes": "Notes",
        "FinanceJournalID": "Finance Journal ID",
        "GroupID": "Group ID",
        "TaxRate": "Tax Rate",
        "TaxRateID": "Tax Rate",
        "ItemID": "Item ID",
        "ItemPrompt": "Item Prompt",
        "ContactID": "Contact ID",
        "PaymentID": "Payment ID",
        "JobID": "Job ID",
        "InvoiceID": "Invoice ID",
    },
    "financeSettingRecord": {
        "entityTitle": "Finance Setting Record",
        "Settings": "Settings",
    },
    "getCommunicationLogForContact": {
        "entityTitle": "Get Communication Log For Contact",
        "ID": "ID",
        "Date": "Date",
        "Type": "Type",
        "Category": "Category",
        "Description": "Description",
        "ContactPoint": "Contact Point",
        "Outcome": "Outcome",
        "User_abbrev": "User",
        "User": "User",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Job": "Job",
        "JobID": "Job ID",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice ID",
        "SupplyJob": "Supply Job",
        "PurchaseOrderID": "Purchase Order ID",
        "Supplier": "Supplier",
    },
    "getCommunicationLogForInvoice": {
        "entityTitle": "Get Communication Log For Invoice",
        "ID": "ID",
        "Date": "Date",
        "Type": "Type",
        "Category": "Category",
        "Description": "Description",
        "ContactPoint": "Contact Point",
        "Outcome": "Outcome",
        "User_abbrev": "User",
        "User": "User",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Job": "Job",
        "JobID": "Job ID",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice ID",
        "SupplyJob": "Supply Job",
        "PurchaseOrderID": "Purchase Order ID",
        "Supplier": "Supplier",
    },
    "getCommunicationLogForJob": {
        "entityTitle": "Get Communication Log For Job",
        "ID": "ID",
        "Date": "Date",
        "Type": "Type",
        "Category": "Category",
        "Description": "Description",
        "ContactPoint": "Contact Point",
        "Outcome": "Outcome",
        "User_abbrev": "User",
        "User": "User",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Job": "Job",
        "JobID": "Job ID",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice ID",
        "SupplyJob": "Supply Job",
        "PurchaseOrderID": "Purchase Order ID",
        "Supplier": "Supplier",
    },
    "getCommunicationLogForSupplyJob": {
        "entityTitle": "Get Communication Log For Supply Job",
        "ID": "ID",
        "Date": "Date",
        "Type": "Type",
        "Category": "Category",
        "Description": "Description",
        "ContactPoint": "Contact Point",
        "Outcome": "Outcome",
        "User_abbrev": "User",
        "User": "User",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Job": "Job",
        "JobID": "Job ID",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice ID",
        "SupplyJob": "Supply Job",
        "PurchaseOrderID": "Purchase Order ID",
        "Supplier": "Supplier",
    },
    "gridFilterAccess": {
        "entityTitle": "Grid Filter Access",
        "GridFilter": "Grid Filter",
        "GridFilterID": "Grid Filter",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Team": "Team",
        "TeamID": "Team",
    },
    "gridFilters": {
        "entityTitle": "Grid Filters",
        "Name": "Name",
        "Filter": "Filter",
        "EntityType": "Entity Type",
        "Owner": "Representative",
        "OwnerID": "Representative",
        "FilterAccess": "Filter Access",
    },
    "gridSettings": {
        "entityTitle": "Grid Settings",
        "Key": "Key",
        "Settings": "Settings",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
    },
    "integrationSettings": {
        "entityTitle": "Integration Settings",
        "Settings": "Settings",
    },
    "invoiceLines": {
        "entityTitle": "Invoice Lines",
        "LineNo_abbrev": "Line No",
        "LineNo": "Line No",
        "Description": "Description",
        "InvoiceLineID": "Invoice Line ID",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice",
        "UnitPrice": "Unit Price",
        "Qty": "Qty",
        "Amount": "Amount",
        "Tax": "Tax Rate",
        "AmountIncTax": "Amount Inc Tax",
        "ProductName": "Product Name",
        "ProductID": "Product ID",
        "Status": "Status",
        "JobLine": "Job Line",
        "JobLineID": "Job Line",
        "TaxRate": "Tax Rate",
        "TaxRateID": "Tax Rate",
        "Locked": "Locked",
        "ChangeStatus": "Change Status",
        "Notes": "Notes",
    },
    "invoices": {
        "entityTitle": "Invoices",
        "LinkedReference": "Linked Reference",
        "LinkedReferenceID": "Linked Reference ID",
        "InvoiceID": "Invoice ID",
        "InvoiceNo": "Invoice No",
        "InvoiceDate": "Invoice Date",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Company": "Company",
        "CompanyID": "Company",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "Locked": "Locked",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "DateExported": "Date Exported",
        "Status": "Job Custom Status",
        "FinanceArchived": "Finance Archived",
        "Job": "Job",
        "JobID": "Job",
        "DueDate": "Due Date",
        "CloseDate": "Close Date",
        "BillingAddress": "Address",
        "BillingAddressID": "Address",
        "TaxRate": "Tax Rate",
        "TaxRateID": "Tax Rate",
        "FinanceExternalID": "Finance External ID",
        "CreditNote": "Credit Note",
        "CustomStatus": "Job Custom Status",
        "PL_CustomStatusID_abbrev": "Custom Status",
        "PL_CustomStatusID": "Job Custom Status",
        "BusinessUnit": "Business Unit",
        "BusinessUnitID": "Business Unit",
        "ChangeStatus": "Change Status",
        "InvoiceLines": "Invoice Lines",
        "DocumentVersion": "Document Version",
        "DocumentTemplateID": "Document Template ID",
        "ReportSettings": "Report Settings",
    },
    "invoicesAwaitingPayment": {
        "entityTitle": "Invoices Awaiting Payment",
        "ID": "ID",
        "InvoiceDate": "Invoice Date",
        "ProjectCustomerPO_abbrev": "Cust Ref",
        "ProjectCustomerPO": "Project Customer PO",
        "InvoiceNo": "Invoice No",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Amount": "Amount",
        "Tax": "Tax",
        "AmountIncTax": "Amount Inc Tax",
        "Rep": "Rep",
        "Status": "Status",
        "DueDate_abbrev": "Due",
        "DueDate": "Due Date",
    },
    "invoicesForStatus": {
        "entityTitle": "Invoices For Status",
        "ID": "ID",
        "InvoiceDate": "Invoice Date",
        "ProjectCustomerPO_abbrev": "Cust Ref",
        "ProjectCustomerPO": "Project Customer PO",
        "InvoiceNo": "Invoice No",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Amount": "Amount",
        "Tax": "Tax",
        "AmountIncTax": "Amount Inc Tax",
        "Rep": "Rep",
        "Status": "Status",
        "DueDate_abbrev": "Due",
        "DueDate": "Due Date",
    },
    "invoicesOverdue": {
        "entityTitle": "Invoices Overdue",
        "ID": "ID",
        "InvoiceDate": "Invoice Date",
        "ProjectCustomerPO_abbrev": "Cust Ref",
        "ProjectCustomerPO": "Project Customer PO",
        "InvoiceNo": "Invoice No",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Amount": "Amount",
        "Tax": "Tax",
        "AmountIncTax": "Amount Inc Tax",
        "Rep": "Rep",
        "Status": "Status",
        "DueDate_abbrev": "Due",
        "DueDate": "Due Date",
    },
    "job_Activities": {
        "entityTitle": "Job _ Activities",
        "ID": "ID",
        "Subject": "Subject",
        "Start": "Start",
        "AllDay": "All Day",
        "Closed": "Closed",
        "Notes": "Notes",
        "ActivityType_abbrev": "Type",
        "ActivityType": "Activity Type",
        "ActivityCategory_abbrev": "Category",
        "ActivityCategory": "Activity Category",
        "Confirmed": "Confirmed",
        "Representative": "Representative",
        "Priority": "Priority",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity ID",
        "IsInstall": "Is Install",
        "IsPickup": "Is Pickup",
        "IsDelivery": "Is Delivery",
        "IsService": "Is Service",
    },
    "job_Lines": {
        "entityTitle": "Job _ Lines",
        "JobLineNo_abbrev": "Line No",
        "JobLineNo": "Job Line No",
        "OrderDate": "Order Date",
        "ETA": "ETA",
        "Width": "Width",
        "Drop": "Drop",
        "Qty": "Qty",
        "Price": "Price",
        "PriceTax": "Price Tax",
        "PriceIncTax": "Price Inc Tax",
        "SalePrice": "Sale Price",
        "SalePriceTax": "Sale Price Tax",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "BasePrice": "Base Price",
        "BaseCost": "Base Cost",
        "InstallPrice": "Install Price",
        "InstallCost": "Install Cost",
        "OptionsPrice": "Options Price",
        "OptionsCost": "Options Cost",
        "DeliveryPrice": "Delivery Price",
        "DeliveryCost": "Delivery Cost",
        "AdjustmentPrice": "Adjustment Price",
        "AdjustmentCost": "Adjustment Cost",
        "CostPrice": "Cost Price",
        "CostPriceTax": "Cost Price Tax",
        "CostPriceIncTax": "Cost Price Inc Tax",
        "OriginalCostPrice": "Original Cost Price",
        "OriginalCostPriceTax": "Original Cost Price Tax",
        "OriginalCostPriceIncTax": "Original Cost Price Inc Tax",
        "WidthMeasurements": "Width Measurements",
        "DropMeasurements": "Drop Measurements",
        "UndoCancelState": "Undo Cancel State",
        "SupportsOptimisation": "Supports Optimisation",
        "Job": "Job",
        "JobID": "Job",
        "SplitParent": "Job Line",
        "SplitParentID": "Job Line",
        "JobLineService": "Job Line Service",
        "JobLineServiceID": "Job Line Service",
        "RequireCheckMeasure": "Require Check Measure",
        "CM_Approved": "CM _ Approved",
        "Invoiced": "Invoiced",
        "SupplyJobCreated": "Supply Job Created",
        "RequireInstall": "Require Install",
        "RequireDelivery": "Require Delivery",
        "RequirePickup": "Require Pickup",
        "RequireService": "Require Service",
        "Inst_Completed": "Inst _ Completed",
        "EstInstallTime": "Est Install Time",
        "EstCheckMeasureTime": "Est Check Measure Time",
        "IsService": "Is Service",
        "Srvc_Completed": "Srvc _ Completed",
        "QtyReceived": "Qty Received",
        "LocationOther_abbrev": "Location/Desc",
        "LocationOther": "Location Other",
        "ProductName": "Product Name",
        "ProductCode": "Product Code",
        "ProductID": "Product ID",
        "SupplierName": "Supplier Name",
        "ProductVersion": "Product Version",
        "PriceListVersion": "Price List Version",
        "SortIndex": "Sort Index",
        "SupplierID": "Supplier ID",
        "Notes": "Notes",
        "SupplyNotes": "Supply Notes",
        "InstallationNotes": "Installation Notes",
        "SalesTaxRate": "Sales Tax Rate",
        "CostTaxRate": "Cost Tax Rate",
        "PreviousStage": "Previous Stage",
        "DispatchStage": "Dispatch Stage",
        "Status": "Status",
        "Stage": "Stage",
        "LineType": "Line Type",
        "StageDate": "Stage Date",
        "OrderLineOptionsData": "Order Line Options Data",
        "JobLineID": "Job Line ID",
        "ValidationErrors": "Validation Errors",
        "DisplayOption1": "Display Option 1",
        "DisplayOption2": "Display Option 2",
        "DisplayOption3": "Display Option 3",
        "DisplayOption4": "Display Option 4",
        "DisplayOption5": "Display Option 5",
        "DisplayOption6": "Display Option 6",
        "DisplayOption7": "Display Option 7",
        "DisplayOption8": "Display Option 8",
        "DisplayOption9": "Display Option 9",
        "DisplayOption10": "Display Option 10",
        "IsConfirmed": "Is Confirmed",
        "IsDispatched": "Is Dispatched",
        "HasActiveService": "Has Active Service",
        "CommissionDate1": "Commission Date 1",
        "CommissionDate2": "Commission Date 2",
        "CommissionDate3": "Commission Date 3",
        "CommissionDate4": "Commission Date 4",
        "CommissionDate5": "Commission Date 5",
        "GroupKey": "Group Key",
        "PriceModel": "Price Model",
        "RelatedPOLines": "Related PO Lines",
        "LineNo": "Line No",
        "ItemID": "Item ID",
        "LineItemID": "Line Item ID",
    },
    "job_PriceDetails": {
        "entityTitle": "Job _ Price Details",
        "JobLineNo_abbrev": "Line No",
        "JobLineNo": "Job Line No",
        "OrderDate": "Order Date",
        "ETA": "ETA",
        "Width": "Width",
        "Drop": "Drop",
        "Qty": "Qty",
        "Price": "Price",
        "PriceTax": "Price Tax",
        "PriceIncTax": "Price Inc Tax",
        "SalePrice": "Sale Price",
        "SalePriceTax": "Sale Price Tax",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "BasePrice": "Base Price",
        "BaseCost": "Base Cost",
        "InstallPrice": "Install Price",
        "InstallCost": "Install Cost",
        "OptionsPrice": "Options Price",
        "OptionsCost": "Options Cost",
        "DeliveryPrice": "Delivery Price",
        "DeliveryCost": "Delivery Cost",
        "AdjustmentPrice": "Adjustment Price",
        "AdjustmentCost": "Adjustment Cost",
        "CostPrice": "Cost Price",
        "CostPriceTax": "Cost Price Tax",
        "CostPriceIncTax": "Cost Price Inc Tax",
        "OriginalCostPrice": "Original Cost Price",
        "OriginalCostPriceTax": "Original Cost Price Tax",
        "OriginalCostPriceIncTax": "Original Cost Price Inc Tax",
        "WidthMeasurements": "Width Measurements",
        "DropMeasurements": "Drop Measurements",
        "UndoCancelState": "Undo Cancel State",
        "SupportsOptimisation": "Supports Optimisation",
        "Job": "Job",
        "JobID": "Job",
        "SplitParent": "Job Line",
        "SplitParentID": "Job Line",
        "JobLineService": "Job Line Service",
        "JobLineServiceID": "Job Line Service",
        "RequireCheckMeasure": "Require Check Measure",
        "CM_Approved": "CM _ Approved",
        "Invoiced": "Invoiced",
        "SupplyJobCreated": "Supply Job Created",
        "RequireInstall": "Require Install",
        "RequireDelivery": "Require Delivery",
        "RequirePickup": "Require Pickup",
        "RequireService": "Require Service",
        "Inst_Completed": "Inst _ Completed",
        "EstInstallTime": "Est Install Time",
        "EstCheckMeasureTime": "Est Check Measure Time",
        "IsService": "Is Service",
        "Srvc_Completed": "Srvc _ Completed",
        "QtyReceived": "Qty Received",
        "LocationOther_abbrev": "Location/Desc",
        "LocationOther": "Location Other",
        "ProductName": "Product Name",
        "ProductCode": "Product Code",
        "ProductID": "Product ID",
        "SupplierName": "Supplier Name",
        "ProductVersion": "Product Version",
        "PriceListVersion": "Price List Version",
        "SortIndex": "Sort Index",
        "SupplierID": "Supplier ID",
        "Notes": "Notes",
        "SupplyNotes": "Supply Notes",
        "InstallationNotes": "Installation Notes",
        "SalesTaxRate": "Sales Tax Rate",
        "CostTaxRate": "Cost Tax Rate",
        "PreviousStage": "Previous Stage",
        "DispatchStage": "Dispatch Stage",
        "Status": "Status",
        "Stage": "Stage",
        "LineType": "Line Type",
        "StageDate": "Stage Date",
        "OrderLineOptionsData": "Order Line Options Data",
        "JobLineID": "Job Line ID",
        "ValidationErrors": "Validation Errors",
        "DisplayOption1": "Display Option 1",
        "DisplayOption2": "Display Option 2",
        "DisplayOption3": "Display Option 3",
        "DisplayOption4": "Display Option 4",
        "DisplayOption5": "Display Option 5",
        "DisplayOption6": "Display Option 6",
        "DisplayOption7": "Display Option 7",
        "DisplayOption8": "Display Option 8",
        "DisplayOption9": "Display Option 9",
        "DisplayOption10": "Display Option 10",
        "IsConfirmed": "Is Confirmed",
        "IsDispatched": "Is Dispatched",
        "HasActiveService": "Has Active Service",
        "CommissionDate1": "Commission Date 1",
        "CommissionDate2": "Commission Date 2",
        "CommissionDate3": "Commission Date 3",
        "CommissionDate4": "Commission Date 4",
        "CommissionDate5": "Commission Date 5",
        "GroupKey": "Group Key",
        "PriceModel": "Price Model",
        "RelatedPOLines": "Related PO Lines",
        "LineNo": "Line No",
        "ItemID": "Item ID",
        "LineItemID": "Line Item ID",
    },
    "job_ReceiveLines": {
        "entityTitle": "Job _ Receive Lines",
        "JobLineNo_abbrev": "Line No",
        "JobLineNo": "Job Line No",
        "OrderDate": "Order Date",
        "ETA": "ETA",
        "Width": "Width",
        "Drop": "Drop",
        "Qty": "Qty",
        "Price": "Price",
        "PriceTax": "Price Tax",
        "PriceIncTax": "Price Inc Tax",
        "SalePrice": "Sale Price",
        "SalePriceTax": "Sale Price Tax",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "BasePrice": "Base Price",
        "BaseCost": "Base Cost",
        "InstallPrice": "Install Price",
        "InstallCost": "Install Cost",
        "OptionsPrice": "Options Price",
        "OptionsCost": "Options Cost",
        "DeliveryPrice": "Delivery Price",
        "DeliveryCost": "Delivery Cost",
        "AdjustmentPrice": "Adjustment Price",
        "AdjustmentCost": "Adjustment Cost",
        "CostPrice": "Cost Price",
        "CostPriceTax": "Cost Price Tax",
        "CostPriceIncTax": "Cost Price Inc Tax",
        "OriginalCostPrice": "Original Cost Price",
        "OriginalCostPriceTax": "Original Cost Price Tax",
        "OriginalCostPriceIncTax": "Original Cost Price Inc Tax",
        "WidthMeasurements": "Width Measurements",
        "DropMeasurements": "Drop Measurements",
        "UndoCancelState": "Undo Cancel State",
        "SupportsOptimisation": "Supports Optimisation",
        "Job": "Job",
        "JobID": "Job",
        "SplitParent": "Job Line",
        "SplitParentID": "Job Line",
        "JobLineService": "Job Line Service",
        "JobLineServiceID": "Job Line Service",
        "RequireCheckMeasure": "Require Check Measure",
        "CM_Approved": "CM _ Approved",
        "Invoiced": "Invoiced",
        "SupplyJobCreated": "Supply Job Created",
        "RequireInstall": "Require Install",
        "RequireDelivery": "Require Delivery",
        "RequirePickup": "Require Pickup",
        "RequireService": "Require Service",
        "Inst_Completed": "Inst _ Completed",
        "EstInstallTime": "Est Install Time",
        "EstCheckMeasureTime": "Est Check Measure Time",
        "IsService": "Is Service",
        "Srvc_Completed": "Srvc _ Completed",
        "QtyReceived": "Qty Received",
        "LocationOther_abbrev": "Location/Desc",
        "LocationOther": "Location Other",
        "ProductName": "Product Name",
        "ProductCode": "Product Code",
        "ProductID": "Product ID",
        "SupplierName": "Supplier Name",
        "ProductVersion": "Product Version",
        "PriceListVersion": "Price List Version",
        "SortIndex": "Sort Index",
        "SupplierID": "Supplier ID",
        "Notes": "Notes",
        "SupplyNotes": "Supply Notes",
        "InstallationNotes": "Installation Notes",
        "SalesTaxRate": "Sales Tax Rate",
        "CostTaxRate": "Cost Tax Rate",
        "PreviousStage": "Previous Stage",
        "DispatchStage": "Dispatch Stage",
        "Status": "Status",
        "Stage": "Stage",
        "LineType": "Line Type",
        "StageDate": "Stage Date",
        "OrderLineOptionsData": "Order Line Options Data",
        "JobLineID": "Job Line ID",
        "ValidationErrors": "Validation Errors",
        "DisplayOption1": "Display Option 1",
        "DisplayOption2": "Display Option 2",
        "DisplayOption3": "Display Option 3",
        "DisplayOption4": "Display Option 4",
        "DisplayOption5": "Display Option 5",
        "DisplayOption6": "Display Option 6",
        "DisplayOption7": "Display Option 7",
        "DisplayOption8": "Display Option 8",
        "DisplayOption9": "Display Option 9",
        "DisplayOption10": "Display Option 10",
        "IsConfirmed": "Is Confirmed",
        "IsDispatched": "Is Dispatched",
        "HasActiveService": "Has Active Service",
        "CommissionDate1": "Commission Date 1",
        "CommissionDate2": "Commission Date 2",
        "CommissionDate3": "Commission Date 3",
        "CommissionDate4": "Commission Date 4",
        "CommissionDate5": "Commission Date 5",
        "GroupKey": "Group Key",
        "PriceModel": "Price Model",
        "RelatedPOLines": "Related PO Lines",
        "LineNo": "Line No",
        "ItemID": "Item ID",
        "LineItemID": "Line Item ID",
    },
    "jobDetailExport": {
        "entityTitle": "Job Detail Export",
        "JobID": "Job ID",
        "Reference": "Reference",
        "Stage": "Stage",
        "JobType": "Job Type",
        "SalesRep": "Sales Rep",
        "CustomStatus": "Custom Status",
        "CommitReason": "Commit Reason",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "Contact": "Contact",
        "SiteContact": "Site Contact",
        "City": "City",
        "CMBy": "CM By",
        "InstallBy": "Install By",
        "LineNo": "Line No",
        "OrderDate": "Order Date",
        "ETA": "ETA",
        "Qty": "Qty",
        "SalePrice": "Sale Price",
        "SalePriceTax": "Sale Price Tax",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "Product": "Product",
        "Supplier": "Supplier",
        "LineStage": "Line Stage",
        "OrderLineOptionsData": "Order Line Options Data",
        "CMDate": "CM Date",
        "InstallDate": "Install Date",
        "Paid": "Paid",
        "Tags": "Tags",
    },
    "jobDiscountRules": {
        "entityTitle": "Job Discount Rules",
        "Job": "Job",
        "JobID": "Job",
        "TaxIncluded": "Tax Included",
        "IsPercentage": "Is Percentage",
        "Level": "Level",
        "Type": "Type",
        "PriceType": "Price Type",
        "AmountType": "Amount Type",
        "ProductID": "Product ID",
        "JobLineID": "Job Line ID",
        "ProductOptionID": "Product Option ID",
        "ProductOptionValueID": "Product Option Value ID",
        "Value": "Value",
    },
    "restockGridView": {
        "Job": "Job",
        "JobLineNo": "Line",
        "Product": "Product",
        "Width": "Width",
        "Height": "Height",
        "StockLocation": "Stock Location",
        "Stage": "Stage",
        "StageDate": "Stage Date",
        "StageDays": "StageDays",
        "RestockDate": "Restock Date",
        "RestockDays": "Restock Days",
        "CostPrice": "CostPrice",
        "StandardPrice": "Standard Price",
        "DisplayOption1": "Option1",
        "DisplayOption2": "Option2",
        "DisplayOption3": "Option3",
        "DisplayOption4": "Option4",
        "DisplayOption5": "Option5",
        "consume": "Consume Stock",
        "createInvoice": "Create Invoice",
        "unconsume": "Undo Consume Stock",
        "discard": "Discard Stock",
        "undiscard": "Undo Discard Stock",
    },
    "productLinksGrid": {
        "Fabric": "Fabric",
        "Product": "Product",
        "Supplier": "Supplier",
        "Active": "Active"
    },
    "jobGridView": {
        "entityTitle": "Job Grid View",
        "Reference": "Reference",
        "Contact": "Contact",
        "SiteContact": "Site Contact",
        "Company": "Company",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "SalesRep": "Sales Rep",
        "JobDate": "Job Date",
        "Stage": "Stage",
        "Status": "Status",
        "Stages": "Stages",
        "JobType": "Job Type",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "BusinessUnit": "Business Unit",
        "Expiry": "Expiry",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
        "MinOrderDate": "Order Date",
        "MaxOrderDate": "Last Order Date",
        "CustomStatus": "Custom Status",
        "SalesPriceInc_abbrev": "Sales Inc",
        "SalesPriceInc": "Sales Price Inc",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
        "InvoicedAmount": "Invoiced Amount",
        "InvoicedAmountIncTax": "Invoiced Amount Inc Tax",
        "UnInvoicedAmount": "Uninvoiced Amount",
        "UnInvoicedAmountIncTax": "Uninvoiced Amount Inc Tax"
    },
    "jobLineOrderLines": {
        "entityTitle": "Job Line Order Lines",
        "OrderLine": "Order Line",
        "OrderLineID": "Order Line",
        "JobLine": "Job Line",
        "JobLineID": "Job Line",
        "CostRatio": "Cost Ratio",
    },
    "jobLines": {
        "entityTitle": "Job Lines",
        "JobLineNo_abbrev": "Line No",
        "JobLineNo": "Job Line No",
        "OrderDate": "Order Date",
        "ETA": "ETA",
        "Width": "Width",
        "Drop": "Drop",
        "Qty": "Qty",
        "Price": "Price",
        "PriceTax": "Price Tax",
        "PriceIncTax": "Price Inc Tax",
        "SalePrice": "Sale Price",
        "SalePriceTax": "Sale Price Tax",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "BasePrice": "Base Price",
        "BaseCost": "Base Cost",
        "InstallPrice": "Install Price",
        "InstallCost": "Install Cost",
        "OptionsPrice": "Options Price",
        "OptionsCost": "Options Cost",
        "DeliveryPrice": "Delivery Price",
        "DeliveryCost": "Delivery Cost",
        "AdjustmentPrice": "Adjustment Price",
        "AdjustmentCost": "Adjustment Cost",
        "CostPrice": "Cost Price",
        "CostPriceTax": "Cost Price Tax",
        "CostPriceIncTax": "Cost Price Inc Tax",
        "OriginalCostPrice": "Original Cost Price",
        "OriginalCostPriceTax": "Original Cost Price Tax",
        "OriginalCostPriceIncTax": "Original Cost Price Inc Tax",
        "WidthMeasurements": "Width Measurements",
        "DropMeasurements": "Drop Measurements",
        "UndoCancelState": "Undo Cancel State",
        "SupportsOptimisation": "Supports Optimisation",
        "Job": "Job",
        "JobID": "Job",
        "SplitParent": "Job Line",
        "SplitParentID": "Job Line",
        "JobLineService": "Job Line Service",
        "JobLineServiceID": "Job Line Service",
        "RequireCheckMeasure": "Require Check Measure",
        "CM_Approved": "CM _ Approved",
        "Invoiced": "Invoiced",
        "SupplyJobCreated": "Supply Job Created",
        "RequireInstall": "Require Install",
        "RequireDelivery": "Require Delivery",
        "RequirePickup": "Require Pickup",
        "RequireService": "Require Service",
        "Inst_Completed": "Inst _ Completed",
        "EstInstallTime": "Est Install Time",
        "EstCheckMeasureTime": "Est Check Measure Time",
        "IsService": "Is Service",
        "Srvc_Completed": "Srvc _ Completed",
        "QtyReceived": "Qty Received",
        "LocationOther_abbrev": "Location/Desc",
        "LocationOther": "Location Other",
        "ProductName": "Product Name",
        "ProductCode": "Product Code",
        "ProductID": "Product ID",
        "SupplierName": "Supplier Name",
        "ProductVersion": "Product Version",
        "PriceListVersion": "Price List Version",
        "SortIndex": "Sort Index",
        "SupplierID": "Supplier ID",
        "Notes": "Notes",
        "SupplyNotes": "Supply Notes",
        "InstallationNotes": "Installation Notes",
        "SalesTaxRate": "Sales Tax Rate",
        "CostTaxRate": "Cost Tax Rate",
        "PreviousStage": "Previous Stage",
        "DispatchStage": "Dispatch Stage",
        "Status": "Status",
        "Stage": "Stage",
        "LineType": "Line Type",
        "StageDate": "Stage Date",
        "OrderLineOptionsData": "Order Line Options Data",
        "JobLineID": "Job Line ID",
        "ValidationErrors": "Validation Errors",
        "DisplayOption1": "Display Option 1",
        "DisplayOption2": "Display Option 2",
        "DisplayOption3": "Display Option 3",
        "DisplayOption4": "Display Option 4",
        "DisplayOption5": "Display Option 5",
        "DisplayOption6": "Display Option 6",
        "DisplayOption7": "Display Option 7",
        "DisplayOption8": "Display Option 8",
        "DisplayOption9": "Display Option 9",
        "DisplayOption10": "Display Option 10",
        "IsConfirmed": "Is Confirmed",
        "IsDispatched": "Is Dispatched",
        "HasActiveService": "Has Active Service",
        "CommissionDate1": "Commission Date 1",
        "CommissionDate2": "Commission Date 2",
        "CommissionDate3": "Commission Date 3",
        "CommissionDate4": "Commission Date 4",
        "CommissionDate5": "Commission Date 5",
        "GroupKey": "Group Key",
        "PriceModel": "Price Model",
        "RelatedPOLines": "Related PO Lines",
        "LineNo": "Line No",
        "ItemID": "Item ID",
        "LineItemID": "Line Item ID",
    },
    "jobLineServices": {
        "entityTitle": "Job Line Services",
        "Job": "Job",
        "JobID": "Job",
        "JobLine": "Job",
        "JobLineID": "Job",
        "ChargeAmount": "Charge Amount",
        "ReasonNotes": "Reason Notes",
        "UserAtFault": "Representative",
        "UserAtFaultID": "Representative",
        "SupplierAtFault": "Supplier",
        "SupplierAtFaultID": "Supplier",
        "FaultReason": "Fault Reason",
        "PL_FaultReasonID_abbrev": "Fault Reason",
        "PL_FaultReasonID": "Fault Reason",
    },
    "jobLinesForJob": {
        "entityTitle": "Job Lines For Job",
        "JobLineNo_abbrev": "Line No",
        "JobLineNo": "Job Line No",
        "OrderDate": "Order Date",
        "ETA": "ETA",
        "Width": "Width",
        "Drop": "Drop",
        "Qty": "Qty",
        "Price": "Price",
        "PriceTax": "Price Tax",
        "PriceIncTax": "Price Inc Tax",
        "SalePrice": "Sale Price",
        "SalePriceTax": "Sale Price Tax",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "BasePrice": "Base Price",
        "BaseCost": "Base Cost",
        "InstallPrice": "Install Price",
        "InstallCost": "Install Cost",
        "OptionsPrice": "Options Price",
        "OptionsCost": "Options Cost",
        "DeliveryPrice": "Delivery Price",
        "DeliveryCost": "Delivery Cost",
        "AdjustmentPrice": "Adjustment Price",
        "AdjustmentCost": "Adjustment Cost",
        "CostPrice": "Cost Price",
        "CostPriceTax": "Cost Price Tax",
        "CostPriceIncTax": "Cost Price Inc Tax",
        "OriginalCostPrice": "Original Cost Price",
        "OriginalCostPriceTax": "Original Cost Price Tax",
        "OriginalCostPriceIncTax": "Original Cost Price Inc Tax",
        "WidthMeasurements": "Width Measurements",
        "DropMeasurements": "Drop Measurements",
        "UndoCancelState": "Undo Cancel State",
        "SupportsOptimisation": "Supports Optimisation",
        "Job": "Job",
        "JobID": "Job",
        "SplitParent": "Job Line",
        "SplitParentID": "Job Line",
        "JobLineService": "Job Line Service",
        "JobLineServiceID": "Job Line Service",
        "RequireCheckMeasure": "Require Check Measure",
        "CM_Approved": "CM _ Approved",
        "Invoiced": "Invoiced",
        "SupplyJobCreated": "Supply Job Created",
        "RequireInstall": "Require Install",
        "RequireDelivery": "Require Delivery",
        "RequirePickup": "Require Pickup",
        "RequireService": "Require Service",
        "Inst_Completed": "Inst _ Completed",
        "EstInstallTime": "Est Install Time",
        "EstCheckMeasureTime": "Est Check Measure Time",
        "IsService": "Is Service",
        "Srvc_Completed": "Srvc _ Completed",
        "QtyReceived": "Qty Received",
        "LocationOther_abbrev": "Location/Desc",
        "LocationOther": "Location Other",
        "ProductName": "Product Name",
        "ProductCode": "Product Code",
        "ProductID": "Product ID",
        "SupplierName": "Supplier Name",
        "ProductVersion": "Product Version",
        "PriceListVersion": "Price List Version",
        "SortIndex": "Sort Index",
        "SupplierID": "Supplier ID",
        "Notes": "Notes",
        "SupplyNotes": "Supply Notes",
        "InstallationNotes": "Installation Notes",
        "SalesTaxRate": "Sales Tax Rate",
        "CostTaxRate": "Cost Tax Rate",
        "PreviousStage": "Previous Stage",
        "DispatchStage": "Dispatch Stage",
        "Status": "Status",
        "Stage": "Stage",
        "LineType": "Line Type",
        "StageDate": "Stage Date",
        "OrderLineOptionsData": "Order Line Options Data",
        "JobLineID": "Job Line ID",
        "ValidationErrors": "Validation Errors",
        "DisplayOption1": "Display Option 1",
        "DisplayOption2": "Display Option 2",
        "DisplayOption3": "Display Option 3",
        "DisplayOption4": "Display Option 4",
        "DisplayOption5": "Display Option 5",
        "DisplayOption6": "Display Option 6",
        "DisplayOption7": "Display Option 7",
        "DisplayOption8": "Display Option 8",
        "DisplayOption9": "Display Option 9",
        "DisplayOption10": "Display Option 10",
        "IsConfirmed": "Is Confirmed",
        "IsDispatched": "Is Dispatched",
        "HasActiveService": "Has Active Service",
        "CommissionDate1": "Commission Date 1",
        "CommissionDate2": "Commission Date 2",
        "CommissionDate3": "Commission Date 3",
        "CommissionDate4": "Commission Date 4",
        "CommissionDate5": "Commission Date 5",
        "GroupKey": "Group Key",
        "PriceModel": "Price Model",
        "RelatedPOLines": "Related PO Lines",
        "LineNo": "Line No",
        "ItemID": "Item ID",
        "LineItemID": "Line Item ID",
    },
    "jobs": {
        "entityTitle": "Jobs",
        "JobID": "Job ID",
        "QuoteExpiryDate_abbrev": "Expiry Date",
        "QuoteExpiryDate": "Quote Expiry Date",
        "HandoverDate": "Handover Date",
        "QuoteSentDate_abbrev": "Quote Sent",
        "QuoteSentDate": "Quote Sent Date",
        "Forecasted": "Forecasted",
        "IsConfirmed": "Is Confirmed",
        "IsClosed": "Is Closed",
        "IsLost": "Is Lost",
        "IgnoreDepositLimit": "Ignore Deposit Limit",
        "TaxRateOverridden": "Tax Rate Overridden",
        "Status": "Job Custom Status",
        "PaymentTerms": "Payment Terms",
        "DefaultPaymentDue": "Default Payment Due",
        "InvoiceDueDays": "Invoice Due Days",
        "SupplyNotes": "Supply Notes",
        "Reference": "Reference",
        "LinkedReference": "Linked Reference",
        "LinkedReferenceID": "Linked Reference ID",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "DispatchSummary": "Dispatch Summary",
        "ProductSummary": "Product Summary",
        "StageSummary": "Stage Summary",
        "JobDate": "Job Date",
        "CloseDate": "Close Date",
        "ETADate": "ETA Date",
        "EstETADate": "Est ETA Date",
        "OrderDate": "Order Date",
        "Stage": "Stage",
        "JobType": "Job Type",
        "Priority": "Priority",
        "ShowroomQuote": "Showroom Quote",
        "InstallNotes": "Install Notes",
        "InternalNotes": "Internal Notes",
        "CustomerNotes": "Customer Notes",
        "PriceChangedWarning": "Price Changed Warning",
        "ProductOrder": "Product Order",
        "SalesRep": "Representative",
        "SalesRepID": "Representative",
        "MarginApproved": "Representative",
        "MarginApprovedBy": "Representative",
        "MarginApprovedByID": "Representative",
        "MarginApprovalRequired": "Margin Approval Required",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "Address": "Address",
        "AddressID": "Address",
        "DeliveryAddress": "Address",
        "DeliveryAddressID": "Address",
        "Contact": "Contact",
        "ContactID": "Contact",
        "SiteContact": "Contact",
        "SiteContactID": "Contact",
        "Parent": "Job",
        "ParentID": "Job",
        "ParentGroupKey": "Parent Group Key",
        "Company": "Company",
        "CompanyID": "Company",
        "TaxRate": "Tax Rate",
        "TaxRateID": "Tax Rate",
        "Actions": "Advanced Filters . Views . IV _ Job Actions",
        "ActionsID": "Advanced Filters . Views . IV _ Job Actions",
        "JobLines": "Job Lines",
        "DiscountRules": "Discount Rules",
        "CustomStatus": "Job Custom Status",
        "PL_CustomStatusID_abbrev": "Custom Status",
        "PL_CustomStatusID": "Job Custom Status",
        "CommitmentReason": "Commitment Reason",
        "InstallationRule": "Installation Rule",
        "PL_CommitmentReasonID_abbrev": "Commit Reason",
        "PL_CommitmentReasonID": "Commitment Reason",
        "BusinessUnit": "Business Unit",
        "BusinessUnitID": "Business Unit",
        "NoSalesCommission": "No Sales Commission",
        "FileNotes": "File Notes",
        "Documents": "Documents",
        "Tags": "Tags",
        "ReportSettings": "Report Settings",
        "Tracking": "Tracking",
        "TrackingID": "Tracking",
        "ReceiveAutomatedEmail": "Receive Operational Email",
        "ReceiveAutomatedSMS": "Receive Operational SMS",
        "ItemID": "Item ID",
        "PriceListID": "Price List ID",
        "CompanyPriceMappings": "Company Price Mappings",
    },
    "jobs_For_Rep_Month": {
        "entityTitle": "Jobs _ For _ Rep _ Month",
        "Reference": "Reference",
        "Contact": "Contact",
        "SiteContact": "Site Contact",
        "Company": "Company",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "SalesRep": "Sales Rep",
        "JobDate": "Job Date",
        "Stage": "Stage",
        "Stages": "Stages",
        "JobType": "Job Type",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "BusinessUnit": "Business Unit",
        "Expiry": "Expiry",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
        "MinOrderDate": "Order Date",
        "MaxOrderDate": "Last Order Date",
        "CustomStatus": "Custom Status",
        "SalesPriceInc_abbrev": "Sales Inc",
        "SalesPriceInc": "Sales Price Inc",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
    },
    "jobsForCompany": {
        "entityTitle": "Jobs For Company",
        "Reference": "Reference",
        "Contact": "Contact",
        "SiteContact": "Site Contact",
        "Company": "Company",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "SalesRep": "Sales Rep",
        "JobDate": "Job Date",
        "Stage": "Stage",
        "Stages": "Stages",
        "JobType": "Job Type",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "BusinessUnit": "Business Unit",
        "Expiry": "Expiry",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
        "MinOrderDate": "Order Date",
        "MaxOrderDate": "Last Order Date",
        "CustomStatus": "Custom Status",
        "SalesPriceInc_abbrev": "Sales Inc",
        "SalesPriceInc": "Sales Price Inc",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
    },
    "jobsForContact": {
        "entityTitle": "Jobs For Contact",
        "Reference": "Reference",
        "Contact": "Contact",
        "SiteContact": "Site Contact",
        "Company": "Company",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "SalesRep": "Sales Rep",
        "JobDate": "Job Date",
        "Stage": "Stage",
        "Stages": "Stages",
        "JobType": "Job Type",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "BusinessUnit": "Business Unit",
        "Expiry": "Expiry",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
        "MinOrderDate": "Order Date",
        "MaxOrderDate": "Last Order Date",
        "CustomStatus": "Custom Status",
        "SalesPriceInc_abbrev": "Sales Inc",
        "SalesPriceInc": "Sales Price Inc",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
    },
    "jobsForOpportunity": {
        "entityTitle": "Jobs For Opportunity",
        "Reference": "Reference",
        "Contact": "Contact",
        "SiteContact": "Site Contact",
        "Company": "Company",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "SalesRep": "Sales Rep",
        "JobDate": "Job Date",
        "Stage": "Stage",
        "Stages": "Stages",
        "JobType": "Job Type",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "BusinessUnit": "Business Unit",
        "Expiry": "Expiry",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
        "MinOrderDate": "Order Date",
        "MaxOrderDate": "Last Order Date",
        "CustomStatus": "Custom Status",
        "SalesPriceInc_abbrev": "Sales Inc",
        "SalesPriceInc": "Sales Price Inc",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
    },
    "journalEntries": {
        "entityTitle": "Journal Entries",
        "EntryDate": "Entry Date",
        "TransferDate": "Transfer Date",
        "Amount": "Amount",
        "Tax": "Tax Rate",
        "Type": "Type",
        "Notes": "Notes",
        "JournalEntryID": "Journal Entry ID",
        "GroupID": "Group ID",
        "TaxRate": "Tax Rate",
        "TaxRateID": "Tax Rate",
    },
    "leadIntegrationSettingsRecord": {
        "entityTitle": "Lead Integration Settings Record",
        "Settings": "Settings",
    },
    "leads_Search": {
        "entityTitle": "Leads _ Search",
        "ID": "ID",
        "LastName": "Last Name",
        "FirstName": "First Name",
        "Email": "Email",
        "WorkPhone": "Work Phone",
        "HomePhone": "Home Phone",
        "Mobile": "Mobile",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "JobCategory": "Job Category",
        "JobTitle": "Job Title",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "CustomerName": "Customer Name",
        "CompanyName": "Company Name",
        "BillingContactName": "Billing Contact Name",
    },
    "localeCountry_SelectList": {
        "entityTitle": "Locale Country _ Select List",
        "ID": "ID",
        "Description": "Description",
    },
    "lookupTableItems": {
        "entityTitle": "Lookup Table Items",
        "LookupTable": "Lookup Table",
        "LookupTableID": "Lookup Table",
        "Notes": "Notes",
        "From": "From",
        "To": "To",
        "Text": "Text",
        "ProductID": "Product ID",
        "RepresentativeID": "Representative ID",
        "Value": "Value",
    },
    "lookupTables": {
        "entityTitle": "Lookup Tables",
        "Name": "Name",
    },
    "mFSchedulingTrackingViews": {
        "entityTitle": "MF Scheduling Tracking Views",
        "PurchaseOrderID": "Purchase Order ID",
        "OrderNumber": "Order Number",
        "JobID": "Job ID",
        "Job": "Job",
        "CustomerReference": "Customer Reference",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Supplier": "Supplier",
        "CommitReason": "Commit Reason",
        "BusinessUnit": "Business Unit",
        "Product": "Product",
        "Department": "Department",
        "DispatchDate": "Dispatch Date",
        "ETADate": "ETA Date",
        "Status": "Status",
        "MFDate": "MF Date",
        "OrderDate": "Order Date",
        "Internal": "Internal",
        "Qty": "Qty",
        "JobQty": "Job Qty",
        "DispatchDays": "Dispatch Days",
        "Age": "Age",
        "IDs": "I Ds",
        "SupplyNotes": "Supply Notes",
    },
    "notifications": {
        "entityTitle": "Notifications",
        "Subject": "Subject",
        "Message": "Message",
        "Expiry": "Expiry",
        "StartDate": "Start Date",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "NotificationID": "Notification ID",
    },
    "opportunities": {
        "entityTitle": "Opportunities",
        "Code": "Code",
        "Description_abbrev": "Desc",
        "Description": "Description",
        "Status": "Status",
        "PipelineStage_abbrev": "Stage",
        "PipelineStage": "Pipeline Stage",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Company": "Company",
        "CompanyID": "Company",
        "SiteContact": "Contact",
        "SiteContactID": "Contact",
        "ExpectedRevenue_abbrev": "Exp Rev",
        "ExpectedRevenue": "Expected Revenue",
        "Representative_abbrev": "Rep",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "LeadGenerator_abbrev": "Generator",
        "LeadGenerator": "Representative",
        "LeadGeneratorID": "Representative",
        "ReferedBy_abbrev": "Ref By",
        "ReferedBy": "Contact",
        "ReferedByID": "Contact",
        "LeadDate": "Lead Date",
        "EstQuoteDate": "Est Quote Date",
        "ExpectedCloseDate": "Expected Close Date",
        "CloseDate": "Close Date",
        "AssignedDate": "Assigned Date",
        "Forecast": "Forecast",
        "VisitedShowroom": "Visited Showroom",
        "Address": "Address",
        "AddressID": "Address",
        "ProductsOfInterest": "Products Of Interest",
        "LeadSource": "Lead Source",
        "PL_LeadSourceID_abbrev": "Lead Source",
        "PL_LeadSourceID": "Lead Source",
        "ConfidenceLevel": "Opp Confidence Level",
        "PL_OppConfidenceLevelID_abbrev": "Confidence Level",
        "PL_OppConfidenceLevelID": "Opp Confidence Level",
        "QuoteOutcomeReason": "Outcome Reason",
        "PL_QuoteOutcomeReasonID": "Outcome Reason",
        "QuoteOutcomeNotes": "Outcome Notes",
        "ExternalLead": "External Lead",
        "ExternalLeadID": "External Lead",
        "BusinessUnit": "Business Unit",
        "BusinessUnitID": "Business Unit",
        "Notes": "Notes",
        "FileNotes": "File Notes",
        "Jobs": "Jobs",
        "Tags": "Tags",
    },
    "opportunities_ForCompany": {
        "entityTitle": "Opportunities _ For Company",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "QuoteOutcomeReason": "Outcome Reason",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "opportunities_ForContact": {
        "entityTitle": "Opportunities _ For Contact",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "opportunitiesForContact": {
        "entityTitle": "Opportunities For Contact",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "opportunityTrackingViews": {
        "entityTitle": "Opportunity Tracking Views",
        "ID": "ID",
        "Description": "Description",
        "LeadDate": "Lead Date",
        "Forecast": "Forecast",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "LeadSource": "Lead Source",
        "PipelineStage_abbrev": "Stage",
        "PipelineStage": "Pipeline Stage",
        "Status": "Status",
        "ConfidenceLevel": "Confidence Level",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Representative": "Representative",
        "RepresentativeID": "Representative ID",
        "BusinessUnit": "Business Unit",
        "Tags": "Tags",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "ExpectedRevenue_abbrev": "Forcast {{accentCurrencySymbol}}",
        "ExpectedRevenue": "Expected Revenue",
        "ActivityID": "Activity ID",
        "ActivityContactID": "Activity Contact ID",
        "ActivityType": "Activity Type",
        "ActivityClosed": "Activity Closed",
        "ActivityConfirmed": "Activity Confirmed",
        "ActivityPriority": "Activity Priority",
        "ActivityStart": "Activity Start",
        "ActivitySubject": "Activity Subject",
        "Notes": "Notes",
    },
    "orderLines": {
        "entityTitle": "Order Lines",
        "OrderLineNo_abbrev": "Line No",
        "OrderLineNo": "Order Line No",
        "Width": "Width",
        "Drop": "Drop",
        "Qty": "Qty",
        "CostPrice": "Cost Price",
        "CostPriceTax": "Cost Price Tax",
        "CostPriceIncTax": "Cost Price Inc Tax",
        "BaseCost": "Base Cost",
        "InstallCost": "Install Cost",
        "OptionsCost": "Options Cost",
        "DeliveryCost": "Delivery Cost",
        "AdjustmentCost": "Adjustment Cost",
        "WidthMeasurements": "Width Measurements",
        "DropMeasurements": "Drop Measurements",
        "UndoCancelState": "Undo Cancel State",
        "SupportsOptimisation": "Supports Optimisation",
        "Order": "Purchase Order",
        "OrderID": "Purchase Order",
        "LocationOther_abbrev": "Location/Desc",
        "LocationOther": "Location Other",
        "ProductName": "Product Name",
        "ProductCode": "Product Code",
        "ProductID": "Product ID",
        "SupplierName": "Supplier Name",
        "SupplierID": "Supplier ID",
        "Notes": "Notes",
        "SupplyNotes": "Supply Notes",
        "Status": "Status",
        "OrderLineOptionsData": "Order Line Options Data",
        "ConsolidationData": "Consolidation Data",
        "PriceModel": "Price Model",
        "RelatedJobLines": "Related Job Lines",
        "MFDate": "MF Date",
        "Department": "MF Department",
        "PL_MFDepartmentID_abbrev": "Department",
        "PL_MFDepartmentID": "MF Department",
        "OrderLineID": "Order Line ID",
        "DisplayOption1": "Display Option 1",
        "DisplayOption2": "Display Option 2",
        "DisplayOption3": "Display Option 3",
        "DisplayOption4": "Display Option 4",
        "DisplayOption5": "Display Option 5",
        "DisplayOption6": "Display Option 6",
        "DisplayOption7": "Display Option 7",
        "DisplayOption8": "Display Option 8",
        "DisplayOption9": "Display Option 9",
        "DisplayOption10": "Display Option 10",
        "LineNo": "Line No",
        "ItemID": "Item ID",
        "LineItemID": "Line Item ID",
        "InstallationNotes": "Installation Notes",
        "Price": "Price",
        "PriceTax": "Price Tax",
        "SalePrice": "Sale Price",
        "SalePriceTax": "Sale Price Tax",
        "PriceIncTax": "Price Inc Tax",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "OriginalCostPrice": "Original Cost Price",
        "OriginalCostPriceTax": "Original Cost Price Tax",
        "OriginalCostPriceIncTax": "Original Cost Price Inc Tax",
        "BasePrice": "Base Price",
        "InstallPrice": "Install Price",
        "OptionsPrice": "Options Price",
        "DeliveryPrice": "Delivery Price",
        "AdjustmentPrice": "Adjustment Price",
        "SalesTaxRate": "Sales Tax Rate",
        "CostTaxRate": "Cost Tax Rate",
        "ValidationErrors": "Validation Errors",
        "PriceListVersion": "Price List Version",
    },
    "orderLinesForPurchaseOrder": {
        "entityTitle": "Order Lines For Purchase Order",
        "ID": "ID",
        "ProductName": "Product Name",
        "OrderLineNo": "Order Line No",
        "Width": "Width",
        "Drop": "Drop",
        "Qty": "Qty",
        "LocationOther": "Location Other",
        "CostPrice": "Cost Price",
        "Status": "Status",
        "ValidationErrors": "Validation Errors",
    },
    "paymentAllocations": {
        "entityTitle": "Payment Allocations",
        "Payment": "Payment",
        "PaymentID": "Payment",
        "Amount": "Amount",
        "Job": "Job",
        "JobID": "Job",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice",
        "PaymentAllocationID": "Payment Allocation ID",
        "HasRefund": "Has Refund",
    },
    "payments": {
        "entityTitle": "Payments",
        "ReceiptNo": "Receipt No",
        "Date": "Date",
        "Method": "Payment Method",
        "PL_PaymentMethodID_abbrev": "Method",
        "PL_PaymentMethodID": "Payment Method",
        "CreditCard": "Credit Card",
        "PL_CreditCardID": "Credit Card",
        "Fee": "Fee",
        "Amount": "Amount",
        "Type": "Type",
        "Status": "Status",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Notes": "Notes",
        "CreditNote": "Invoice",
        "CreditNoteID": "Invoice",
        "FinanceArchived": "Finance Archived",
        "IsDeposit": "Is Deposit",
        "PaymentAllocations": "Payment Allocations",
    },
    "paymentsForContact": {
        "entityTitle": "Payments For Contact",
        "ID": "ID",
        "ReceiptNo": "Receipt No",
        "Date": "Date",
        "Amount": "Amount",
        "Method": "Method",
        "Status": "Status",
        "UnAllocated": "Un Allocated",
    },
    "paymentsForJob": {
        "entityTitle": "Payments For Job",
        "ID": "ID",
        "ReceiptNo": "Receipt No",
        "Date": "Date",
        "Amount": "Amount",
        "Method": "Method",
        "Status": "Status",
        "UnAllocated": "Un Allocated",
    },
    "PL_ActivityCancelReason": {
        "ActivityTypes": "Activity Types",
    },
    "pL_ActivityCategories": {
        "entityTitle": "PL _ Activity Categories",
        "PL_ActivityCategoryID": "PL _ Activity Category ID",
    },
    "pL_CommissionAmendmentCategories": {
        "entityTitle": "PL _ Commission Amendment Categories",
        "PL_CommissionAmendmentCategoryID": "PL _ Commission Amendment Category ID",
    },
    "pL_CommitmentReasons": {
        "entityTitle": "PL _ Commitment Reasons",
        "PL_CommitmentReasonID": "PL _ Commitment Reason ID",
    },
    "pL_ContactJobCategories": {
        "entityTitle": "PL _ Contact Job Categories",
        "PL_ContactJobCategoryID": "PL _ Contact Job Category ID",
    },
    "pL_FaultReasons": {
        "entityTitle": "PL _ Fault Reasons",
        "PL_FaultReasonID": "PL _ Fault Reason ID",
    },
    "pL_JobCustomStatuses": {
        "entityTitle": "PL _ Job Custom Statuses",
        "PL_JobCustomStatusID": "PL _ Job Custom Status ID",
    },
    "pL_LeadDiscardReasons": {
        "entityTitle": "PL _ Lead Discard Reasons",
        "PL_LeadDiscardReasonID": "PL _ Lead Discard Reason ID",
    },
    "pL_LeadSources": {
        "entityTitle": "PL _ Lead Sources",
        "PL_LeadSourceID": "PL _ Lead Source ID",
    },
    "pL_MFDepartments": {
        "entityTitle": "PL _ MF Departments",
        "PL_MFDepartmentID": "PL _ MF Department ID",
    },
    "pL_OppConfidenceLevels": {
        "entityTitle": "PL _ Opp Confidence Levels",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
    },
    "pL_OrderLineLocations": {
        "entityTitle": "PL _ Order Line Locations",
        "PL_OrderLineLocationID": "PL _ Order Line Location ID",
    },
    "pL_OrganisationTypes": {
        "entityTitle": "PL _ Organisation Types",
        "PL_OrganisationTypeID": "PL _ Organisation Type ID",
    },
    "pL_PaymentMethods": {
        "entityTitle": "PL _ Payment Methods",
        "PL_PaymentMethodID": "PL _ Payment Method ID",
    },
    "pL_QuoteOutcomeReasons": {
        "entityTitle": "PL _ Outcome Reasons",
        "PL_QuoteOutcomeReasonID": "PL _ Outcome Reason ID",
    },
    "pL_Tags": {
        "entityTitle": "PL _ Tags",
        "PL_TagID": "PL _ Tag ID",
    },
    "printSettings": {
        "entityTitle": "Print Settings",
        "Name": "Name",
        "ProductPrintSettings": "Product Print Settings",
    },
    "product_Grid": {
        "entityTitle": "Product _ Grid",
        "ID": "ID",
        "Product": "Product",
        "Supplier": "Supplier",
        "ActiveVersionNumber": "Version",
        "ProductTaxCode": "TaxCode",
        "ProductCategory": "Product Category",
        "AlterProductID": "Alter Product",
        "Active": "Active",
        "CanSell": "Can Sell",
        "ServiceProduct": "Service Product",
        "SupplementaryCharge": "Supplementary Charge",
    },
    "products": {
        "entityTitle": "Products",
        "ProductName": "Product Name",
        "Active": "Active",
        "CanSell": "Can Sell",
        "ServiceProduct": "Service Product",
        "SupplementaryCharge": "Supplementary Charge",
        "NotesTemplate": "Notes Template",
        "ProductID": "Product ID",
        "Supplier": "Supplier",
        "SupplierID": "Supplier",
        "BlobUrl": "Blob Url",
        "CutSheetTemplate": "Binary Data Field",
        "CutSheetTemplateID": "Binary Data Field",
        "CutSheetPrintType_abbrev": "Attach As",
        "CutSheetPrintType": "Cut Sheet Print Type",
    },
    "productShared": {
        "entityTitle": "Product Shared",
        "ProductID": "Product ID",
        "AlterProductID": "Alter Product ID",
    },
    "productShared_ForProduct": {
        "entityTitle": "Product Shared _ For Product",
        "ProductID": "Product ID",
        "AlterProductID": "Alter Product ID",
    },
    "productsOfInterest": {
        "entityTitle": "Products Of Interest",
        "Qty": "Qty",
        "Full": "Full",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "ProductOfInterestID": "Product Of Interest",
        "Product": "Product Of Interest",
        "PL_ProductOfInterestID": "Product Of Interest",
    },
    "productsOfInterestForOpportunity": {
        "entityTitle": "Products Of Interest For Opportunity",
        "Qty": "Qty",
        "Full": "Full",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "ProductOfInterestID": "Product Of Interest",
        "Product": "Product Of Interest",
        "PL_ProductOfInterestID": "Product Of Interest",
    },
    "projectStages": {
        "entityTitle": "Project Stages",
        "Description": "Description",
        "ActivityType": "Activity Type",
        "SortOrder": "Sort Order",
        "ActivityCategory": "Activity Category",
        "PL_ActivityCategoryID": "Activity Category",
        "ProjectTemplate": "Project Template",
        "ProjectTemplateID": "Project Template",
        "ProjectStageID": "Project Stage ID",
    },
    "projectStageViews": {
        "entityTitle": "Project Stage Views",
        "ProjectTemplateID": "Project Template ID",
        "JobLineID": "Job Line ID",
        "JobID": "Job ID",
        "Stage_0": "Stage _0",
        "Stage_1": "Stage _1",
        "Stage_2": "Stage _2",
        "Stage_3": "Stage _3",
        "Stage_4": "Stage _4",
        "Stage_5": "Stage _5",
        "Stage_6": "Stage _6",
        "Stage_7": "Stage _7",
        "Stage_8": "Stage _8",
        "Stage_9": "Stage _9",
        "Stage_10": "Stage _10",
        "Stage_11": "Stage _11",
        "Stage_12": "Stage _12",
        "Stage_13": "Stage _13",
        "Stage_14": "Stage _14",
        "Stage_15": "Stage _15",
        "Stage_16": "Stage _16",
        "Stage_17": "Stage _17",
        "Stage_18": "Stage _18",
        "Stage_19": "Stage _19",
        "Stage_20": "Stage _20",
        "Stage_21": "Stage _21",
        "Stage_22": "Stage _22",
        "Stage_23": "Stage _23",
        "Stage_24": "Stage _24",
        "Stage_25": "Stage _25",
        "Stage_26": "Stage _26",
        "Stage_27": "Stage _27",
        "Stage_28": "Stage _28",
        "Stage_29": "Stage _29",
        "Stage_30": "Stage _30",
        "Stage_0_ID": "Stage _0_ ID",
        "Stage_1_ID": "Stage _1_ ID",
        "Stage_2_ID": "Stage _2_ ID",
        "Stage_3_ID": "Stage _3_ ID",
        "Stage_4_ID": "Stage _4_ ID",
        "Stage_5_ID": "Stage _5_ ID",
        "Stage_6_ID": "Stage _6_ ID",
        "Stage_7_ID": "Stage _7_ ID",
        "Stage_8_ID": "Stage _8_ ID",
        "Stage_9_ID": "Stage _9_ ID",
        "Stage_10_ID": "Stage _10_ ID",
        "Stage_11_ID": "Stage _11_ ID",
        "Stage_12_ID": "Stage _12_ ID",
        "Stage_13_ID": "Stage _13_ ID",
        "Stage_14_ID": "Stage _14_ ID",
        "Stage_15_ID": "Stage _15_ ID",
        "Stage_16_ID": "Stage _16_ ID",
        "Stage_17_ID": "Stage _17_ ID",
        "Stage_18_ID": "Stage _18_ ID",
        "Stage_19_ID": "Stage _19_ ID",
        "Stage_20_ID": "Stage _20_ ID",
        "Stage_21_ID": "Stage _21_ ID",
        "Stage_22_ID": "Stage _22_ ID",
        "Stage_23_ID": "Stage _23_ ID",
        "Stage_24_ID": "Stage _24_ ID",
        "Stage_25_ID": "Stage _25_ ID",
        "Stage_26_ID": "Stage _26_ ID",
        "Stage_27_ID": "Stage _27_ ID",
        "Stage_28_ID": "Stage _28_ ID",
        "Stage_29_ID": "Stage _29_ ID",
        "Stage_30_ID": "Stage _30_ ID",
        "Stage_0_Closed": "Stage _0_ Closed",
        "Stage_1_Closed": "Stage _1_ Closed",
        "Stage_2_Closed": "Stage _2_ Closed",
        "Stage_3_Closed": "Stage _3_ Closed",
        "Stage_4_Closed": "Stage _4_ Closed",
        "Stage_5_Closed": "Stage _5_ Closed",
        "Stage_6_Closed": "Stage _6_ Closed",
        "Stage_7_Closed": "Stage _7_ Closed",
        "Stage_8_Closed": "Stage _8_ Closed",
        "Stage_9_Closed": "Stage _9_ Closed",
        "Stage_10_Closed": "Stage _10_ Closed",
        "Stage_11_Closed": "Stage _11_ Closed",
        "Stage_12_Closed": "Stage _12_ Closed",
        "Stage_13_Closed": "Stage _13_ Closed",
        "Stage_14_Closed": "Stage _14_ Closed",
        "Stage_15_Closed": "Stage _15_ Closed",
        "Stage_16_Closed": "Stage _16_ Closed",
        "Stage_17_Closed": "Stage _17_ Closed",
        "Stage_18_Closed": "Stage _18_ Closed",
        "Stage_19_Closed": "Stage _19_ Closed",
        "Stage_20_Closed": "Stage _20_ Closed",
        "Stage_21_Closed": "Stage _21_ Closed",
        "Stage_22_Closed": "Stage _22_ Closed",
        "Stage_23_Closed": "Stage _23_ Closed",
        "Stage_24_Closed": "Stage _24_ Closed",
        "Stage_25_Closed": "Stage _25_ Closed",
        "Stage_26_Closed": "Stage _26_ Closed",
        "Stage_27_Closed": "Stage _27_ Closed",
        "Stage_28_Closed": "Stage _28_ Closed",
        "Stage_29_Closed": "Stage _29_ Closed",
        "Stage_30_Closed": "Stage _30_ Closed",
    },
    "projectTemplates": {
        "entityTitle": "Project Templates",
        "Description": "Description",
        "ProjectTemplateID": "Project Template ID",
        "Stages": "Stages",
    },
    "projectTrackingViews": {
        "entityTitle": "Project Tracking Views",
        "JobID": "Job ID",
        "ProductID": "Product ID",
        "ProductName": "Product Name",
        "Stage": "Stage",
        "Reference": "Reference",
        "Company": "Company",
        "SiteContact": "Site Contact",
        "ContactEmail": "Contact Email",
        "CustomStatus": "Custom Status",
        "ProjectCustomerPO": "Project Customer PO",
        "SiteAddress": "Site Address",
        "SalesRep": "Sales Rep",
        "SalesRepID": "Sales Rep ID",
        "Tags": "Tags",
        "HandoverDate": "Handover Date",
        "ProjectTemplateID": "Project Template ID",
        "CompanyID": "Company ID",
        "SiteContactID": "Site Contact ID",
        "OpportunityID": "Opportunity ID",
        "SiteAddressID": "Site Address ID",
        "Action_CanMoveToSupply": "Action _ Can Move To Supply",
        "Action_CanResendToSupply": "Action _ Can Resend To Supply",
        "Action_CanUpdateETA": "Action _ Can Update ETA",
        "Action_CanReceiptGoods": "Action _ Can Receipt Goods",
        "Action_CanInvoice": "Action _ Can Invoice",
        "ETA": "ETA",
        "Qty": "Qty",
        "SalePrice": "Sale Price",
        "StageID_0": "Stage ID _0",
        "StageID_1": "Stage ID _1",
        "StageID_2": "Stage ID _2",
        "StageID_3": "Stage ID _3",
        "StageID_4": "Stage ID _4",
        "StageID_5": "Stage ID _5",
        "StageID_6": "Stage ID _6",
        "StageID_7": "Stage ID _7",
        "StageID_8": "Stage ID _8",
        "StageID_9": "Stage ID _9",
        "StageDate_0": "Stage Date _0",
        "StageDate_1": "Stage Date _1",
        "StageDate_2": "Stage Date _2",
        "StageDate_3": "Stage Date _3",
        "StageDate_4": "Stage Date _4",
        "StageDate_5": "Stage Date _5",
        "StageDate_6": "Stage Date _6",
        "StageDate_7": "Stage Date _7",
        "StageDate_8": "Stage Date _8",
        "StageDate_9": "Stage Date _9",
        "Adv_Q_P_0": "Adv _ Q _ P _0",
    },
    "purchaseOrders": {
        "entityTitle": "Purchase Orders",
        "OrderNumber": "Order Number",
        "LinkedReference": "Linked Reference",
        "LinkedReferenceID": "Linked Reference ID",
        "CustomerReference_abbrev": "Cust. Ref",
        "CustomerReference": "Customer Reference",
        "ProductSummary": "Product Summary",
        "OrderDate": "Order Date",
        "CloseDate": "Close Date",
        "ETADate": "ETA Date",
        "DateReceived": "Date Received",
        "DateSent": "Date Sent",
        "UndoCancelState": "Undo Cancel State",
        "Status": "Status",
        "StatusDate": "Status Date",
        "InternalNotes": "Internal Notes",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Job": "Job",
        "JobID": "Job",
        "DeliveryAddress": "Address",
        "DeliveryAddressID": "Address",
        "BillingAddress": "Address",
        "BillingAddressID": "Address",
        "OrderLines": "Order Lines",
        "SupplyNotes": "Supply Notes",
        "SupplierName": "Supplier Name",
        "SupplierID": "Supplier ID",
        "PurchaseOrderID": "Purchase Order ID",
        "JobType": "Job Type",
        "ItemID": "Item ID",
        "PriceListID": "Price List ID",
        "CompanyPriceMappings": "Company Price Mappings",
        "CompanyID": "Company ID",
        "ProjectCustomerPO": "Project Customer PO",
    },
    "purchaseOrdersByETA": {
        "entityTitle": "Purchase Orders By ETA",
        "ID": "ID",
        "OrderDate": "Order Date",
        "CustomerReference_abbrev": "Cust Ref",
        "CustomerReference": "Customer Reference",
        "OrderNumber": "Order Number",
        "CostPrice": "Cost Price",
        "Rep": "Rep",
        "Status": "Status",
        "Supplier": "Supplier",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
    },
    "purchaseOrdersForStatus": {
        "entityTitle": "Purchase Orders For Status",
        "ID": "ID",
        "OrderDate": "Order Date",
        "CustomerReference_abbrev": "Cust Ref",
        "CustomerReference": "Customer Reference",
        "OrderNumber": "Order Number",
        "CostPrice": "Cost Price",
        "Rep": "Rep",
        "Status": "Status",
        "Supplier": "Supplier",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
    },
    "quotesBySalePriceDesc": {
        "entityTitle": "Quotes By Sale Price Desc",
        "ID": "ID",
        "Reference": "Reference",
        "Contact": "Contact",
        "ExpiryDate": "Expiry Date",
        "SalesPriceInc": "Sales Price Inc",
        "ContactID": "Contact ID",
    },
    "reminders": {
        "entityTitle": "Reminders",
        "Message": "Message",
        "StartDate": "Start Date",
        "Job": "Job",
        "JobID": "Job",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "ReminderID": "Reminder ID",
    },
    "reportAccess": {
        "entityTitle": "Report Access",
        "AccessControl": "Access Control",
        "QuoteStyles": "Quote Styles",
        "QuoteTermsAndConditions": "Quote Terms And Conditions",
        "QuotePaymentDetails": "Quote Payment Details",
        "ProductPrintSettings": "Product Print Settings",
        "ReportSettingsID": "Report Settings ID",
    },
    "reportSettings": {
        "entityTitle": "Report Settings",
        "AccessControl": "Access Control",
        "QuoteStyles": "Quote Styles",
        "QuoteTermsAndConditions": "Quote Terms And Conditions",
        "QuotePaymentDetails": "Quote Payment Details",
        "ProductPrintSettings": "Product Print Settings",
        "ReportSettingsID": "Report Settings ID",
    },
    "reportSettingsRecord": {
        "entityTitle": "Report Settings Record",
        "AccessControl": "Access Control",
        "QuoteStyles": "Quote Styles",
        "QuoteTermsAndConditions": "Quote Terms And Conditions",
        "QuotePaymentDetails": "Quote Payment Details",
        "ProductPrintSettings": "Product Print Settings",
        "ReportSettingsID": "Report Settings ID",
    },
    "representative_Grid": {
        "entityTitle": "Representative _ Grid",
        "ID": "ID",
        "FullName": "Full Name",
        "Active": "Active",
        "DefaultTeam": "Default Team",
        "DefaultBusinessUnit": "Default Business Unit",
        "Email": "Email",
    },
    "representative_SelectList": {
        "entityTitle": "Representative _ Select List",
        "ID": "ID",
        "FullName": "Full Name",
    },
    "representatives": {
        "entityTitle": "Representatives",
        "FirstName": "First Name",
        "LastName": "Last Name",
        "FullName": "Full Name",
        "Email": "Email",
        "RepresentativeID": "Representative ID",
        "UserID": "User ID",
        "FeatureAllowSetup": "Feature Allow Setup",
        "FeatureAllowManagement": "Feature Allow Management",
        "FeatureCanManageWorkflows": "Feature Can Manage Workflows",
        "FeatureCanManageCustomizations": "Feature Can Manage Customizations",
        "FeatureAllowProductExplainer": "Feature Allow AI Product Explainer",
        "FeatureAllowSendOrder": "Feature Allow Send Order",
        "FeatureAllowPlaceAccountOnHold": "Feature Allow Place Account On Hold",
        "FeatureAllowReleaseAccountFromOnHold": "Feature Allow Release Account From On Hold",
        "FeatureAllowConfirmJobForOnHoldAccounts": "Feature Allow Confirm Job For On Hold Accounts",
        "FeatureAllowViewCostPrice": "Feature Allow View Cost Price",
        "FeatureCanViewSalesData": "Feature Can View Sales Data",
        "FeatureCanViewCalendars": "Feature Can View Calendars",
        "FeatureAllowQuoting": "Feature Allow Quoting",
        "FeatureShowInCalendar": "Feature Show In Calendar",
        "FeatureSyncCalendar": "Feature Sync Calendar",
        "FeatureCanViewFinance": "Feature Can View Finance",
        "FeatureCanViewProjects": "Feature Can View Projects",
        "FeatureCanViewCustomerChat": "Feature Can View Customer Chat",
        "FeatureCanViewCustomerChatData": "Feature Can View Customer Chat Data",
        "FeatureCanEditCustomerChatData": "Feature Can Edit Customer Chat Data",
        "FeatureCanAssignCustomerChatData": "Feature Can Assign Customer Chat Data",
        "FeatureCanViewUnassigned": "Feature Can View Unassigned",
        "FeatureCanViewArchived": "Feature Can View Archived",
        "FeatureCanArchive": "Feature Can Archive",
        "FeatureAllowInstallations": "Feature Allow Installations",
        "FeatureCanProcessWebLeads": "Feature Can Process Web Leads",
        "FeatureAllowFurtherDiscountOnPromotionLines": "Feature Allow Further Discounting On Promotions",
        "FeatureAllowEditReadOnlyOpportunities": "Feature Allow Edit Read Only Opportunities",
        "FeatureAllowOpenExpiredQuotes": "Feature Allow Open Expired\\Lost Quotes",
        "FeatureAllowPerformCheckMeasure": "Feature Allow Perform Check Measure",
        "FeatureAllowApproveCheckMeasure": "Feature Allow Approve Check Measure",
        "FeatureAllowDiscounting": "Feature Allow Discounting",
        "FeatureAllowEditJobs": "Feature Allow Edit Jobs",
        "FeatureAllowBeginEditJobs": "Feature Allow Begin Edit Jobs",
        "FeatureAllowFinishEditJobs": "Feature Allow Finish Edit Jobs",
        "FeatureAllowFinishEditPriceOverride": "Allow Finish Edit Price Override",
        "FeatureAllowChangeBusinessUnit": "Feature Allow Change Business Unit",
        "FeatureAllowCreateServiceJob": "Feature Allow Create Service Job",
        "FeatureAllowViewDispatchPlanning": "Feature Allow View Dispatch Planning",
        "FeatureAllowChangeCostPrice": "Feature Allow Change Cost Price",
        "FeatureAllowOverrideDispatch": "Feature Allow Override Dispatch",
        "FeatureAllowRunCommissions": "Feature Allow Run Commissions",
        "FeatureAllowEditCommissionDate": "Feature Allow Edit Commission Date",
        "FeatureAllowViewEstimatedCommissions": "Feature Allow View Estimated Commissions",
        "FeatureAllowDeleteAppointment": "Feature Allow Delete Appointment",
        "FeatureAllowReceiptGoods": "Feature Allow Receipt Goods",
        "FeatureAllowProcessMerchantPayments": "Feature Allow Process Merchant Payments",
        "FeatureCanManageCalendarRoster": "Feature Can Manage Calendar Roster",
        "FeatureAllowViewCalendarRunValues": "Feature Allow View Calendar Run Values",
        "FeatureAllowBulkAssignLeads": "Feature Allow Bulk Assign Leads",
        "FeatureAllowProcessDispatch": "Feature Allow Process Dispatch",
        "FeatureAllowViewRestock": "Feature Allow View Restock",
        "FeatureAllowChangeJobLineSupplier": "Feature Allow Change Job Line Supplier",
        "FeatureAllowFabricOptimisation": "Feature Allow Fabric Optimisation",
        "FeatureAllowViewWholesaleChat": "Feature Allow View Wholesale Chat",
        "FeatureAllowProductManagement": "Feature Allow View Product Management",
        "FeatureAllowManageCustomReports": "Feature Allow Manage Custom Reports",
        "FeatureAllowViewMarketing": "Feature Allow View Marketing",
        "FeatureAllowCreditLimitToBeExceeded": "Feature Allow Credit Limit To Be Exceeded",
        "FeatureAllowChangeOtherUsersEvents": "Feature Allow Change Other Users Events",
        "Active": "Active",
        "DefaultTeam": "Team",
        "DefaultTeamID": "Team",
        "DefaultBusinessUnit": "Business Unit",
        "DefaultBusinessUnitID": "Business Unit",
        "CalendarColor": "Calendar Color",
        "Licensed": "Licensed",
        "LicenseIDs": "License I Ds",
        "CalendarSettings": "Calendar Settings",
        "ApplicationSettings": "Application Settings",
        "VersionSettings": "Version Settings",
        "Mobile": "Mobile",
        "WorkPhone": "Work Phone",
        "Address": "Address",
        "AddressID": "Address",
        "JobTitle": "Job Title",
        "EmailSignature": "Email Signature",
        "CalendarID": "Calendar ID",
        "CommissionRules": "Commission Rules",
    },
    "salesDiscountRule": {
        "entityTitle": "Sales Discount Rule",
        "Level": "Level",
        "BusinessUnit": "Business Unit",
        "BusinessUnitID": "Business Unit",
        "User": "Representative",
        "UserID": "Representative",
        "MinimumMargin": "Minimum Margin",
    },
    "salesDiscountRule_BusinessUnits": {
        "entityTitle": "Sales Discount Rule _ Business Units",
        "ID": "ID",
        "BusinessUnit": "Business Unit",
        "MinimumMargin": "Minimum Margin",
        "MinimumMarkup": "Minimum Markup",
    },
    "salesDiscountRule_Representative_SelectList": {
        "entityTitle": "Sales Discount Rule _ Representative _ Select List",
        "ID": "ID",
        "FullName": "Full Name",
    },
    "salesDiscountRule_System": {
        "entityTitle": "Sales Discount Rule _ System",
        "Level": "Level",
        "BusinessUnit": "Business Unit",
        "BusinessUnitID": "Business Unit",
        "User": "Representative",
        "UserID": "Representative",
        "MinimumMargin": "Minimum Margin",
    },
    "salesDiscountRule_Users": {
        "entityTitle": "Sales Discount Rule _ Users",
        "ID": "ID",
        "User": "User",
        "MinimumMargin": "Minimum Margin",
        "MinimumMarkup": "Minimum Markup",
    },
    "saveLookupItem": {
        "entityTitle": "Save Lookup Item",
        "LookupTable": "Lookup Table",
        "LookupTableID": "Lookup Table",
        "Notes": "Notes",
        "From": "From",
        "To": "To",
        "Text": "Text",
        "ProductID": "Product ID",
        "RepresentativeID": "Representative ID",
        "Value": "Value",
    },
    "scheduler_UserSelectList": {
        "entityTitle": "Scheduler _ User Select List",
        "ID": "ID",
        "FullName": "Full Name",
    },
    "search_Company": {
        "entityTitle": "Search _ Company",
        "ID": "ID",
        "Name": "Name",
        "Type": "Type",
        "Phone": "Phone",
        "Fax": "Fax",
        "Mobile": "Mobile",
        "Email": "Email",
        "WWW": "WWW",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "InternalNotes": "Internal Notes",
    },
    "search_Contact": {
        "entityTitle": "Search _ Contact",
        "ID": "ID",
        "FirstName": "First Name",
        "LastName": "Last Name",
        "WorkPhone": "Work Phone",
        "HomePhone": "Home Phone",
        "Mobile": "Mobile",
        "Email": "Email",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "InternalNotes": "Internal Notes",
        "Company": "Company",
        "CompanyID": "Company ID",
        "JobCategory": "Job Category",
        "JobTitle": "Job Title",
    },
    "search_Invoice": {
        "entityTitle": "Search _ Invoice",
        "ID": "ID",
        "InvoiceDate": "Invoice Date",
        "ProjectCustomerPO_abbrev": "Cust Ref",
        "ProjectCustomerPO": "Project Customer PO",
        "InvoiceNo": "Invoice No",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Amount": "Amount",
        "Tax": "Tax",
        "AmountIncTax": "Amount Inc Tax",
        "Rep": "Rep",
        "Status": "Status",
        "DueDate_abbrev": "Due",
        "DueDate": "Due Date",
    },
    "search_Job": {
        "entityTitle": "Search _ Job",
        "Reference": "Reference",
        "Contact": "Contact",
        "SiteContact": "Site Contact",
        "Company": "Company",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "SalesRep": "Sales Rep",
        "JobDate": "Job Date",
        "Stage": "Stage",
        "Stages": "Stages",
        "JobType": "Job Type",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "BusinessUnit": "Business Unit",
        "Expiry": "Expiry",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
        "MinOrderDate": "Order Date",
        "MaxOrderDate": "Last Order Date",
        "CustomStatus": "Custom Status",
        "SalesPriceInc_abbrev": "Sales Inc",
        "SalesPriceInc": "Sales Price Inc",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
    },
    "search_Job_ForContact": {
        "entityTitle": "Search _ Job _ For Contact",
        "Reference": "Reference",
        "Contact": "Contact",
        "SiteContact": "Site Contact",
        "Company": "Company",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "SalesRep": "Sales Rep",
        "JobDate": "Job Date",
        "Stage": "Stage",
        "Stages": "Stages",
        "JobType": "Job Type",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "BusinessUnit": "Business Unit",
        "Expiry": "Expiry",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
        "MinOrderDate": "Order Date",
        "MaxOrderDate": "Last Order Date",
        "CustomStatus": "Custom Status",
        "SalesPriceInc_abbrev": "Sales Inc",
        "SalesPriceInc": "Sales Price Inc",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
    },
    "search_PurchaseOrder": {
        "entityTitle": "Search _ Purchase Order",
        "ID": "ID",
        "OrderDate": "Order Date",
        "CustomerReference_abbrev": "Cust Ref",
        "CustomerReference": "Customer Reference",
        "OrderNumber": "Order Number",
        "CostPrice": "Cost Price",
        "Rep": "Rep",
        "Status": "Status",
        "Supplier": "Supplier",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
    },
    "settingRecord": {
        "entityTitle": "Setting Record",
        "DefaultMarkupPercentage": "Default Markup Percentage",
        "QuoteExpireDays": "Quote Expire Days",
        "InvoiceDueDays": "Invoice Due Days",
        "DefaultCommitmentReason": "Commitment Reason",
        "DefaultCommitmentReasonID": "Commitment Reason",
        "PrimaryBusinessUnit": "Business Unit",
        "PrimaryBusinessUnitID": "Business Unit",
        "DefaultPaymentTerms": "Default Payment Terms",
        "DefaultPaymentDue": "Default Payment Due",
        "MinDeposit": "Min Deposit",
        "FinancialYearStartDate": "Financial Year Start Date",
        "FinanceLockDate": "Finance Lock Date",
        "CommissionDate1Rule": "Commission Date 1 Rule",
        "CommissionDate1RuleByLine": "Commission Date 1 Rule By Line",
        "DefaultSupplierEmailTemplate": "Template",
        "DefaultSupplierEmailTemplateID": "Template",
        "DefaultBusinessUnitRule": "Default Business Unit Rule",
        "OrderCustomerRefRequired": "Order Customer Ref Required",
        "DefaultSettingID": "Default Setting ID",
        "SetupWizardCompleted": "Setup Wizard Completed",
        "DocumentStore": "Document Store",
        "TrackingEmailAddress": "Tracking Email Address",
        "ManufacturingETABuffer": "Manufacturing ETA Buffer",
        "Tracking_QuoteExpiryDays": "Tracking _ Quote Expiry Days",
        "Tracking_CMNotBookedDays": "Tracking _ CM Not Booked Days",
        "Tracking_CMNotConfirmedDays": "Tracking _ CM Not Confirmed Days",
        "Tracking_StockDuedDays": "Tracking _ Stock Dued Days",
        "Tracking_StockNotArrivedDays": "Tracking _ Stock Not Arrived Days",
        "Tracking_InstNotConfirmedDays": "Tracking _ Inst Not Confirmed Days",
        "Tracking_InstallerNotCompleteDays": "Tracking _ Installer Not Complete Days",
        "AutomationEnabled": "Automation Enabled",
        "AutoCreateFinalPriceDiscountRules": "Auto Create Final Price Discount Rules to Lock Sale Prices",
    },
    "snapshots": {
        "entityTitle": "Snapshots",
        "Name": "Name",
        "Date": "Date",
        "SnapshotData": "Snapshot Data",
        "JobLine": "Job Line",
        "JobLineID": "Job Line",
        "Job": "Job Line",
        "JobID": "Job",
        "OtherID": "Other ID",
    },
    "statements": {
        "entityTitle": "Statements",
        "ID": "ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Email": "Email",
        "Address": "Address",
        "OutstandingBalance": "Outstanding Balance",
        "Overdue": "Overdue",
    },
    "suppliers": {
        "entityTitle": "Suppliers",
        "Name": "Name",
        "Phone": "Phone",
        "Fax": "Fax",
        "Mobile": "Mobile",
        "Email": "Email",
        "WWW": "WWW",
        "SupplierID": "Supplier ID",
        "TaxRate": "Tax Rate",
        "Internal": "Internal",
        "SplitByProduct": "Split By Product",
        "IsMarketplaceLicensed": "Is Marketplace Licensed",
        "MarketplaceID": "Marketplace ID",
        "AccountID": "Account ID",
        "FabricTemplate": "Binary Data Field",
        "FabricTemplateID": "Binary Data Field",
        "ComponentTemplate": "Binary Data Field",
        "ComponentTemplateID": "Binary Data Field",
        "TemplatePrintType": "Template Print Type",
    },
    "supplyJobMultiLineView": {
        "entityTitle": "Supply Job Multi Line View",
        "OrderNumber": "Order Number",
        "LinkedReference": "Linked Reference",
        "LinkedReferenceID": "Linked Reference ID",
        "CustomerReference_abbrev": "Cust. Ref",
        "CustomerReference": "Customer Reference",
        "ProductSummary": "Product Summary",
        "OrderDate": "Order Date",
        "CloseDate": "Close Date",
        "ETADate": "ETA Date",
        "DateReceived": "Date Received",
        "DateSent": "Date Sent",
        "UndoCancelState": "Undo Cancel State",
        "Status": "Status",
        "StatusDate": "Status Date",
        "InternalNotes": "Internal Notes",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Job": "Job",
        "JobID": "Job",
        "DeliveryAddress": "Address",
        "DeliveryAddressID": "Address",
        "BillingAddress": "Address",
        "BillingAddressID": "Address",
        "OrderLines": "Order Lines",
        "SupplyNotes": "Supply Notes",
        "SupplierName": "Supplier Name",
        "SupplierID": "Supplier ID",
        "PurchaseOrderID": "Purchase Order ID",
        "JobType": "Job Type",
        "ItemID": "Item ID",
        "PriceListID": "Price List ID",
        "CompanyPriceMappings": "Company Price Mappings",
        "CompanyID": "Company ID",
        "ProjectCustomerPO": "Project Customer PO",
    },
    "tagsRelated": {
        "entityTitle": "Tags Related",
        "Tag": "Tag",
        "TagID": "Tag",
        "Job": "Job",
        "JobID": "Job",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "TemplateResponse": "Template Response",
        "TemplateResponseID": "Template Response",
    },
    "taxRates": {
        "entityTitle": "Tax Rates",
        "Rate_abbrev": "Rate %",
        "Rate": "Rate",
        "Description": "Description",
        "TaxRateID": "Tax Rate ID",
        "Active": "Active",
    },
    "teamReps": {
        "entityTitle": "Team Reps",
        "Team": "Team",
        "TeamID": "Team",
        "Rep": "Representative",
        "RepID": "Representative",
    },
    "accessRoleReps": {
        "entityTitle": "Access Role Reps",
        "AccessRole": "Access Role",
        "AccessRoleID": "Access Role",
        "Rep": "Representative",
        "RepID": "Representative",
    },
    "teams": {
        "entityTitle": "Teams",
        "Name": "Name",
        "Active": "Active",
        "TeamID": "Team ID",
    },
    "teams_Active": {
        "entityTitle": "Teams _ Active",
        "Name": "Name",
        "Active": "Active",
        "TeamID": "Team ID",
    },
    "templateResponses": {
        "entityTitle": "Template Responses",
        "Template": "Template",
        "TemplateID": "Template ID",
        "Condition": "Condition",
        "Value": "Value",
        "Action": "Action",
        "ResponseTimeout": "Response Timeout",
        "ModifyTags": "Modify Tags",
        "TagAction": "Tag Action",
        "Tags": "Tags",
    },
    "templateParams": {
        "entityTitle": "Template Params",
        "Template": "Template",
        "TemplateID": "Template ID",
        "Name": "Name",
        "Value": "Value",
    },
    "templateCustomField": {
        "entityTitle": "Template Custom Field",
        "Category": "Category",
        "Name": "Name",
        "InsertTemplate": "Insert Tamplate",
        "Kind": "Kind",
        "Expression": "Expression",
        "Enabled": "Enabled",
        "SortOrder": "Sort Order",
    },
    "templates": {
        "entityTitle": "Templates",
        "Description": "Description",
        "Type": "Type",
        "Category": "Category",
        "Subject": "Subject",
        "Body": "Body",
        "IsHTML": "Is HTML",
        "TemplateID": "Template ID",
        "Document": "Document",
        "Version": "Version",
        "AllowReply": "Allow Reply",
        "RenderEngine": "Render Engine",
    },
    "templatesByType": {
        "entityTitle": "Templates By Type",
        "Description": "Description",
        "Type": "Type",
        "Category": "Category",
        "Subject": "Subject",
        "Body": "Body",
        "IsHTML": "Is HTML",
        "TemplateID": "Template ID",
        "Document": "Document",
        "Version": "Version",
        "AllowReply": "Allow Reply",
    },
    "tracking": {
        "entityTitle": "Tracking",
        "TrackingData": "Tracking Data",
    },
    "tracking_ActiveJobs": {
        "entityTitle": "Tracking _ Active Jobs",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "SalesRepMobile": "Sales Rep Mobile",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
        "Contact": "Contact",
        "ContactEmail": "Contact Email",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "City": "City",
        "CommitReason": "Commit Reason",
        "BusinessUnit": "Business Unit",
        "JobType": "Job Type",
        "Status": "Status",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "Paid": "Paid",
        "ETA": "ETA",
        "OrderDate": "Order Date",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "Tags": "Tags",
    },
    "tracking_ActiveQuotes": {
        "entityTitle": "Tracking _ Active Quotes",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "Tags": "Tags",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "BusinessUnit": "Business Unit",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "QuoteDate": "Quote Date",
        "City": "City",
        "Paid": "Paid",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "DaysSinceSent": "Days Since Sent",
        "DaysToExpiry": "Days To Expiry",
        "IsActive": "Is Active",
        "IsOpen": "Is Open",
        "IsExpired": "Is Expired",
        "IsSent": "Is Sent",
        "IsLost": "Is Lost",
        "CommitReason": "Commit Reason",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
    },
    "tracking_ActiveServiceJobs": {
        "entityTitle": "Tracking _ Active Service Jobs",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "SalesRepMobile": "Sales Rep Mobile",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
        "Contact": "Contact",
        "ContactEmail": "Contact Email",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "City": "City",
        "CommitReason": "Commit Reason",
        "BusinessUnit": "Business Unit",
        "JobType": "Job Type",
        "Status": "Status",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "Paid": "Paid",
        "ETA": "ETA",
        "OrderDate": "Order Date",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "Tags": "Tags",
    },
    "tracking_AllOrderJobs": {
        "entityTitle": "Tracking _ All Order Jobs",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "SalesRepMobile": "Sales Rep Mobile",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
        "Contact": "Contact",
        "ContactEmail": "Contact Email",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "City": "City",
        "CommitReason": "Commit Reason",
        "BusinessUnit": "Business Unit",
        "JobType": "Job Type",
        "Status": "Status",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "Paid": "Paid",
        "ETA": "ETA",
        "OrderDate": "Order Date",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "Tags": "Tags",
    },
    "tracking_ExpiredQuotes": {
        "entityTitle": "Tracking _ Expired Quotes",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "Tags": "Tags",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "BusinessUnit": "Business Unit",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "QuoteDate": "Quote Date",
        "City": "City",
        "Paid": "Paid",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "DaysSinceSent": "Days Since Sent",
        "DaysToExpiry": "Days To Expiry",
        "IsActive": "Is Active",
        "IsOpen": "Is Open",
        "IsExpired": "Is Expired",
        "IsSent": "Is Sent",
        "IsLost": "Is Lost",
        "CommitReason": "Commit Reason",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
    },
    "tracking_ExpiredService": {
        "entityTitle": "Tracking _ Expired Service",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "Tags": "Tags",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "BusinessUnit": "Business Unit",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "QuoteDate": "Quote Date",
        "City": "City",
        "Paid": "Paid",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "DaysSinceSent": "Days Since Sent",
        "DaysToExpiry": "Days To Expiry",
        "IsActive": "Is Active",
        "IsOpen": "Is Open",
        "IsExpired": "Is Expired",
        "IsSent": "Is Sent",
        "IsLost": "Is Lost",
        "CommitReason": "Commit Reason",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
    },
    "tracking_LostQuotes": {
        "entityTitle": "Tracking _ Lost Quotes",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "Tags": "Tags",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "BusinessUnit": "Business Unit",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "QuoteDate": "Quote Date",
        "City": "City",
        "Paid": "Paid",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "DaysSinceSent": "Days Since Sent",
        "DaysToExpiry": "Days To Expiry",
        "IsActive": "Is Active",
        "IsOpen": "Is Open",
        "IsExpired": "Is Expired",
        "IsSent": "Is Sent",
        "IsLost": "Is Lost",
        "CommitReason": "Commit Reason",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
    },
    "tracking_MFScheduling": {
        "entityTitle": "Tracking _ MF Scheduling",
        "PurchaseOrderID": "Purchase Order ID",
        "OrderNumber": "Order Number",
        "JobID": "Job ID",
        "Job": "Job",
        "CustomerReference": "Customer Reference",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Supplier": "Supplier",
        "CommitReason": "Commit Reason",
        "BusinessUnit": "Business Unit",
        "Product": "Product",
        "Department": "Department",
        "DispatchDate": "Dispatch Date",
        "ETADate": "ETA Date",
        "Status": "Status",
        "MFDate": "MF Date",
        "OrderDate": "Order Date",
        "Internal": "Internal",
        "Qty": "Qty",
        "JobQty": "Job Qty",
        "DispatchDays": "Dispatch Days",
        "Age": "Age",
        "IDs": "I Ds",
        "SupplyNotes": "Supply Notes",
    },
    "tracking_OpenQuotes": {
        "entityTitle": "Tracking _ Open Quotes",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "Tags": "Tags",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "BusinessUnit": "Business Unit",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "QuoteDate": "Quote Date",
        "City": "City",
        "Paid": "Paid",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "DaysSinceSent": "Days Since Sent",
        "DaysToExpiry": "Days To Expiry",
        "IsActive": "Is Active",
        "IsOpen": "Is Open",
        "IsExpired": "Is Expired",
        "IsSent": "Is Sent",
        "IsLost": "Is Lost",
        "CommitReason": "Commit Reason",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
    },
    "tracking_PendingApprovalService": {
        "entityTitle": "Tracking _ Pending Approval Service",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "Tags": "Tags",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "BusinessUnit": "Business Unit",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "QuoteDate": "Quote Date",
        "City": "City",
        "Paid": "Paid",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "DaysSinceSent": "Days Since Sent",
        "DaysToExpiry": "Days To Expiry",
        "IsActive": "Is Active",
        "IsOpen": "Is Open",
        "IsExpired": "Is Expired",
        "IsSent": "Is Sent",
        "IsLost": "Is Lost",
        "CommitReason": "Commit Reason",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
    },
    "tracking_Projects": {
        "entityTitle": "Tracking _ Projects",
        "ID": "ID",
        "JobID": "Job ID",
        "Reference": "Reference",
        "Company": "Company",
        "SiteContact": "Site Contact",
        "CustomStatus": "Custom Status",
        "ProjectCustomerPO": "Project Customer PO",
        "SiteAddress": "Site Address",
        "SalesRep": "Sales Rep",
        "SalesRepID": "Sales Rep ID",
        "Tags": "Tags",
        "HandoverDate": "Handover Date",
        "ProjectTemplateID": "Project Template ID",
        "CompanyID": "Company ID",
        "SiteContactID": "Site Contact ID",
        "OpportunityID": "Opportunity ID",
        "SiteAddressID": "Site Address ID",
        "ETA": "ETA",
        "SalePrice": "Sale Price",
        "ContactEmail": "Contact Email",
        "StageDate_0": "Stage Date _0",
        "StageDate_1": "Stage Date _1",
        "StageDate_2": "Stage Date _2",
        "StageDate_3": "Stage Date _3",
        "StageDate_4": "Stage Date _4",
        "StageDate_5": "Stage Date _5",
        "StageDate_6": "Stage Date _6",
        "StageDate_7": "Stage Date _7",
        "StageDate_8": "Stage Date _8",
        "StageDate_9": "Stage Date _9",
        "StageID_0": "Stage ID _0",
        "StageID_1": "Stage ID _1",
        "StageID_2": "Stage ID _2",
        "StageID_3": "Stage ID _3",
        "StageID_4": "Stage ID _4",
        "StageID_5": "Stage ID _5",
        "StageID_6": "Stage ID _6",
        "StageID_7": "Stage ID _7",
        "StageID_8": "Stage ID _8",
        "StageID_9": "Stage ID _9",
        "Action_CanMoveToSupply": "Action _ Can Move To Supply",
        "Action_CanResendToSupply": "Action _ Can Resend To Supply",
        "Action_CanUpdateETA": "Action _ Can Update ETA",
        "Action_CanReceiptGoods": "Action _ Can Receipt Goods",
        "Action_CanInvoice": "Action _ Can Invoice",
        "Products": "Products",
    },
    "tracking_SentQuotes": {
        "entityTitle": "Tracking _ Sent Quotes",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "Tags": "Tags",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "BusinessUnit": "Business Unit",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "QuoteDate": "Quote Date",
        "City": "City",
        "Paid": "Paid",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "DaysSinceSent": "Days Since Sent",
        "DaysToExpiry": "Days To Expiry",
        "IsActive": "Is Active",
        "IsOpen": "Is Open",
        "IsExpired": "Is Expired",
        "IsSent": "Is Sent",
        "IsLost": "Is Lost",
        "CommitReason": "Commit Reason",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
    },
    "tracking_SentService": {
        "entityTitle": "Tracking _ Sent Service",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "Tags": "Tags",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "BusinessUnit": "Business Unit",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "QuoteDate": "Quote Date",
        "City": "City",
        "Paid": "Paid",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "DaysSinceSent": "Days Since Sent",
        "DaysToExpiry": "Days To Expiry",
        "IsActive": "Is Active",
        "IsOpen": "Is Open",
        "IsExpired": "Is Expired",
        "IsSent": "Is Sent",
        "IsLost": "Is Lost",
        "CommitReason": "Commit Reason",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
    },
    "user_NoTeamFilter": {
        "entityTitle": "User _ No Team Filter",
        "Name": "Name",
        "Active": "Active",
        "TeamID": "Team ID",
    },
    "user_NoUserFilter": {
        "entityTitle": "User _ No User Filter",
        "ID": "ID",
        "FullName": "Full Name",
    },
    "user_SalesTeamFilter": {
        "entityTitle": "User _ Sales Team Filter",
        "Name": "Name",
        "Active": "Active",
        "TeamID": "Team ID",
    },
    "user_SalesUserFilter": {
        "entityTitle": "User _ Sales User Filter",
        "ID": "ID",
        "FullName": "Full Name",
    },
    "user_TeamFilter": {
        "entityTitle": "User _ Team Filter",
        "Name": "Name",
        "Active": "Active",
        "TeamID": "Team ID",
    },
    "user_UserFilter": {
        "entityTitle": "User _ User Filter",
        "ID": "ID",
        "FullName": "Full Name",
    },
    "userApplicationSettings": {
        "entityTitle": "User Application Settings",
        "ActivityFilter": "Activity Filter",
        "CalendarSettings": "Calendar Settings",
        "ApplicationSettings": "Application Settings",
        "VersionSettings": "Version Settings",
        "DashboardSettings": "Dashboard Settings",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
    },
    "userCommissionRules": {
        "entityTitle": "User Commission Rules",
        "User": "Representative",
        "UserID": "Representative",
        "CommissionRule": "Commission Rule",
        "CommissionRuleID": "Commission Rule",
    },
    "view_InvoiceStatements": {
        "entityTitle": "View _ Invoice Statements",
        "InvoiceDate": "Invoice Date",
        "DueDate": "Due Date",
        "InvoiceNo": "Invoice No",
        "ProjectCustomerPO": "Project Customer PO",
        "CompanyID": "Company ID",
        "Company": "Company",
        "CompanyMobile": "Company Mobile",
        "CompanyPhone": "Company Phone",
        "CompanyFax": "Company Fax",
        "ContactID": "Contact ID",
        "Contact": "Contact",
        "ContactHomePhone": "Contact Home Phone",
        "ContactMobile": "Contact Mobile",
        "ContactWorkPhone": "Contact Work Phone",
        "Email": "Email",
        "Address": "Address",
        "DaysOverdue": "Days Overdue",
        "Amount": "Amount",
        "Overdue": "Overdue",
        "Paid": "Paid",
        "Balance": "Balance",
    },
    "view_JobAmount": {
        "entityTitle": "View _ Job Amount",
        "ID": "ID",
        "OpportunityID": "Opportunity ID",
        "Amount": "Amount",
        "AmountEx": "Amount Ex",
        "Count": "Count",
    },
    "view_JobLine": {
        "entityTitle": "View _ Job Line",
        "ID": "ID",
        "RequireCM": "Require CM",
        "RequireInstall": "Require Install",
        "RequirePickup": "Require Pickup",
        "RequireDelivery": "Require Delivery",
        "Stage": "Stage",
        "LineType": "Line Type",
        "DispatchStage": "Dispatch Stage",
        "Status": "Status",
        "ProductID": "Product ID",
        "SupplierID": "Supplier ID",
        "ETA": "ETA",
        "OrderDate": "Order Date",
        "CommissionDate1": "Commission Date 1",
        "CommissionDate2": "Commission Date 2",
        "CommissionDate3": "Commission Date 3",
        "CommissionDate4": "Commission Date 4",
        "CommissionDate5": "Commission Date 5",
        "Count": "Count",
    },
    "view_JobPaid": {
        "entityTitle": "View _ Job Paid",
        "ID": "ID",
        "Paid": "Paid",
        "Count": "Count",
    },
    "views_Opportunities_Confirmed": {
        "entityTitle": "Views _ Opportunities _ Confirmed",
        "ID": "ID",
        "Description": "Description",
        "LeadDate": "Lead Date",
        "Forecast": "Forecast",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "LeadSource": "Lead Source",
        "PipelineStage_abbrev": "Stage",
        "PipelineStage": "Pipeline Stage",
        "Status": "Status",
        "ConfidenceLevel": "Confidence Level",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Representative": "Representative",
        "RepresentativeID": "Representative ID",
        "BusinessUnit": "Business Unit",
        "Tags": "Tags",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "ExpectedRevenue_abbrev": "Forcast {{accentCurrencySymbol}}",
        "ExpectedRevenue": "Expected Revenue",
        "ActivityID": "Activity ID",
        "ActivityContactID": "Activity Contact ID",
        "ActivityType": "Activity Type",
        "ActivityClosed": "Activity Closed",
        "ActivityConfirmed": "Activity Confirmed",
        "ActivityPriority": "Activity Priority",
        "ActivityStart": "Activity Start",
        "ActivitySubject": "Activity Subject",
        "Notes": "Notes",
    },
    "views_Opportunities_Leads": {
        "entityTitle": "Views _ Opportunities _ Leads",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "views_Opportunities_Leads_For_Rep": {
        "entityTitle": "Views _ Opportunities _ Leads _ For _ Rep",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "views_Opportunities_Lost": {
        "entityTitle": "Views _ Opportunities _ Lost",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "views_Opportunities_Lost_For": {
        "entityTitle": "Views _ Opportunities _ Lost _ For",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "views_Opportunities_Lost_For_Rep": {
        "entityTitle": "Views _ Opportunities _ Lost _ For _ Rep",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "views_Opportunities_Negotiation": {
        "entityTitle": "Views _ Opportunities _ Negotiation",
        "ID": "ID",
        "Description": "Description",
        "LeadDate": "Lead Date",
        "Forecast": "Forecast",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "LeadSource": "Lead Source",
        "PipelineStage_abbrev": "Stage",
        "PipelineStage": "Pipeline Stage",
        "Status": "Status",
        "ConfidenceLevel": "Confidence Level",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Representative": "Representative",
        "RepresentativeID": "Representative ID",
        "BusinessUnit": "Business Unit",
        "Tags": "Tags",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "ExpectedRevenue_abbrev": "Forcast {{accentCurrencySymbol}}",
        "ExpectedRevenue": "Expected Revenue",
        "ActivityID": "Activity ID",
        "ActivityContactID": "Activity Contact ID",
        "ActivityType": "Activity Type",
        "ActivityClosed": "Activity Closed",
        "ActivityConfirmed": "Activity Confirmed",
        "ActivityPriority": "Activity Priority",
        "ActivityStart": "Activity Start",
        "ActivitySubject": "Activity Subject",
        "Notes": "Notes",
    },
    "views_Opportunities_Negotiation_For_Rep": {
        "entityTitle": "Views _ Opportunities _ Negotiation _ For _ Rep",
        "ID": "ID",
        "Description": "Description",
        "LeadDate": "Lead Date",
        "Forecast": "Forecast",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "LeadSource": "Lead Source",
        "PipelineStage_abbrev": "Stage",
        "PipelineStage": "Pipeline Stage",
        "Status": "Status",
        "ConfidenceLevel": "Confidence Level",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Representative": "Representative",
        "RepresentativeID": "Representative ID",
        "BusinessUnit": "Business Unit",
        "Tags": "Tags",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "ExpectedRevenue_abbrev": "Forcast {{accentCurrencySymbol}}",
        "ExpectedRevenue": "Expected Revenue",
        "ActivityID": "Activity ID",
        "ActivityContactID": "Activity Contact ID",
        "ActivityType": "Activity Type",
        "ActivityClosed": "Activity Closed",
        "ActivityConfirmed": "Activity Confirmed",
        "ActivityPriority": "Activity Priority",
        "ActivityStart": "Activity Start",
        "ActivitySubject": "Activity Subject",
        "Notes": "Notes",
    },
    "views_Opportunities_Quotation": {
        "entityTitle": "Views _ Opportunities _ Quotation",
        "ID": "ID",
        "Description": "Description",
        "LeadDate": "Lead Date",
        "Forecast": "Forecast",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "LeadSource": "Lead Source",
        "PipelineStage_abbrev": "Stage",
        "PipelineStage": "Pipeline Stage",
        "Status": "Status",
        "ConfidenceLevel": "Confidence Level",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Representative": "Representative",
        "RepresentativeID": "Representative ID",
        "BusinessUnit": "Business Unit",
        "Tags": "Tags",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "ExpectedRevenue_abbrev": "Forcast {{accentCurrencySymbol}}",
        "ExpectedRevenue": "Expected Revenue",
        "ActivityID": "Activity ID",
        "ActivityContactID": "Activity Contact ID",
        "ActivityType": "Activity Type",
        "ActivityClosed": "Activity Closed",
        "ActivityConfirmed": "Activity Confirmed",
        "ActivityPriority": "Activity Priority",
        "ActivityStart": "Activity Start",
        "ActivitySubject": "Activity Subject",
        "Notes": "Notes",
    },
    "views_Opportunities_Quotation_For_Rep": {
        "entityTitle": "Views _ Opportunities _ Quotation _ For _ Rep",
        "ID": "ID",
        "Description": "Description",
        "LeadDate": "Lead Date",
        "Forecast": "Forecast",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "LeadSource": "Lead Source",
        "PipelineStage_abbrev": "Stage",
        "PipelineStage": "Pipeline Stage",
        "Status": "Status",
        "ConfidenceLevel": "Confidence Level",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Representative": "Representative",
        "RepresentativeID": "Representative ID",
        "BusinessUnit": "Business Unit",
        "Tags": "Tags",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "ExpectedRevenue_abbrev": "Forcast {{accentCurrencySymbol}}",
        "ExpectedRevenue": "Expected Revenue",
        "ActivityID": "Activity ID",
        "ActivityContactID": "Activity Contact ID",
        "ActivityType": "Activity Type",
        "ActivityClosed": "Activity Closed",
        "ActivityConfirmed": "Activity Confirmed",
        "ActivityPriority": "Activity Priority",
        "ActivityStart": "Activity Start",
        "ActivitySubject": "Activity Subject",
        "Notes": "Notes",
    },
    "views_Opportunities_Won": {
        "entityTitle": "Views _ Opportunities _ Won",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "views_Opportunities_Won_For": {
        "entityTitle": "Views _ Opportunities _ Won _ For",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },
    "views_Opportunities_Won_For_Rep": {
        "entityTitle": "Views _ Opportunities _ Won _ For _ Rep",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
    },

    "basePicklist": {
        "entityTitle": "Base Picklist",
        "ID": "Record ID",
        "Description": "Description",
        "Active": "Active",
    },
    "documentBase": {
        "entityTitle": "Document Base",
        "ID": "Record ID",
        "Uri": "Uri",
        "Description": "Description",
        "Tag": "Tag",
        "Protected": "Protected",
        "DocumentID": "Document ID",
        "Version": "Version",
        "DocumentDate_abbrev": "Date",
        "DocumentDate": "Document Date",
    },
    "commissionAccountTransactionGrid": {
        "entityTitle": "Commission Account Transaction Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Date": "Date",
        "User": "User",
        "UserID": "User ID",
        "RunID": "Run ID",
        "Run": "Run",
        "Plan": "Plan",
        "Type": "Type",
        "Description": "Description",
        "Status": "Status",
        "Amount": "Amount",
        "Notes": "Notes",
        "IDs": "I Ds",
    },
    "templateResponseGrid": {
        "entityTitle": "Template Response Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Condition": "Condition",
        "Value": "Value",
        "Action": "Action",
        "ResponseTimeout": "Response Timeout",
    },
    "templateParamGrid": {
        "entityTitle": "Template Param Grid",
        "ID": "ID",
        "Name": "Name",
        "Value": "Value",
    },
    "localeCountry": {
        "entityTitle": "Locale Country",
        "ID": "Record ID",
        "ID": "ID",
        "Description": "Description",
    },
    "purchaseOrderGrid": {
        "entityTitle": "Purchase Order Grid",
        "ID": "Record ID",
        "ID": "ID",
        "OrderDate": "Order Date",
        "CustomerReference_abbrev": "Cust Ref",
        "CustomerReference": "Customer Reference",
        "OrderNumber": "Order Number",
        "CostPrice": "Cost Price",
        "Rep": "Rep",
        "Status": "Status",
        "Supplier": "Supplier",
        "ETADate_abbrev": "ETA",
        "ETADate": "ETA Date",
    },
    "salesDiscountRuleBusinessUnitGrid": {
        "entityTitle": "Sales Discount Rule Business Unit Grid",
        "ID": "Record ID",
        "ID": "ID",
        "BusinessUnit": "Business Unit",
        "MinimumMargin": "Minimum Margin",
        "MinimumMarkup": "Minimum Markup",
    },
    "salesDiscountRuleUserGrid": {
        "entityTitle": "Sales Discount Rule User Grid",
        "ID": "Record ID",
        "ID": "ID",
        "User": "User",
        "MinimumMargin": "Minimum Margin",
        "MinimumMarkup": "Minimum Markup",
    },
    "companyGrid": {
        "entityTitle": "Company Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Name": "Name",
        "Type": "Type",
        "Phone": "Phone",
        "Fax": "Fax",
        "Mobile": "Mobile",
        "Email": "Email",
        "WWW": "WWW",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "InternalNotes": "Internal Notes",
    },
    "documentGrid": {
        "entityTitle": "Document Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Description": "Description",
        "Job": "Job",
        "JobID": "Job ID",
        "JobLine": "Job Line",
        "JobLineID": "Job Line ID",
        "SupplyJob": "Supply Job",
        "SupplyJobID": "Supply Job ID",
        "SupplyJobLine": "Supply Job Line",
        "SupplyJobLineID": "Supply Job Line ID",
        "Type": "Type",
        "Date": "Date",
        "Version": "Version",
        "SendToCustomer": "Send To Customer",
        "SendToSupplier": "Send To Supplier",
        "Signed": "Signed",
    },
    "communicationGrid": {
        "entityTitle": "Communication Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Date": "Date",
        "Type": "Type",
        "Category": "Category",
        "Description": "Description",
        "ContactPoint": "Contact Point",
        "Outcome": "Outcome",
        "OutcomeStatus": "Status",
        "User_abbrev": "User",
        "User": "User",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Job": "Job",
        "JobID": "Job ID",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice ID",
        "SupplyJob": "Supply Job",
        "PurchaseOrderID": "Purchase Order ID",
        "Supplier": "Supplier",
    },
    "statementGrid": {
        "entityTitle": "Statement Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Email": "Email",
        "Address": "Address",
        "OutstandingBalance": "Outstanding Balance",
        "Overdue": "Overdue",
    },
    "orderLineGrid": {
        "entityTitle": "Order Line Grid",
        "ID": "Record ID",
        "ID": "ID",
        "ProductName": "Product Name",
        "OrderLineNo": "Order Line No",
        "Width": "Width",
        "Drop": "Drop",
        "Qty": "Qty",
        "LocationOther": "Location Other",
        "CostPrice": "Cost Price",
        "Status": "Status",
        "ValidationErrors": "Validation Errors",
    },
    "lookupTableItemGrid": {
        "entityTitle": "Lookup Table Item Grid",
        "ID": "Record ID",
        "ID": "ID",
        "From": "From",
        "To": "To",
        "Text": "Text",
        "ProductName": "Product Name",
        "ProductID": "Product ID",
        "RepresentativeName": "Representative Name",
        "RepresentativeID": "Representative ID",
        "Value": "Value",
        "Notes": "Notes",
    },
    "activityGrid": {
        "entityTitle": "Activity Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Subject": "Subject",
        "Start": "Start",
        "AllDay": "All Day",
        "Closed": "Closed",
        "Cancelled": "Cancelled",
        "CancelledReason": "Cancel Reason",
        "CancelledNotes": "Cancel Notes",
        "Status": "Status",
        "Notes": "Notes",
        "ActivityType_abbrev": "Type",
        "ActivityType": "Activity Type",
        "ActivityCategory_abbrev": "Category",
        "ActivityCategory": "Activity Category",
        "Confirmed": "Confirmed",
        "Representative": "Representative",
        "Priority": "Priority",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity ID",
        "IsInstall": "Is Install",
        "IsPickup": "Is Pickup",
        "IsDelivery": "Is Delivery",
        "IsService": "Is Service",
    },
    "opportunityGrid": {
        "entityTitle": "Opportunity Grid",
        "ID": "ID",
        "LeadDate": "Lead Date",
        "Description": "Description",
        "LeadSource": "Lead Source",
        "Forecast": "Forecast",
        "Status": "Status",
        "PipelineStage": "Pipeline Stage",
        "ConfidenceLevel": "Confidence Level",
        "Representative": "Representative",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "SalesArea": "Sales Area",
        "InstallArea": "Install Area",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "Address": "Address",
        "Notes": "Notes",
        "Phone": "Phone",
        "Email": "Email",
        "SnoozeDate": "Snooze Date",
        "QuoteOutcomeReason": "Outcome Reason",
    },
    "invoiceGrid": {
        "entityTitle": "Invoice Grid",
        "ID": "ID",
        "InvoiceDate": "Invoice Date",
        "ProjectCustomerPO_abbrev": "Cust Ref",
        "ProjectCustomerPO": "Project Customer PO",
        "InvoiceNo": "Invoice No",
        "Contact": "Contact",
        "BusinessUnit": "Business Unit",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Amount": "Amount",
        "Tax": "Tax",
        "AmountIncTax": "Amount Inc Tax",
        "Rep": "Rep",
        "Status": "Status",
        "DueDate_abbrev": "Due",
        "DueDate": "Due Date",
    },
    "productGrid": {
        "entityTitle": "Product Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Product": "Product",
        "Supplier": "Supplier",
        "Active": "Active",
        "ServiceProduct": "Service Product",
        "SupplementaryCharge": "Supplementary Charge",
    },
    "leadSearchGrid": {
        "entityTitle": "Lead Search Grid",
        "ID": "Record ID",
        "ID": "ID",
        "LastName": "Last Name",
        "FirstName": "First Name",
        "Email": "Email",
        "WorkPhone": "Work Phone",
        "HomePhone": "Home Phone",
        "Mobile": "Mobile",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "JobCategory": "Job Category",
        "JobTitle": "Job Title",
        "Company": "Company",
        "ContactID": "Contact ID",
        "CompanyID": "Company ID",
        "CustomerName": "Customer Name",
        "CompanyName": "Company Name",
        "BillingContactName": "Billing Contact Name",
    },
    "contactGrid": {
        "entityTitle": "Contact Grid",
        "ID": "ID",
        "FirstName": "First Name",
        "LastName": "Last Name",
        "WorkPhone": "Work Phone",
        "HomePhone": "Home Phone",
        "Mobile": "Mobile",
        "Email": "Email",
        "AddressLines": "Address Lines",
        "City": "City",
        "State": "State",
        "Postcode": "Postcode",
        "InternalNotes": "Internal Notes",
        "Company": "Company",
        "CompanyID": "Company ID",
        "JobCategory": "Job Category",
        "JobTitle": "Job Title",
    },
    "commissionRunGrid": {
        "entityTitle": "Commission Run Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Plan": "Plan",
        "Description": "Description",
        "StartDate": "Start Date",
        "EndDate": "End Date",
        "LastRunBy": "Last Run By",
        "PaidBy": "Paid By",
    },
    "largestQuoteGrid": {
        "entityTitle": "Largest Quote Grid",
        "ID": "Record ID",
        "ID": "ID",
        "Reference": "Reference",
        "Contact": "Contact",
        "ExpiryDate": "Expiry Date",
        "SalesPriceInc": "Sales Price Inc",
        "ContactID": "Contact ID",
    },
    "paymentGrid": {
        "entityTitle": "Payment Grid",
        "ID": "Record ID",
        "ID": "ID",
        "ReceiptNo": "Receipt No",
        "Date": "Date",
        "Amount": "Amount",
        "Method": "Method",
        "Status": "Status",
        "UnAllocated": "Un Allocated",
    },
    "communication": {
        "entityTitle": "Communication",
        "ID": "Record ID",
        "Date": "Date",
        "Type": "Type",
        "Category": "Category",
        "Description": "Description",
        "Outcome": "Outcome",
        "OutcomeDate": "Outcome Date",
        "ContactPoint": "Contact Point",
        "Tag": "Tag",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Company": "Company",
        "CompanyID": "Company",
        "Job": "Job",
        "JobID": "Job",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "Supplier": "Supplier",
        "SupplierID": "Supplier",
        "SupplyJob": "Supply Job",
        "SupplyJobID": "Purchase Order",
        "CommunicationID": "Communication ID",
        "activity": "activity",
        "ActivityID": "Activity",
        "TemplateID": "Template ID",
    },
    "commandAction": {
        "entityTitle": "Command Action",
        "ID": "Record ID",
        "Type": "Type",
        "Date": "Date",
        "CommandData": "Command Data",
        "CommandActionKey": "Command Action Key",
    },
    "iV_JobLine": {
        "entityTitle": "IV _ Job Line",
        "ID": "Record ID",
        "ID": "ID",
        "RequireCM": "Require CM",
        "RequireInstall": "Require Install",
        "RequirePickup": "Require Pickup",
        "RequireDelivery": "Require Delivery",
        "Stage": "Stage",
        "LineType": "Line Type",
        "DispatchStage": "Dispatch Stage",
        "Status": "Status",
        "ProductID": "Product ID",
        "SupplierID": "Supplier ID",
        "ETA": "ETA",
        "OrderDate": "Order Date",
        "CommissionDate1": "Commission Date 1",
        "Count": "Count",
    },
    "iV_AdvancedFilter_Job": {
        "entityTitle": "IV _ Advanced Filter _ Job",
        "ID": "Record ID",
        "ID": "ID",
        "QuoteDate": "Quote Date",
        "QuoteExpiryDate": "Quote Expiry Date",
        "HandoverDate": "Handover Date",
        "LJ__CommissionDate1": "LJ __ Commission Date 1",
        "LJ__CommissionDate2": "LJ __ Commission Date 2",
        "LJ__CommissionDate3": "LJ __ Commission Date 3",
        "LJ__CommissionDate4": "LJ __ Commission Date 4",
        "LJ__CommissionDate5": "LJ __ Commission Date 5",
        "LJ__OrderDate": "LJ __ Order Date",
        "LJ__ETADate": "LJ __ ETA Date",
        "LJ__Amount": "LJ __ Amount",
        "LJ__Paid": "LJ __ Paid",
        "LJ__HasPayment": "LJ __ Has Payment",
        "Stage": "Stage",
        "Status": "Status",
        "JobType": "Job Type",
        "MarginApprovalRequired": "Margin Approval Required",
        "LJ__JobLineStatus": "LJ __ Job Line Status",
        "LJ__JobLineStage": "LJ __ Job Line Stage",
        "LJ__JobLineStageDate": "LJ __ Job Line Stage Date",
        "LJ__JobLineType": "LJ __ Job Line Type",
        "LJ__FaultReasonID": "LJ __ Fault Reason ID",
        "LJ__AtFaultUserID": "LJ __ At Fault User ID",
        "LJ__AtFaultSupplierID": "LJ __ At Fault Supplier ID",
        "LJ__JobLineDispatchStage": "LJ __ Job Line Dispatch Stage",
        "SalesRepID": "Sales Rep ID",
        "BusinessUnitID": "Business Unit ID",
        "PL_CommitmentReasonID": "PL _ Commitment Reason ID",
        "LJ__Balance": "LJ __ Balance",
        "LJ__PercentagePaid": "LJ __ Percentage Paid",
        "LJ__JobLineProductID": "LJ __ Job Line Product ID",
        "LJ__JobLineSupplierID": "LJ __ Job Line Supplier ID",
        "LJ__CompanyName": "LJ __ Company Name",
        "LJ__OrganisationType": "LJ __ Organisation Type",
        "LJ__AccountType": "LJ __ Account Type",
        "LJ__ContactFirstName": "LJ __ Contact First Name",
        "LJ__ContactLastName": "LJ __ Contact Last Name",
        "LJ__ContactHasCredit": "LJ __ Contact Has Credit",
        "LJ__SiteContactFirstName": "LJ __ Site Contact First Name",
        "LJ__SiteContactLastName": "LJ __ Site Contact Last Name",
        "LJ__ActivityType": "LJ __ Activity Type",
        "LJ__ActivityCategory": "LJ __ Activity Category",
        "LJ__ActivityStart": "LJ __ Activity Start",
        "LJ__ActivityRepresentative": "LJ __ Activity Representative",
        "LJ__Tags": "LJ __ Tags",
        "LJ__ActivityClosed": "LJ __ Activity Closed",
        "LJ__ActivityConfirmed": "LJ __ Activity Confirmed",
        "LJ__ActivityCancelled": "LJ __ Activity Cancelled",
        "LJ__ReferredByID": "LJ __ Referred By ID",
        "LJ__LeadGenerator": "LJ __ Lead Generator",
        "LJ__OpportunityConfidenceLevel": "LJ __ Opportunity Confidence Level",
        "LJ__OpportunityStatus": "LJ __ Opportunity Status",
        "LJ__OpportunityOutcomeReason": "LJ __ Opportunity Outcome Reason",
        "LJ__OpportunityForecast": "LJ __ Opportunity Forecast",
        "LJ__LeadSource": "LJ __ Lead Source",
        "LJ__VisitedShowroom": "LJ __ Visited Showroom",
        "LJ__OpportunityRepresentative": "LJ __ Opportunity Representative",
        "LJ__CMRequired": "LJ __ CM Required",
        "LJ__InstallRequired": "LJ __ Install Required",
        "LJ__PickupRequired": "LJ __ Pickup Required",
        "LJ__DeliveryRequired": "LJ __ Delivery Required",
        "LJ__PercentageInvoiced": "LJ __ Percentage Invoiced",
    },
    "iV_AdvancedFilter_Opportunity": {
        "entityTitle": "IV _ Advanced Filter _ Opportunity",
        "ID": "Record ID",
        "ID": "ID",
        "Description": "Description",
        "ExpectedCloseDate": "Expected Close Date",
        "Status": "Status",
        "RepresentativeID": "Representative ID",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Forecast": "Forecast",
        "LeadGeneratorID": "Lead Generator ID",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "BusinessUnitID": "Business Unit ID",
        "PL_QuoteOutcomeReasonID": "PL _ Outcome Reason ID",
        "ReferedByID": "Refered By ID",
        "VisitedShowroom": "Visited Showroom",
        "LJ__Tags": "LJ __ Tags",
        "LJ__ActivityType": "LJ __ Activity Type",
        "LJ__ActivityCategory": "LJ __ Activity Category",
        "LJ__ActivityStart": "LJ __ Activity Start",
        "LJ__ActivityRepresentative": "LJ __ Activity Representative",
        "LJ__ActivityClosed": "LJ __ Activity Closed",
        "LJ__ActivityConfirmed": "LJ __ Activity Confirmed",
        "LJ__ActivityCancelled": "LJ __ Activity Cancelled",
        "LJ__CompanyName": "LJ __ Company Name",
        "LJ__OrganisationType": "LJ __ Organisation Type",
        "LJ__CompanyAccountType": "LJ __ Company Account Type",
        "LJ__ContactFirstName": "LJ __ Contact First Name",
        "LJ__ContactLastName": "LJ __ Contact Last Name",
        "LJ__Amount": "LJ __ Amount",
        "LJ__QuoteLastSentDate": "LJ __ Quote Last Sent Date",
        "LJ__QuoteDate": "LJ __ Quote Date",
        "LJ__QuoteExpiryDate": "LJ __ Quote Expiry Date",
        "LJ__JobID": "LJ __ Job ID",
        "LJ__JobSalesRep": "LJ __ Job Sales Rep",
        "LJ__JobStage": "LJ __ Job Stage",
        "LJ__JobTags": "LJ __ Job Tags",
        "LJ__JobCompanyName": "LJ __ Job Company Name",
        "LJ__JobOrganisationType": "LJ __ Job Organisation Type",
        "LJ__JobCompanyAccountType": "LJ __ Job Company Account Type",
        "LJ__JobContactFirstName": "LJ __ Job Contact First Name",
        "LJ__JobContactLastName": "LJ __ Job Contact Last Name",
        "LJ__JobLineETADate": "LJ __ Job Line ETA Date",
        "LJ__JobLineProductID": "LJ __ Job Line Product ID",
        "LJ__JobLineSupplierID": "LJ __ Job Line Supplier ID",
        "LJ__JobLineCMRequired": "LJ __ Job Line CM Required",
        "LJ__JobLineInstallRequired": "LJ __ Job Line Install Required",
        "LJ__JobLinePickupRequired": "LJ __ Job Line Pickup Required",
        "LJ__JobLineDeliveryRequired": "LJ __ Job Line Delivery Required",
        "LJ__JobLineStatus": "LJ __ Job Line Status",
        "LJ__JobLineStage": "LJ __ Job Line Stage",
    },
    "iV_JobAmount": {
        "entityTitle": "IV _ Job Amount",
        "ID": "Record ID",
        "ID": "ID",
        "OpportunityID": "Opportunity ID",
        "Amount": "Amount",
        "AmountEx": "Amount Ex",
        "Count": "Count",
    },
    "iV_JobPaid": {
        "entityTitle": "IV _ Job Paid",
        "ID": "Record ID",
        "ID": "ID",
        "Paid": "Paid",
        "Count": "Count",
    },
    "iV_AdvancedFilter_SupplyJob": {
        "entityTitle": "IV _ Advanced Filter _ Supply Job",
        "ID": "Record ID",
        "ID": "ID",
        "PurchaseOrderID": "Purchase Order ID",
        "RepresentativeID": "Representative ID",
        "OrderNumber": "Order Number",
        "CustomerReference": "Customer Reference",
        "Status": "Status",
        "SupplierID": "Supplier ID",
        "ETADate": "ETA Date",
        "LJ__Internal": "LJ __ Internal",
        "LJ__SupplyLineProductID": "LJ __ Supply Line Product ID",
        "LJ__SupplyLineStatus": "LJ __ Supply Line Status",
        "LJ__SupplyLineMFDate": "LJ __ Supply Line MF Date",
        "LJ__SupplyLineDepartment": "LJ __ Supply Line Department",
        "LJ__CommitmentReason": "LJ __ Commitment Reason",
        "LJ__HandoverDate": "LJ __ Handover Date",
        "LJ__SalesRepID": "LJ __ Sales Rep ID",
        "LJ__DispatchDate": "LJ __ Dispatch Date",
        "LJ__DispatchBy": "LJ __ Dispatch By",
        "LJ__CompanyName": "LJ __ Company Name",
        "LJ__OrganisationType": "LJ __ Organisation Type",
        "LJ__AccountType": "LJ __ Account Type",
        "LJ__Tags": "LJ __ Tags",
        "LJ__InstallRequired": "LJ __ Install Required",
        "LJ__PickupRequired": "LJ __ Pickup Required",
        "LJ__DeliveryRequired": "LJ __ Delivery Required",
    },
    "defaultSetting": {
        "entityTitle": "Default Setting",
        "ID": "Record ID",
        "DefaultMarkupPercentage": "Default Markup Percentage",
        "QuoteExpireDays": "Quote Expire Days",
        "InvoiceDueDays": "Invoice Due Days",
        "DefaultCommitmentReason": "Default Commitment Reason",
        "DefaultCommitmentReasonID": "Commitment Reason",
        "PrimaryBusinessUnit": "Primary Business Unit",
        "PrimaryBusinessUnitID": "Business Unit",
        "DefaultPaymentTerms": "Default Payment Terms",
        "DefaultPaymentDue": "Default Payment Due",
        "MinDeposit": "Min Deposit",
        "FinancialYearStartDate": "Financial Year Start Date",
        "FinanceLockDate": "Finance Lock Date",
        "CommissionDate1Rule": "Commission Date 1 Rule",
        "CommissionDate1RuleByLine": "Commission Date 1 Rule By Line",
        "DefaultSupplierEmailTemplate": "Default Supplier Email Template",
        "DefaultSupplierEmailTemplateID": "Template",
        "DefaultBusinessUnitRule": "Default Business Unit Rule",
        "OrderCustomerRefRequired": "Order Customer Ref Required",
        "DefaultSettingID": "Default Setting ID",
        "SetupWizardCompleted": "Setup Wizard Completed",
        "DocumentStore": "Document Store",
        "TrackingEmailAddress": "Tracking Email Address",
        "ManufacturingETABuffer": "Manufacturing ETA Buffer",
        "Tracking_QuoteExpiryDays": "Tracking _ Quote Expiry Days",
        "Tracking_CMNotBookedDays": "Tracking _ CM Not Booked Days",
        "Tracking_CMNotConfirmedDays": "Tracking _ CM Not Confirmed Days",
        "Tracking_StockDuedDays": "Tracking _ Stock Dued Days",
        "Tracking_StockNotArrivedDays": "Tracking _ Stock Not Arrived Days",
        "Tracking_InstNotConfirmedDays": "Tracking _ Inst Not Confirmed Days",
        "Tracking_InstallerNotCompleteDays": "Tracking _ Installer Not Complete Days",
        "AutomationEnabled": "Automation Enabled",
        "SkillsEnabled": "Skills Enabled",
        "AutoCreateFinalPriceDiscountRules": "Auto Create Final Price Discount Rules to Lock Sale Prices",
        "DefaultMeasurementSystem": "Default Measurement System",
        "FinishEditMatchPriceMode": "Finish Edit Match Price Mode"
    },
    "opportunity": {
        "entityTitle": "Opportunity",
        "ID": "Record ID",
        "Code": "Code",
        "Description_abbrev": "Desc",
        "Description": "Description",
        "Status": "Status",
        "PipelineStage_abbrev": "Stage",
        "PipelineStage": "Pipeline Stage",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Company": "Company",
        "CompanyID": "Company",
        "SiteContact": "Site Contact",
        "SiteContactID": "Contact",
        "ExpectedRevenue_abbrev": "Exp Rev",
        "ExpectedRevenue": "Expected Revenue",
        "Representative_abbrev": "Rep",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "LeadGenerator_abbrev": "Generator",
        "LeadGenerator": "Lead Generator",
        "LeadGeneratorID": "Lead Generator",
        "ReferedBy_abbrev": "Ref By",
        "ReferedBy": "Referred By",
        "ReferedByID": "Referred By",
        "LeadDate": "Lead Date",
        "EstQuoteDate": "Est Quote Date",
        "ExpectedCloseDate": "Expected Close Date",
        "CloseDate": "Close Date",
        "AssignedDate": "Assigned Date",
        "Forecast": "Forecast",
        "VisitedShowroom": "Visited Showroom",
        "Address": "Address",
        "AddressID": "Address",
        "ProductsOfInterest": "Products Of Interest",
        "LeadSource": "Lead Source",
        "PL_LeadSourceID_abbrev": "Lead Source",
        "PL_LeadSourceID": "Lead Source",
        "ConfidenceLevel": "Confidence Level",
        "PL_OppConfidenceLevelID_abbrev": "Confidence Level",
        "PL_OppConfidenceLevelID": "Opp Confidence Level",
        "QuoteOutcomeReason": "Outcome Reason",
        "PL_QuoteOutcomeReasonID": "Outcome Reason",
        "QuoteOutcomeNotes": "Outcome Notes",
        "ExternalLead": "External Lead",
        "ExternalLeadID": "External Lead",
        "BusinessUnit": "Business Unit",
        "BusinessUnitID": "Business Unit",
        "Notes": "Notes",
        "GCLID": "GCLID",
        "FileNotes": "File Notes",
        "Jobs": "Jobs",
        "Tags": "Tags",
    },
    "team": {
        "entityTitle": "Team",
        "ID": "Record ID",
        "Name": "Name",
        "Active": "Active",
        "TeamID": "Team ID",
    },
    "accessRole": {
        "entityTitle": "Access Role",
        "ID": "Record ID",
        "RoleKey": "Role Key",
        "Name": "Name",
        "Active": "Active",
        "AccessRoleID": "Access Role ID",
    },
    "commissionRule": {
        "entityTitle": "Commission Rule",
        "ID": "Record ID",
        "Name": "Name",
        "Expression": "Expression",
        "TextValues": "Text Values",
        "ByJob": "By Job",
        "Users": "Users",
    },
    "commissionRuleUser": {
        "entityTitle": "Commission Rule User",
        "ID": "Record ID",
        "User": "User",
        "UserID": "Representative",
        "CommissionRule": "Commission Rule",
        "CommissionRuleID": "Commission Rule",
    },
    "contact": {
        "entityTitle": "Contact",
        "ID": "Record ID",
        "FirstName": "First Name",
        "LastName": "Last Name",
        "FullName": "Full Name",
        "JobTitle": "Job Title",
        "JobCategory": "Job Category",
        "PL_ContactJobCategoryID_abbrev": "Job Category",
        "PL_ContactJobCategoryID": "Contact Job Category",
        "WorkPhone": "Work Phone",
        "HomePhone": "Home Phone",
        "Mobile": "Mobile",
        "Email": "Email",
        "Notes": "Notes",
        "Address": "Address",
        "AddressID": "Address",
        "Company": "Company",
        "CompanyID": "Company",
        "FileNotes": "File Notes",
        "ContactID": "Contact ID",
        "FinanceIntegrationID": "Finance Integration ID",
        "ReceiveAutomatedEmail": "Receive Operational Email",
        "ReceiveAutomatedSMS": "Receive Operational SMS",
        "ReceiveAutomatedWhatsApp": "Receive Operational WhatsApp Message",
        "MarketingEmailOptOut": "Marketing Email Opt Out",
        "MarketingSMSOptOut": "Marketing SMS Opt Out",
        "MarketingWhatsAppOptOut": "Marketing WhatsApp Opt Out",
        "MarketingTelOptOut": "Marketing Tel Opt Out",
        "MarketingMailOptOut": "Marketing Mail Opt Out",
        "PreferredContactMethod": "Preferred Contact Method"
    },
    "fileNote": {
        "entityTitle": "File Note",
        "ID": "Record ID",
        "Date": "Date",
        "Notes": "Notes",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Company": "Company",
        "CompanyID": "Company",
        "Job": "Job",
        "JobID": "Job",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "ExternalLead": "External Lead",
        "ExternalLeadID": "External Lead",
        "FileNoteID": "File Note ID",
    },
    "productOfInterest": {
        "entityTitle": "Product Of Interest",
        "ID": "Record ID",
        "Qty": "Qty",
        "Full": "Full",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "ProductOfInterestID": "Product Of Interest ID",
        "Product": "Product",
        "PL_ProductOfInterestID": "Product Of Interest",
    },
    "commitmentReason": {
        "entityTitle": "Commitment Reason",
        "ID": "Record ID",
        "PL_CommitmentReasonID": "PL _ Commitment Reason ID",
        "Description": "Description",
        "Active": "Active",
    },
    "purchaseOrder": {
        "entityTitle": "Supply Job",
        "ID": "Record ID",
        "OrderNumber": "Order Number",
        "LinkedReference": "Linked Reference",
        "LinkedReferenceID": "Linked Reference ID",
        "CustomerReference_abbrev": "Cust. Ref",
        "CustomerReference": "Customer Reference",
        "ProductSummary": "Product Summary",
        "OrderDate": "Order Date",
        "CloseDate": "Close Date",
        "ETADate": "ETA Date",
        "DateReceived": "Date Received",
        "DateSent": "Date Sent",
        "UndoCancelState": "Undo Cancel State",
        "Status": "Status",
        "StatusDate": "Status Date",
        "InternalNotes": "Internal Notes",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Job": "Job",
        "JobID": "Job",
        "DeliveryAddress": "Delivery Address",
        "DeliveryAddressID": "Address",
        "BillingAddress": "Billing Address",
        "BillingAddressID": "Address",
        "OrderLines": "Order Lines",
        "SupplyNotes": "Supply Notes",
        "SupplierName": "Supplier Name",
        "SupplierID": "Supplier ID",
        "PurchaseOrderID": "Purchase Order ID",
        "JobType": "Job Type",
        "ItemID": "Item ID",
        "PriceListID": "Price List ID",
        "CompanyPriceMappings": "Company Price Mappings",
        "CompanyID": "Company ID",
        "ProjectCustomerPO": "Project Customer PO",
        "TaxRateOverridden": "Tax Rate Overridden"
    },
    "supplier": {
        "entityTitle": "Supplier",
        "ID": "Record ID",
        "Code": "Code",
        "Name": "Name",
        "Phone": "Phone",
        "Fax": "Fax",
        "Mobile": "Mobile",
        "Email": "Email",
        "WWW": "WWW",
        "SupplierID": "Supplier ID",
        "TaxRate": "Tax Rate",
        "Internal": "Internal",
        "SplitByProduct": "Split By Product",
        "InterfaceKey": "Interface File Type",
		"DeliveryAddressRule": "Delivery Address Rule",
		"IsMarketplaceLicensed": "Is Marketplace Licensed",
		"MarketplaceID": "Marketplace ID",
		"AccountID": "Account ID",
		"FabricTemplate": "Fabric Template",
		"FabricTemplateID": "Binary Data Field",
		"ComponentTemplate": "Component Template",
		"ComponentTemplateID": "Binary Data Field",
		"TemplatePrintType": "Template Print Type",
	},
	"jobLineService": {
		"entityTitle": "Job Line Service",
		"ID": "Record ID",
		"Job": "Job",
		"JobID": "Job",
		"JobLine": "Job Line",
		"JobLineID": "Job",
		"ChargeAmount": "Charge Amount",
		"ReasonNotes": "Reason Notes",
		"UserAtFault": "User At Fault",
		"UserAtFaultID": "Representative",
		"SupplierAtFault": "Supplier At Fault",
		"SupplierAtFaultID": "Supplier",
		"FaultReason": "Fault Reason",
		"PL_FaultReasonID_abbrev": "Fault Reason",
		"PL_FaultReasonID": "Fault Reason",
	},
	"invoice": {
		"entityTitle": "Invoice",
		"ID": "Record ID",
		"LinkedReference": "Linked Reference",
		"LinkedReferenceID": "Linked Reference ID",
		"InvoiceID": "Invoice ID",
		"InvoiceNo": "Invoice No",
		"InvoiceDate": "Invoice Date",
		"Contact": "Contact",
		"ContactID": "Contact",
		"Company": "Company",
		"CompanyID": "Company",
		"ProjectCustomerPO_abbrev": "Project/Cust PO",
		"ProjectCustomerPO": "Project Customer PO",
		"Locked": "Locked",
		"Representative": "Representative",
		"RepresentativeID": "Representative",
		"DateExported": "Date Exported",
		"Status": "Status",
		"FinanceArchived": "Finance Archived",
		"Job": "Job",
		"JobID": "Job",
		"DueDate": "Due Date",
		"CloseDate": "Close Date",
		"BillingAddress": "Billing Address",
		"BillingAddressID": "Address",
		"TaxRate": "Tax Rate",
		"TaxRateID": "Tax Rate",
		"FinanceExternalID": "Finance External ID",
		"CreditNote": "Credit Note",
		"CustomStatus": "Custom Status",
		"PL_CustomStatusID_abbrev": "Custom Status",
		"PL_CustomStatusID": "Job Custom Status",
		"BusinessUnit": "Business Unit",
		"BusinessUnitID": "Business Unit",
		"ChangeStatus": "Change Status",
		"InvoiceLines": "Invoice Lines",
		"DocumentVersion": "Document Version",
		"DocumentTemplateID": "Document Template ID",
		"ReportSettings": "Report Settings",
	},
	"companyPriceMapping": {
		"entityTitle": "Company Price Mapping",
		"ID": "Record ID",
		"Company": "Company",
		"CompanyID": "Company",
		"PriceListID": "Price List ID",
		"ProductID": "Product ID",
		"PriceList": "Price List",
		"Product": "Product",
		"Supplier": "Supplier",

    },
    "jobCustomStatus": {
        "entityTitle": "Job Custom Status",
        "ID": "Record ID",
        "PL_JobCustomStatusID": "PL _ Job Custom Status ID",
        "Description": "Description",
        "Active": "Active",
    },
    "activityCategory": {
        "entityTitle": "Activity Category",
        "ID": "Record ID",
        "PL_ActivityCategoryID": "PL _ Activity Category ID",
        "Description": "Description",
        "Active": "Active",
    },
    "reminder": {
        "entityTitle": "Reminder",
        "ID": "Record ID",
        "Message": "Message",
        "StartDate": "Start Date",
        "Job": "Job",
        "JobID": "Job",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "ReminderID": "Reminder ID",
    },
    "commissionRun": {
        "entityTitle": "Commission Run",
        "ID": "Record ID",
        "Description": "Description",
        "StartDate": "Start Date",
        "EndDate": "End Date",
        "Plan": "Plan",
        "PlanID": "Commission Plan",
        "LastRunBy": "Last Run By",
        "LastRunByID": "Representative",
        "PaidBy": "Paid By",
        "PaidByID": "Representative",
        "Paid": "Paid",
        "InProgress": "In Progress",
    },
    "activity": {
        "entityTitle": "Activity",
        "ID": "Record ID",
        "Subject": "Subject",
        "Start": "Start",
        "End": "End",
        "AllDay": "All Day",
        "Closed": "Closed",
        "Cancelled": "Cancelled",
        "CancelledReason": "Cancel Reason",
        "CancelledNotes": "Cancel Notes",
        "CancelledBy": "Cancelled By",
        "Notes": "Notes",
        "ProcessDetails": "Process Details",
        "ActivityType_abbrev": "Type",
        "ActivityType": "Activity Type",
        "Confirmed": "Confirmed",
        "IsInstall": "Is Install",
        "IsPickup": "Is Pickup",
        "IsDelivery": "Is Delivery",
        "IsService": "Is Service",
        "Category": "Category",
        "PL_ActivityCategoryID_abbrev": "Category",
        "PL_ActivityCategoryID": "Activity Category",
        "PL_CustomerAvailabilityID": "Customer Availability",
        "AutoScheduleLocked": "Auto Schedule Locked",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "Team": "Team",
        "TeamID": "Team",
        "Address": "Address",
        "AddressID": "Address",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Company": "Company",
        "CompanyID": "Company",
        "Job": "Job",
        "JobID": "Job",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "CreatedBy": "Created By",
        "CreatedByID": "Representative",
        "CreatedOn": "Created On",
        "Priority": "Priority",
        "Attendees": "Attendees",
        "JobLines": "Job Lines",
        "TagData": "Tag Data",
        "ActivityID": "Activity ID",
        "Address": {
            "entityTitle": "Address",
            "ID": "Record ID",
            "AddressLines": "Address Lines",
            "City": "City",
            "State": "State",
            "Postcode": "Postcode",
            "Country": "Country",
            "Location": "Location",
            "PosLong": "Pos Long",
            "PosLat": "Pos Lat",
            "AddressID": "Address ID",
            "Formatted": "Formatted",
        },
    },
    "currentActivity": {
        "entityTitle": "Current Activity",
        "ID": "Record ID",
        "ActivityID": "Activity ID",
        "JobID": "Job ID",
        "JobLineID": "Job Line ID",
        "ActiveTypeID": "Active Type ID",
        "ActiveCategoryID": "Active Category ID",
        "ActivityType": "Activity Type",
        "Representative": "Representative",
        "RepresentativeID": "Representative ID",
        "Team": "Team",
        "TeamID": "Team ID",
        "Subject": "Subject",
        "Priority": "Priority",
        "Confirmed": "Confirmed",
        "Closed": "Closed",
        "ContactID": "Contact ID",
        "PL_ActivityCategoryID": "PL _ Activity Category ID",
        "Start": "Start",
        "CreatedOn": "Created On",
    },
    "taxRate": {
        "entityTitle": "Tax Rate",
        "ID": "Record ID",
        "Rate_abbrev": "Rate %",
        "Rate": "Rate",
        "Description": "Description",
        "TaxRateID": "Tax Rate ID",
        "Active": "Active",
    },
    "discountLevel": {
        "entityTitle": "Discount Level",
        "ID": "Record ID",
        "Description": "Description",
        "Code": "Code",
        "Type": "Type",
        "Active": "Active",
        "ApplyToCost": "Applies To My Cost",
        "DiscountLevelID": "Discount Level ID",
        "DicountItems": "Dicount Items",
        "CompanyDiscounts": "Company Discounts",
        "Supplier": "Supplier",
        "SupplierID": "Supplier",
    },
    "companyDiscount": {
        "entityTitle": "Company Discount",
        "ID": "Record ID",
        "DiscountLevel": "Discount Level",
        "DiscountLevelID": "Discount Level",
        "Company": "Company",
        "CompanyID": "Company",
    },
    "discountItem": {
        "entityTitle": "Discount Item",
        "ID": "Record ID",
        "Active": "Active",
        "Start": "Start",
        "Finish": "Finish",
        "ApplyToBase": "Apply To Base",
        "ApplyToOptions": "Apply To Options",
        "ApplyToDelivery": "Apply To Delivery",
        "ApplyToInstallation": "Apply To Installation",
        "Percentage": "Percentage",
        "Amount": "Amount",
        "DiscountLevel": "Discount Level",
        "DiscountLevelID": "Discount Level",
        "ProductID": "Product ID",
        "Supplier": "Supplier",
        "Product": "Product",
        "Option1": "Option 1",
        "Option1ID": "Option 1 ID",
        "Option2ID": "Option 2 ID",
        "Option2": "Option 2",
        "Option1ValueID": "Option 1 Value ID",
        "Option1Value": "Option 1 Value",
        "Option2ValueID": "Option 2 Value ID",
        "Option2Value": "Option 2 Value",
        "Option1GroupCode": "Option 1 Group Code",
        "Option2GroupCode": "Option 2 Group Code",
        "DiscountItemID": "Discount Item ID",
    },
    "printSetting": {
        "entityTitle": "Print Setting",
        "ID": "Record ID",
        "Name": "Name",
        "ProductPrintSettings": "Product Print Settings",
    },
    "paymentMethod": {
        "entityTitle": "Payment Method",
        "ID": "Record ID",
        "PL_PaymentMethodID": "PL _ Payment Method ID",
        "Description": "Description",
        "Active": "Active",
    },
    "jobDiscountRule": {
        "entityTitle": "Job Discount Rule",
        "ID": "Record ID",
        "Job": "Job",
        "JobID": "Job",
        "TaxIncluded": "Tax Included",
        "IsPercentage": "Is Percentage",
        "Level": "Level",
        "Type": "Type",
        "PriceType": "Price Type",
        "AmountType": "Amount Type",
        "ProductID": "Product ID",
        "JobLineID": "Job Line ID",
        "ProductOptionID": "Product Option ID",
        "ProductOptionValueID": "Product Option Value ID",
        "Value": "Value",
    },
    "lookupTableItem": {
        "entityTitle": "Lookup Table Item",
        "ID": "Record ID",
        "LookupTable": "Lookup Table",
        "LookupTableID": "Lookup Table",
        "Notes": "Notes",
        "From": "From",
        "To": "To",
        "Text": "Text",
        "ProductID": "Product ID",
        "RepresentativeID": "Representative ID",
        "Value": "Value",
    },
    "commissionPlan": {
        "entityTitle": "Commission Plan",
        "ID": "Record ID",
        "Description": "Description",
        "Rules": "Rules",
    },
    "commissionPlanRule": {
        "entityTitle": "Commission Plan Rule",
        "ID": "Record ID",
        "CommissionPlan": "Commission Plan",
        "CommissionPlanID": "Commission Plan",
        "CommissionRule": "Commission Rule",
        "CommissionRuleID": "Commission Rule",
    },
    "document": {
        "entityTitle": "Document",
        "ID": "Record ID",
        "Job": "Job",
        "JobID": "Job",
        "JobLineID": "Job Line",
        "SupplyJob": "Supply Job",
        "SupplyJobID": "Supply Job",
        "SupplyJobLineID": "Supply Job Line",
        "Signed": "Signed",
        "SendToCustomer": "Send To Customer",
        "SendToSupplier": "Send To Supplier",
        "SendToSuppierID": "Send To Suppier ID",
        "Uri": "Uri",
        "Description": "Description",
        "Tag": "Tag",
        "Protected": "Protected",
        "DocumentID": "Document ID",
        "Version": "Version",
        "DocumentDate_abbrev": "Date",
        "DocumentDate": "Document Date",
    },
    "supplySheetTemplate": {
        "entityTitle": "Supply Sheet Template",
        "ID": "Record ID",
        "Supplier": "Supplier",
        "SupplierID": "Supplier",
        "Uri": "Uri",
        "Description": "Description",
        "Tag": "Tag",
        "Protected": "Protected",
        "DocumentID": "Document ID",
        "Version": "Version",
        "DocumentDate": "Document Date",
        "Date": "Date",
    },
    "notification": {
        "entityTitle": "Notification",
        "ID": "Record ID",
        "Subject": "Subject",
        "Message": "Message",
        "Expiry": "Expiry",
        "StartDate": "Start Date",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
        "NotificationID": "Notification ID",
    },
    "binaryDataField": {
        "entityTitle": "Binary Data Field",
        "ID": "Record ID",
        "Data": "Data",
    },
    "commissionAccountTx": {
        "entityTitle": "Commission Account Tx",
        "ID": "Record ID",
        "Date": "Date",
        "User": "User",
        "UserID": "Representative",
        "Run": "Run",
        "RunID": "Commission Run",
        "Type": "Type",
        "Description": "Description",
        "Status": "Status",
        "Amount": "Amount",
        "Notes": "Notes",
        "Details": "Details",
    },
    "commissionAccountTxDetail": {
        "entityTitle": "Commission Account Tx Detail",
        "ID": "Record ID",
        "Transaction": "Transaction",
        "TransactionID": "Commission Account Tx",
        "Job": "Job",
        "JobID": "Job",
        "Values": "Values",
    },
    "quoteTrackingView": {
        "entityTitle": "Quote Tracking View",
        "ID": "Record ID",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "Tags": "Tags",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "BusinessUnit": "Business Unit",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "QuoteDate": "Quote Date",
        "City": "City",
        "SalesArea": "Sales Area",
        "InstallArea": "Install Area",
        "Paid": "Paid",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "DaysSinceSent": "Days Since Sent",
        "DaysToExpiry": "Days To Expiry",
        "IsActive": "Is Active",
        "IsOpen": "Is Open",
        "IsExpired": "Is Expired",
        "IsSent": "Is Sent",
        "IsLost": "Is Lost",
        "CommitReason": "Commit Reason",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
    },
    "activeJobTrackingView": {
        "entityTitle": "Active Job Tracking View",
        "ID": "Record ID",
        "Reference": "Reference",
        "SalesRep": "Sales Rep",
        "SalesRepMobile": "Sales Rep Mobile",
        "SalesRepID": "Sales Rep ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "OpportunityID": "Opportunity ID",
        "Contact": "Contact",
        "ContactEmail": "Contact Email",
        "ContactID": "Contact ID",
        "SiteContact": "Site Contact",
        "SiteContactID": "Site Contact ID",
        "City": "City",
        "SalesArea": "Sales Area",
        "InstallArea": "Install Area",
        "CommitReason": "Commit Reason",
        "BusinessUnit": "Business Unit",
        "JobType": "Job Type",
        "Status": "Status",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "Paid": "Paid",
        "InvoicedAmount": "Invoiced Amount",
        "InvoicedAmountIncTax": "Invoiced Amount Inc Tax",
        "UnInvoicedAmount": "Uninvoiced Amount",
        "UnInvoicedAmountIncTax": "Uninvoiced Amount Inc Tax",
        "ETA": "ETA",
        "OrderDate": "Order Date",
        "SalePrice": "Sale Price",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "Stage": "Stage",
        "Stages": "Stages",
        "Products": "Products",
        "Dispatch": "Dispatch",
        "Tags": "Tags",
    },
    "opportunityTrackingView": {
        "entityTitle": "Opportunity Tracking View",
        "ID": "Record ID",
        "ID": "ID",
        "Description": "Description",
        "LeadDate": "Lead Date",
        "Forecast": "Forecast",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "LeadSource": "Lead Source",
        "PipelineStage_abbrev": "Stage",
        "PipelineStage": "Pipeline Stage",
        "Status": "Status",
        "ConfidenceLevel": "Confidence Level",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Representative": "Representative",
        "RepresentativeID": "Representative ID",
        "BusinessUnit": "Business Unit",
        "SalesArea": "Sales Area",
        "InstallArea": "Install Area",
        "Tags": "Tags",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "SiteContactID": "Site Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "ExpectedRevenue_abbrev": "Forcast Amount",
        "ExpectedRevenue": "Expected Revenue",
        "ActivityID": "Activity ID",
        "ActivityContactID": "Activity Contact ID",
        "ActivityType": "Activity Type",
        "ActivityClosed": "Activity Closed",
        "ActivityConfirmed": "Activity Confirmed",
        "ActivityPriority": "Activity Priority",
        "ActivityStart": "Activity Start",
        "ActivitySubject": "Activity Subject",
        "Notes": "Notes",
    },
    "mFSchedulingTrackingView": {
        "entityTitle": "MF Scheduling Tracking View",
        "ID": "Record ID",
        "PurchaseOrderID": "Purchase Order ID",
        "OrderNumber": "Order Number",
        "JobID": "Job ID",
        "Job": "Job",
        "CustomerReference": "Customer Reference",
        "Contact": "Contact",
        "ContactID": "Contact ID",
        "Company": "Company",
        "CompanyID": "Company ID",
        "Supplier": "Supplier",
        "CommitReason": "Commit Reason",
        "BusinessUnit": "Business Unit",
        "Product": "Product",
        "Department": "Department",
        "DispatchDate": "Dispatch Date",
        "ETADate": "ETA Date",
        "Status": "Status",
        "MFDate": "MF Date",
        "OrderDate": "Order Date",
        "Internal": "Internal",
        "Qty": "Qty",
        "JobQty": "Job Qty",
        "DispatchDays": "Dispatch Days",
        "Age": "Age",
        "IDs": "I Ds",
        "SupplyNotes": "Supply Notes",
    },
    "job": {
        "entityTitle": "Job",
        "ID": "Record ID",
        "JobID": "Job ID",
        "QuoteExpiryDate_abbrev": "Expiry Date",
        "QuoteExpiryDate": "Quote Expiry Date",
        "HandoverDate": "Handover Date",
        "QuoteSentDate_abbrev": "Quote Sent",
        "QuoteSentDate": "Quote Sent Date",
        "Forecasted": "Forecasted",
        "IsConfirmed": "Is Confirmed",
        "IsClosed": "Is Closed",
        "IsLost": "Is Lost",
        "IgnoreDepositLimit": "Ignore Deposit Limit",
        "TaxRateOverridden": "Tax Rate Overridden",
        "Status": "Status",
        "PaymentTerms": "Payment Terms",
        "DefaultPaymentDue": "Default Payment Due",
        "InvoiceDueDays": "Invoice Due Days",
        "SupplyNotes": "Supply Notes",
        "Reference": "Reference",
        "LinkedReference": "Linked Reference",
        "LinkedReferenceID": "Linked Reference ID",
        "ProjectCustomerPO_abbrev": "Project/Cust PO",
        "ProjectCustomerPO": "Project Customer PO",
        "DispatchSummary": "Dispatch Summary",
        "ProductSummary": "Product Summary",
        "StageSummary": "Stage Summary",
        "JobDate": "Job Date",
        "CloseDate": "Close Date",
        "ETADate": "ETA Date",
        "EstETADate": "Est ETA Date",
        "OrderDate": "Order Date",
        "Stage": "Stage",
        "JobType": "Job Type",
        "Priority": "Priority",
        "ShowroomQuote": "Showroom Quote",
        "InstallNotes": "Install Notes",
        "InternalNotes": "Internal Notes",
        "CustomerNotes": "Customer Notes",
        "PriceChangedWarning": "Price Changed Warning",
        "ProductOrder": "Product Order",
        "SalesRep": "Sales Rep",
        "SalesRepID": "Representative",
        "MarginApproved": "Margin Approved",
        "MarginApprovedBy": "Margin Approved By",
        "MarginApprovedByID": "Representative",
        "MarginApprovalRequired": "Margin Approval Required",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "Address": "Address",
        "AddressID": "Address",
        "DeliveryAddress": "Delivery Address",
        "DeliveryAddressID": "Address",
        "Contact": "Contact",
        "ContactID": "Contact",
        "SiteContact": "Site Contact",
        "SiteContactID": "Contact",
        "Parent": "Parent",
        "ParentID": "Job",
        "ParentGroupKey": "Parent Group Key",
        "Company": "Company",
        "CompanyID": "Company",
        "TaxRate": "Tax Rate",
        "TaxRateID": "Tax Rate",
        "Actions": "Actions",
        "ActionsID": "Advanced Filters . Views . IV _ Job Actions",
        "JobLines": "Job Lines",
        "DiscountRules": "Discount Rules",
        "CustomStatus": "Custom Status",
        "InstallationRule": "Installation Rule",
        "PL_CustomStatusID_abbrev": "Custom Status",
        "PL_CustomStatusID": "Job Custom Status",
        "CommitmentReason": "Commitment Reason",
        "PL_CommitmentReasonID_abbrev": "Commit Reason",
        "PL_CommitmentReasonID": "Commitment Reason",
        "BusinessUnit": "Business Unit",
        "BusinessUnitID": "Business Unit",
        "NoSalesCommission": "No Sales Commission",
        "FileNotes": "File Notes",
        "Documents": "Documents",
        "Tags": "Tags",
        "ReportSettings": "Report Settings",
        "Tracking": "Tracking",
        "TrackingID": "Tracking",
        "ReceiveAutomatedEmail": "Receive Operational Email",
        "ReceiveAutomatedSMS": "Receive Operational SMS",
        "ItemID": "Item ID",
        "PriceListID": "Price List ID",
        "CompanyPriceMappings": "Company Price Mappings",
        "PlannedInstallerID": "Planned Installer",
        "CustomerPO": "Customer PO",
        "CustomerPOContact": "Customer PO Contact"
    },
    "faultReason": {
        "entityTitle": "Fault Reason",
        "ID": "Record ID",
        "PL_FaultReasonID": "PL _ Fault Reason ID",
        "Description": "Description",
        "Active": "Active",
    },
    "lookupTable": {
        "entityTitle": "Lookup Table",
        "ID": "Record ID",
        "Name": "Name",
    },
    "teamRep": {
        "entityTitle": "Team Rep",
        "ID": "Record ID",
        "Team": "Team",
        "TeamID": "Team",
        "Rep": "Rep",
        "RepID": "Representative",
    },
    "projectTemplate": {
        "entityTitle": "Project Template",
        "ID": "Record ID",
        "Description": "Description",
        "ProjectTemplateID": "Project Template ID",
        "Stages": "Stages",
    },
    "projectStage": {
        "entityTitle": "Project Stage",
        "ID": "Record ID",
        "Description": "Description",
        "ActivityType": "Activity Type",
        "SortOrder": "Sort Order",
        "ActivityCategory": "Activity Category",
        "PL_ActivityCategoryID": "Activity Category",
        "ProjectTemplate": "Project Template",
        "ProjectTemplateID": "Project Template",
        "ProjectStageID": "Project Stage ID",
    },
    "projectStageView": {
        "entityTitle": "Project Stage View",
        "ID": "Record ID",
        "ProjectTemplateID": "Project Template ID",
        "JobLineID": "Job Line ID",
        "JobID": "Job ID",
        "Stage_0": "Stage _0",
        "Stage_1": "Stage _1",
        "Stage_2": "Stage _2",
        "Stage_3": "Stage _3",
        "Stage_4": "Stage _4",
        "Stage_5": "Stage _5",
        "Stage_6": "Stage _6",
        "Stage_7": "Stage _7",
        "Stage_8": "Stage _8",
        "Stage_9": "Stage _9",
        "Stage_10": "Stage _10",
        "Stage_11": "Stage _11",
        "Stage_12": "Stage _12",
        "Stage_13": "Stage _13",
        "Stage_14": "Stage _14",
        "Stage_15": "Stage _15",
        "Stage_16": "Stage _16",
        "Stage_17": "Stage _17",
        "Stage_18": "Stage _18",
        "Stage_19": "Stage _19",
        "Stage_20": "Stage _20",
        "Stage_21": "Stage _21",
        "Stage_22": "Stage _22",
        "Stage_23": "Stage _23",
        "Stage_24": "Stage _24",
        "Stage_25": "Stage _25",
        "Stage_26": "Stage _26",
        "Stage_27": "Stage _27",
        "Stage_28": "Stage _28",
        "Stage_29": "Stage _29",
        "Stage_30": "Stage _30",
        "Stage_0_ID": "Stage _0_ ID",
        "Stage_1_ID": "Stage _1_ ID",
        "Stage_2_ID": "Stage _2_ ID",
        "Stage_3_ID": "Stage _3_ ID",
        "Stage_4_ID": "Stage _4_ ID",
        "Stage_5_ID": "Stage _5_ ID",
        "Stage_6_ID": "Stage _6_ ID",
        "Stage_7_ID": "Stage _7_ ID",
        "Stage_8_ID": "Stage _8_ ID",
        "Stage_9_ID": "Stage _9_ ID",
        "Stage_10_ID": "Stage _10_ ID",
        "Stage_11_ID": "Stage _11_ ID",
        "Stage_12_ID": "Stage _12_ ID",
        "Stage_13_ID": "Stage _13_ ID",
        "Stage_14_ID": "Stage _14_ ID",
        "Stage_15_ID": "Stage _15_ ID",
        "Stage_16_ID": "Stage _16_ ID",
        "Stage_17_ID": "Stage _17_ ID",
        "Stage_18_ID": "Stage _18_ ID",
        "Stage_19_ID": "Stage _19_ ID",
        "Stage_20_ID": "Stage _20_ ID",
        "Stage_21_ID": "Stage _21_ ID",
        "Stage_22_ID": "Stage _22_ ID",
        "Stage_23_ID": "Stage _23_ ID",
        "Stage_24_ID": "Stage _24_ ID",
        "Stage_25_ID": "Stage _25_ ID",
        "Stage_26_ID": "Stage _26_ ID",
        "Stage_27_ID": "Stage _27_ ID",
        "Stage_28_ID": "Stage _28_ ID",
        "Stage_29_ID": "Stage _29_ ID",
        "Stage_30_ID": "Stage _30_ ID",
        "Stage_0_Closed": "Stage _0_ Closed",
        "Stage_1_Closed": "Stage _1_ Closed",
        "Stage_2_Closed": "Stage _2_ Closed",
        "Stage_3_Closed": "Stage _3_ Closed",
        "Stage_4_Closed": "Stage _4_ Closed",
        "Stage_5_Closed": "Stage _5_ Closed",
        "Stage_6_Closed": "Stage _6_ Closed",
        "Stage_7_Closed": "Stage _7_ Closed",
        "Stage_8_Closed": "Stage _8_ Closed",
        "Stage_9_Closed": "Stage _9_ Closed",
        "Stage_10_Closed": "Stage _10_ Closed",
        "Stage_11_Closed": "Stage _11_ Closed",
        "Stage_12_Closed": "Stage _12_ Closed",
        "Stage_13_Closed": "Stage _13_ Closed",
        "Stage_14_Closed": "Stage _14_ Closed",
        "Stage_15_Closed": "Stage _15_ Closed",
        "Stage_16_Closed": "Stage _16_ Closed",
        "Stage_17_Closed": "Stage _17_ Closed",
        "Stage_18_Closed": "Stage _18_ Closed",
        "Stage_19_Closed": "Stage _19_ Closed",
        "Stage_20_Closed": "Stage _20_ Closed",
        "Stage_21_Closed": "Stage _21_ Closed",
        "Stage_22_Closed": "Stage _22_ Closed",
        "Stage_23_Closed": "Stage _23_ Closed",
        "Stage_24_Closed": "Stage _24_ Closed",
        "Stage_25_Closed": "Stage _25_ Closed",
        "Stage_26_Closed": "Stage _26_ Closed",
        "Stage_27_Closed": "Stage _27_ Closed",
        "Stage_28_Closed": "Stage _28_ Closed",
        "Stage_29_Closed": "Stage _29_ Closed",
        "Stage_30_Closed": "Stage _30_ Closed",
    },
    "projectTrackingViewGrid": {
        "entityTitle": "Project Tracking View Grid",
        "ID": "Record ID",
        "ID": "ID",
        "JobID": "Job ID",
        "Reference": "Reference",
        "Company": "Company",
        "SiteContact": "Site Contact",
        "CustomStatus": "Custom Status",
        "ProjectCustomerPO": "Project Customer PO",
        "SiteAddress": "Site Address",
        "SalesRep": "Sales Rep",
        "SalesRepID": "Sales Rep ID",
        "Tags": "Tags",
        "HandoverDate": "Handover Date",
        "ProjectTemplateID": "Project Template ID",
        "CompanyID": "Company ID",
        "SiteContactID": "Site Contact ID",
        "OpportunityID": "Opportunity ID",
        "SiteAddressID": "Site Address ID",
        "ETA": "ETA",
        "SalePrice": "Sale Price",
        "ContactEmail": "Contact Email",
        "StageDate_0": "Stage Date _0",
        "StageDate_1": "Stage Date _1",
        "StageDate_2": "Stage Date _2",
        "StageDate_3": "Stage Date _3",
        "StageDate_4": "Stage Date _4",
        "StageDate_5": "Stage Date _5",
        "StageDate_6": "Stage Date _6",
        "StageDate_7": "Stage Date _7",
        "StageDate_8": "Stage Date _8",
        "StageDate_9": "Stage Date _9",
        "StageID_0": "Stage ID _0",
        "StageID_1": "Stage ID _1",
        "StageID_2": "Stage ID _2",
        "StageID_3": "Stage ID _3",
        "StageID_4": "Stage ID _4",
        "StageID_5": "Stage ID _5",
        "StageID_6": "Stage ID _6",
        "StageID_7": "Stage ID _7",
        "StageID_8": "Stage ID _8",
        "StageID_9": "Stage ID _9",
        "Action_CanMoveToSupply": "Action _ Can Move To Supply",
        "Action_CanResendToSupply": "Action _ Can Resend To Supply",
        "Action_CanUpdateETA": "Action _ Can Update ETA",
        "Action_CanReceiptGoods": "Action _ Can Receipt Goods",
        "Action_CanInvoice": "Action _ Can Invoice",
        "Products": "Products",
    },
    "projectTrackingView": {
        "entityTitle": "Project Tracking View",
        "ID": "Record ID",
        "JobID": "Job ID",
        "ProductID": "Product ID",
        "ProductName": "Product Name",
        "Stage": "Stage",
        "Reference": "Reference",
        "Company": "Company",
        "SiteContact": "Site Contact",
        "ContactEmail": "Contact Email",
        "CustomStatus": "Custom Status",
        "ProjectCustomerPO": "Project Customer PO",
        "SiteAddress": "Site Address",
        "SalesRep": "Sales Rep",
        "SalesRepID": "Sales Rep ID",
        "Tags": "Tags",
        "HandoverDate": "Handover Date",
        "ProjectTemplateID": "Project Template ID",
        "CompanyID": "Company ID",
        "SiteContactID": "Site Contact ID",
        "OpportunityID": "Opportunity ID",
        "SiteAddressID": "Site Address ID",
        "Action_CanMoveToSupply": "Action _ Can Move To Supply",
        "Action_CanResendToSupply": "Action _ Can Resend To Supply",
        "Action_CanUpdateETA": "Action _ Can Update ETA",
        "Action_CanReceiptGoods": "Action _ Can Receipt Goods",
        "Action_CanInvoice": "Action _ Can Invoice",
        "ETA": "ETA",
        "Qty": "Qty",
        "SalePrice": "Sale Price",
        "StageID_0": "Stage ID _0",
        "StageID_1": "Stage ID _1",
        "StageID_2": "Stage ID _2",
        "StageID_3": "Stage ID _3",
        "StageID_4": "Stage ID _4",
        "StageID_5": "Stage ID _5",
        "StageID_6": "Stage ID _6",
        "StageID_7": "Stage ID _7",
        "StageID_8": "Stage ID _8",
        "StageID_9": "Stage ID _9",
        "StageDate_0": "Stage Date _0",
        "StageDate_1": "Stage Date _1",
        "StageDate_2": "Stage Date _2",
        "StageDate_3": "Stage Date _3",
        "StageDate_4": "Stage Date _4",
        "StageDate_5": "Stage Date _5",
        "StageDate_6": "Stage Date _6",
        "StageDate_7": "Stage Date _7",
        "StageDate_8": "Stage Date _8",
        "StageDate_9": "Stage Date _9",
        "Adv_Q_P_0": "Adv _ Q _ P _0",
    },
    "mFDepartment": {
        "entityTitle": "MF Department",
        "ID": "Record ID",
        "PL_MFDepartmentID": "PL _ MF Department ID",
        "Description": "Description",
        "Active": "Active",
    },
    "journalEntry": {
        "entityTitle": "Journal Entry",
        "ID": "Record ID",
        "EntryDate": "Entry Date",
        "TransferDate": "Transfer Date",
        "Amount": "Amount",
        "Tax": "Tax",
        "Type": "Type",
        "Notes": "Notes",
        "JournalEntryID": "Journal Entry ID",
        "GroupID": "Group ID",
        "TaxRate": "Tax Rate",
        "TaxRateID": "Tax Rate",
    },
    "financeJournal": {
        "entityTitle": "Finance Journal",
        "ID": "Record ID",
        "EntryDate": "Entry Date",
        "TransferDate": "Transfer Date",
        "Amount": "Amount",
        "Tax": "Tax",
        "Type": "Type",
        "Notes": "Notes",
        "FinanceJournalID": "Finance Journal ID",
        "GroupID": "Group ID",
        "TaxRate": "Tax Rate",
        "TaxRateID": "Tax Rate",
        "ItemID": "Item ID",
        "ItemPrompt": "Item Prompt",
        "ContactID": "Contact ID",
        "PaymentID": "Payment ID",
        "JobID": "Job ID",
        "InvoiceID": "Invoice ID",
    },
    "orderLineLocation": {
        "entityTitle": "Order Line Location",
        "ID": "Record ID",
        "PL_OrderLineLocationID": "PL _ Order Line Location ID",
        "Description": "Description",
        "Active": "Active",
    },
    "quoteOutcomeReason": {
        "entityTitle": "Outcome Reason",
        "ID": "Record ID",
        "PL_QuoteOutcomeReasonID": "PL _ Outcome Reason ID",
        "Description": "Description",
        "Active": "Active",
    },
    "oppConfidenceLevel": {
        "entityTitle": "Opp Confidence Level",
        "ID": "Record ID",
        "PL_OppConfidenceLevelID": "PL _ Opp Confidence Level ID",
        "Description": "Description",
        "Active": "Active",
    },
    "jobLine": {
        "entityTitle": "Product Line",
        "ID": "Record ID",
        "JobLineNo_abbrev": "Line No",
        "JobLineNo": "Job Line No",
        "OrderDate": "Order Date",
        "ETA": "ETA",
        "Width": "Width",
        "Drop": "Drop",
        "Qty": "Qty",
        "Price": "Price",
        "PriceTax": "Price Tax",
        "PriceIncTax": "Price Inc Tax",
        "SalePrice": "Sale Price",
        "SalePriceTax": "Sale Price Tax",
        "SalePriceIncTax": "Sale Price Inc Tax",
        "BasePrice": "Base Price",
        "BaseCost": "Base Cost",
        "InstallPrice": "Install Price",
        "InstallCost": "Install Cost",
        "OptionsPrice": "Options Price",
        "OptionsCost": "Options Cost",
        "DeliveryPrice": "Delivery Price",
        "DeliveryCost": "Delivery Cost",
        "AdjustmentPrice": "Adjustment Price",
        "AdjustmentCost": "Adjustment Cost",
        "CostPrice": "Cost Price",
        "CostPriceTax": "Cost Price Tax",
        "CostPriceIncTax": "Cost Price Inc Tax",
        "OriginalCostPrice": "Original Cost Price",
        "OriginalCostPriceTax": "Original Cost Price Tax",
        "OriginalCostPriceIncTax": "Original Cost Price Inc Tax",
        "WidthMeasurements": "Width Measurements",
        "DropMeasurements": "Drop Measurements",
        "UndoCancelState": "Undo Cancel State",
        "SupportsOptimisation": "Supports Optimisation",
        "Job": "Job",
        "JobID": "Job",
        "SplitParent": "Split Parent",
        "SplitParentID": "Job Line",
        "JobLineService": "Job Line Service",
        "JobLineServiceID": "Job Line Service",
        "RequireCheckMeasure": "Require Check Measure",
        "CM_Approved": "CM _ Approved",
        "Invoiced": "Invoiced",
        "SupplyJobCreated": "Supply Job Created",
        "RequireInstall": "Require Install",
        "RequireDelivery": "Require Delivery",
        "RequirePickup": "Require Pickup",
        "RequireService": "Require Service",
        "Inst_Completed": "Inst _ Completed",
        "EstInstallTime": "Est Install Time",
        "EstCheckMeasureTime": "Est Check Measure Time",
        "IsService": "Is Service",
        "Srvc_Completed": "Srvc _ Completed",
        "QtyReceived": "Qty Received",
        "LocationOther_abbrev": "Location/Desc",
        "LocationOther": "Location Other",
        "ProductName": "Product Name",
        "ProductCode": "Product Code",
        "ProductID": "Product ID",
        "SupplierName": "Supplier Name",
        "ProductVersion": "Product Version",
        "PriceListVersion": "Price List Version",
        "SortIndex": "Sort Index",
        "SupplierID": "Supplier",
        "Notes": "Notes",
        "SupplyNotes": "Supply Notes",
        "InstallationNotes": "Installation Notes",
        "SalesTaxRate": "Sales Tax Rate",
        "CostTaxRate": "Cost Tax Rate",
        "PreviousStage": "Previous Stage",
        "DispatchStage": "Dispatch Stage",
        "Status": "Status",
        "Stage": "Stage",
        "LineType": "Line Type",
        "StageDate": "Stage Date",
        "OrderLineOptionsData": "Order Line Options Data",
        "JobLineID": "Job Line ID",
        "ValidationErrors": "Validation Errors",
        "DisplayOption1": "Display Option 1",
        "DisplayOption2": "Display Option 2",
        "DisplayOption3": "Display Option 3",
        "DisplayOption4": "Display Option 4",
        "DisplayOption5": "Display Option 5",
        "DisplayOption6": "Display Option 6",
        "DisplayOption7": "Display Option 7",
        "DisplayOption8": "Display Option 8",
        "DisplayOption9": "Display Option 9",
        "DisplayOption10": "Display Option 10",
        "IsConfirmed": "Is Confirmed",
        "IsDispatched": "Is Dispatched",
        "HasActiveService": "Has Active Service",
        "CommissionDate1": "Commission Date 1",
        "CommissionDate2": "Commission Date 2",
        "CommissionDate3": "Commission Date 3",
        "CommissionDate4": "Commission Date 4",
        "CommissionDate5": "Commission Date 5",
        "GroupKey": "Group Key",
        "PriceModel": "Price Model",
        "RelatedPOLines": "Related PO Lines",
        "LineNo": "Line No",
        "ItemID": "Item ID",
        "LineItemID": "Line Item ID",
        "RestockNotes": "Restock Notes",
        "PL_StockLocationID": "Stock Location",
        "StockLocation": "Stock Location"
    },
    "jobLineInfo": {
        "entityTitle": "Job Line Info",
        "ID": "Record ID",
        "JobID": "Job ID",
        "CheckMeasureID": "Check Measure ID",
        "CM_PL_ActivityCategoryID": "CM _ PL _ Activity Category ID",
        "CM_ActivityType": "CM _ Activity Type",
        "CM_Representative": "CM _ Representative",
        "CM_RepresentativeID": "CM _ Representative ID",
        "CM_Team": "CM _ Team",
        "CM_TeamID": "CM _ Team ID",
        "CM_Subject": "CM _ Subject",
        "CM_Priority": "CM _ Priority",
        "CM_Confirmed": "CM _ Confirmed",
        "CM_Closed": "CM _ Closed",
        "CM_ContactID": "CM _ Contact ID",
        "CM_Start": "CM _ Start",
        "CM_CreatedOn": "CM _ Created On",
        "InstallID": "Install ID",
        "IA_PL_ActivityCategoryID": "IA _ PL _ Activity Category ID",
        "IA_ActivityType": "IA _ Activity Type",
        "IA_RepresentativeID": "IA _ Representative ID",
        "IA_Representative": "IA _ Representative",
        "IA_TeamID": "IA _ Team ID",
        "IA_Team": "IA _ Team",
        "IA_Subject": "IA _ Subject",
        "IA_Priority": "IA _ Priority",
        "IA_Confirmed": "IA _ Confirmed",
        "IA_Closed": "IA _ Closed",
        "IA_ContactID": "IA _ Contact ID",
        "IA_Start": "IA _ Start",
        "IA_CreatedOn": "IA _ Created On",
        "Tracking_IsNotValid": "Tracking _ Is Not Valid",
    },
    "templateResponse": {
        "entityTitle": "Template Response",
        "ID": "Record ID",
        "Template": "Template",
        "TemplateID": "Template ID",
        "Condition": "Condition",
        "Value": "Value",
        "Action": "Action",
        "ResponseTimeout": "Response Timeout",
        "ModifyTags": "Modify Tags",
        "TagAction": "Tag Action",
        "Tags": "Tags",
    },
    "templateParam": {
        "entityTitle": "Template Param",
        "ID": "Record ID",
        "Template": "Template",
        "TemplateID": "Template ID",
        "Name": "Name",
        "Value": "Value"
    },
    "paymentAllocation": {
        "entityTitle": "Payment Allocation",
        "ID": "Record ID",
        "Payment": "Payment",
        "PaymentID": "Payment",
        "Amount": "Amount",
        "Job": "Job",
        "JobID": "Job",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice",
        "PaymentAllocationID": "Payment Allocation ID",
        "HasRefund": "Has Refund",
    },
    "invoiceLine": {
        "entityTitle": "Invoice Line",
        "ID": "Record ID",
        "LineNo_abbrev": "Line No",
        "LineNo": "Line No",
        "Description": "Description",
        "InvoiceLineID": "Invoice Line ID",
        "Invoice": "Invoice",
        "InvoiceID": "Invoice",
        "UnitPrice": "Unit Price",
        "Qty": "Qty",
        "Amount": "Amount",
        "Tax": "Tax",
        "AmountIncTax": "Amount Inc Tax",
        "ProductName": "Product Name",
        "ProductID": "Product ID",
        "Status": "Status",
        "JobLine": "Job Line",
        "JobLineID": "Job Line",
        "TaxRate": "Tax Rate",
        "TaxRateID": "Tax Rate",
        "Locked": "Locked",
        "ChangeStatus": "Change Status",
        "Notes": "Notes",
    },
    "documentTemplate": {
        "entityTitle": "Document Template",
        "ID": "Record ID",
        "Name": "Name",
        "Type": "Type",
        "TemplateID": "Template ID",
        "TemplateParams": "Template Params",
        "CustomDocumentID": "Custom Document (Optional)"
    },
    "blobItem": {
        "entityTitle": "Blob Item",
        "ID": "Record ID",
        "Data": "Data",
        "BlobItemID": "Blob Item ID",
    },
    "activityRep": {
        "entityTitle": "Activity Rep",
        "ID": "Record ID",
        "Activity": "Activity",
        "ActivityID": "Activity",
        "Rep": "Rep",
        "RepID": "Representative",
    },
    "leadDiscardReason": {
        "entityTitle": "Lead Discard Reason",
        "ID": "Record ID",
        "PL_LeadDiscardReasonID": "PL _ Lead Discard Reason ID",
        "Description": "Description",
        "Active": "Active",
    },
    "organisationType": {
        "entityTitle": "Organisation Type",
        "ID": "Record ID",
        "PL_OrganisationTypeID": "PL _ Organisation Type ID",
        "Description": "Description",
        "Active": "Active",
    },
    "activityJobLine": {
        "entityTitle": "Activity Job Line",
        "ID": "Record ID",
        "Job": "Job",
        "JobID": "Job",
        "JobLine": "Job Line",
        "JobLineID": "Job Line",
        "Activity": "Activity",
        "ActivityID": "Activity",
    },
    "payment": {
        "entityTitle": "Payment",
        "ID": "Record ID",
        "ReceiptNo": "Receipt No",
        "Date": "Date",
        "Method": "Method",
        "PL_PaymentMethodID_abbrev": "Method",
        "PL_PaymentMethodID": "Payment Method",
        "CreditCard": "Method",
        "PL_CreditCardID": "Credit Card",
        "Fee": "Fee",
        "Amount": "Amount",
        "Type": "Type",
        "Status": "Status",
        "Contact": "Contact",
        "ContactID": "Contact",
        "Notes": "Notes",
        "CreditNote": "Credit Note",
        "CreditNoteID": "Invoice",
        "FinanceArchived": "Finance Archived",
        "IsDeposit": "Is Deposit",
        "PaymentAllocations": "Payment Allocations",
    },
    "tag": {
        "entityTitle": "Tag",
        "ID": "Record ID",
        "PL_TagID": "PL _ Tag ID",
        "Description": "Description",
        "Active": "Active",
    },
    "tagRelated": {
        "entityTitle": "Tag Related",
        "ID": "Record ID",
        "Tag": "Tag",
        "TagID": "Tag",
        "Job": "Job",
        "JobID": "Job",
        "Opportunity": "Opportunity",
        "OpportunityID": "Opportunity",
        "TemplateResponse": "Template Response",
        "TemplateResponseID": "Template Response",
    },
    "externalLead": {
        "entityTitle": "External Lead",
        "ID": "Record ID",
        "Date": "Date",
        "Processed": "Processed",
        "SnoozeDate": "Snooze Date",
        "ContactFirstName": "Contact First Name",
        "ContactLastName": "Contact Last Name",
        "ContactEmail": "Contact Email",
        "ContactMobile": "Contact Mobile",
        "ContactWorkPh": "Contact Work Ph",
        "ContactHomePh": "Contact Home Ph",
        "LeadData": "Lead Data",
        "LeadSource": "Lead Source",
        "PL_LeadSourceID_abbrev": "Lead Source",
        "PL_LeadSourceID": "Lead Source",
        "DiscardNotes": "Discard Notes",
        "PL_LeadDiscardReason": "PL _ Lead Discard Reason",
        "PL_LeadDiscardReasonID": "Lead Discard Reason",
    },
    "representative": {
        "entityTitle": "Representative",
        "ID": "Record ID",
        "FirstName": "First Name",
        "LastName": "Last Name",
        "FullName": "Full Name",
        "Email": "Email",
        "RepresentativeID": "Representative ID",
        "UserID": "User ID",
        "FeatureAllowSetup": "Feature Allow Setup",
        "FeatureAllowManagement": "Feature Allow Management",
        "FeatureCanManageWorkflows": "Feature Can Manage Workflows",
        "FeatureCanManageCustomizations": "Feature Can Manage Customizations",
        "FeatureAllowProductExplainer": "Feature Allow AI Product Explainer",
        "FeatureAllowSendOrder": "Feature Allow Send Order",
        "FeatureAllowPlaceAccountOnHold": "Feature Allow Place Account On Hold",
        "FeatureAllowReleaseAccountFromOnHold": "Feature Allow Release Account From On Hold",
        "FeatureAllowConfirmJobForOnHoldAccounts": "Feature Allow Confirm Job For On Hold Accounts",
        "FeatureAllowViewCostPrice": "Feature Allow View Cost Price",
        "FeatureCanViewSalesData": "Feature Can View Sales Data",
        "FeatureCanViewCalendars": "Feature Can View Calendars",
        "FeatureAllowQuoting": "Feature Allow Quoting",
        "FeatureShowInCalendar": "Feature Show In Calendar",
        "FeatureSyncCalendar": "Feature Sync Calendar",
        "FeatureCanViewFinance": "Feature Can View Finance",
        "FeatureCanViewProjects": "Feature Can View Projects",
        "FeatureCanViewCustomerChat": "Feature Can View Customer Chat",
        "FeatureCanViewCustomerChatData": "Feature Can View Customer Chat Data",
        "FeatureCanEditCustomerChatData": "Feature Can Edit Customer Chat Data",
        "FeatureCanAssignCustomerChatData": "Feature Can Assign Customer Chat Data",
        "FeatureCanViewUnassigned": "Feature Can View Unassigned",
        "FeatureCanViewArchived": "Feature Can View Archived",
        "FeatureCanArchive": "Feature Can Archive",
        "FeatureAllowInstallations": "Feature Allow Installations",
        "FeatureCanProcessWebLeads": "Feature Can Process Web Leads",
        "FeatureAllowFurtherDiscountOnPromotionLines": "Feature Allow Further Discounting On Promotions",
        "FeatureAllowEditReadOnlyOpportunities": "Feature Allow Edit Read Only Opportunities",
        "FeatureAllowOpenExpiredQuotes": "Feature Allow Open Expired\\Lost Quotes",
        "FeatureAllowPerformCheckMeasure": "Feature Allow Perform Check Measure",
        "FeatureAllowApproveCheckMeasure": "Feature Allow Approve Check Measure",
        "FeatureAllowDiscounting": "Feature Allow Discounting",
        "FeatureAllowEditJobs": "Feature Allow Edit Jobs",
        "FeatureAllowBeginEditJobs": "Feature Allow Begin Edit Jobs",
        "FeatureAllowFinishEditJobs": "Feature Allow Finish Edit Jobs",
        "FeatureAllowFinishEditPriceOverride": "Allow Finish Edit Price Override",
        "FeatureAllowChangeBusinessUnit": "Feature Allow Change Business Unit",
        "FeatureAllowCreateServiceJob": "Feature Allow Create Service Job",
        "FeatureAllowViewDispatchPlanning": "Feature Allow View Dispatch Planning",
        "FeatureAllowManageCustomReports": "Feature Allow Manage Custom Reports",
        "FeatureAllowViewMarketing": "Feature Allow View Marketing",
        "FeatureAllowChangeCostPrice": "Feature Allow Change Cost Price",
        "FeatureAllowOverrideDispatch": "Feature Allow Override Dispatch",
        "FeatureAllowRunCommissions": "Feature Allow Run Commissions",
        "FeatureAllowEditCommissionDate": "Feature Allow Edit Commission Date",
        "FeatureAllowViewEstimatedCommissions": "Feature Allow View Estimated Commissions",
        "FeatureAllowDeleteAppointment": "Feature Allow Delete Appointment",
        "FeatureAllowReceiptGoods": "Feature Allow Receipt Goods",
        "FeatureAllowProcessMerchantPayments": "Feature Allow Process Merchant Payments",
        "FeatureCanManageCalendarRoster": "Feature Can Manage Calendar Roster",
        "FeatureAllowViewCalendarRunValues": "Feature Allow View Calendar Run Values",
        "FeatureAllowBulkAssignLeads": "Feature Allow Bulk Assign Leads",
        "ReceiveNotificationsByEmail": "Receive Notifications By Email",
        "FeatureAllowProcessDispatch": "Feature Allow Process Dispatch",
        "FeatureAllowViewRestock": "Feature Allow View Restock",
        "FeatureAllowChangeJobLineSupplier": "Feature Allow Change Job Line Supplier",
        "FeatureAllowFabricOptimisation": "Feature Allow Fabric Optimisation",
        "FeatureAllowViewWholesaleChat": "Feature Allow View Wholesale Chat",
        "FeatureAllowProductManagement": "Feature Allow View Product Management",
        "FeatureAllowCreditLimitToBeExceeded": "Feature Allow Credit Limit To Be Exceeded",
        "FeatureAllowChangeOtherUsersEvents": "Feature Allow Change Other Users Events",
		"Active": "Active",
		"DefaultTeam": "Default Team",
		"DefaultTeamID": "Team",
		"DefaultBusinessUnit": "Default Business Unit",
		"DefaultBusinessUnitID": "Business Unit",
		"CalendarColor": "Calendar Color",
		"Licensed": "Licensed",
		"LicenseIDs": "License I Ds",
		"CalendarSettings": "Calendar Settings",
		"ApplicationSettings": "Application Settings",
		"VersionSettings": "Version Settings",
		"Mobile": "Mobile",
		"WorkPhone": "Work Phone",
		"Address": "Address",
		"AddressID": "Address",
		"JobTitle": "Job Title",
		"EmailSignature": "Email Signature",
		"CalendarID": "Calendar ID",
		"CommissionRules": "Commission Rules",
	},
	"address": {
		"entityTitle": "Address",
		"ID": "Record ID",
		"AddressLines": "Address Lines",
		"City": "City",
		"State": "State",
		"StateSubArea1": "County",
		"Postcode": "Postcode",
		"Country": "Country",
		"Location": "Location",
		"PosLong": "Pos Long",
		"PosLat": "Pos Lat",
		"AddressID": "Address ID",
		"Formatted": "Formatted",
	},
	"template": {
		"entityTitle": "Template",
		"ID": "Record ID",
		"Description": "Description",
		"Type": "Type",
		"Category": "Category",
		"Subject": "Subject",
		"Body": "Body",
		"IsHTML": "Is HTML",
		"TemplateID": "Template ID",
		"Document": "Document",
		"Version": "Version",
		"AllowReply": "Allow Reply",
		"RenderEngine": "Render Engine",
	},
	"product": {
		"entityTitle": "Product",
		"ID": "Record ID",
		"ProductName": "Product Name",
		"Active": "Active",
		"CanSell": "Can Sell",
		"ServiceProduct": "Service Product",
		"SupplementaryCharge": "Supplementary Charge",
		"NotesTemplate": "Notes Template",
		"ProductID": "Product ID",
		"Supplier": "Supplier",
		"SupplierID": "Supplier",
		"BlobUrl": "Blob Url",
		"CutSheetTemplate": "Cut Sheet Template",
		"CutSheetTemplateID": "Binary Data Field",
		"CutSheetPrintType_abbrev": "Attach As",
		"CutSheetPrintType": "Cut Sheet Print Type",
		"DiscontinuedDate": "Discontinued Date"
	},
	"priceList": {
		"entityTitle": "PriceList",
		"errors": {
			"error_code_must_be_unique": "Price List Codes Must Be Unique"
		},
		"ID": "Price List ID",
		"Code": "Price List Code",
		"Description": "Description",
		"StartDate": "Start Date",
		"EndDate": "End Date",
	},
	"PriceListGrid": {
		"entityTitle": "PriceList - Grid",
		"ID": "ID",
		"Code": "Price List Code",
		"Description": "Description",
		"SearchOrder": "Search Order",
		"StartDate": "Start Date",
        "EndDate": "End Date",
        "PriceListID": "ID",
	},
	"PriceListVersionGrid": {
		"entityTitle": "PriceList Version - Grid",
		"ID": "Record ID",
		"Status": "Status",
		"PublishedDate": "Published Date",
		"PublishedBy": "Published By",
		"VersionNumber": "Version Number",
		"PriceListVersionID": "Version ID",
	},
	"PriceListProductGrid": {
		"entityTitle": "PriceList Product - Grid",
		"ProductID": "Product ID",
		"ProductName": "Product Name",
		"SupplierName": "Supplier Name",
		"IsServiceProduct": "Service Product",
		"IsSupplementaryChargeProduct": "Supplementary Charge",
		"IsActive": "Active",
		"CanSell": "Can Sell",
		"DiscontinuedDate": "Discontinued Date",
	},
	"PriceListPartGrid": {
		"entityTitle": "PriceList Part - Grid",
		"PartID": "Part ID",
		"PartName": "Part Name",
		"PartCode": "Part Code",
		"IsActive": "Active",
		"CanSell": "Can Sell",
		"DiscontinuedDate": "Discontinued Date",
	},
	"PriceListFabricGrid": {
		"entityTitle": "PriceList Fabric - Grid",
		"FabricID": "Fabric ID",
		"FabricName": "Fabric Name",
		"FabricCode": "Fabric Code",
		"SupplierName": "Supplier Name",
		"IsActive": "Active",
		"CanSell": "Can Sell",
		"DiscontinuedDate": "Discontinued Date",
	},
	"ProductPriceListGrid": {
		"entityTitle": "Product Price List - Grid",
		"PriceListID": "Price List ID",
		"PriceListGUID": "Price List ID",
		"PriceListCode": "Price List Code",
		"PriceListName": "Price List Name",
		"StartDate": "Start Date",
		"EndDate": "End Date",
	},
	"productVersion": {
		"entityTitle": "Product Version",
		"ID": "Record ID",
		"Status": "Status",
		"PublishedDate": "Published Date",
		"PublishedBy": "Published By",
		"VersionNumber": "Version Number",
		"ProductVersionID": "Version ID",
	},
	"automation": {
		"entityTitle": "Automation",
		"ID": "Record ID",
		"AutomationID": "Automation ID",
		"Name": "Name",
		"Notes": "Notes",
		"Type": "Type",
		"SMSTemplate": "SMS Template",
		"SMSTemplateID": "Template",
        "WhatsAppTemplate": "WhatsApp Template",
        "WhatsAppTemplateID": "Template",
		"EmailTemplate": "Email Template",
		"EmailTemplateID": "Template",
		"SendTo": "Send To",
		"ScheduleTimeframe": "Schedule Timeframe",
		"ScheduleAmount": "Schedule Amount",
		"ScheduleTimeOfDay": "Schedule Time Of Day",
		"Confirmed": "Confirmed",
		"BalanceOutstanding": "Balance Outstanding",
		"AppointmentType": "Appointment Type",
		"DispatchType": "Dispatch Type",
		"JobType": "Job Type",
		"JobLineStageFilter": "Job Line Stage",
		"RepeatDays": "Repeat Days",
		"ReevaluateOnEtaChange": "Re-evaluate on ETA change",
		"Enabled": "Enabled",
		"SmsDeliveryReceipt": "Sms Delivery Receipt",
	},
	"gridFilter": {
		"entityTitle": "Grid Filter",
		"ID": "Record ID",
		"Name": "Name",
		"Filter": "Filter",
		"EntityType": "Entity Type",
		"Owner": "Owner",
		"OwnerID": "Representative",
		"FilterAccess": "Filter Access",
	},
	"commissionValue": {
		"entityTitle": "Commission Value",
		"ID": "Record ID",
		"Name": "Name",
		"SummaryType": "Summary Type",
		"Filter": "Filter",
		"Expression": "Expression",
		"GroupBy": "Group By",
		"SummaryBy": "Summary By",
		"ShowOnStatement": "Show On Statement",
		"IsText": "Is Text",
		"SortOrder": "Sort Order",
	},
	"businessUnit": {
		"entityTitle": "Business Unit",
		"ID": "Record ID",
		"BusinessUnitID": "Business Unit ID",
        "Name": "Name",
        "Code": "Code",
		"Logo": "Logo",
		"BusinessNumber": "Business Number",
		"Phone": "Phone",
		"Mobile": "Mobile",
		"Email": "Email",
		"WWW": "WWW",
		"Locale": "Locale",
		"TimeZone": "Time Zone",
		"Address": "Address",
		"AddressID": "Address",
		"DeliveryAddress": "Delivery Address",
		"DeliveryAddressID": "Address",
		"BillingAddress": "Billing Address",
		"BillingAddressID": "Address",
		"ProductExclusions": "Product Exclusions",
	},
	"bUProductExclusion": {
		"entityTitle": "BU Product Exclusion",
		"ID": "Record ID",
		"BusinessUnit": "Business Unit",
		"BusinessUnitID": "Business Unit",
		"ProductID": "Product ID",
	},
	"orderLine": {
		"entityTitle": "Product Line",
		"ID": "Record ID",
		"OrderLineNo_abbrev": "Line No",
		"OrderLineNo": "Order Line No",
		"Width": "Width",
		"Drop": "Drop",
		"Qty": "Qty",
		"CostPrice": "Cost Price",
		"CostPriceTax": "Cost Price Tax",
		"CostPriceIncTax": "Cost Price Inc Tax",
		"BaseCost": "Base Cost",
		"InstallCost": "Install Cost",
		"OptionsCost": "Options Cost",
		"DeliveryCost": "Delivery Cost",
		"AdjustmentCost": "Adjustment Cost",
		"WidthMeasurements": "Width Measurements",
		"DropMeasurements": "Drop Measurements",
		"UndoCancelState": "Undo Cancel State",
		"SupportsOptimisation": "Supports Optimisation",
		"Order": "Order",
		"OrderID": "Purchase Order",
		"LocationOther_abbrev": "Location/Desc",
		"LocationOther": "Location Other",
		"ProductName": "Product Name",
		"ProductCode": "Product Code",
		"ProductID": "Product ID",
		"SupplierName": "Supplier Name",
		"SupplierID": "Supplier",
		"Notes": "Notes",
		"SupplyNotes": "Supply Notes",
		"Status": "Status",
		"OrderLineOptionsData": "Order Line Options Data",
		"ConsolidationData": "Consolidation Data",
		"PriceModel": "Price Model",
		"RelatedJobLines": "Related Job Lines",
		"MFDate": "MF Date",
		"Department": "Department",
		"PL_MFDepartmentID_abbrev": "Department",
		"PL_MFDepartmentID": "MF Department",
		"OrderLineID": "Order Line ID",
		"DisplayOption1": "Display Option 1",
		"DisplayOption2": "Display Option 2",
		"DisplayOption3": "Display Option 3",
		"DisplayOption4": "Display Option 4",
		"DisplayOption5": "Display Option 5",
		"DisplayOption6": "Display Option 6",
		"DisplayOption7": "Display Option 7",
		"DisplayOption8": "Display Option 8",
		"DisplayOption9": "Display Option 9",
		"DisplayOption10": "Display Option 10",
		"LineNo": "Line No",
		"ItemID": "Item ID",
		"LineItemID": "Line Item ID",
		"InstallationNotes": "Installation Notes",
		"Price": "Price",
		"PriceTax": "Price Tax",
		"SalePrice": "Sale Price",
		"SalePriceTax": "Sale Price Tax",
		"PriceIncTax": "Price Inc Tax",
		"SalePriceIncTax": "Sale Price Inc Tax",
		"OriginalCostPrice": "Original Cost Price",
		"OriginalCostPriceTax": "Original Cost Price Tax",
		"OriginalCostPriceIncTax": "Original Cost Price Inc Tax",
		"BasePrice": "Base Price",
		"InstallPrice": "Install Price",
		"OptionsPrice": "Options Price",
		"DeliveryPrice": "Delivery Price",
		"AdjustmentPrice": "Adjustment Price",
		"SalesTaxRate": "Sales Tax Rate",
		"CostTaxRate": "Cost Tax Rate",
		"ValidationErrors": "Validation Errors",
		"PriceListVersion": "Price List Version",
	},
	"jobLineOrderLine": {
		"entityTitle": "Job Line Order Line",
		"ID": "Record ID",
		"OrderLine": "Order Line",
		"OrderLineID": "Order Line",
		"JobLine": "Job Line",
		"JobLineID": "Job Line",
		"CostRatio": "Cost Ratio",
	},
	"company": {
		"entityTitle": "Company",
		"ID": "Record ID",
        "Name": "Name",
        "Code": "Code",
		"Phone": "Phone",
		"Fax": "Fax",
		"Mobile": "Mobile",
		"Email": "Email",
		"WWW": "WWW",
		"DefaultPaymentTerms": "Default Payment Terms",
		"DefaultPaymentDue": "Default Payment Due",
		"InvoiceDueDays": "Invoice Due Days",
		"Notes": "Notes",
		"OrganisationType": "Organisation Type",
		"PL_OrganisationTypeID": "Organisation Type",
		"Address": "Address",
		"AddressID": "Address",
		"PriceListID": "Price List ID",
		"BillingContact": "Billing Contact",
		"BillingContactID": "Contact",
		"FileNotes": "File Notes",
		"PriceMappings": "Price Mappings",
		"AccountType": "Account Type",
		"PricingType": "Pricing Type",
		"BusinessNumber": "Business Number",
		"CompanyID": "Company ID",
		"ReceiveAutomatedEmail": "Receive Operational Email",
        "ReceiveAutomatedSMS": "Receive Operational SMS",
        "ReceiveAutomatedWhatsApp": "Receive Operational WhatsApp Message",
        "RequireUniqueCustomerRef": "Requires Unique Project Customer PO",
    },
    "leadSource": {
        "entityTitle": "Lead Source",
        "ID": "Record ID",
        "PL_LeadSourceID": "PL _ Lead Source ID",
        "Description": "Description",
        "Active": "Active",
    },
    "entitySnapshot": {
        "entityTitle": "Entity Snapshot",
        "ID": "Record ID",
        "Name": "Name",
        "Date": "Date",
        "SnapshotData": "Snapshot Data",
        "JobLine": "Job Line",
        "JobLineID": "Job Line",
        "Job": "Job",
        "JobID": "Job",
        "OtherID": "Other ID",
    },
    "contactJobCategory": {
        "entityTitle": "Contact Job Category",
        "ID": "Record ID",
        "PL_ContactJobCategoryID": "PL _ Contact Job Category ID",
        "Description": "Description",
        "Active": "Active",
    },
    "invoiceStatementView": {
        "entityTitle": "Invoice Statement View",
        "ID": "Record ID",
        "InvoiceDate": "Invoice Date",
        "DueDate": "Due Date",
        "InvoiceNo": "Invoice No",
        "ProjectCustomerPO": "Project Customer PO",
        "CompanyID": "Company ID",
        "Company": "Company",
        "CompanyMobile": "Company Mobile",
        "CompanyPhone": "Company Phone",
        "CompanyFax": "Company Fax",
        "ContactID": "Contact ID",
        "Contact": "Contact",
        "ContactHomePhone": "Contact Home Phone",
        "ContactMobile": "Contact Mobile",
        "ContactWorkPhone": "Contact Work Phone",
        "Email": "Email",
        "Address": "Address",
        "DaysOverdue": "Days Overdue",
        "Amount": "Amount",
        "Overdue": "Overdue",
        "Paid": "Paid",
        "Balance": "Balance",
    },
    "authToken": {
        "entityTitle": "Auth Token",
        "ID": "Record ID",
        "Token": "Token",
        "Type": "Type",
        "Application": "Application",
        "Date": "Date",
        "Representative": "Representative",
        "RepresentativeID": "Representative",
    },
    "commissionAmendmentCategory": {
        "entityTitle": "Commission Amendment Category",
        "ID": "Record ID",
        "PL_CommissionAmendmentCategoryID": "PL _ Commission Amendment Category ID",
        "Description": "Description",
        "Active": "Active",
    },
    "PL_ActivityColor": {
        "Color": "Colour"
    },
    "PL_ProductOfInterest": {
        "EstimatedValue": "Estimated Value"
    },
    "PL_CreditCard": {
        "Provider": "Provider"
    },
    "PL_CustomerAvailability": {
        "Type": "Type",
        "StartTime": "Start Time",
        "EndTime": "End Time"
    },
    "PL_PaymentMethod": {
        "IsCreditCard": "Is Credit Card"
    },
    "PL_UnitType": {
        "Code": "Code (UN/CEFACT Unit of Measure)",
        "Symbol": "Symbol"
    },
    "PL_ProductCategory": {
        "Code": "Code"
    },
    "PL_FabricCategory": {
        "Code": "Code"
    },
    "PL_ProductTaxCode": {
        "Code": "Tax Code"
    },
    "PL_TaxExemptionReason": {
        "FinanceIntegrationId": "Finance Integration Id"
    },
    "financeTrasferAnomaliesGrid": {
        Message: "Message",
        "Date": "Issue Date",
        "Contact": "Contact",
        "Invoice": "Invoice",
        "Payment": "Payment",
        "Allocation": "Allocation"
    },
    "SalesSkill": {
        "RepresentativeID": "Representative",
        "Representative": "Representative",
        "ProductOfInterest": "Product Of Interest",
        "Notes": "Notes"
    },
    "FitterSkill": {
        "RepresentativeID": "Representative",
        "Representative": "Representative",
        "Product": "Product",
        "ProductID": "Product",
        "Notes": "Notes"
    },
    "ProductSupplier": {
        "SupplierID": "Supplier",
        "Supplier": "Supplier",
        "SendUBL": "Send UBL File",
        "IsDefault": "Is Default Supplier",
        "Active": "Is Active",
        "LeadTime": "Lead Time",
        "ReworkLeadTime": "Rework Lead Time",
        "DiscontinuedDate": "Discontinued Date",
        "OutOfStock": "Out Of Stock",
        "InStockETA": "In Stock ETA",
        "OutOfStockNotes": "Out Of Stock Notes"
    },
    "ItemGrid": {
        "Code": "Code",
        "Name": "Name",
        "Active": "Active",
        "CanSell": "Can Sell",
        "ProductCategory": "Product Category",
        "UnitType": "Unit Type",
        "OutOfStock": "Is Out of Stock",
        "OutOfStockNotes": "Out of Stock Notes",
        "InStockETA": "Estimated Time in Stock",
        "DiscontinuedDate": "Discontinued Date"
    },
    "SupplierItemGrid": {
        "Code": "Product Code",
        "Name": "Product Name",
        "Active": "Active",
        "CanSell": "Can Sell",
        "ProductCategory": "Product Category",
        "UnitType": "Unit Type",
        "OutOfStock": "Is Out of Stock",
        "OutOfStockNotes": "Out of Stock Notes",
        "InStockETA": "Estimated Time in Stock",
        "DiscontinuedDate": "Discontinued Date",
        "SupplierID": "Supplier",
        "Supplier": "Supplier"
    },
    "FabricGrid": {
        "Code": "Code",
        "Name": "Name",
        "Supplier": "Supplier",
        "Active": "Active",
        "CanSell": "Can Sell",
        "ProductCategory": "Product Category",
        "UnitType": "Unit Type",
        "OutOfStock": "Is Out of Stock",
        "OutOfStockNotes": "Out of Stock Notes",
        "InStockETA": "Estimated Time in Stock",
        "DiscontinuedDate": "Discontinued Date",
        "FabricCategory": "Fabric Categories",
        "FabricName": "Fabric",
        "FabricColour": "Color",
        "Continuous": "Continuous",
        "DefaultGroupCode": "Default Group Code",
        "MeasureUnit": "Measure Unit",
        "AreaUnit": "Area Unit"
    },
    "Item": {
        "Code": "Product Code",
        "Name": "Product Name",
        "Active": "Active",
        "CanSell": "Can Sell",
        "ProductCategory": "Product Category",
        "PL_ProductCategoryID": "Product Category",
        "UnitType": "Unit Type",
        "PL_UnitTypeID": "Unit Type",
        "OutOfStock": "Is Out of Stock",
        "OutOfStockNotes": "Out of Stock Notes",
        "InStockETA": "Estimated Time in Stock",
        "DiscontinuedDate": "Discontinued Date"
    },
    "SupplierItem": {
        "Code": "Product Code",
        "Name": "Product Name",
        "Active": "Active",
        "CanSell": "Can Sell",
        "ProductCategory": "Product Category",
        "PL_ProductCategoryID": "Product Category",
        "UnitType": "Unit Type",
        "PL_UnitTypeID": "Unit Type",
        "OutOfStock": "Is Out of Stock",
        "OutOfStockNotes": "Out of Stock Notes",
        "InStockETA": "Estimated Time in Stock",
        "DiscontinuedDate": "Discontinued Date",
        "SupplierID": "Supplier",
        "Supplier": "Supplier",
        "LeadTime": "Lead Time",
        "ReworkLeadTime": "Rework Lead Time"
    },
    "Fabric": {
        "Code": "Code",
        "Name": "Name",
        "FabricName": "Fabric Name",
        "FabricColour": "Fabric Color",
        "Active": "Active",
        "CanSell": "Can Sell",
        "ProductCategory": "Product Category",
        "PL_ProductCategoryID": "Product Category",
        "UnitType": "Unit Type",
        "PL_UnitTypeID": "Unit Type",
        "OutOfStock": "Is Out of Stock",
        "OutOfStockNotes": "Out of Stock Notes",
        "InStockETA": "Estimated Time in Stock",
        "DiscontinuedDate": "Discontinued Date",
        "Continuous": "Continuous",
        "Width": "Width",
        "Drop": "Drop",
        "HPatternRepeat": "Horizontal Pattern Repeat",
        "VPatternRepeat": "Vertical Pattern Repeat",
        "HPatternRepeatAllowance": "Horizontal Pattern Repeat Allowance",
        "VPatternRepeatAllowance": "Vertical Pattern Repeat Allowance",
        "CuttingCode": "Cutting Code",
        "CuttingPreference": "Cutting Preference",
        "SupplierID": "Supplier",
        "Supplier": "Supplier",
        "DefaultGroupCode": "Default Group Code",
        "AreaUnit": "AreaUnit",
        "MeasureUnit": "Measure Unit",
        "MeasurePrecision": "Measure Precision",
        "MaxWidth": "Max Opening Width",
        "MaxDrop": "Max Opening Drop",
        "MaxSqm": "Max Opening Area",
        "RailRoadingMaxWidth": "Max Opening Width",
        "RailRoadingMaxDrop": "Max Opening Drop",
        "RailRoadingMaxSqm": "Max Opening Area",
        "RailRoading": "Rail Roading"

    }

};

window.myinsyteresources.en.translation.application_strings.enums = {

    "MeasuredValueUnit": "Unknown Unit",

    "MeasuredValueUnit_10": "Millimeters",
    "MeasuredValueUnit_100": "Centimeters",
    "MeasuredValueUnit_254": "Inches",
    "MeasuredValueUnit_10000": "Meters",
    "MeasuredValueUnit_3048": "Feet",
    "MeasuredValueUnit_9144": "Yards",
    "MeasuredValueUnit_10000000": "Kilometers",
    "MeasuredValueUnit_16093440": "Miles",

    "MeasuredValueUnit_Millimeters": "Millimeters",
    "MeasuredValueUnit_Centimeters": "Centimeters",
    "MeasuredValueUnit_Inches": "Inches",
    "MeasuredValueUnit_Meters": "Meters",
    "MeasuredValueUnit_Feet": "Feet",
    "MeasuredValueUnit_Yards": "Yards",
    "MeasuredValueUnit_Kilometers": "Kilometers",
    "MeasuredValueUnit_Miles": "Miles",

    "MeasuredValueUnit_millimeters": "Millimeters",
    "MeasuredValueUnit_centimeters": "Centimeters",
    "MeasuredValueUnit_inches": "Inches",
    "MeasuredValueUnit_meters": "Meters",
    "MeasuredValueUnit_feet": "Feet",
    "MeasuredValueUnit_yards": "Yards",
    "MeasuredValueUnit_kilometers": "Kilometers",
    "MeasuredValueUnit_miles": "Miles",
};

/*
    // initial script resource generation
    // run in console from breakpoint in ScriptParamsCtrl
    window.tempScriptResources = {}
    for (const script of scriptData) {
        const pattern = /^\s*(?<className>.*?),\s*(?<assembly>.*?),.*$/;
        const { className, assembly } = script.ClassName.match(pattern).groups;
        window.tempScriptResources[assembly] ??= {};
        const scriptTran = (window.tempScriptResources[assembly][className] = {
            $ScriptTitle: script.Description, // using '$' prefix so there's no chance of a collision with a property name
        });
        
        for (const prop of script.Properties) {
            const params = prop.Parameters;
            const propTran = (scriptTran[prop.Name] = { 
                Description: params.Description,
                ToolTip: params.ToolTip ?? "" // default to empty as UI will show key otherwise
            });
    
            if (params.Values) {
                propTran.Values = Object.fromEntries(params.Values.map(p => [p.split('|').at(0),p.split('|').at(-1)]));
            }
        }
    }
    
    console.log(JSON.stringify(window.tempScriptResources, null, 4));
    delete window.tempScriptResources;
*/
window.myinsyteresources.en.translation.application_strings.scripts = {
    "InsyteProductShared": {
        "InsyteProductShared.Scripts.DefaultValueByAdvancedScript": {
            "$ScriptTitle": "Default Value by Advanced Script",
            "Script": {
                "Description": "AdvancedScript",
                "ToolTip": ""
            }
        },
        "InsyteProductShared.Scripts.IsCalculatedByAdvancedScript": {
            "$ScriptTitle": "Is Calculated By AdvancedScript",
            "Script": {
                "Description": "AdvancedScript",
                "ToolTip": ""
            }
        },
        "InsyteProductShared.Scripts.CalculateOptionMandatoryByAdvancedScript": {
            "$ScriptTitle": "Mandatory By Advanced Script",
            "Script": {
                "Description": "AdvancedScript",
                "ToolTip": ""
            }
        },
        "InsyteProductShared.Scripts.ValidateOptionByAdvancedScript": {
            "$ScriptTitle": "Required By Advanced Script",
            "Script": {
                "Description": "AdvancedScript",
                "ToolTip": ""
            }
        },
        "InsyteProduct.Scripts.CustomOptionDisplayFormatter": {
            "$ScriptTitle": "Custom Display Formatter",
            "FormatString": {
                "Description": "Format",
                "ToolTip": "Eg. Format Expression: My Option Value is {Option_Code} from Order Line {Line}"
            }
        },
        "InsyteProduct.Scripts.DefaultByParameter": {
            "$ScriptTitle": "Default Value By Parameter (Option Value)",
            "ParamName": {
                "Description": "Parameter",
                "ToolTip": ""
            }
        },
        "InsyteProduct.Scripts.DefaultValueByExpressionNumeric": {
            "$ScriptTitle": "Default Value by Expression (Numeric)",
            "Options": {
                "Description": "Options",
                "ToolTip": "List of Product Options to use in Format String"
            },
            "RequiredOptions": {
                "Description": "Required Options",
                "ToolTip": "List of Product Options that must have a numeric value > 0 to run expression"
            },
            "Expression": {
                "Description": "Expression",
                "ToolTip": "Numeric Expression Format String using {} as placeholders starting with index 0. e.g. {0} x {1}\nThe following operators are allowed: ()+-/*"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingMultiple": {
                "Description": "Result Rounding Multiple",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            }
        },
        "InsyteProduct.Scripts.DefaultValueByExpressionText": {
            "$ScriptTitle": "Default Value by Expression (Text)",
            "Options": {
                "Description": "Options",
                "ToolTip": "List of Product Options to use in Format String"
            },
            "RequiredOptions": {
                "Description": "Required Options",
                "ToolTip": "List of Product Options that must have value other than \"\" to run expression"
            },
            "Expression": {
                "Description": "Expression",
                "ToolTip": "Format String using {} as placeholders starting with index 0. e.g. {0} - {1}"
            },
            "ReturnEmptyWhenValuesEmpty": {
                "Description": "Blank When Values are Empty",
                "ToolTip": "If all the values are empty, return blank string (instead of expression format string)"
            }
        },
        "InsyteProduct.Scripts.DefaultValueByNumericLookupParameter": {
            "$ScriptTitle": "Default Value By Parameter (Lookup)",
            "ParamCode": {
                "Description": "Parameter",
                "ToolTip": ""
            }
        },
        "InsyteProduct.Scripts.DefaultValueByNumericOption": {
            "$ScriptTitle": "Default Value by Numeric Option",
            "OptionID": {
                "Description": "Option",
                "ToolTip": "Numeric Product Option that contains Input Value"
            },
            "ReturnZeroForZeroInput": {
                "Description": "Return Zero if Input is Zero",
                "ToolTip": "If set, when the input is 0 then the result will be 0"
            },
            "AdjustmentOptionID": {
                "Description": "Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value"
            },
            "AdjustmentValue": {
                "Description": "Adjustment Value",
                "ToolTip": "Deduction or Addition in mm"
            },
            "AdjustmentType": {
                "Description": "Adjustment Type",
                "ToolTip": "",
                "Values": {
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingMultiple": {
                "Description": "Result Rounding Multiple",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            }
        },
        "InsyteProduct.Scripts.DefaultValueBySizeParameter": {
            "$ScriptTitle": "Default Value By Parameter (Numeric)",
            "ParamName": {
                "Description": "Parameter",
                "ToolTip": ""
            },
            "ParameterValueField": {
                "Description": "Parameter Numeric Value Field",
                "ToolTip": "",
                "Values": {
                    "Width 1": "Width 1",
                    "Width 2": "Width 2",
                    "Height 1": "Height 1",
                    "Height 2": "Height 2",
                    "Square Metres 1": "Area 1",
                    "Square Metres 2": "Area 2"
                }
            }
        },
        "InsyteProduct.Scripts.DefaultValueByTokenCount": {
            "$ScriptTitle": "Default Value By Token Count",
            "SearchOptionID": {
                "Description": "Search Option",
                "ToolTip": "Product Option whose value will be searched for the tokens"
            },
            "Tokens": {
                "Description": "Tokens",
                "ToolTip": "List of string to search for in the Option Value (can be multiple delimited by the Token Separator)"
            },
            "TokenSeparator": {
                "Description": "Token Separator",
                "ToolTip": "Separator character used when multiple tokens are supplied"
            },
            "CaseSensitive": {
                "Description": "Case Sensitive",
                "ToolTip": "Whether the Tokens are case sensitive"
            },
            "WordMatch": {
                "Description": "Match Whole Word Only",
                "ToolTip": "Match only the full word or match characters in any word"
            }
        },
        "InsyteProduct.Scripts.DefaultValue_Apollo_Business": {
            "$ScriptTitle": "Default Value (Legacy Compatibilty - AWS)"
        },
        "InsyteProduct.Scripts.FabricDisplayFormatter": {
            "$ScriptTitle": "Fabric Display Formatter",
            "ShowWidth": {
                "Description": "Show Fabric Width",
                "ToolTip": "Will show or hide fabric width from display"
            },
            "ShowPatternRepeat": {
                "Description": "Show Pattern Repeat",
                "ToolTip": "Will show or hide pattern repeat info from display"
            }
        },
        "InsyteProduct.Scripts.IsCalculatedByOptionValue": {
            "$ScriptTitle": "Is Calculated By Option Value",
            "OptionValueIDs": {
                "Description": "Option Values",
                "ToolTip": "Numeric Product Option that contains Input Value"
            },
            "CalculatedIfNoValue": {
                "Description": "Calculated if No Value",
                "ToolTip": ""
            }
        },
        "InsyteProduct.Scripts.MandatoryByExpressionNumeric": {
            "$ScriptTitle": "Mandatory By Expression (Numeric)",
            "Options": {
                "Description": "Options",
                "ToolTip": "List of Product Options to use in Format String"
            },
            "Expression": {
                "Description": "Expression",
                "ToolTip": "Numeric Expression Format String using {} as placeholders starting with index 0. e.g. {0} x {1}\nThe following operators are allowed: ()+-/*"
            },
            "ComparisionOperator": {
                "Description": "Operator",
                "ToolTip": "",
                "Values": {
                    "Is Equal": "Is Equal",
                    "Does Not Equal": "Does Not Equal",
                    "Greater Than": "Greater Than",
                    "Greater Than or Equal To": "Greater Than or Equal To",
                    "Less Than": "Less Than",
                    "Less Than or Equal To": "Less Than or Equal To",
                    "Between": "Between"
                }
            },
            "ComparisonValue1": {
                "Description": "Comparison Value 1",
                "ToolTip": "Either Comparison Value or Comparison Value 1 - Option is required"
            },
            "ComparisonValue1Option": {
                "Description": "Comparison Value 1 - Option",
                "ToolTip": "using {} as placeholder starting with index 0. e.g. {0}. Either Comparison Value or Comparison Value 1 - Option is required"
            },
            "ComparisonValue2": {
                "Description": "Comparison Value 2",
                "ToolTip": "Either Comparison Value 2 or Comparison Value 2 - Option is required if the Operator = Between"
            },
            "ComparisonValue2Option": {
                "Description": "Comparison Value 2 - Option",
                "ToolTip": "using {} as placeholder starting with index 0. e.g. {0}. Either Comparison Value 2 or Comparison Value 2 - Option is required if the Operator = Between"
            },
            "RequiredTypes": {
                "Description": "Required for",
                "ToolTip": "Whether Mandatory for Quoting, Ordering or both",
                "Values": {
                    "Quoting": "Quoting",
                    "Ordering": "Ordering",
                    "Quoting/Ordering": "Quoting/Ordering"
                }
            }
        },
        "InsyteProduct.Scripts.MandatoryBySize": {
            "$ScriptTitle": "Mandatory By Size",
            "Dimension": {
                "Description": "Size",
                "ToolTip": "Size to use. Either Size and Size Value or Size Option is required",
                "Values": {
                    "Width": "Width",
                    "Drop": "Drop",
                    "Square Metres": "Area"
                }
            },
            "DimensionValue": {
                "Description": "Size Value",
                "ToolTip": "Measurement to use. Only applicable for products with Multiple Measurements. Either Size and Size Value or Size Option is required",
                "Values": {
                    "Default": "Default",
                    "Smallest": "Smallest",
                    "Largest": "Largest",
                    "Average": "Average"
                }
            },
            "SizeOptionID": {
                "Description": "Size Option",
                "ToolTip": "Numeric Product Option that contains a Size. Either Size and Size Value or Size Option is required"
            },
            "MinValue": {
                "Description": "Min Value",
                "ToolTip": "If size is greater than Min Value, then option is Mandatory. Either Min Value or Min Value Parameter is required"
            },
            "MinValueParamName": {
                "Description": "Min Value Parameter",
                "ToolTip": "If size is greater than Min Value Parameter, then option is Mandatory. Either Min Value or Min Value Parameter is required"
            },
            "MinValueParameterField": {
                "Description": "Min Value Parameter Field",
                "ToolTip": "",
                "Values": {
                    "Width 1": "Width 1",
                    "Width 2": "Width 2",
                    "Height 1": "Height 1",
                    "Height 2": "Height 2",
                    "Square Metres 1": "Area 1",
                    "Square Metres 2": "Area 2"
                }
            },
            "MinValueParamIgnoreNoMatch": {
                "Description": "Min Value Parameter Ignore No Match",
                "ToolTip": "If set and no parameter value is matched, then option will not be mandatory"
            },
            "RequiredTypes": {
                "Description": "Required for",
                "ToolTip": "Whether Mandatory for Quoting, Ordering or both",
                "Values": {
                    "Quoting": "Quoting",
                    "Ordering": "Ordering",
                    "Quoting/Ordering": "Quoting/Ordering"
                }
            }
        },
        "InsyteProduct.Scripts.MandatoryBySizeParameter": {
            "$ScriptTitle": "Mandatory by Size Parameter",
            "ParamName": {
                "Description": "Parameter",
                "ToolTip": ""
            }
        },
        "InsyteProduct.Scripts.MandatoryByTokenCount": {
            "$ScriptTitle": "Mandatory By Token Count",
            "SearchOptionID": {
                "Description": "Search Option",
                "ToolTip": "Product Option whose value will be searched for the tokens"
            },
            "Tokens": {
                "Description": "Tokens",
                "ToolTip": "List of string to search for in the Option Value (can be multiple delimited by the Token Separator)"
            },
            "TokenSeparator": {
                "Description": "Token Separator",
                "ToolTip": "Separator character used when multiple tokens are supplied"
            },
            "CaseSensitive": {
                "Description": "Case Sensitive",
                "ToolTip": "Whether the Tokens are case sensitive"
            },
            "WordMatch": {
                "Description": "Match Whole Word Only",
                "ToolTip": "Match only the full word or match characters in any word"
            },
            "ComparisonType": {
                "Description": "Comparison Type",
                "ToolTip": "Comparison Operator to use when evaluating a match",
                "Values": {
                    "Equal": "Equal",
                    "Not Equal": "Not Equal",
                    "Less Than": "Less Than",
                    "Less Than or Equal": "Less Than or Equal",
                    "Greater Than": "Greater Than",
                    "Greater Than or Equal": "Greater Than or Equal"
                }
            },
            "ComparisonValue": {
                "Description": "Comparison Value",
                "ToolTip": "Mandatory if the Token count comparison matches this value"
            },
            "RequiredTypes": {
                "Description": "Required for",
                "ToolTip": "Whether Mandatory for Quoting, Ordering or both",
                "Values": {
                    "Quoting": "Quoting",
                    "Ordering": "Ordering",
                    "Quoting/Ordering": "Quoting/Ordering"
                }
            }
        },
        "InsyteProduct.Scripts.MandatoryIfRetail": {
            "$ScriptTitle": "Mandatory for Retail Only"
        },
        "InsyteProduct.Scripts.MeasureLengthValidation": {
            "$ScriptTitle": "Length Validation",
            "AllowZero": {
                "Description": "Allow Zero",
                "ToolTip": ""
            },
            "MinValue": {
                "Description": "Minimum Value",
                "ToolTip": ""
            },
            "MaxValue": {
                "Description": "Maximum Value",
                "ToolTip": ""
            }
        },
        "InsyteProduct.Scripts.NumericValidation": {
            "$ScriptTitle": "Numeric Validation",
            "AllowZero": {
                "Description": "Allow Zero",
                "ToolTip": ""
            },
            "MinValue": {
                "Description": "Minimum Value",
                "ToolTip": ""
            },
            "MaxValue": {
                "Description": "Maximum Value",
                "ToolTip": ""
            }
        },
        "InsyteProduct.Scripts.ProductSourceByParameter": {
            "$ScriptTitle": "Product Source by Parameter",
            "ParamCode": {
                "Description": "Parameter",
                "ToolTip": ""
            },
            "DoNotAllowUserOverride": {
                "Description": "Do not allow user override",
                "ToolTip": ""
            }
        },
        "InsyteProduct.Scripts.RatioWarningValidation": {
            "$ScriptTitle": "Width-Drop Ratio Warning",
            "Ratio": {
                "Description": "Width-Drop Ratio",
                "ToolTip": "Ratio as a number. e.g. 1:2.5 enter 2.5"
            },
            "Message": {
                "Description": "Message",
                "ToolTip": "Message to be displayed when ratio is exceeded"
            }
        },
        "InsyteProduct.Scripts.RequiredByExpressionNumeric": {
            "$ScriptTitle": "Required by Expression (Numeric)",
            "Options": {
                "Description": "Options",
                "ToolTip": "List of Product Options to use in Format String"
            },
            "Expression": {
                "Description": "Expression",
                "ToolTip": "Numeric Expression Format String using {} as placeholders starting with index 0. e.g. {0} x {1}\nThe following operators are allowed: ()+-/*"
            },
            "ComparisionOperator": {
                "Description": "Operator",
                "ToolTip": "",
                "Values": {
                    "Is Equal": "Is Equal",
                    "Does Not Equal": "Does Not Equal",
                    "Greater Than": "Greater Than",
                    "Greater Than or Equal To": "Greater Than or Equal To",
                    "Less Than": "Less Than",
                    "Less Than or Equal To": "Less Than or Equal To",
                    "Between": "Between"
                }
            },
            "ComparisonValue1": {
                "Description": "Comparison Value 1",
                "ToolTip": "Either Comparison Value or Comparison Value 1 - Option is required"
            },
            "ComparisonValue1Option": {
                "Description": "Comparison Value 1 - Option",
                "ToolTip": "using {} as placeholder starting with index 0. e.g. {0}. Either Comparison Value or Comparison Value 1 - Option is required"
            },
            "ComparisonValue2": {
                "Description": "Comparison Value 2",
                "ToolTip": "Either Comparison Value 2 or Comparison Value 2 - Option is required if the Operator = Between"
            },
            "ComparisonValue2Option": {
                "Description": "Comparison Value 2 - Option",
                "ToolTip": "using {} as placeholder starting with index 0. e.g. {0}. Either Comparison Value 2 or Comparison Value 2 - Option is required if the Operator = Between"
            },
            "RequiredMessage": {
                "Description": "Custom Required Message",
                "ToolTip": "Expression Format String using {} as placeholders starting with index 0. e.g. {0}. Can also use the following Placeholders: {Operator},{Calculated Value},{Comparison Value 1},{Comparison Value 2},{ProductOption}"
            },
            "NotRequiredMessage": {
                "Description": "Custom Not Required Message",
                "ToolTip": "Expression Format String using {} as placeholders starting with index 0. e.g. {0}. Can also use the following Placeholders: {Operator},{Calculated Value},{Comparison Value 1},{Comparison Value 2},{ProductOption}"
            }
        },
        "InsyteProduct.Scripts.SizeAdjustmentByNumericOption": {
            "$ScriptTitle": "Size Adjustment by Numeric Option",
            "Dimension": {
                "Description": "Dimension",
                "ToolTip": "",
                "Values": {
                    "Width": "Width",
                    "Drop": "Drop"
                }
            },
            "DimensionValue": {
                "Description": "Dimension Value",
                "ToolTip": "Measurement to use. Only applicable for products with Multiple Measurements",
                "Values": {
                    "Default": "Default",
                    "Smallest": "Smallest",
                    "Largest": "Largest",
                    "Average": "Average",
                    "Top": "Top",
                    "Middle": "Middle",
                    "Bottom": "Bottom",
                    "Left": "Left",
                    "Right": "Right"
                }
            },
            "AdjustmentOptionID": {
                "Description": "Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value"
            },
            "AdjustmentType": {
                "Description": "Adjustment Type",
                "ToolTip": "",
                "Values": {
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingMultiple": {
                "Description": "Result Rounding Multiple",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            }
        },
        "InsyteProduct.Scripts.SizeAdjustmentByParameter": {
            "$ScriptTitle": "Size Adjustment by Parameter",
            "Dimension": {
                "Description": "Dimension",
                "ToolTip": "",
                "Values": {
                    "Width": "Width",
                    "Drop": "Drop"
                }
            },
            "DimensionValue": {
                "Description": "Dimension Value",
                "ToolTip": "Measurement to use. Only applicable for products with Multiple Measurements",
                "Values": {
                    "Default": "Default",
                    "Smallest": "Smallest",
                    "Largest": "Largest",
                    "Average": "Average",
                    "Top": "Top",
                    "Middle": "Middle",
                    "Bottom": "Bottom",
                    "Left": "Left",
                    "Right": "Right"
                }
            },
            "AdjustmentParamCode": {
                "Description": "Adjustment Value Parameter",
                "ToolTip": "Either Adjustment Value or Adjustment Parameter (or both) must be specified"
            },
            "AdjustmentValue": {
                "Description": "Adjustment Value",
                "ToolTip": "Either Adjustment Value or Adjustment Parameter (or both) must be specified"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingMultiple": {
                "Description": "Result Rounding Multiple",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            }
        },
        "InsyteProduct.Scripts.ValidationByExpressionNumeric": {
            "$ScriptTitle": "Validation by Expression (Numeric)",
            "Options": {
                "Description": "Options",
                "ToolTip": "List of Product Options to use in Format String"
            },
            "Expression": {
                "Description": "Expression",
                "ToolTip": "Numeric Expression Format String using {} as placeholders starting with index 0. e.g. {0} x {1}\nThe following operators are allowed: ()+-/*"
            },
            "ComparisionOperator": {
                "Description": "Operator",
                "ToolTip": "",
                "Values": {
                    "Is Equal": "Is Equal",
                    "Does Not Equal": "Does Not Equal",
                    "Greater Than": "Greater Than",
                    "Greater Than or Equal To": "Greater Than or Equal To",
                    "Less Than": "Less Than",
                    "Less Than or Equal To": "Less Than or Equal To",
                    "Between": "Between"
                }
            },
            "ComparisonValue1": {
                "Description": "Comparison Value 1",
                "ToolTip": "Either Comparison Value or Comparison Value 1 - Option is required"
            },
            "ComparisonValue1Option": {
                "Description": "Comparison Value 1 - Option",
                "ToolTip": "using {} as placeholder starting with index 0. e.g. {0}. Either Comparison Value or Comparison Value 1 - Option is required"
            },
            "ComparisonValue2": {
                "Description": "Comparison Value 2",
                "ToolTip": "Either Comparison Value 2 or Comparison Value 2 - Option is required if the Operator = Between"
            },
            "ComparisonValue2Option": {
                "Description": "Comparison Value 2 - Option",
                "ToolTip": "using {} as placeholder starting with index 0. e.g. {0}. Either Comparison Value 2 or Comparison Value 2 - Option is required if the Operator = Between"
            },
            "InvalidMessage": {
                "Description": "Invalid Message",
                "ToolTip": "Expression Format String using {} as placeholders starting with index 0. e.g. {0}. Can also use the following Placeholders: {Operator},{Calculated Value},{Comparison Value 1},{Comparison Value 2}"
            }
        },
        "InsyteProduct.Scripts.ValidationBySizeParameter": {
            "$ScriptTitle": "Validation By Size Parameter",
            "Param1Code": {
                "Description": "Parameter 1",
                "ToolTip": "Size Parameter to Check"
            },
            "Param1SizeMatchType": {
                "Description": "Parameter 1 - Size Match Type",
                "ToolTip": "Controls whether the message is displayed when the evaluated size is within or outside the selected Product Param Value Size",
                "Values": {
                    "Valid when outside Product Param Value Size": "Valid when outside Product Param Value Size",
                    "Valid when within Product Param Value Size": "Valid when within Product Param Value Size"
                }
            },
            "Param1CustomWidthOptionID": {
                "Description": "Parameter 1 - Custom Width Option",
                "ToolTip": "Optional Length Product Option to use for width and area comparison. If not set, Opening Width will be used. If set but no value is entered, zero will be used."
            },
            "Param1CustomHeightOptionID": {
                "Description": "Parameter 1 - Custom Height Option",
                "ToolTip": "Optional Length Product Option to use for height and area comparison. If not set, Opening Height will be used. If set but no value is entered, zero will be used."
            },
            "Param1Warning": {
                "Description": "Parameter 1 - Warning Only",
                "ToolTip": "If Checked, only a warning is displayed"
            },
            "Param1Message": {
                "Description": "Parameter 1 - Message",
                "ToolTip": "Message Text to be displayed, Required. Can use the following placeholders: {ParamValue.MinWidth}, {ParamValue.MaxWidth}, {ParamValue.MinHeight}, {ParamValue.MaxHeight}, {ParamValue.MinArea}, {ParamValue.MaxArea}, {EvaluatedWidth}, {EvaluatedHeight}, {EvaluatedArea}"
            },
            "Param2Code": {
                "Description": "Parameter 2",
                "ToolTip": "Second Size Parameter to Check (Optional)"
            },
            "Param2SizeMatchType": {
                "Description": "Parameter 2 - Size Match Type",
                "ToolTip": "Controls whether the message is displayed when the evaluated size is within or outside the selected Product Param Value Size",
                "Values": {
                    "Valid when outside Product Param Value Size": "Valid when outside Product Param Value Size",
                    "Valid when within Product Param Value Size": "Valid when within Product Param Value Size"
                }
            },
            "Param2CustomWidthOptionID": {
                "Description": "Parameter 2 - Custom Width Option",
                "ToolTip": "Optional Length Product Option to use for width and area comparison. If not set, Opening Width will be used. If set but no value is entered, zero will be used."
            },
            "Param2CustomHeightOptionID": {
                "Description": "Parameter 2 - Custom Height Option",
                "ToolTip": "Optional Length Product Option to use for height and area comparison. If not set, Opening Height will be used. If set but no value is entered, zero will be used."
            },
            "Param2Warning": {
                "Description": "Parameter 2 - Warning Only",
                "ToolTip": "If Checked, only a warning is displayed"
            },
            "Param2Message": {
                "Description": "Parameter 2 - Message",
                "ToolTip": "Message Text to be displayed, Required if Parameter 2 is set. Can use the following placeholders: {ParamValue.MinWidth}, {ParamValue.MaxWidth}, {ParamValue.MinHeight}, {ParamValue.MaxHeight}, {ParamValue.MinArea}, {ParamValue.MaxArea}, {EvaluatedWidth}, {EvaluatedHeight}, {EvaluatedArea}"
            }
        },
        "InsyteProduct.Scripts.ValidationByTokenCount": {
            "$ScriptTitle": "Numeric Validation By Token Count",
            "SearchOptionID": {
                "Description": "Search Option",
                "ToolTip": "Product Option whose value will be searched for the tokens"
            },
            "Tokens": {
                "Description": "Tokens",
                "ToolTip": "List of string to search for in the Option Value (can be multiple delimited by the Token Separator)"
            },
            "TokenSeparator": {
                "Description": "Token Separator",
                "ToolTip": "Separator character used when multiple tokens are supplied"
            },
            "CaseSensitive": {
                "Description": "Case Sensitive",
                "ToolTip": "Whether the Tokens are case sensitive"
            },
            "WordMatch": {
                "Description": "Match Whole Word Only",
                "ToolTip": "Match only the full word or match characters in any word"
            }
        },
        "InsyteProduct.Scripts.ValidationTextList": {
            "$ScriptTitle": "Validation - Text List",
            "Message": {
                "Description": "Message",
                "ToolTip": "Message Text to be displayed. Use {0} as a placeholder for option description"
            }
        },
        "InsyteProduct.Scripts.WarningValidation": {
            "$ScriptTitle": "Warning",
            "Message": {
                "Description": "Message",
                "ToolTip": "Warning Message to be displayed"
            }
        },
        "InsyteProduct.Scripts.PanelPatternValidation": {
            "$ScriptTitle": "Panel Pattern Validation",
            "MainPatternColourOptionID": {
                "Description": "Main Pattern Colour Option",
                "ToolTip": "If this parameter is set, will validate that the pattern contains the main colour"
            },
            "MaxPatternColours": {
                "Description": "Maximum Pattern Colours",
                "ToolTip": "Maximum number of distinct colours in pattern allowed. Defaults to 0 (Unlimited)"
            }
        },
        "InsyteProduct.Scripts.VenetianBlind.VenetianBlindBearing": {
            "$ScriptTitle": "Venetian Blind - Bearing",
            "FinishedWidthOptionID": {
                "Description": "Finished Width Option",
                "ToolTip": "Optional, if not set, Opening Width will be used"
            },
            "FirstBearingPositionOptionID": {
                "Description": "First Bearing Position Option",
                "ToolTip": ""
            },
            "BearingWidthOptionID": {
                "Description": "Bearing Width Option",
                "ToolTip": ""
            },
            "MaximumBearingDistanceLookupRangeID": {
                "Description": "Max. Bearing Distance Lookup Range",
                "ToolTip": ""
            },
            "OuterCableBearingSpacingLookupRangeID": {
                "Description": "Outer Cable Bearing Spacing Lookup Range",
                "ToolTip": ""
            },
            "InnerCableBearingSpacingLookupRangeID": {
                "Description": "Inner Cable Bearing Spacing Lookup Range",
                "ToolTip": ""
            },
            "NoBearingsLookupParamName": {
                "Description": "No. of Bearings Lookup Parameter",
                "ToolTip": ""
            },
            "Cable1PositionOptionID": {
                "Description": "Cable 1 Position Option",
                "ToolTip": "Optional"
            },
            "Cable2PositionOptionID": {
                "Description": "Cable 2 Position Option",
                "ToolTip": "Optional"
            },
            "Cable3PositionOptionID": {
                "Description": "Cable 3 Position Option",
                "ToolTip": "Optional"
            },
            "Cable4PositionOptionID": {
                "Description": "Cable 4 Position Option",
                "ToolTip": "Optional"
            },
            "Cable5PositionOptionID": {
                "Description": "Cable 5 Position Option",
                "ToolTip": "Optional"
            },
            "Cable6PositionOptionID": {
                "Description": "Cable 6 Position Option",
                "ToolTip": "Optional"
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "Number of Bearings": "Number of Bearings",
                    "Total Number of Bearings": "Total Number of Bearings",
                    "Bearing 1 Position": "Bearing 1 Position",
                    "Bearing 2 Position": "Bearing 2 Position",
                    "Bearing 3 Position": "Bearing 3 Position",
                    "Bearing 4 Position": "Bearing 4 Position",
                    "Bearing 5 Position": "Bearing 5 Position",
                    "Bearing 6 Position": "Bearing 6 Position",
                    "Bearing 7 Position": "Bearing 7 Position",
                    "Bearing 8 Position": "Bearing 8 Position",
                    "Bearing 9 Position": "Bearing 9 Position",
                    "Bearing 10 Position": "Bearing 10 Position",
                    "Bearing 11 Position": "Bearing 11 Position",
                    "Bearing 12 Position": "Bearing 12 Position"
                }
            }
        },
        "InsyteProduct.Scripts.VenetianBlind.VenetianBlindCable": {
            "$ScriptTitle": "Venetian Blind - Cable",
            "FinishedWidthOptionID": {
                "Description": "Finished Width Option",
                "ToolTip": "Optional, if not set, Opening Width will be used"
            },
            "MaxCableSpan": {
                "Description": "Max Cable Span",
                "ToolTip": "Maximum distance between cables"
            },
            "ExtraInnerCablesOptionID": {
                "Description": "Extra Inner Cables Option",
                "ToolTip": "Option to have extra inner cables over calculated default"
            },
            "FirstCablePositionLookupRangeID": {
                "Description": "First Cable Position Lookup Range",
                "ToolTip": "Either First Cable Position Lookup Range or First Cable Position Lookup Option is required"
            },
            "FirstCablePositionOptionID": {
                "Description": "First Cable Position Option",
                "ToolTip": "Either First Cable Position Lookup Range or First Cable Position Lookup Option is required"
            },
            "InnerCable1PositionOptionID": {
                "Description": "Inner Cable 1 Position Option",
                "ToolTip": ""
            },
            "InnerCable2PositionOptionID": {
                "Description": "Inner Cable 2 Position Option",
                "ToolTip": ""
            },
            "InnerCable3PositionOptionID": {
                "Description": "Inner Cable 3 Position Option",
                "ToolTip": ""
            },
            "InnerCable4PositionOptionID": {
                "Description": "Inner Cable 4 Position Option",
                "ToolTip": ""
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "Number of Cables": "Number of Cables",
                    "Total Number of Cables": "Total Number of Cables",
                    "Cable 1 Position": "Cable 1 Position",
                    "Cable 2 Position": "Cable 2 Position",
                    "Cable 3 Position": "Cable 3 Position",
                    "Cable 4 Position": "Cable 4 Position",
                    "Cable 5 Position": "Cable 5 Position",
                    "Cable 6 Position": "Cable 6 Position"
                }
            }
        },
        "InsyteProduct.Scripts.VenetianBlind.VenetianBlindMotor": {
            "$ScriptTitle": "Venetian Blind - Motor",
            "FinishedWidthOptionID": {
                "Description": "Finished Width Option",
                "ToolTip": "Optional, if not set, Opening Width will be used"
            },
            "MotorWidthOptionID": {
                "Description": "Motor Width Option",
                "ToolTip": ""
            },
            "BearingWidthOptionID": {
                "Description": "Bearing Width Option",
                "ToolTip": ""
            },
            "BearingSpacing": {
                "Description": "Bearing Spacing",
                "ToolTip": "Required spacing to bearing"
            },
            "CableBracketWidthOptionID": {
                "Description": "Cable Bracket Width Option",
                "ToolTip": ""
            },
            "CableBracketSpacing": {
                "Description": "Cable Bracket Spacing",
                "ToolTip": "Required spacing to cable bracket"
            },
            "DriveShaftExtension": {
                "Description": "Drive Shaft Extension",
                "ToolTip": "Amount that the drive shaft extends beyond last bearing"
            },
            "Cable1PositionOptionID": {
                "Description": "Cable 1 Position Option",
                "ToolTip": "Optional"
            },
            "Cable2PositionOptionID": {
                "Description": "Cable 2 Position Option",
                "ToolTip": "Optional"
            },
            "Cable3PositionOptionID": {
                "Description": "Cable 3 Position Option",
                "ToolTip": "Optional"
            },
            "Cable4PositionOptionID": {
                "Description": "Cable 4 Position Option",
                "ToolTip": "Optional"
            },
            "Cable5PositionOptionID": {
                "Description": "Cable 5 Position Option",
                "ToolTip": "Optional"
            },
            "Cable6PositionOptionID": {
                "Description": "Cable 6 Position Option",
                "ToolTip": "Optional"
            },
            "Bearing1PositionOptionID": {
                "Description": "Bearing 1 Position Option",
                "ToolTip": ""
            },
            "Bearing2PositionOptionID": {
                "Description": "Bearing 2 Position Option",
                "ToolTip": ""
            },
            "Bearing3PositionOptionID": {
                "Description": "Bearing 3 Position Option",
                "ToolTip": ""
            },
            "Bearing4PositionOptionID": {
                "Description": "Bearing 4 Position Option",
                "ToolTip": ""
            },
            "Bearing5PositionOptionID": {
                "Description": "Bearing 5 Position Option",
                "ToolTip": ""
            },
            "Bearing6PositionOptionID": {
                "Description": "Bearing 6 Position Option",
                "ToolTip": ""
            },
            "Bearing7PositionOptionID": {
                "Description": "Bearing 7 Position Option",
                "ToolTip": ""
            },
            "Bearing8PositionOptionID": {
                "Description": "Bearing 8 Position Option",
                "ToolTip": ""
            },
            "Bearing9PositionOptionID": {
                "Description": "Bearing 9 Position Option",
                "ToolTip": ""
            },
            "Bearing10PositionOptionID": {
                "Description": "Bearing 10 Position Option",
                "ToolTip": ""
            },
            "Bearing11PositionOptionID": {
                "Description": "Bearing 11 Position Option",
                "ToolTip": ""
            },
            "Bearing12PositionOptionID": {
                "Description": "Bearing 12 Position Option",
                "ToolTip": ""
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "Drive Shaft A": "Drive Shaft A",
                    "Drive Shaft B": "Drive Shaft B",
                    "Motor Position": "Motor Position"
                }
            }
        },
        "InsyteProduct.Scripts.VenetianBlind.VenetianBlindNoSlats": {
            "$ScriptTitle": "Venetian Blind - Number of Slats",
            "FinishedHeightOptionID": {
                "Description": "Finished Height Option",
                "ToolTip": "Optional, if not set, Opening Height will be used"
            },
            "SlatHeightOptionID": {
                "Description": "Slat Height Option",
                "ToolTip": ""
            },
            "SlatOverlap": {
                "Description": "Slat Overlap",
                "ToolTip": ""
            },
            "ExtraSlats": {
                "Description": "Extra Slats",
                "ToolTip": ""
            }
        },
        "InsyteProduct.Scripts.RollerShutterV2.RollerShutterProfile": {
            "$ScriptTitle": "Roller Shutter Profile V2",
            "FinishedHeightOptionID": {
                "Description": "Finished Height Option",
                "ToolTip": "Optional, if not set, Opening Height will be used"
            },
            "ProfileTypeOptionID": {
                "Description": "Profile Type Option",
                "ToolTip": ""
            },
            "ProfileHeightOptionID": {
                "Description": "Profile Height Option",
                "ToolTip": ""
            },
            "BottomRailHeightOptionID": {
                "Description": "Bottom Rail Height Option",
                "ToolTip": ""
            },
            "BottomRailQtyOptionID": {
                "Description": "Bottom Rail Qty Option",
                "ToolTip": "Optional, defaults to 1 is not option set"
            },
            "MainProfileColourOptionID": {
                "Description": "Main Profile Colour Option",
                "ToolTip": ""
            },
            "HeadboxHeightOptionID": {
                "Description": "Headbox Height Option",
                "ToolTip": ""
            },
            "BlanksOptionID": {
                "Description": "Blanks Option",
                "ToolTip": ""
            },
            "ExtrasOptionID": {
                "Description": "Extras Option",
                "ToolTip": ""
            },
            "PanelPatternOptionID": {
                "Description": "Panel Pattern Option",
                "ToolTip": ""
            },
            "Rounding": {
                "Description": "Rounding",
                "ToolTip": "",
                "Values": {
                    "Up": "Up",
                    "Down": "Down",
                    "Nearest": "Nearest"
                }
            },
            "MinAmountInBox": {
                "Description": "Min Amount In Box",
                "ToolTip": "Minimum amount that profile must be within the box. Only Applicable if Rounding = Nearest"
            },
            "ReturnProfileQty": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "Total Qty": "Total Qty",
                    "Stripe Qty": "Stripe Qty",
                    "Blanks Qty": "Blanks Qty",
                    "Holes Qty": "Holes Qty",
                    "Stripe Info": "Stripe Info",
                    "Colour": "Colour",
                    "Colour Qty": "Colour Qty"
                }
            },
            "ColourIndex": {
                "Description": "Return Value Colour Index",
                "ToolTip": "Index of Colour to return value for. 1 = main colour, 2 = next colour in pattern etc. Required if Return Value = 'Colour' or 'Colour Qty'"
            }
        },
        "InsyteProduct.Scripts.RollerShutter.RollerShutterProfile": {
            "$ScriptTitle": "Roller Shutter Profile",
            "FinishedHeightOptionID": {
                "Description": "Finished Height Option",
                "ToolTip": "Optional, if not set, Opening Height will be used"
            },
            "ProfileTypeOptionID": {
                "Description": "Profile Type Option",
                "ToolTip": ""
            },
            "ProfileHeightOptionID": {
                "Description": "Profile Height Option",
                "ToolTip": ""
            },
            "BottomRailHeightOptionID": {
                "Description": "Bottom Rail Height Option",
                "ToolTip": ""
            },
            "BottomRailQtyOptionID": {
                "Description": "Bottom Rail Qty Option",
                "ToolTip": "Optional, defaults to 1 is not option set"
            },
            "MainProfileColourOptionID": {
                "Description": "Main Profile Colour Option",
                "ToolTip": ""
            },
            "HeadboxHeightOptionID": {
                "Description": "Headbox Height Option",
                "ToolTip": ""
            },
            "BlanksOptionID": {
                "Description": "Blanks Option",
                "ToolTip": ""
            },
            "ExtrasOptionID": {
                "Description": "Extras Option",
                "ToolTip": ""
            },
            "PanelPatternOptionID": {
                "Description": "Panel Pattern Option",
                "ToolTip": ""
            },
            "Rounding": {
                "Description": "Rounding",
                "ToolTip": "",
                "Values": {
                    "Up": "Up",
                    "Down": "Down",
                    "Nearest": "Nearest"
                }
            },
            "MinAmountInBox": {
                "Description": "Min Amount In Box",
                "ToolTip": "Minimum amount that profile must be within the box. Only Applicable if Rounding = Nearest"
            },
            "ReturnProfileQty": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "Total Qty": "Total Qty",
                    "Stripe Qty": "Stripe Qty",
                    "Blanks Qty": "Blanks Qty",
                    "Holes Qty": "Holes Qty",
                    "Stripe Info": "Stripe Info",
                    "Colour": "Colour",
                    "Colour Qty": "Colour Qty"
                }
            },
            "ColourIndex": {
                "Description": "Return Value Colour Index",
                "ToolTip": "Index of Colour to return value for. 1 = main colour, 2 = next colour in pattern etc. Required if Return Value = 'Colour' or 'Colour Qty'"
            }
        },
        "InsyteProduct.Scripts.PanelPattern.PanelPatternDisplayFormatter": {
            "$ScriptTitle": "Panel Pattern Display Formatter",
            "DisplayOrder": {
                "Description": "Display Order",
                "ToolTip": "",
                "Values": {
                    "TopToBottom": "TopToBottom",
                    "BottomToTop": "BottomToTop"
                }
            },
            "UseSpacesInsteadOfLineBreaks": {
                "Description": "Use Spaces Instead Of Line Breaks",
                "ToolTip": "If checked, line breaks (the default) will be swapped to spaces"
            },
            "PrefixWithNewLine": {
                "Description": "Prefix Value with a New line",
                "ToolTip": "If checked, the value will be prefixed with a new line"
            }
        },
        "InsyteProduct.Scripts.Awning.AwningFixedLouvres": {
            "$ScriptTitle": "Awning (Fixed Louvre) - Louvres",
            "FinishedProjectionOptionID": {
                "Description": "Finished Projection Option",
                "ToolTip": ""
            },
            "ProfileSpacingOptionID": {
                "Description": "Profile Spacing Option",
                "ToolTip": ""
            },
            "MinProfileOverlapOptionID": {
                "Description": "Min Profile Overlap Option",
                "ToolTip": ""
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "No of Louvres": "No of Louvres",
                    "Final Gap": "Final Gap"
                }
            }
        },
        "InsyteProduct.Scripts.Awning.AwningPVCStarFabric": {
            "$ScriptTitle": "Awning (PVC Star) - Fabric",
            "FinishedWidthOptionID": {
                "Description": "Finished Width Option",
                "ToolTip": "Optional, if not set, Opening Width will be used"
            },
            "FinishedProjectionOptionID": {
                "Description": "Finished Projection Option",
                "ToolTip": ""
            },
            "FabricOptionID": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "OuterBatternWidthOptionID": {
                "Description": "Outer Battern Width Option",
                "ToolTip": ""
            },
            "TotalNoOfBatternsOptionID": {
                "Description": "Total No. of Batterns Option",
                "ToolTip": ""
            },
            "SplineAllowance": {
                "Description": "Spline Allowance",
                "ToolTip": ""
            },
            "SplineAllowanceOptionID": {
                "Description": "Spline Allowance Option",
                "ToolTip": ""
            },
            "JoinAllowance": {
                "Description": "Join Allowance",
                "ToolTip": ""
            },
            "JoinAllowanceOptionID": {
                "Description": "Join Allowance Option",
                "ToolTip": ""
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "No of Joins": "No of Joins",
                    "No of Stages": "No of Stages",
                    "Fabric Meterage": "Fabric Meterage",
                    "Overall Projection": "Overall Projection",
                    "Battern Summary": "Battern Summary",
                    "Battern Position": "Battern Position"
                }
            },
            "ReturnValueIndex": {
                "Description": "Return Value Index",
                "ToolTip": "Required if Return Value = Battern Position"
            }
        },
        "InsyteProduct.Scripts.Awning.AwningPVCVertexFabric": {
            "$ScriptTitle": "Awning (PVC Vertex) - Fabric",
            "FinishedWidthOptionID": {
                "Description": "Finished Width Option",
                "ToolTip": "Optional, if not set, Opening Width will be used"
            },
            "FinishedProjectionOptionID": {
                "Description": "Finished Projection Option",
                "ToolTip": ""
            },
            "FabricOptionID": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "OuterBatternWidthOptionID": {
                "Description": "Outer Battern Width Option",
                "ToolTip": ""
            },
            "TotalNoOfBatternsOptionID": {
                "Description": "Total No. of Batterns Option",
                "ToolTip": ""
            },
            "SplineAllowance": {
                "Description": "Spline Allowance",
                "ToolTip": ""
            },
            "SplineAllowanceOptionID": {
                "Description": "Spline Allowance Option",
                "ToolTip": ""
            },
            "JoinAllowance": {
                "Description": "Join Allowance",
                "ToolTip": ""
            },
            "JoinAllowanceOptionID": {
                "Description": "Join Allowance Option",
                "ToolTip": ""
            },
            "CuttingSpacing": {
                "Description": "Cutting Spacing",
                "ToolTip": ""
            },
            "CuttingSpacingOptionID": {
                "Description": "Cutting Spacing Option",
                "ToolTip": ""
            },
            "FallDegress": {
                "Description": "Fall Degrees",
                "ToolTip": ""
            },
            "FallDegressOptionID": {
                "Description": "Fall Degrees Option",
                "ToolTip": ""
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "No of Panels": "No of Panels",
                    "Panel Length": "Panel Length",
                    "No of Joins": "No of Joins",
                    "No of Stages": "No of Stages",
                    "Fabric Meterage": "Fabric Meterage",
                    "Overall Projection": "Overall Projection",
                    "Battern Summary": "Battern Summary",
                    "Battern Position": "Battern Position",
                    "Panel Summary": "Panel Summary",
                    "Panel Size": "Panel Size",
                    "Panel Inner Width": "Panel Inner Width",
                    "Panel Outer Width": "Panel Outer Width"
                }
            },
            "ReturnValueIndex": {
                "Description": "Return Value Index",
                "ToolTip": "Required if Return Value = Battern Position, Panel Size, Panel Inner Width, Panel Outer Width"
            }
        },
        "InsyteProduct.Scripts.Awning.AwningRetractableLouvres": {
            "$ScriptTitle": "Awning (Retractable Louvre) - Louvres",
            "FinishedProjectionOptionID": {
                "Description": "Finished Projection Option",
                "ToolTip": ""
            },
            "ProfileSpacingOptionID": {
                "Description": "Profile Spacing Option",
                "ToolTip": ""
            },
            "MinProfileOverlapOptionID": {
                "Description": "Min Profile Overlap Option",
                "ToolTip": ""
            },
            "CoverProfileWidthOptionID": {
                "Description": "Cover Profile Width Option",
                "ToolTip": ""
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "No of Louvres": "No of Louvres",
                    "Final Gap": "Final Gap"
                }
            }
        },
        "InsyteProduct.Scripts.AluPlantationShutter.AluPlantationShutterControlBars": {
            "$ScriptTitle": "Aluminium Plantation Shutter - Control Bars",
            "NoBladesOptionID": {
                "Description": "No Blades Option",
                "ToolTip": ""
            },
            "NoControlBarsOptionID": {
                "Description": "No Control Bars Option",
                "ToolTip": ""
            },
            "DualControlBarsOptionID": {
                "Description": "Dual Control Bars Option",
                "ToolTip": ""
            },
            "PanelQtyOptionID": {
                "Description": "Panel Qty Option",
                "ToolTip": "Defaults to 1 if not set"
            },
            "SummaryFormatString": {
                "Description": "Summary Format String",
                "ToolTip": "Only application if Return value = \"Control Bar Summary\". Format String that uses the placeholder {0} for the summary"
            },
            "SummarySeparator": {
                "Description": "Summary Separator",
                "ToolTip": "Only application if Return value = \"Control Bar Summary\". Separator to use between control bars in summary"
            },
            "SummaryGroupByBladeQty": {
                "Description": "Summary Group by Blade Qty",
                "ToolTip": "Only application if Return value = \"Control Bar Summary\". If set control bars with the same number of blades will be grouped together"
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "No Blades - Bar 1": "No Blades - Bar 1",
                    "No Blades - Bar 2": "No Blades - Bar 2",
                    "No Blades - Bar 3": "No Blades - Bar 3",
                    "No Blades - Bar 4": "No Blades - Bar 4",
                    "Control Bar Summary": "Control Bar Summary"
                }
            }
        },
        "InsyteProduct.Scripts.AluPlantationShutter.AluPlantationShutterPanelWidth": {
            "$ScriptTitle": "Aluminium Plantation Shutter - Panel Width",
            "FinishedWidthOptionID": {
                "Description": "Finished Width Option",
                "ToolTip": "Optional, if not set, Opening Width will be used"
            },
            "PanelTypeOptionID": {
                "Description": "Panel Type Option",
                "ToolTip": ""
            },
            "PanelQtyOptionID": {
                "Description": "Panel Qty Option",
                "ToolTip": ""
            },
            "FirstPanelWidthOptionID": {
                "Description": "First Panel Width Option",
                "ToolTip": ""
            },
            "LastPanelWidthOptionID": {
                "Description": "Last Panel Width Option",
                "ToolTip": ""
            },
            "PanelWidthRounding": {
                "Description": "Panel Width Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "PanelWidthRoundingDP": {
                "Description": "Panel Width Rounding Decimal Places",
                "ToolTip": ""
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "First Panel Width": "First Panel Width",
                    "Intermediate Panel 1 Width": "Intermediate Panel 1 Width",
                    "Intermediate Panel 2 Width": "Intermediate Panel 2 Width",
                    "Intermediate Panel 3 Width": "Intermediate Panel 3 Width",
                    "Intermediate Panel 4 Width": "Intermediate Panel 4 Width",
                    "Intermediate Panel 5 Width": "Intermediate Panel 5 Width",
                    "Intermediate Panel 6 Width": "Intermediate Panel 6 Width",
                    "Intermediate Panel 7 Width": "Intermediate Panel 7 Width",
                    "Intermediate Panel 8 Width": "Intermediate Panel 8 Width",
                    "Intermediate Panel 9 Width": "Intermediate Panel 9 Width",
                    "Intermediate Panel 10 Width": "Intermediate Panel 10 Width",
                    "Last Panel Width": "Last Panel Width",
                    "": ""
                }
            }
        },
        "InsyteProduct.Scripts.AluPlantationShutter.AluPlantationShutterProfile": {
            "$ScriptTitle": "Aluminium Plantation Shutter - Profile",
            "FinishedHeightOptionID": {
                "Description": "Finished Height Option",
                "ToolTip": "Optional, if not set, Opening Height will be used"
            },
            "PanelQtyOptionID": {
                "Description": "Panel Qty Option",
                "ToolTip": "Optional, if not set, Panel Qty = 1"
            },
            "MinTopRailHeightOptionID": {
                "Description": "Minimum Top Rail Height Option",
                "ToolTip": ""
            },
            "MinBottomRailHeightOptionID": {
                "Description": "Minimum Bottom Rail Height Option",
                "ToolTip": ""
            },
            "MaxRailHeight": {
                "Description": "Maximum Rail Height",
                "ToolTip": "Either Max Rail Height or Max Rail Height Option must be specified"
            },
            "MaxRailHeightOptionID": {
                "Description": "Max Rail Height Option",
                "ToolTip": "Either Max Rail Height or Max Rail Height Option must be specified"
            },
            "PreferredTopRailHeight": {
                "Description": "Preferred Top Rail Height ",
                "ToolTip": "Either Preferred Top Rail Height or Preferred Top Rail Height Option must be specified"
            },
            "PreferredTopRailHeightOptionID": {
                "Description": "Preferred Top Rail Height Option",
                "ToolTip": "Either Preferred Top Rail Height  or Preferred Top Rail Height Option must be specified"
            },
            "PreferredTopRailMidrailVariance": {
                "Description": "Preferred Top Rail Midrail Variance",
                "ToolTip": "Either Preferred Top Rail Midrail Variance or Preferred Top Rail Midrail Variance Option must be specified"
            },
            "PreferredTopRailMidrailVarianceOptionID": {
                "Description": "Preferred Top Rail Midrail Variance Option",
                "ToolTip": "Either Preferred Top Rail Midrail Variance or Preferred Top Rail Midrail Variance Option must be specified"
            },
            "ProfileBladeHeightOptionID": {
                "Description": "Profile Blade Height Option",
                "ToolTip": ""
            },
            "ProfileBladePitchOptionID": {
                "Description": "Profile Blade Pitch Option",
                "ToolTip": ""
            },
            "FirstMidrailHeightOptionID": {
                "Description": "1st Midrail Height Option",
                "ToolTip": ""
            },
            "FirstMidrailLockedOptionID": {
                "Description": "1st Midrail Locked Option",
                "ToolTip": ""
            },
            "SecondMidrailHeightOptionID": {
                "Description": "2nd Midrail Height Option",
                "ToolTip": ""
            },
            "ThirdMidrailHeightOptionID": {
                "Description": "3rd Midrail Height Option",
                "ToolTip": ""
            },
            "ForthMidrailHeightOptionID": {
                "Description": "4th Midrail Height Option",
                "ToolTip": ""
            },
            "HoleAllowance": {
                "Description": "Hole Allowance",
                "ToolTip": ""
            },
            "StileEndCapClearance": {
                "Description": "Stile End Cap Clearance",
                "ToolTip": ""
            },
            "ReturnValue": {
                "Description": "Return Value",
                "ToolTip": "",
                "Values": {
                    "Bottom Hole Position": "Bottom Hole Position",
                    "Top Hole Position": "Top Hole Position",
                    "Total Blade Qty": "Total Blade Qty",
                    "Blade Qty Bottom": "Blade Qty Bottom",
                    "Blade Qty Middle": "Blade Qty Middle",
                    "Blade Qty Top": "Blade Qty Top",
                    "Bottom Rail Height": "Bottom Rail Height",
                    "Top Rail Height": "Top Rail Height",
                    "Midrail Position": "Midrail Position"
                }
            },
            "ReturnValueIndex": {
                "Description": "Return Value Index",
                "ToolTip": "Required if Return Value = Blade Qty Middle,Midrail Position"
            }
        }
    },
    "SoftFurnishingsShared": {
        "SoftFurnishings.Scripts.FabricValidation": {
            "$ScriptTitle": "Fabric Validation",
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "FinishedLengthOption": {
                "Description": "Finished Length Option",
                "ToolTip": "Numeric Product Option that contains Finished Length, if not set opening height will be used"
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "AllowContinuous": {
                "Description": "Continuous Allowed",
                "ToolTip": ""
            },
            "AllowRailRoading": {
                "Description": "Railroading Allowed",
                "ToolTip": ""
            },
            "IgnoreFabricWidth": {
                "Description": "Ignore Fabric Width",
                "ToolTip": "If checked, allow Fabrics where Fabric Width < Total Width. Used for products where the Fabric is not 1 continuous piece across the opening"
            },
            "IgnoreRailroadedFabricWidth": {
                "Description": "Ignore Railroaded Fabric Width",
                "ToolTip": "If checked, allowed Fabric where Fabric Width < Total Drop"
            }
        },
        "SoftFurnishings.Scripts.SupplierFabricPricing": {
            "$ScriptTitle": "Supplier Fabric Pricing",
            "NoMetresOption": {
                "Description": "No Metres Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.TrackWidth": {
            "$ScriptTitle": "Valance - Track Width (*same as Curtain - Track Width*)",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.HeadedSize": {
            "$ScriptTitle": "Valance - Headed Size (*same as Curtain - Headed Size*)",
            "HeadedSizeMeasurement": {
                "Description": "Headed Size Measurement",
                "ToolTip": "",
                "Values": {
                    "1": "1",
                    "2": "2"
                }
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "OperationOption": {
                "Description": "Operation Option",
                "ToolTip": ""
            },
            "HeadedSizeAdjustmentLOption": {
                "Description": "Headed Size (L) Adjustment Option",
                "ToolTip": ""
            },
            "HeadedSizeAdjustmentROption": {
                "Description": "Headed Size (R) Adjustment Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.NoDropFabric": {
            "$ScriptTitle": "Valance - No of Drops (Fabric) (*same as Curtain - No of Drops (Fabric)*)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.NoDropLining": {
            "$ScriptTitle": "Valance - No of Drops (Lining) (*same as Curtain - No of Drops (Lining)*)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.Meterage": {
            "$ScriptTitle": "Valance - Fabric Meterage (*same as Curtain - Fabric Meterage*)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.MeterageLining": {
            "$ScriptTitle": "Valance - Lining Meterage (*same as Curtain - Lining Meterage*)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.ValanceFabricPricing": {
            "$ScriptTitle": "Valance - Fabric Pricing (*same as Curtain - Fabric Pricing*)",
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No Curtains Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Return(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Return(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.ValanceLiningPricing": {
            "$ScriptTitle": "Valance - Lining Pricing (*same as Curtain - Lining Pricing*)",
            "FabricOption": {
                "Description": "Main Fabric Option (Not Lining)",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No Curtains Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Return(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Return(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.ValanceManufacturePricing": {
            "$ScriptTitle": "Valance - Workroom Pricing (*same as Curtain - Workroom Pricing*)",
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "NoCurtainsOption": {
                "Description": "No Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Return(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Return(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            },
            "ManufacturerSettings": {
                "Description": "Workroom Settings",
                "ToolTip": ""
            },
            "FaceFabric": {
                "Description": "Face Fabric Option",
                "ToolTip": ""
            },
            "FaceFabricRailroad": {
                "Description": "Face Fabric Rail Road Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Valance.ValanceSurchargeByDrops": {
            "$ScriptTitle": "Valance - Surcharge - By No of Drops (Fabric) (*same as Curtain - Surcharge - By No of Drops (Fabric)*)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Track.TrackWidth": {
            "$ScriptTitle": "Austrian Blind - Total Track Width",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Track.ManufacturePricing": {
            "$ScriptTitle": "Track - Workroom Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Tieback.Meterage": {
            "$ScriptTitle": "Tieback - Fabric Meterage",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": "Optional, can be calculated separately"
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": "Optional, can be calculated separately"
            }
        },
        "SoftFurnishings.Scripts.Tieback.ContrastMeterage": {
            "$ScriptTitle": "Tieback - Contrast Meterage",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Tieback.PipedMeterage": {
            "$ScriptTitle": "Tieback - Piped Meterage",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Tieback.FrilledMeterage": {
            "$ScriptTitle": "Tieback - Frilled Meterage",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Tieback.TrimMeterage": {
            "$ScriptTitle": "Tieback - Trim Meterage",
            "SizeOption": {
                "Description": "Size Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Tieback.TiebackContrastFabricPricing": {
            "$ScriptTitle": "Tieback - Contrast Fabric Pricing",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Tieback.TiebackFabricPricing": {
            "$ScriptTitle": "Tieback - Fabric Pricing",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Tieback.ManufacturePricing": {
            "$ScriptTitle": "Tieback - Workroom Pricing",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            },
            "ManufacturerSettings": {
                "Description": "Workroom Settings",
                "ToolTip": ""
            },
            "FaceFabric": {
                "Description": "Face Fabric Option",
                "ToolTip": ""
            },
            "FaceFabricRailroad": {
                "Description": "Face Fabric Rail Road Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.HeadboardWidth": {
            "$ScriptTitle": "Swag And Tail - Headboard Size",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.SwagMeterage": {
            "$ScriptTitle": "Swag And Tail - Swag Meterage",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "QtyOption": {
                "Description": "Quantity Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.TailMeterage": {
            "$ScriptTitle": "Swag And Tail - Tail Meterage",
            "FabricOption": {
                "Description": "Fabric/Contrast Fabric Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "ContrastCodes": {
                "Description": "Contrast Style Codes",
                "ToolTip": ""
            },
            "QtyOption": {
                "Description": "Quantity Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.JabotMeterage": {
            "$ScriptTitle": "Swag And Tail - Jabot Meterage",
            "FabricOption": {
                "Description": "Fabric/Contrast Fabric Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "ContrastCodes": {
                "Description": "Contrast Style Codes",
                "ToolTip": ""
            },
            "QtyOption": {
                "Description": "Quantity Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.LiningMeterage": {
            "$ScriptTitle": "Swag And Tail - Lining Meterage",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.TrimMeterage": {
            "$ScriptTitle": "Swag And Tail - Trim Meterage",
            "TrimOption": {
                "Description": "Trim Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.SwagAndTailFabricPricing": {
            "$ScriptTitle": "Swag And Tail - Swag Fabric Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.SwagAndTailJabotFabricPricing": {
            "$ScriptTitle": "Swag And Tail - Jabot Fabric Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "ContrastCodes": {
                "Description": "Contrast Style Codes",
                "ToolTip": ""
            },
            "QtyOption": {
                "Description": "Quantity Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.SwagAndTailManufacturePricing": {
            "$ScriptTitle": "Swag And Tail - Workroom Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.SwagAndTail.SwagAndTailTailFabricPricing": {
            "$ScriptTitle": "Swag And Tail - Tails Fabric Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "ContrastCodes": {
                "Description": "Contrast Style Codes",
                "ToolTip": ""
            },
            "QtyOption": {
                "Description": "Quantity Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.Meterage": {
            "$ScriptTitle": "Roman Blind - Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.CutSizeFabric": {
            "$ScriptTitle": "Roman Blind - Cut Size (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.CutSizeBaseFinish": {
            "$ScriptTitle": "Roman Blind - Cut Size (Base Finish)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            },
            "BorderWidthOption": {
                "Description": "Border Width Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.NoDropBaseFinish": {
            "$ScriptTitle": "Roman Blind - No of Drops (Base Finish)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.MeterageBaseFinish": {
            "$ScriptTitle": "Roman Blind - Meterage (Base Finish)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            },
            "BorderWidthOption": {
                "Description": "Border Width Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.NoDrop": {
            "$ScriptTitle": "Roman Blind - No of Drops (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.NoDropLining": {
            "$ScriptTitle": "Roman Blind - No of Drops (Lining)",
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.LiningMeterage": {
            "$ScriptTitle": "Roman Blind - Meterage (Lining)",
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.CutSizeLining": {
            "$ScriptTitle": "Roman Blind - Cut Size (Lining)",
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.BlindWidth": {
            "$ScriptTitle": "Roman Blind - Blind Width",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.RBContrastFabricPricing": {
            "$ScriptTitle": "Roman Blind - Contrast Fabric Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            },
            "BorderWidthOption": {
                "Description": "Border Width Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.FabricPricing": {
            "$ScriptTitle": "Roman Blind - Fabric Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            },
            "BorderWidthOption": {
                "Description": "Border Width Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.LiningPricing": {
            "$ScriptTitle": "Roman Blind - Lining Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.RomanBlind.ManufacturePricing": {
            "$ScriptTitle": "Roman Blind - Workroom Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.QuiltCover.ContrastFabricPipedPricing": {
            "$ScriptTitle": "Quilt Cover - Contrast Piped Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.QuiltCover.ContrastFabricFrilledFlangedPricing": {
            "$ScriptTitle": "Quilt Cover - Contrast Frilled/Flanged Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.QuiltCover.NoDrops": {
            "$ScriptTitle": "Quilt Cover - No of Drops",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.QuiltCover.MeterageFabric": {
            "$ScriptTitle": "Quilt Cover - Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.QuiltCover.MeterageContractPipedFabric": {
            "$ScriptTitle": "Quilt Cover - Meterage (Contrast Piped)",
            "FabricOption": {
                "Description": "Contrast Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.QuiltCover.MeterageContractFrilledFlangedFabric": {
            "$ScriptTitle": "Quilt Cover - Meterage (Contrast Frilled/Flanged)",
            "FabricOption": {
                "Description": "Contrast Frilled/Flanged Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.QuiltCover.FabricPricing": {
            "$ScriptTitle": "Quilt Cover - Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.QuiltCover.ManufacturePricing": {
            "$ScriptTitle": "Quilt Cover - Workroom Pricing",
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pillowcase.NoDrops": {
            "$ScriptTitle": "Pillowcase - No of Drops",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pillowcase.MeterageFabric": {
            "$ScriptTitle": "Pillowcase - Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pillowcase.MeterageContractPipedFabric": {
            "$ScriptTitle": "Pillowcase - Meterage (Contrast Piped)",
            "FabricOption": {
                "Description": "Contrast Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pillowcase.MeterageContractFrilledFlangedFabric": {
            "$ScriptTitle": "Pillowcase - Meterage (Contrast Frilled/Flanged)",
            "FabricOption": {
                "Description": "Contrast Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pillowcase.ContrastFabricPipedPricing": {
            "$ScriptTitle": "Pillowcase - Contrast Piped Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pillowcase.ContrastFabricFrilledFlangedPricing": {
            "$ScriptTitle": "Pillowcase - Contrast Frilled/Flanged Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pillowcase.FabricPricing": {
            "$ScriptTitle": "Pillowcase - Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pillowcase.ManufacturePricing": {
            "$ScriptTitle": "Pillowcase - Workroom Pricing",
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.Meterage": {
            "$ScriptTitle": "Pelmet - Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": "If selected, Piping will be calculated based on Finish Code, otherwise Piping is excluded"
            }
        },
        "SoftFurnishings.Scripts.Pelmet.NoDrop": {
            "$ScriptTitle": "Pelmet - No of Drops (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.CutSizeFabric": {
            "$ScriptTitle": "Pelmet - Cut Size (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.CutSizePiping": {
            "$ScriptTitle": "Pelmet - Cut Size (Fabric Piping)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.NoDropPiping": {
            "$ScriptTitle": "Pelmet - No of Drops (Fabric Piping)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.MeteragePiping": {
            "$ScriptTitle": "Pelmet - Fabric Meterage (Fabric Piping)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.InterliningMeterage": {
            "$ScriptTitle": "Pelmet - Meterage (Interlining Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": "If selected, Piping will be calculated based on Finish Code, otherwise Piping is excluded"
            }
        },
        "SoftFurnishings.Scripts.Pelmet.InterliningNoDrop": {
            "$ScriptTitle": "Pelmet - No of Drops (Interlining Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.InterliningCutSize": {
            "$ScriptTitle": "Pelmet - Cut Size (Interlining Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.CutSizeInterliningPiping": {
            "$ScriptTitle": "Pelmet - Cut Size (Interlining Fabric Piping)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.NoDropInterliningPiping": {
            "$ScriptTitle": "Pelmet - No of Drops (Interlining Fabric Piping)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.MeterageInterliningPiping": {
            "$ScriptTitle": "Pelmet - Fabric Meterage (Interlining Fabric Piping)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.ContrastMeterage": {
            "$ScriptTitle": "Pelmet - Meterage (Contrast Fabric Piping)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.NoDropContrast": {
            "$ScriptTitle": "Pelmet - No of Drops (Contrast Fabric Piping)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.CutSizeContrast": {
            "$ScriptTitle": "Pelmet - Cut Size (Contrast Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.TrimMeterage": {
            "$ScriptTitle": "Pelmet - Trim Meterage",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.HeadboardWidth": {
            "$ScriptTitle": "Pelmet - Headboard Width",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.PelmetContrastFabricPricing": {
            "$ScriptTitle": "Pelmet - Fabric Pricing (Contrast Fabric)",
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Pelmet.FabricPricing": {
            "$ScriptTitle": "Pelmet - Fabric Pricing (Fabric)",
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": "If selected, Piping will be calculated based on Finish Code, otherwise Piping is excluded"
            }
        },
        "SoftFurnishings.Scripts.Pelmet.PelmetInterliningFabricPricing": {
            "$ScriptTitle": "Pelmet - Fabric Pricing (Interlining Fabric)",
            "RailroadOption": {
                "Description": "Railroad Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": "If selected, Piping will be calculated based on Finish Code, otherwise Piping is excluded"
            }
        },
        "SoftFurnishings.Scripts.Pelmet.ManufacturePricing": {
            "$ScriptTitle": "Pelmet - Workroom Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Headboard.HeadboardWidth": {
            "$ScriptTitle": "Headboard - Total Width",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Headboard.ManufacturePricing": {
            "$ScriptTitle": "Headboard - Workroom Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Timber.DefaultValueLinearMetre": {
            "$ScriptTitle": "Flooring (Timber) - Linear Metres based on Square Metres",
            "SqmOptionID": {
                "Description": "Square Metres Option",
                "ToolTip": "Option that contains Total m2"
            },
            "MaterialOptionID": {
                "Description": "Material Option",
                "ToolTip": "Option that contains the Fabric (either Fabric Option or Conversion Factor is required)"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Timber.DefaultValueOrderAmountSummary": {
            "$ScriptTitle": "Flooring (Timber) - Order Amount Summary based on Square Metres",
            "SqmOptionID": {
                "Description": "Square Metres Option",
                "ToolTip": "Option that contains Total m2"
            },
            "MaterialOptionID": {
                "Description": "Material Option",
                "ToolTip": "Option that contains the Fabric (either Fabric Option or Conversion Factor is required)"
            },
            "LMResultRounding": {
                "Description": "LM Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "LMResultRoundingDP": {
                "Description": "LM Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Timber.DefaultValueOrderQty": {
            "$ScriptTitle": "Flooring (Timber) - Order Quantity based on Square Metres",
            "SqmOptionID": {
                "Description": "Square Metres Option",
                "ToolTip": "Option that contains Total m2"
            },
            "MaterialOptionID": {
                "Description": "Material Option",
                "ToolTip": "Option that contains the Fabric (either Fabric Option or Conversion Factor is required)"
            },
            "LMResultRounding": {
                "Description": "LM Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "LMResultRoundingDP": {
                "Description": "LM Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Timber.DefaultValueOrderTotalAmount": {
            "$ScriptTitle": "Flooring (Timber) - Total Order Amount based on Square Metres",
            "SqmOptionID": {
                "Description": "Square Metres Option",
                "ToolTip": "Option that contains Total m2"
            },
            "MaterialOptionID": {
                "Description": "Material Option",
                "ToolTip": "Option that contains the Fabric (either Fabric Option or Conversion Factor is required)"
            },
            "LMResultRounding": {
                "Description": "LM Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "LMResultRoundingDP": {
                "Description": "LM Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Timber.TimberPricing": {
            "$ScriptTitle": "Flooring (Timber) - Pricing",
            "SqmOptionID": {
                "Description": "Square Metres Option",
                "ToolTip": "Option that contains Total m2"
            },
            "MaterialOptionID": {
                "Description": "Material Option",
                "ToolTip": "Option that contains the Material"
            },
            "UnderlayOptionID": {
                "Description": "Underlay Option",
                "ToolTip": ""
            },
            "LMResultRounding": {
                "Description": "LM Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "LMResultRoundingDP": {
                "Description": "LM Result Rounding Decimal Places",
                "ToolTip": ""
            },
            "PriceField": {
                "Description": "Price Field",
                "ToolTip": "Price Field. Optional, if not set defaults to relevant price field based on where script is defined",
                "Values": {
                    "COST": "COST",
                    "RETAIL": "RETAIL"
                }
            },
            "PriceMultiplier": {
                "Description": "Price Multiplier",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Carpet.CarpetPricingFromCuts": {
            "$ScriptTitle": "Flooring (Carpet) - Pricing (from Cuts)",
            "CutsOptionID": {
                "Description": "Cuts Option",
                "ToolTip": ""
            },
            "CarpetOptionID": {
                "Description": "Carpet Option",
                "ToolTip": ""
            },
            "UnderlayOptionID": {
                "Description": "Underlay Option",
                "ToolTip": ""
            },
            "SQMRounding": {
                "Description": "SQM Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "SQMRoundingDP": {
                "Description": "SQM Rounding Decimal Places",
                "ToolTip": ""
            },
            "PriceField": {
                "Description": "Price Field",
                "ToolTip": "Price Field. Optional, if not set defaults to relevant price field based on where script is defined",
                "Values": {
                    "COST": "COST",
                    "RETAIL": "RETAIL"
                }
            },
            "PriceMultiplier": {
                "Description": "Price Multiplier",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Carpet.CarpetPricingFromSQM": {
            "$ScriptTitle": "Flooring (Carpet) - Pricing (from SQM)",
            "SQMOptionID": {
                "Description": "Square Metres Option",
                "ToolTip": ""
            },
            "CarpetOptionID": {
                "Description": "Carpet Option",
                "ToolTip": ""
            },
            "UnderlayOptionID": {
                "Description": "Underlay Option",
                "ToolTip": ""
            },
            "LMRounding": {
                "Description": "LM Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "LMRoundingDP": {
                "Description": "LM Rounding Decimal Places",
                "ToolTip": ""
            },
            "PriceField": {
                "Description": "Price Field",
                "ToolTip": "Price Field. Optional, if not set defaults to relevant price field based on where script is defined",
                "Values": {
                    "COST": "COST",
                    "RETAIL": "RETAIL"
                }
            },
            "PriceMultiplier": {
                "Description": "Price Multiplier",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Carpet.DefaultValueCarpetLinearMetreByCuts": {
            "$ScriptTitle": "Flooring (Carpet) - Carpet Linear Metres based on Cuts",
            "CutsOptionID": {
                "Description": "Cuts Option",
                "ToolTip": "Option for Cuts"
            }
        },
        "SoftFurnishings.Scripts.Flooring.Carpet.DefaultValueLinearMetreBySQM": {
            "$ScriptTitle": "Flooring (Carpet) - Linear Metres based on Square Metres",
            "SqmOptionID": {
                "Description": "Square Metres Option",
                "ToolTip": "Option that contains Total m2"
            },
            "FabricOptionID": {
                "Description": "Fabric Option",
                "ToolTip": "Option that contains the Fabric (either Fabric Option or Conversion Factor is required)"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Carpet.DefaultValueSquareMetreByCuts": {
            "$ScriptTitle": "Flooring (Carpet) - Square Metres based on Cuts",
            "CutsOptionID": {
                "Description": "Cuts Option",
                "ToolTip": "Option for Cuts"
            },
            "CarpetOptionID": {
                "Description": "Carpet Option",
                "ToolTip": "Option that contains the Carpet"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Carpet.DefaultValueUnderlayLinearMetreByCuts": {
            "$ScriptTitle": "Flooring (Carpet) - Underlay Linear Metres based on Cuts",
            "CutsOptionID": {
                "Description": "Cuts Option",
                "ToolTip": "Option for Cuts"
            },
            "CarpetOptionID": {
                "Description": "Carpet Option",
                "ToolTip": "Option that contains the Carpet"
            },
            "UnderlayOptionID": {
                "Description": "Underlay Option",
                "ToolTip": "Option that contains the Carpet"
            },
            "SQMRounding": {
                "Description": "SQM Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "SQMRoundingDP": {
                "Description": "SQM Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Flooring.Carpet.LinearMetreCutsValidation": {
            "$ScriptTitle": "Flooring (Carpet) - Linear Metre Cuts Validation",
            "LMOptionID": {
                "Description": "Linear Metres Option",
                "ToolTip": "Option that contains Total Linear Metres"
            }
        },
        "SoftFurnishings.Scripts.Cushion.NoDrops": {
            "$ScriptTitle": "Cushion - No of Drops",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "TypeOption": {
                "Description": "Type Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Cushion.MeterageFabric": {
            "$ScriptTitle": "Cushion - Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "TypeOption": {
                "Description": "Type Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "DepthOption": {
                "Description": "Depth Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FrillSizeOption": {
                "Description": "Frill Size Option",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Cushion.MeterageContrastPipedFabric": {
            "$ScriptTitle": "Cushion - Meterage (Contrast Piped)",
            "FabricOption": {
                "Description": "Contrast Fabric Option",
                "ToolTip": ""
            },
            "TypeOption": {
                "Description": "Type Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Cushion.MeterageContrastFrilledFlangedFabric": {
            "$ScriptTitle": "Cushion - Meterage (Contrast Frilled/Flanged)",
            "FabricOption": {
                "Description": "Contrast Fabric Option",
                "ToolTip": ""
            },
            "TypeOption": {
                "Description": "Type Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FrillSizeOption": {
                "Description": "Frill Size Option",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Cushion.ContrastFabricPipedPricing": {
            "$ScriptTitle": "Cushion - Contrast Piped Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "TypeOption": {
                "Description": "Type Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Cushion.ContrastFabricFrilledFlangedPricing": {
            "$ScriptTitle": "Cushion - Contrast Frilled/Flanged Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "TypeOption": {
                "Description": "Type Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FrillSizeOption": {
                "Description": "Frill Size Option",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Cushion.FabricPricing": {
            "$ScriptTitle": "Cushion - Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "DepthOption": {
                "Description": "Depth Option",
                "ToolTip": ""
            },
            "TypeOption": {
                "Description": "Type Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "FrilledCodes": {
                "Description": "Frilled Codes",
                "ToolTip": ""
            },
            "FrillSizeOption": {
                "Description": "Frill Size Option",
                "ToolTip": ""
            },
            "FlangedCodes": {
                "Description": "Flanged Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Cushion.ManufacturePricing": {
            "$ScriptTitle": "Cushion - Workroom Pricing",
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.TrackWidth": {
            "$ScriptTitle": "Curtain v3 - Track Width",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.HeadedSize": {
            "$ScriptTitle": "Curtain v3 - Headed Size",
            "HeadedSizeMeasurement": {
                "Description": "Headed Size Measurement",
                "ToolTip": "",
                "Values": {
                    "1": "1",
                    "2": "2"
                }
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepagePercentageOption": {
                "Description": "Creepage % Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "OperationOption": {
                "Description": "Operation Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.NoDropFabric": {
            "$ScriptTitle": "Curtain v3 - No of Drops (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepagePercentageOption": {
                "Description": "Creepage % Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "OperationOption": {
                "Description": "Operation Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Hem Allowance Option",
                "ToolTip": ""
            },
            "DropMultipleRoundDownTolerance": {
                "Description": "Drop round down Tolerance",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.NoDropManufacture": {
            "$ScriptTitle": "Curtain v3 - No of Drops (Manufacture)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "NoDropsOption": {
                "Description": "No of Drops Option",
                "ToolTip": ""
            },
            "RoundingSettings": {
                "Description": "Rounding Settings",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.CutLength": {
            "$ScriptTitle": "Curtain v3 - Fabric Cut Length",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "FinishedLengthOptionID": {
                "Description": "Finished Length Option",
                "ToolTip": "Numeric Product Option that contains Finished Length, if not set opening height will be used"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Head and Base Hem Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Hem Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.Meterage": {
            "$ScriptTitle": "Curtain v3 - Fabric Linear Length",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "FinishedLengthOptionID": {
                "Description": "Finished Length Option",
                "ToolTip": "Numeric Product Option that contains Finished Length, if not set opening height will be used"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "OperationOption": {
                "Description": "Operation Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Head and Base Hem Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Hem Allowance Option",
                "ToolTip": ""
            },
            "DropMultipleRoundDownTolerance": {
                "Description": "Drop round down Tolerance",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.SelfLinedLining": {
            "$ScriptTitle": "Curtain v3 - Self Lined Lining",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "SelfLinedOption": {
                "Description": "Self Lined Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.LiningIsCalculated": {
            "$ScriptTitle": "Curtain v3 - Lining Is Calculated",
            "SelfLinedOption": {
                "Description": "Self Lined Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.HTrimMFMeterage": {
            "$ScriptTitle": "Curtain v3 - Horizontal Trim MF Meterage",
            "TrimFabricOption": {
                "Description": "Trim Fabric Option",
                "ToolTip": ""
            },
            "TrimLocationOption": {
                "Description": "Trim Location Option",
                "ToolTip": ""
            },
            "FaceFabricOption": {
                "Description": "Face Fabric Option",
                "ToolTip": ""
            },
            "FaceFabricRailroadOption": {
                "Description": "Face Fabric Railroad Option",
                "ToolTip": ""
            },
            "FaceFabricMeterageOption": {
                "Description": "Face Fabric Meterage Option",
                "ToolTip": ""
            },
            "FaceFabricDropsOption": {
                "Description": "Face Fabric Drops Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.VTrimMFMeterage": {
            "$ScriptTitle": "Curtain v3 - Vertical Trim MF Meterage",
            "FaceFabricCutLengthOption": {
                "Description": "Face Fabric Cut Length Option",
                "ToolTip": ""
            },
            "NoCurtainsOption": {
                "Description": "Number of Curtains Option",
                "ToolTip": ""
            },
            "TrimLocationOption": {
                "Description": "Trim Location Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.CurtainV3FabricOptimisation": {
            "$ScriptTitle": "Curtain v3 - Fabric Optimisation",
            "AllowedDrops": {
                "Description": "Allowed Drops",
                "ToolTip": "",
                "Values": {
                    "Full": "Full",
                    "1/2": "1/2",
                    "1/3": "1/3",
                    "1/4": "1/4"
                }
            },
            "AllowedDropsWholesale": {
                "Description": "Allowed Drops Wholesale",
                "ToolTip": "",
                "Values": {
                    "Full": "Full",
                    "1/2": "1/2",
                    "1/3": "1/3",
                    "1/4": "1/4"
                }
            },
            "Fabrics": {
                "Description": "Fabrics",
                "ToolTip": ""
            },
            "StandardWastagePercentageValues": {
                "Description": "Standard Wastage % Values",
                "ToolTip": "Comma Separate List of Standard Wastage Percentages"
            },
            "AllowCustomWastagePercentage": {
                "Description": "Allow Custom Wastage %",
                "ToolTip": "If Checked, user can also enter any wastage % value"
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.CurtainV3FabricPricing": {
            "$ScriptTitle": "Curtain v3 - Fabric Pricing",
            "FabricAmountOptionID": {
                "Description": "Fabric Amount Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.ManufacturePricing": {
            "$ScriptTitle": "Curtain v3 - Workroom Pricing",
            "NoDropsOptionID": {
                "Description": "No Drops Option",
                "ToolTip": ""
            },
            "FabricAmountOption": {
                "Description": "Fabric Amount Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            },
            "ManufacturerSettings": {
                "Description": "Workroom Settings",
                "ToolTip": ""
            },
            "FaceFabric": {
                "Description": "Face Fabric Option",
                "ToolTip": ""
            },
            "FaceFabricRailroad": {
                "Description": "Face Fabric Rail Road Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.CurtainSurchargeByDrops": {
            "$ScriptTitle": "Curtain v3 - By No of Drops/Amount (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "NoDropsOption": {
                "Description": "No Drops Option",
                "ToolTip": ""
            },
            "NoDropsRounding": {
                "Description": "No Drops Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "NoDropsRoundingDP": {
                "Description": "No Drops Rounding Decimal Places",
                "ToolTip": ""
            },
            "FabricAmountOption": {
                "Description": "Fabric Amount Option",
                "ToolTip": ""
            },
            "FabricAmountRoundingType": {
                "Description": "Fabric Amount Rounding Type",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "FabricAmountRoundingMultiple": {
                "Description": "Fabric Amount Rounding",
                "ToolTip": "Before calculating how many Length Units, round the total length to a multiple of this."
            },
            "PriceLinearUnit": {
                "Description": "Price Linear Unit",
                "ToolTip": "the length unit that the price represents (e.g., if something costs $5 per 2 meters, enter '2 meters')"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "Rounding of Final Price Required",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Rounding Decimal Places of Final Price"
            }
        },
        "SoftFurnishings.Scripts.CurtainV3.CurtainV3SurchargeByHorizontal": {
            "$ScriptTitle": "Curtain v3 - By Horizontal Length (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "NoDropsOption": {
                "Description": "No Drops Option",
                "ToolTip": ""
            },
            "NoDropsRounding": {
                "Description": "No Drops Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "NoDropsRoundingDP": {
                "Description": "No Drops Rounding Decimal Places",
                "ToolTip": ""
            },
            "FabricAmountOption": {
                "Description": "Fabric Amount Option",
                "ToolTip": ""
            },
            "FabricAmountRoundingType": {
                "Description": "Fabric Amount Rounding Type",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "FabricAmountRoundingMultiple": {
                "Description": "Fabric Amount Rounding",
                "ToolTip": "Before calculating how many Length Units, round the total length to a multiple of this."
            },
            "PriceLinearUnit": {
                "Description": "Price Linear Unit",
                "ToolTip": "the length unit that the price represents (e.g., if something costs $5 per 2 meters, enter '2 meters')"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "Rounding of Final Price Required",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Rounding Decimal Places of Final Price"
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.TrackWidth": {
            "$ScriptTitle": "Curtain v2 - Track Width",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.HeadedSize": {
            "$ScriptTitle": "Curtain v2 - Headed Size",
            "HeadedSizeMeasurement": {
                "Description": "Headed Size Measurement",
                "ToolTip": "",
                "Values": {
                    "1": "1",
                    "2": "2"
                }
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepagePercentageOption": {
                "Description": "Creepage % Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "OperationOption": {
                "Description": "Operation Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.NoDropFabric": {
            "$ScriptTitle": "Curtain v2 - No of Drops (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepagePercentageOption": {
                "Description": "Creepage % Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "OperationOption": {
                "Description": "Operation Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Hem Allowance Option",
                "ToolTip": ""
            },
            "DropMultipleRoundDownTolerance": {
                "Description": "Drop round down Tolerance",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.NoDropManufacture": {
            "$ScriptTitle": "Curtain v2 - No of Drops (Manufacture)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "NoDropsOption": {
                "Description": "No of Drops Option",
                "ToolTip": ""
            },
            "RoundingSettings": {
                "Description": "Rounding Settings",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.CutLength": {
            "$ScriptTitle": "Curtain v2 - Fabric Cut Length",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "FinishedLengthOptionID": {
                "Description": "Finished Length Option",
                "ToolTip": "Numeric Product Option that contains Finished Length, if not set opening height will be used"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Head and Base Hem Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Hem Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.Meterage": {
            "$ScriptTitle": "Curtain v2 - Fabric Meterage",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "FinishedLengthOptionID": {
                "Description": "Finished Length Option",
                "ToolTip": "Numeric Product Option that contains Finished Length, if not set opening height will be used"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "OperationOption": {
                "Description": "Operation Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Head and Base Hem Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Hem Allowance Option",
                "ToolTip": ""
            },
            "DropMultipleRoundDownTolerance": {
                "Description": "Drop round down Tolerance",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.SelfLinedLining": {
            "$ScriptTitle": "Curtain v2 - Self Lined Lining",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "SelfLinedOption": {
                "Description": "Self Lined Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.LiningIsCalculated": {
            "$ScriptTitle": "Curtain v2 - Lining Is Calculated",
            "SelfLinedOption": {
                "Description": "Self Lined Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.HTrimMFMeterage": {
            "$ScriptTitle": "Curtain v2 - Horizontal Trim MF Meterage",
            "TrimFabricOption": {
                "Description": "Trim Fabric Option",
                "ToolTip": ""
            },
            "TrimLocationOption": {
                "Description": "Trim Location Option",
                "ToolTip": ""
            },
            "FaceFabricOption": {
                "Description": "Face Fabric Option",
                "ToolTip": ""
            },
            "FaceFabricRailroadOption": {
                "Description": "Face Fabric Railroad Option",
                "ToolTip": ""
            },
            "FaceFabricMeterageOption": {
                "Description": "Face Fabric Meterage Option",
                "ToolTip": ""
            },
            "FaceFabricDropsOption": {
                "Description": "Face Fabric Drops Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.VTrimMFMeterage": {
            "$ScriptTitle": "Curtain v2 - Vertical Trim MF Meterage",
            "FaceFabricCutLengthOption": {
                "Description": "Face Fabric Cut Length Option",
                "ToolTip": ""
            },
            "NoCurtainsOption": {
                "Description": "Number of Curtains Option",
                "ToolTip": ""
            },
            "TrimLocationOption": {
                "Description": "Trim Location Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.CurtainV2FabricOptimisation": {
            "$ScriptTitle": "Curtain v2 - Fabric Optimisation",
            "AllowedDrops": {
                "Description": "Allowed Drops",
                "ToolTip": "",
                "Values": {
                    "Full": "Full",
                    "1/2": "1/2",
                    "1/3": "1/3",
                    "1/4": "1/4"
                }
            },
            "AllowedDropsWholesale": {
                "Description": "Allowed Drops Wholesale",
                "ToolTip": "",
                "Values": {
                    "Full": "Full",
                    "1/2": "1/2",
                    "1/3": "1/3",
                    "1/4": "1/4"
                }
            },
            "Fabrics": {
                "Description": "Fabrics",
                "ToolTip": ""
            },
            "StandardWastagePercentageValues": {
                "Description": "Standard Wastage % Values",
                "ToolTip": "Comma Separate List of Standard Wastage Percentages"
            },
            "AllowCustomWastagePercentage": {
                "Description": "Allow Custom Wastage %",
                "ToolTip": "If Checked, user can also enter any wastage % value"
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.FabricPricing": {
            "$ScriptTitle": "Curtain v2 - Fabric Pricing",
            "NoMetresOptionID": {
                "Description": "No Metres Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.ManufacturePricing": {
            "$ScriptTitle": "Curtain v2 - Workroom Pricing",
            "NoDropsOptionID": {
                "Description": "No Drops Option",
                "ToolTip": ""
            },
            "NoMetresOptionID": {
                "Description": "No Metres Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            },
            "ManufacturerSettings": {
                "Description": "Workroom Settings",
                "ToolTip": ""
            },
            "FaceFabric": {
                "Description": "Face Fabric Option",
                "ToolTip": ""
            },
            "FaceFabricRailroad": {
                "Description": "Face Fabric Rail Road Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.CurtainSurchargeByDrops": {
            "$ScriptTitle": "Curtain v2 - By No of Drops/Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "NoDropsOption": {
                "Description": "No Drops Option",
                "ToolTip": ""
            },
            "NoDropsRounding": {
                "Description": "No Drops Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "NoDropsRoundingDP": {
                "Description": "No Drops Rounding Decimal Places",
                "ToolTip": ""
            },
            "NoMetresOption": {
                "Description": "No Metres Option",
                "ToolTip": ""
            },
            "NoMetresRounding": {
                "Description": "No Metres Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "NoMetresRoundingDP": {
                "Description": "No Metres Rounding Decimal Places",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "Rounding of Final Price Required",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Rounding Decimal Places of Final Price"
            }
        },
        "SoftFurnishings.Scripts.CurtainV2.CurtainV2SurchargeByHMetres": {
            "$ScriptTitle": "Curtain v2 - By Horizontal Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FabricRailroadOption": {
                "Description": "Fabric Railroad Option",
                "ToolTip": ""
            },
            "NoDropsOption": {
                "Description": "No Drops Option",
                "ToolTip": ""
            },
            "NoDropsRounding": {
                "Description": "No Drops Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "NoDropsRoundingDP": {
                "Description": "No Drops Rounding Decimal Places",
                "ToolTip": ""
            },
            "NoMetresOption": {
                "Description": "No Metres Option",
                "ToolTip": ""
            },
            "NoMetresRounding": {
                "Description": "No Metres Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "NoMetresRoundingDP": {
                "Description": "No Metres Rounding Decimal Places",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "Rounding of Final Price Required",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Rounding Decimal Places of Final Price"
            }
        },
        "SoftFurnishings.Scripts.Curtain.TrackWidth": {
            "$ScriptTitle": "Curtain - Track Width",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.HeadedSize": {
            "$ScriptTitle": "Curtain - Headed Size",
            "HeadedSizeMeasurement": {
                "Description": "Headed Size Measurement",
                "ToolTip": "",
                "Values": {
                    "1": "1",
                    "2": "2"
                }
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "OperationOption": {
                "Description": "Operation Option",
                "ToolTip": ""
            },
            "HeadedSizeAdjustmentLOption": {
                "Description": "Headed Size (L) Adjustment Option",
                "ToolTip": ""
            },
            "HeadedSizeAdjustmentROption": {
                "Description": "Headed Size (R) Adjustment Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.FinishedDrop": {
            "$ScriptTitle": "Curtain - Finished Drop",
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            }
        },
        "SoftFurnishings.Scripts.Curtain.NoDropFabric": {
            "$ScriptTitle": "Curtain - No of Drops (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.NoDropLining": {
            "$ScriptTitle": "Curtain - No of Drops (Lining)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.CutSize": {
            "$ScriptTitle": "Curtain - Fabric Cut Size",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.CutSizeLining": {
            "$ScriptTitle": "Curtain - Lining Cut Size",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.Meterage": {
            "$ScriptTitle": "Curtain - Fabric Meterage",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.MeterageLining": {
            "$ScriptTitle": "Curtain - Lining Meterage",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.NoPanelsByFullness": {
            "$ScriptTitle": "Curtain - No of Panels by Fullness",
            "WidthOptionID": {
                "Description": "Width Option",
                "ToolTip": "Optional. If not set Opening Width will be used"
            },
            "FullnessOptionID": {
                "Description": "Fullness Option",
                "ToolTip": "Fullness that width will be multiplied by"
            },
            "MinimumFullness": {
                "Description": "Minimum Fullness",
                "ToolTip": "If the Fullness is less than this value, this value is used instead"
            },
            "PanelWidth": {
                "Description": "Panel Width",
                "ToolTip": "Width of a Panel"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingMultiple": {
                "Description": "Result Rounding Multiple",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            }
        },
        "SoftFurnishings.Scripts.Curtain.FabricPricing": {
            "$ScriptTitle": "Curtain - Fabric Pricing",
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No Curtains Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Return(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Return(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.CurtainLiningPricing": {
            "$ScriptTitle": "Curtain - Lining Pricing",
            "FabricOption": {
                "Description": "Main Fabric Option (Not Lining)",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No Curtains Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Return(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Return(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.ManufacturePricing": {
            "$ScriptTitle": "Curtain - Workroom Pricing",
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "NoCurtainsOption": {
                "Description": "No Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Return(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Return(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            },
            "ManufacturerSettings": {
                "Description": "Workroom Settings",
                "ToolTip": ""
            },
            "FaceFabric": {
                "Description": "Face Fabric Option",
                "ToolTip": ""
            },
            "FaceFabricRailroad": {
                "Description": "Face Fabric Rail Road Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Curtain.CurtainSurchargeByDrops": {
            "$ScriptTitle": "Curtain Surcharge - By MF No of Drops/Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "DropAdjustmentOptionType": {
                "Description": "Drop Adjustment Option Type",
                "ToolTip": "Drop Adjustment Type",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Deduction": "Deduction"
                }
            },
            "DropAdjustmentOptionID": {
                "Description": "Drop Adjustment Option",
                "ToolTip": "Numeric Product Option that contains Adjustment Value. Required if Drop Adjustment Option Type equals Standard or Deduction"
            },
            "NoCurtainsOption": {
                "Description": "No of Curtains Option",
                "ToolTip": ""
            },
            "RetLOption": {
                "Description": "Ret(L) Option",
                "ToolTip": ""
            },
            "RetROption": {
                "Description": "Ret(R) Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "OverlapLOption": {
                "Description": "Overlap(L) Option",
                "ToolTip": ""
            },
            "OverlapROption": {
                "Description": "Overlap(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "CreepageOption": {
                "Description": "Creepage Option",
                "ToolTip": ""
            },
            "TrackDeductionOption": {
                "Description": "Track Deduction Option",
                "ToolTip": ""
            },
            "SeamAllowanceOption": {
                "Description": "Seam Allowance Option",
                "ToolTip": ""
            },
            "SideSeamAllowanceOption": {
                "Description": "Side Seam Allowance Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CBRollerBlind.NoDrops": {
            "$ScriptTitle": "CB Roller Blind - No of Drops",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            },
            "FinishCodes": {
                "Description": "Finish Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CBRollerBlind.Meterage": {
            "$ScriptTitle": "CB Roller Blind - Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            },
            "FinishCodes": {
                "Description": "Finish Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.CBRollerBlind.CBRollerBlindFabricPricing": {
            "$ScriptTitle": "CB Roller Blind - Fabric Pricing",
            "FinishOption": {
                "Description": "Finish Option",
                "ToolTip": ""
            },
            "FinishCodes": {
                "Description": "Finish Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BondedValance.NoDrops": {
            "$ScriptTitle": "Bonded Valance - No of Drops",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "StyleCodes": {
                "Description": "Style Codes",
                "ToolTip": ""
            },
            "ReturnOption": {
                "Description": "Return Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BondedValance.Meterage": {
            "$ScriptTitle": "Bonded Valance - Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "StyleCodes": {
                "Description": "Style Codes",
                "ToolTip": ""
            },
            "ReturnOption": {
                "Description": "Return Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BondedValance.BondedValanceFabricPricing": {
            "$ScriptTitle": "Bonded Valance - Fabric Pricing",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "StyleCodes": {
                "Description": "Style Codes",
                "ToolTip": ""
            },
            "ReturnOption": {
                "Description": "Return Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BondedRollerBlind.NoDrops": {
            "$ScriptTitle": "Bonded Roller Blind - No of Drops",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BondedRollerBlind.Meterage": {
            "$ScriptTitle": "Bonded Roller Blind - Fabric Meterage",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BondedRollerBlind.BRBFabricPricing": {
            "$ScriptTitle": "Bonded Roller Blind - Fabric Pricing"
        },
        "SoftFurnishings.Scripts.BondedRollerBlind.ManufacturePricing": {
            "$ScriptTitle": "Bonded Roller Blind - Workroom Pricing",
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BedValance.NoDropsFabric": {
            "$ScriptTitle": "Bed Valance - No of Drops (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BedValance.NoDropsLining": {
            "$ScriptTitle": "Bed Valance - No of Drops (Lining)",
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BedValance.MeterageFabric": {
            "$ScriptTitle": "Bed Valance - Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BedValance.MeterageLining": {
            "$ScriptTitle": "Bed Valance - Meterage (Lining)",
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BedValance.BedValanceFabricPricing": {
            "$ScriptTitle": "Bed Valance - Fabric Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BedValance.BedValanceLiningPricing": {
            "$ScriptTitle": "Bed Valance - Lining Pricing",
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.BedValance.ManufacturePricing": {
            "$ScriptTitle": "Bed Valance - Workroom Pricing",
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Bedspread.CalcNoDrops": {
            "$ScriptTitle": "Bedspread - No of Drops",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Bedspread.CalcFabricMeterage": {
            "$ScriptTitle": "Bedspread - Fabric Meterage",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            },
            "BandOption": {
                "Description": "Band Option",
                "ToolTip": ""
            },
            "PipingOption": {
                "Description": "Piping Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Bedspread.CalcLiningMeterage": {
            "$ScriptTitle": "Bedspread - Lining Meterage",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Bedspread.CalcContrastBandMeterage": {
            "$ScriptTitle": "Bedspread - Contrast Band Meterage",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            },
            "BandOption": {
                "Description": "Band Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Bedspread.CalcContrastPipingMeterage": {
            "$ScriptTitle": "Bedspread - Contrast Piping Meterage",
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "WidthOption": {
                "Description": "Width Option",
                "ToolTip": ""
            },
            "LengthOption": {
                "Description": "Length Option",
                "ToolTip": ""
            },
            "DropOption": {
                "Description": "Drop Option",
                "ToolTip": ""
            },
            "PipingOption": {
                "Description": "Piping Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.Bedspread.ManufacturePricing": {
            "$ScriptTitle": "Bedspread - Workroom Pricing",
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.MeterageFabric": {
            "$ScriptTitle": "Austrian Blind - Meterage (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "SingleFrilledCodes": {
                "Description": "Single Frilled Codes",
                "ToolTip": ""
            },
            "DoubleFrilledCodes": {
                "Description": "Double Frilled Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.MeterageLining": {
            "$ScriptTitle": "Austrian Blind - Meterage (Lining)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.MeterageContrastFabric": {
            "$ScriptTitle": "Austrian Blind - Meterage (Contrast Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ContrastFabricOption": {
                "Description": "Contrast Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "SingleFrilledCodes": {
                "Description": "Single Frilled Codes",
                "ToolTip": ""
            },
            "DoubleFrilledCodes": {
                "Description": "Double Frilled Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.CutSizeFabric": {
            "$ScriptTitle": "Austrian Blind - Cut Size (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.NoDropFabric": {
            "$ScriptTitle": "Austrian Blind - No of Drops (Fabric)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.CutSizeLining": {
            "$ScriptTitle": "Austrian Blind - Cut Size (Lining)",
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.NoDropLining": {
            "$ScriptTitle": "Austrian Blind - No of Drops (Lining)",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "LiningOption": {
                "Description": "Lining Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.BlindWidth": {
            "$ScriptTitle": "Austrian Blind - Blind Width",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.ContrastFabricPricing": {
            "$ScriptTitle": "Austrian Blind - Contrast Fabric Pricing",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "SingleFrilledCodes": {
                "Description": "Single Frilled Codes",
                "ToolTip": ""
            },
            "DoubleFrilledCodes": {
                "Description": "Double Frilled Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.FabricPricing": {
            "$ScriptTitle": "Austrian Blind - Fabric Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            },
            "StyleOption": {
                "Description": "Style Option",
                "ToolTip": ""
            },
            "PipedCodes": {
                "Description": "Piped Codes",
                "ToolTip": ""
            },
            "SingleFrilledCodes": {
                "Description": "Single Frilled Codes",
                "ToolTip": ""
            },
            "DoubleFrilledCodes": {
                "Description": "Double Frilled Codes",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.LiningPricing": {
            "$ScriptTitle": "Austrian Blind - Lining Pricing",
            "FabricOption": {
                "Description": "Fabric Option",
                "ToolTip": ""
            },
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "FullnessOption": {
                "Description": "Fullness Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AustrianBlind.ManufacturePricing": {
            "$ScriptTitle": "Austrian Blind - Workroom Pricing",
            "ExtLOption": {
                "Description": "Ext(L) Option",
                "ToolTip": ""
            },
            "ExtROption": {
                "Description": "Ext(R) Option",
                "ToolTip": ""
            },
            "UseProductPricingOptions": {
                "Description": "Use Product Pricing Options",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AlShutter.PerfectShutterHeight": {
            "$ScriptTitle": "Aluminium Shutter - Perfect Shutter Height",
            "ShutterHeightLookupRangeID": {
                "Description": "Shutter Height Lookup Range",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AlShutter.BladeQty": {
            "$ScriptTitle": "Aluminium Shutter - Blade Qty",
            "ShutterHeightLookupRangeID": {
                "Description": "Shutter Height Lookup Range",
                "ToolTip": ""
            },
            "ShutterBladeQtyLookupRangeID": {
                "Description": "Shutter Blade Qty Lookup Range",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AlShutter.Gap": {
            "$ScriptTitle": "Aluminium Shutter - Gap",
            "ShutterHeightLookupRangeID": {
                "Description": "Shutter Height Lookup Range",
                "ToolTip": ""
            },
            "GapAllowance": {
                "Description": "Gap Allowance",
                "ToolTip": ""
            }
        },
        "SoftFurnishings.Scripts.AlShutter.HingeQty": {
            "$ScriptTitle": "Aluminium Shutter - Hinge Qty",
            "ShutterHingeQtyLookupRangeID": {
                "Description": "Shutter Hinge Qty Lookup Range",
                "ToolTip": ""
            },
            "MountTypeOption": {
                "Description": "Mount Type Option",
                "ToolTip": ""
            },
            "HingeColourOption": {
                "Description": "Hinge Colour Option",
                "ToolTip": ""
            }
        },
        "SoftFurnishingsShared.Scripts.LinearMetreCutDisplayTypeSettings": {
            "$ScriptTitle": "Linear Metre Cuts",
            "LinearMetresOptionID": {
                "Description": "Linear Metres Option",
                "ToolTip": ""
            },
            "DefaultNoRows": {
                "Description": "Default No of Rows",
                "ToolTip": ""
            }
        },
        "SoftFurnishingsShared.Scripts.Fabric2LineDisplayTypeSettings": {
            "$ScriptTitle": "Fabric 2 Line",
            "AllowContinuous": {
                "Description": "Continuous Allowed",
                "ToolTip": ""
            },
            "AllowRailRoading": {
                "Description": "Railroading Allowed",
                "ToolTip": ""
            },
            "RailroadingOption": {
                "Description": "Railroading Option",
                "ToolTip": ""
            },
            "WidthAdjustment": {
                "Description": "Width Adjustment",
                "ToolTip": ""
            },
            "DropAdjustment": {
                "Description": "Drop Adjustment",
                "ToolTip": ""
            },
            "IgnoreFabricWidth": {
                "Description": "Ignore Fabric Width",
                "ToolTip": "If checked, do not filter the fabrics based on the Fabric Width. Used for products where the Fabric is not 1 continuous piece across the opening"
            },
            "IgnoreRailroadedFabricWidth": {
                "Description": "Ignore Railroaded Fabric Width",
                "ToolTip": "If checked, do not filter the fabrics when railroaded based on Fabric Width >= Drop"
            }
        },
        "SoftFurnishingsShared.Scripts.FabricDisplayTypeSettings": {
            "$ScriptTitle": "Fabric",
            "AllowContinuous": {
                "Description": "Continuous Allowed",
                "ToolTip": ""
            },
            "AllowRailRoading": {
                "Description": "Railroading Allowed",
                "ToolTip": ""
            },
            "RailroadingOption": {
                "Description": "Railroading Option",
                "ToolTip": ""
            },
            "WidthAdjustment": {
                "Description": "Width Adjustment",
                "ToolTip": ""
            },
            "DropAdjustment": {
                "Description": "Drop Adjustment",
                "ToolTip": ""
            },
            "IgnoreFabricWidth": {
                "Description": "Ignore Fabric Width",
                "ToolTip": "If checked, do not filter the fabrics based on the Fabric Width. Used for products where the Fabric is not 1 continuous piece across the opening"
            },
            "IgnoreRailroadedFabricWidth": {
                "Description": "Ignore Railroaded Fabric Width",
                "ToolTip": "If checked, do not filter the fabrics when railroaded based on Fabric Width >= Drop"
            }
        }
    },
    "InsytePricingShared": {
        "InsytePricing.Scripts.ConditionalNumericRangePricing": {
            "$ScriptTitle": "Conditional Numeric Range Pricing",
            "MinValue": {
                "Description": "Minimum Value",
                "ToolTip": "Minimum Value allowed to use price"
            },
            "MaxValue": {
                "Description": "Maximum Value",
                "ToolTip": "Maximum Value allowed to use price. 0 = No Maximum"
            }
        },
        "InsytePricing.Scripts.DoublePricing": {
            "$ScriptTitle": "Double Pricing",
            "RequiredOptionValueID": {
                "Description": "Required Option Value",
                "ToolTip": ""
            },
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": ""
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": ""
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": ""
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.HighestPricing": {
            "$ScriptTitle": "Highest Pricing",
            "Value2PricingOption1": {
                "Description": "Price 2 - Price Opt 1",
                "ToolTip": ""
            },
            "Value2PricingOption1UseGroupCode": {
                "Description": "Price 2 - Price Opt 1 - Use Grp Code",
                "ToolTip": ""
            },
            "Value2PricingOption2": {
                "Description": "Price 2 - Price Opt 2",
                "ToolTip": ""
            },
            "Value2PricingOption2UseGroupCode": {
                "Description": "Price 2 - Price Opt 2 - Use Grp Code",
                "ToolTip": ""
            },
            "Value3PricingOption1": {
                "Description": "Price 3 - Price Opt 1",
                "ToolTip": ""
            },
            "Value3PricingOption1UseGroupCode": {
                "Description": "Price 3 - Price Opt 1 - Use Grp Code",
                "ToolTip": ""
            },
            "Value3PricingOption2": {
                "Description": "Price 3 - Price Opt 2",
                "ToolTip": ""
            },
            "Value3PricingOption2UseGroupCode": {
                "Description": "Price 3 - Price Opt 2 - Use Grp Code",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.IgnoreLineQuantity": {
            "$ScriptTitle": "Ignore Line Quantity"
        },
        "InsytePricing.Scripts.NoPricing": {
            "$ScriptTitle": "No Price"
        },
        "InsytePricing.Scripts.PriceByExpressionNumeric": {
            "$ScriptTitle": "Pricing by Expression (Numeric)",
            "Options": {
                "Description": "Options",
                "ToolTip": "List of Product Options to use in the Expression"
            },
            "RequiredOptions": {
                "Description": "Required Options",
                "ToolTip": "List of Product Options that must have a numeric value > 0 to run expression"
            },
            "Expression": {
                "Description": "Expression",
                "ToolTip": "Numeric Expression Expression using {} as placeholders starting with index 0. e.g. {0} x {1}\nThe following operators are allowed: ()+-/*"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingMultiple": {
                "Description": "Result Rounding Multiple",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            }
        },
        "InsytePricing.Scripts.PriceByNumericOptionValue": {
            "$ScriptTitle": "Pricing by Numeric Option Value",
            "NumericOptionID": {
                "Description": "Numeric Option",
                "ToolTip": "Numeric Product Option whose value will be multipled by the price"
            },
            "AdjustmentType": {
                "Description": "Adjustment Type",
                "ToolTip": "Adjustment applied to Product Option Value",
                "Values": {
                    "None": "None",
                    "Multiply": "Multiply",
                    "Divide": "Divide",
                    "Add": "Add",
                    "Subtract": "Subtract"
                }
            },
            "AdjustmentValue": {
                "Description": "Adjustment Value",
                "ToolTip": "Numeric Value to adjust the Product Option Value using the Adjustment Type"
            },
            "AdjustmentRounding": {
                "Description": "Adjustment Rounding",
                "ToolTip": "Rounding to be applied after Adjustment is applied to Product Option Value",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "AdjustmentRoundingDP": {
                "Description": "Adjustment Rounding Decimal Places",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "Rounding to be applied to final calculated price",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.PriceByParameter": {
            "$ScriptTitle": "Pricing by Parameter",
            "ParamCode": {
                "Description": "Parameter",
                "ToolTip": ""
            },
            "AppendToBase": {
                "Description": "Append to base Price",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.PriceByQuantity": {
            "$ScriptTitle": "Pricing by Quantity",
            "QtyProductOptionID": {
                "Description": "Quantity Option",
                "ToolTip": ""
            },
            "Cost": {
                "Description": "Cost",
                "ToolTip": ""
            },
            "CostCurrency": {
                "Description": "Cost Currency",
                "ToolTip": "Uses System Setup Default Currency if not set"
            },
            "CostParamCode": {
                "Description": "Cost Parameter",
                "ToolTip": ""
            },
            "AppendToBase": {
                "Description": "Append to base Price",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.PricingByAlternateSize": {
            "$ScriptTitle": "Pricing By Alternate Size",
            "AlternateWidthOptionID": {
                "Description": "Alternate Width Option",
                "ToolTip": ""
            },
            "AlternateHeightOptionID": {
                "Description": "Alternate Drop Option",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.PricingByCubicMetre": {
            "$ScriptTitle": "Pricing Per Cubic Metre (Width * Height * Length)",
            "WidthOptionID": {
                "Description": "Width Option",
                "ToolTip": "Width Option. If not set and Width/Height option not set, defaults to the Line Width"
            },
            "HeightOptionID": {
                "Description": "Height Option",
                "ToolTip": "Height Option. If not set and Width/Height option not set, defaults to the Line Height"
            },
            "WidthHeightOptionID": {
                "Description": "Width/Height (Size) Option",
                "ToolTip": "Width/Height Combined Size Option. If not set and Width, Height option not set, defaults to the Line Height and Width"
            },
            "LengthOptionID": {
                "Description": "Length Option",
                "ToolTip": "Length Option"
            },
            "Minm3": {
                "Description": "Minimum m3",
                "ToolTip": "If the m3 is less than this value, this value is used instead"
            },
            "MinMultiplierProductOptionID": {
                "Description": "Min m3 Multiplier Option",
                "ToolTip": "Option to Multiply the Minimum m3 by to calculate Total Minimum m3"
            },
            "MinMultiplierProductOptionUseCode": {
                "Description": "Use Multiplier Option Code",
                "ToolTip": "If Multiplier Option is Picklist then whether to use the Option Value Code or Description"
            },
            "M3Rounding": {
                "Description": "m3 Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "M3RoundingDP": {
                "Description": "m3 Rounding Decimal Places",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.PricingByHeightMetre": {
            "$ScriptTitle": "Pricing Per Metre (Drop)",
            "MinHeight": {
                "Description": "Minimum Drop (m)",
                "ToolTip": "If the Drop (m) is less than this value, this value is used instead"
            },
            "HeightRounding": {
                "Description": "Drop Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "HeightRoundingDP": {
                "Description": "Drop Rounding Decimal Places",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.PricingByPerimeter": {
            "$ScriptTitle": "Pricing By Perimeter ( (2 * Width) + (2 * Drop) )",
            "MinMetres": {
                "Description": "Minimum metres",
                "ToolTip": "If the calculated meters is less than this value, this value is used instead"
            },
            "MinMultiplierProductOptionID": {
                "Description": "Min metres Multiplier Option",
                "ToolTip": "Option to Multiply the Minimum metres by to calculate Total Minimum metres"
            },
            "MinMultiplierProductOptionUseCode": {
                "Description": "Use Multiplier Option Code",
                "ToolTip": "If Multiplier Option is Picklist then whether to use the Option Value Code or Description"
            },
            "MetresRounding": {
                "Description": "metres Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "MetresRoundingDP": {
                "Description": "metres Rounding Decimal Places",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.PricingBySquareMetre": {
            "$ScriptTitle": "Pricing Per Square Metre (Width * Drop)",
            "Minm2": {
                "Description": "Minimum m2",
                "ToolTip": "If the m2 is less than this value, this value is used instead"
            },
            "MinMultiplierProductOptionID": {
                "Description": "Min m2 Multiplier Option",
                "ToolTip": "Option to Multiply the Minimum m2 by to calculate Total Minimum m2"
            },
            "MinMultiplierProductOptionUseCode": {
                "Description": "Use Multiplier Option Code",
                "ToolTip": "If Multiplier Option is Picklist then whether to use the Option Value Code or Description"
            },
            "M2Rounding": {
                "Description": "m2 Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "M2RoundingDP": {
                "Description": "m2 Rounding Decimal Places",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.PricingBySquareMetreWithTokenSurcharge": {
            "$ScriptTitle": "Pricing Per Square Metre With Token Surcharge",
            "Minm2": {
                "Description": "Minimum m2",
                "ToolTip": "If the m2 is less than this value, this value is used instead"
            },
            "TokenProductOptionID": {
                "Description": "Token Option",
                "ToolTip": "Product Option to search for Tokens codes"
            },
            "TokenCodes": {
                "Description": "Token Codes",
                "ToolTip": "Surcharge will only apply if Token option contains one of these codes. Separate multiple values by ';'"
            },
            "SurchargeProductOptionID": {
                "Description": "Surcharge Option",
                "ToolTip": "If set, surcharge will only apply if this option has a value"
            },
            "SurchargeProductOptionValueCodes": {
                "Description": "Surcharge Option - Value Codes",
                "ToolTip": "If set, surcharge will only apply if the value is one of these. Separate multiple values by ';'"
            },
            "SurchargeMultiplier": {
                "Description": "Surcharge Multiplier",
                "ToolTip": "Multiplier to multiple the price by if the surcharge applies"
            }
        },
        "InsytePricing.Scripts.PricingByWidthMetre": {
            "$ScriptTitle": "Pricing Per Metre (Width)",
            "MinWidth": {
                "Description": "Minimum Width (m)",
                "ToolTip": "If the Width (m) is less than this value, this value is used instead"
            },
            "WidthRounding": {
                "Description": "Width Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "WidthRoundingDP": {
                "Description": "Width Rounding Decimal Places",
                "ToolTip": ""
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.PricingPerMetre": {
            "$ScriptTitle": "Pricing Per Metre (Option Value)",
            "ValueUnit": {
                "Description": "Value Unit",
                "ToolTip": "Unit of Measure that the value is entered in",
                "Values": {
                    "Metre": "Metre",
                    "Millimetre": "Millimetre",
                    "Centimetre": "Centimetre"
                }
            },
            "MinMetres": {
                "Description": "Minimum Metres (m)",
                "ToolTip": "If the Value (m) is less than this value, this value is used instead"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.WebOnly.ConditionalLengthRangePricing": {
            "$ScriptTitle": "Conditional Length Range Pricing",
            "MinLength": {
                "Description": "Minimum Length",
                "ToolTip": "Minimum Length allowed to use price"
            },
            "MaxLength": {
                "Description": "Maximum Length",
                "ToolTip": "Maximum Length allowed to use price. 0 = No Maximum"
            }
        },
        "InsytePricing.Scripts.WebOnly.ConditionalNumericRangePricing": {
            "$ScriptTitle": "Conditional Numeric Range Pricing",
            "MinValue": {
                "Description": "Minimum Value",
                "ToolTip": "Minimum Value allowed to use price"
            },
            "MaxValue": {
                "Description": "Maximum Value",
                "ToolTip": "Maximum Value allowed to use price. 0 = No Maximum"
            }
        },
        "InsytePricing.Scripts.WebOnly.PricingByMultiSize": {
            "$ScriptTitle": "Multi Size Pricing",
            "PricingOption1": {
                "Description": "Pricing Option 1",
                "ToolTip": "Option to use for Pricing Option 1. If not set, Product Pricing Option 1 is used."
            },
            "PricingOption1UseGroupCode": {
                "Description": "Pricing Option 1 - Use Group Code",
                "ToolTip": "Use Group Code for Pricing Option 1"
            },
            "PricingOption2": {
                "Description": "Pricing Option 2",
                "ToolTip": "Option to use for Pricing Option 2. If not set, Product Pricing Option 2 is used."
            },
            "PricingOption2UseGroupCode": {
                "Description": "Pricing Option 2 - Use Group Code",
                "ToolTip": "Use Group Code for Pricing Option 2"
            },
            "Dual_PricingOptionValueID": {
                "Description": "Dual Pricing: Dual Pricing Enabled Option Value",
                "ToolTip": "Product Option Value that determines if Dual pricing is used instead of Multi-Size Pricing. Product Pricing Options are used for 1st Price, Dual Pricing parameters below set Pricing Options for the Second Price"
            },
            "Dual_PricingOption1": {
                "Description": "Dual Pricing: Pricing Option 1 for Second Price",
                "ToolTip": "Option to use for Pricing Option 1. Required for Dual Pricing"
            },
            "Dual_PricingOption1UseGroupCode": {
                "Description": "Dual Pricing: Pricing Option 1 - Use Group Code",
                "ToolTip": "Use Group Code for Pricing Option 1"
            },
            "Dual_PricingOption2": {
                "Description": "Dual Pricing: Pricing Option 2 for Second Price",
                "ToolTip": "Option to use for Pricing Option 2. Required for Dual Pricing"
            },
            "Dual_PricingOption2UseGroupCode": {
                "Description": "Dual Pricing: Pricing Option 2 - Use Group Code",
                "ToolTip": "Use Group Code for Pricing Option 2"
            },
            "Dual_WidthSourceOptionID": {
                "Description": "Dual Pricing: Width Value Option",
                "ToolTip": "Product Option for Width when using Dual Pricing. If not set will use Line Opening Width.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Dual_HeightSourceOptionID": {
                "Description": "Dual Pricing: Height Value Option",
                "ToolTip": "Product Option for Height when using Dual Pricing. If not set will use Line Opening Height.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "MultiSizeAutoSplitWidthOptionID": {
                "Description": "Multi-Size: Auto Split Width Enabled Option",
                "ToolTip": "Product Option that determines whether to Auto Split a Single Width into multiple even widths"
            },
            "MultiSizeAutoSplitWidthQtyValueOptionID": {
                "Description": "Multi-Size: Auto Split Width Qty Option",
                "ToolTip": "Product Option that determines the Total Qty to split Total Width by to Split when using Auto Split"
            },
            "MultiSizeAutoSplitWidthValueOptionID": {
                "Description": "Multi-Size: Auto Split Width Value Option",
                "ToolTip": "Product Option that determines Total Width to Split when using Auto Split. If not set will use Line Opening Width.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "MultiSizeAutoSplitHeightValueOptionID": {
                "Description": "Multi-Size: Auto Split Height Value Option",
                "ToolTip": "Product Option for Height when using Auto Split. If not set will use Line Opening Height.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price1_WidthValueOptionID": {
                "Description": "Multi-Size Price 1: Width Value Option",
                "ToolTip": "Price1: Product Option for Width when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price1_FallbackWidthValueOptionID": {
                "Description": "Multi-Size Price 1: Fallback Width Value Option",
                "ToolTip": "Price1: Product Option to use for Width when the selected Width Value is zero.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price1_WidthValueRequired": {
                "Description": "Multi-Size Price 1: Width Value Required",
                "ToolTip": "If set, and no Width Value, no price will be calculated for Price 1"
            },
            "Price1_HeightValueOptionID": {
                "Description": "Multi-Size Price 1: Height Value Option",
                "ToolTip": "Price1: Product Option for Height when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price1_FallbackHeightValueOptionID": {
                "Description": "Multi-Size Price 1: Fallback Height Value Option",
                "ToolTip": "Price1: Product Option to use for Height when the selected Height Value is zero.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price1_HeightValueRequired": {
                "Description": "Multi-Size Price 1: Height Value Required",
                "ToolTip": "If set, and no Height Value, no price will be calculated for Price 1"
            },
            "Price2_WidthValueOptionID": {
                "Description": "Multi-Size Price 2: Width Value Option",
                "ToolTip": "Price2: Product Option for Width when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price2_FallbackWidthValueOptionID": {
                "Description": "Multi-Size Price 2: Fallback Width Value Option",
                "ToolTip": "Price2: Product Option to use for Width when the selected Width Value is zero.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price2_WidthValueRequired": {
                "Description": "Multi-Size Price 2: Width Value Required",
                "ToolTip": "If set, and no Width Value, no price will be calculated for Price 2"
            },
            "Price2_HeightValueOptionID": {
                "Description": "Multi-Size Price 2: Height Value Option",
                "ToolTip": "Price2: Product Option for Height when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price2_FallbackHeightValueOptionID": {
                "Description": "Multi-Size Price 2: Fallback Height Value Option",
                "ToolTip": "Price2: Product Option to use for Height when the selected Height Value is zero.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price2_HeightValueRequired": {
                "Description": "Multi-Size Price 2: Height Value Required",
                "ToolTip": "If set, and no Height Value, no price will be calculated for Price 2"
            },
            "Price3_WidthValueOptionID": {
                "Description": "Multi-Size Price 3: Width Value Option",
                "ToolTip": "Price3: Product Option for Width when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price3_FallbackWidthValueOptionID": {
                "Description": "Multi-Size Price 3: Fallback Width Value Option",
                "ToolTip": "Price3: Product Option to use for Width when the selected Width Value is zero.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price3_WidthValueRequired": {
                "Description": "Multi-Size Price 3: Width Value Required",
                "ToolTip": "If set, and no Width Value, no price will be calculated for Price 3"
            },
            "Price3_HeightValueOptionID": {
                "Description": "Multi-Size Price 3: Height Value Option",
                "ToolTip": "Price3: Product Option for Height when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price3_FallbackHeightValueOptionID": {
                "Description": "Multi-Size Price 3: Fallback Height Value Option",
                "ToolTip": "Price3: Product Option to use for Height when the selected Height Value is zero.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price3_HeightValueRequired": {
                "Description": "Multi-Size Price 3: Height Value Required",
                "ToolTip": "If set, and no Height Value, no price will be calculated for Price 3"
            },
            "Price4_WidthValueOptionID": {
                "Description": "Multi-Size Price 4: Width Value Option",
                "ToolTip": "Price4: Product Option for Width when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price4_FallbackWidthValueOptionID": {
                "Description": "Multi-Size Price 4: Fallback Width Value Option",
                "ToolTip": "Price4: Product Option to use for Width when the selected Width Value is zero.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price4_WidthValueRequired": {
                "Description": "Multi-Size Price 4: Width Value Required",
                "ToolTip": "If set, and no Width Value, no price will be calculated for Price 4"
            },
            "Price4_HeightValueOptionID": {
                "Description": "Multi-Size Price 4: Height Value Option",
                "ToolTip": "Price4: Product Option for Height when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price4_FallbackHeightValueOptionID": {
                "Description": "Multi-Size Price 4: Fallback Height Value Option",
                "ToolTip": "Price4: Product Option to use for Height when the selected Height Value is zero.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price4_HeightValueRequired": {
                "Description": "Multi-Size Price 4: Height Value Required",
                "ToolTip": "If set, and no Height Value, no price will be calculated for Price 4"
            },
            "Price5_WidthValueOptionID": {
                "Description": "Multi-Size Price 5: Width Value Option",
                "ToolTip": "Price5: Product Option for Width when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price5_FallbackWidthValueOptionID": {
                "Description": "Multi-Size Price 5: Fallback Width Value Option",
                "ToolTip": "Price5: Product Option to use for Width when the selected Width Value is zero.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price5_WidthValueRequired": {
                "Description": "Multi-Size Price 5: Width Value Required",
                "ToolTip": "If set, and no Width Value, no price will be calculated for Price 5"
            },
            "Price5_HeightValueOptionID": {
                "Description": "Multi-Size Price 5: Height Value Option",
                "ToolTip": "Price5: Product Option for Height when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price5_FallbackHeightValueOptionID": {
                "Description": "Multi-Size Price 5: Fallback Height Value Option",
                "ToolTip": "Price5: Product Option to use for Height when the selected Height Value is zero.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price5_HeightValueRequired": {
                "Description": "Multi-Size Price 5: Height Value Required",
                "ToolTip": "If set, and no Height Value, no price will be calculated for Price 5"
            },
            "Price6_WidthValueOptionID": {
                "Description": "Multi-Size Price 6: Width Value Option",
                "ToolTip": "Price6: Product Option for Width when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price6_FallbackWidthValueOptionID": {
                "Description": "Multi-Size Price 6: Fallback Width Value Option",
                "ToolTip": "Price6: Product Option to use for Width when the selected Width Value is zero.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price6_WidthValueRequired": {
                "Description": "Multi-Size Price 6: Width Value Required",
                "ToolTip": "If set, and no Width Value, no price will be calculated for Price 6"
            },
            "Price6_HeightValueOptionID": {
                "Description": "Multi-Size Price 6: Height Value Option",
                "ToolTip": "Price6: Product Option for Height when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price6_FallbackHeightValueOptionID": {
                "Description": "Multi-Size Price 6: Fallback Height Value Option",
                "ToolTip": "Price6: Product Option to use for Height when the selected Height Value is zero.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price6_HeightValueRequired": {
                "Description": "Multi-Size Price 6: Height Value Required",
                "ToolTip": "If set, and no Height Value, no price will be calculated for Price 6"
            },
            "Price7_WidthValueOptionID": {
                "Description": "Multi-Size Price 7: Width Value Option",
                "ToolTip": "Price7: Product Option for Width when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price7_FallbackWidthValueOptionID": {
                "Description": "Multi-Size Price 7: Fallback Width Value Option",
                "ToolTip": "Price7: Product Option to use for Width when the selected Width Value is zero.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price7_WidthValueRequired": {
                "Description": "Multi-Size Price 7: Width Value Required",
                "ToolTip": "If set, and no Width Value, no price will be calculated for Price 7"
            },
            "Price7_HeightValueOptionID": {
                "Description": "Multi-Size Price 7: Height Value Option",
                "ToolTip": "Price7: Product Option for Height when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price7_FallbackHeightValueOptionID": {
                "Description": "Multi-Size Price 7: Fallback Height Value Option",
                "ToolTip": "Price7: Product Option to use for Height when the selected Height Value is zero.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price7_HeightValueRequired": {
                "Description": "Multi-Size Price 7: Height Value Required",
                "ToolTip": "If set, and no Height Value, no price will be calculated for Price 7"
            },
            "Price8_WidthValueOptionID": {
                "Description": "Multi-Size Price 8: Width Value Option",
                "ToolTip": "Price8: Product Option for Width when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price8_FallbackWidthValueOptionID": {
                "Description": "Multi-Size Price 8: Fallback Width Value Option",
                "ToolTip": "Price8: Product Option to use for Width when the selected Width Value is zero.",
                "Values": {
                    "OrderLine_Width": "Order Line - Width"
                }
            },
            "Price8_WidthValueRequired": {
                "Description": "Multi-Size Price 8: Width Value Required",
                "ToolTip": "If set, and no Width Value, no price will be calculated for Price 8"
            },
            "Price8_HeightValueOptionID": {
                "Description": "Multi-Size Price 8: Height Value Option",
                "ToolTip": "Price8: Product Option for Height when NOT using Dual Pricing or Auto Split.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price8_FallbackHeightValueOptionID": {
                "Description": "Multi-Size Price 8: Fallback Height Value Option",
                "ToolTip": "Price8: Product Option to use for Height when the selected Height Value is zero.",
                "Values": {
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "Price8_HeightValueRequired": {
                "Description": "Multi-Size Price 8: Height Value Required",
                "ToolTip": "If set, and no Height Value, no price will be calculated for Price 8"
            }
        },
        "InsytePricing.Scripts.WebOnly.PricingByAlternateSize": {
            "$ScriptTitle": "Pricing by Alternate Size",
            "AlternateWidthSource": {
                "Description": "Alternate Width Source",
                "ToolTip": "The source of the Width",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "AlternateHeightSource": {
                "Description": "Alternate Height Source",
                "ToolTip": "The source of the Height",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height"
                }
            }
        },
        "InsytePricing.Scripts.WebOnly.PricingByExpressionNumeric": {
            "$ScriptTitle": "Pricing by Expression (Numeric)",
            "Options": {
                "Description": "Options",
                "ToolTip": "List of Product Options to use in the Expression",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height",
                    "OrderLine_Quantity": "Order Line - Quantity",
                    "Input_Price": "Input Price"
                }
            },
            "RequiredOptions": {
                "Description": "Required Options",
                "ToolTip": "List of Product Options that must have a numeric value > 0 to run expression",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height",
                    "OrderLine_Quantity": "Order Line - Quantity",
                    "Input_Price": "Input Price"
                }
            },
            "LinearUnit": {
                "Description": "Linear Unit",
                "ToolTip": "All Length options will be in this unit. e.g. if the Order Line Width is entered as 20mm, and you select 'Centimeters' here, then the `Order Line - Width` option will have the value `2` (20mm converted to 2cm)"
            },
            "Expression": {
                "Description": "Expression",
                "ToolTip": "Numeric Expression Expression using {} as placeholders starting with index 0. e.g. {0} x {1}\nThe following operators are allowed: ()+-/*"
            },
            "ResultRounding": {
                "Description": "Result Rounding",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingMultiple": {
                "Description": "Result Rounding Multiple",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": "Either Rounding Multiple of Rounding Decimal Places can be specified"
            }
        },
        "InsytePricing.Scripts.WebOnly.PricingPerArea": {
            "$ScriptTitle": "Pricing per Area",
            "WidthSource": {
                "Description": "Width Source",
                "ToolTip": "The source of the Width",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "HeightSource": {
                "Description": "Height Source",
                "ToolTip": "The source of the Height",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "MinArea": {
                "Description": "Minimum Area",
                "ToolTip": "If (<Width Source> x <Height Source>) is less than this area, this area is used instead"
            },
            "MinAreaMultiplierProductOptionID": {
                "Description": "Minimum Area Multiplier Option",
                "ToolTip": "Option to Multiply the Minimum Area by to calculate Total Minimum Area"
            },
            "MinAreaMultiplierProductOptionUseCode": {
                "Description": "Use Multiplier Option Code",
                "ToolTip": "If Multiplier Option is a Picklist then whether to use the Option Value Code or Description"
            },
            "AreaRoundingType": {
                "Description": "Area Rounding Type",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "AreaRoundingMultiple": {
                "Description": "Area Rounding",
                "ToolTip": "Before calculating how many Area Units, round the total area to a multiple of this."
            },
            "PriceAreaUnit": {
                "Description": "Price Area Unit",
                "ToolTip": "the area of material that the price represents (e.g., if something costs $2 per 5 square meters, enter '5 square meters')"
            },
            "ResultRoundingType": {
                "Description": "Result Rounding Type",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.WebOnly.PricingPerLinear": {
            "$ScriptTitle": "Pricing per Linear",
            "LengthSource": {
                "Description": "Length Source",
                "ToolTip": "The source of the Length",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height",
                    "Calculated_Perimeter": "Perimeter (2x Width + 2x Height)"
                }
            },
            "MinLength": {
                "Description": "Minimum Length",
                "ToolTip": "If the Length Source is less than this length, this length is used instead"
            },
            "MinLengthMultiplierProductOptionID": {
                "Description": "Minimum Length Multiplier Option",
                "ToolTip": "Option to Multiply the Minimum Length by to calculate Total Minimum Length"
            },
            "MinLengthMultiplierProductOptionUseCode": {
                "Description": "Use Multiplier Option Code",
                "ToolTip": "If Multiplier Option is a Picklist then whether to use the Option Value Code or Description"
            },
            "LengthRoundingType": {
                "Description": "Length Rounding Type",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "LengthRoundingMultiple": {
                "Description": "Length Rounding",
                "ToolTip": "Before calculating how many Length Units, round the total length to a multiple of this."
            },
            "PriceLinearUnit": {
                "Description": "Price Linear Unit",
                "ToolTip": "the length of material that the price represents (e.g., if something costs $5 per 2 meters, enter '2 meters')"
            },
            "ResultRoundingType": {
                "Description": "Result Rounding Type",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        },
        "InsytePricing.Scripts.WebOnly.PricingPerVolume": {
            "$ScriptTitle": "Pricing per Volume",
            "WidthSource": {
                "Description": "Width Source",
                "ToolTip": "The source of the Width",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "HeightSource": {
                "Description": "Height Source",
                "ToolTip": "The source of the Height",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "DepthSource": {
                "Description": "Height Source",
                "ToolTip": "The source of the Depth",
                "Values": {
                    "OrderLine_Width": "Order Line - Width",
                    "OrderLine_Height": "Order Line - Height"
                }
            },
            "MinVolume": {
                "Description": "Minimum Volume",
                "ToolTip": "If (<Width Source> x <Height Source> x <Depth Source>) is less than this volume, this volume is used instead"
            },
            "MinVolumeMultiplierProductOptionID": {
                "Description": "Minimum Volume Multiplier Option",
                "ToolTip": "Option to Multiply the Minimum Volume by to calculate Total Minimum Volume"
            },
            "MinVolumeMultiplierProductOptionUseCode": {
                "Description": "Use Multiplier Option Code",
                "ToolTip": "If Multiplier Option is a Picklist then whether to use the Option Value Code or Description"
            },
            "VolumeRoundingType": {
                "Description": "Volume Rounding Type",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "VolumeRoundingMultiple": {
                "Description": "Volume Rounding",
                "ToolTip": "Before calculating how many Volume Units, round the total volume to a multiple of this."
            },
            "PriceVolumeUnit": {
                "Description": "Price Volume Unit",
                "ToolTip": "the volume of material that the price represents (e.g., if something costs $2 per 5 square meters, enter '5 square meters')"
            },
            "ResultRoundingType": {
                "Description": "Result Rounding Type",
                "ToolTip": "",
                "Values": {
                    "None": "None",
                    "Standard": "Standard",
                    "Up": "Up",
                    "Down": "Down"
                }
            },
            "ResultRoundingDP": {
                "Description": "Result Rounding Decimal Places",
                "ToolTip": ""
            }
        }
    }
}
// SCRIPT OVERRIDES
// The following override values are seperated out like this so it's possible to regenerate the above default values during intial development (in case anything is missed)
// once the default values are finalised these should be merged in.
// TODO: merge into the above before release

window.myinsyteresources.en.translation.application_strings.scripts.ModelItem = {
    "ProductParam": "{{ProductParam.Description}}",
    "ProductOption": "{{ProductOption.Group.Description}} -> {{ProductOption.Description}}",
    "ProductOption_Length": "{{ProductOption.Group.Description}} -> {{ProductOption.Description}} ($t(application_strings.enums.MeasuredValueUnit, {\"context\": \"{{ProductOption.LengthSettings.Unit}}\" }))",
    "ProductOptionValue": "{{ProductOptionValue.Option.Group.Description}} -> {{ProductOptionValue.Option.Description}} -> {{ProductOptionValue.Description}}",
}
window.myinsyteresources.en.translation.application_strings.scripts.productScriptCtrl = {
    type: "Script Type",
};
